
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefc87"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefc87"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
"use strict";

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$k = Symbol.for("react.element"), $1bb9784afa87e369$var$l = Symbol.for("react.fragment"), $1bb9784afa87e369$var$m = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$n = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1bb9784afa87e369$var$m.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1bb9784afa87e369$var$n.current
    };
}
$1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$l;
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("7fPBF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $b9040d2deeb360f4$export$3ba232387fd5d6dd; }, function (v) { return $b9040d2deeb360f4$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b9040d2deeb360f4$export$7568632d0d33d16d; }, function (v) { return $b9040d2deeb360f4$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b9040d2deeb360f4$export$88948ce120ea2619; }, function (v) { return $b9040d2deeb360f4$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf; }, function (v) { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b9040d2deeb360f4$export$f680877a34711e37; }, function (v) { return $b9040d2deeb360f4$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b9040d2deeb360f4$export$aaabe4eda9ed9969; }, function (v) { return $b9040d2deeb360f4$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b9040d2deeb360f4$export$306c0aa65ff9ec16; }, function (v) { return $b9040d2deeb360f4$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b9040d2deeb360f4$export$7b286972b8d8ccbf; }, function (v) { return $b9040d2deeb360f4$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$3ba232387fd5d6dd;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$7568632d0d33d16d;
var $b9040d2deeb360f4$export$88948ce120ea2619;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6a7bc4e911dc01cf;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$f680877a34711e37;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$aaabe4eda9ed9969;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$306c0aa65ff9ec16;
var $b9040d2deeb360f4$export$7b286972b8d8ccbf;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
"use strict";
var $b9040d2deeb360f4$var$l = Symbol.for("react.element"), $b9040d2deeb360f4$var$n = Symbol.for("react.portal"), $b9040d2deeb360f4$var$p = Symbol.for("react.fragment"), $b9040d2deeb360f4$var$q = Symbol.for("react.strict_mode"), $b9040d2deeb360f4$var$r = Symbol.for("react.profiler"), $b9040d2deeb360f4$var$t = Symbol.for("react.provider"), $b9040d2deeb360f4$var$u = Symbol.for("react.context"), $b9040d2deeb360f4$var$v = Symbol.for("react.forward_ref"), $b9040d2deeb360f4$var$w = Symbol.for("react.suspense"), $b9040d2deeb360f4$var$x = Symbol.for("react.memo"), $b9040d2deeb360f4$var$y = Symbol.for("react.lazy"), $b9040d2deeb360f4$var$z = Symbol.iterator;
function $b9040d2deeb360f4$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$z && a[$b9040d2deeb360f4$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b9040d2deeb360f4$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$C = Object.assign, $b9040d2deeb360f4$var$D = {};
function $b9040d2deeb360f4$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
$b9040d2deeb360f4$var$E.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$F() {}
$b9040d2deeb360f4$var$F.prototype = $b9040d2deeb360f4$var$E.prototype;
function $b9040d2deeb360f4$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
var $b9040d2deeb360f4$var$H = $b9040d2deeb360f4$var$G.prototype = new $b9040d2deeb360f4$var$F;
$b9040d2deeb360f4$var$H.constructor = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$var$C($b9040d2deeb360f4$var$H, $b9040d2deeb360f4$var$E.prototype);
$b9040d2deeb360f4$var$H.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$I = Array.isArray, $b9040d2deeb360f4$var$J = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$K = {
    current: null
}, $b9040d2deeb360f4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$J.call(b, d) && !$b9040d2deeb360f4$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b9040d2deeb360f4$var$K.current
    };
}
function $b9040d2deeb360f4$var$N(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$l;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$P = /\/+/g;
function $b9040d2deeb360f4$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$l:
                case $b9040d2deeb360f4$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b9040d2deeb360f4$var$Q(h, 0) : d, $b9040d2deeb360f4$var$I(c) ? (e = "", null != a && (e = a.replace($b9040d2deeb360f4$var$P, "$&/") + "/"), $b9040d2deeb360f4$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b9040d2deeb360f4$var$O(c) && (c = $b9040d2deeb360f4$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b9040d2deeb360f4$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b9040d2deeb360f4$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b9040d2deeb360f4$var$Q(k, g);
        h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    }
    else if (f = $b9040d2deeb360f4$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b9040d2deeb360f4$var$Q(k, g++), h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b9040d2deeb360f4$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b9040d2deeb360f4$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b9040d2deeb360f4$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b9040d2deeb360f4$var$U = {
    current: null
}, $b9040d2deeb360f4$var$V = {
    transition: null
}, $b9040d2deeb360f4$var$W = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$U,
    ReactCurrentBatchConfig: $b9040d2deeb360f4$var$V,
    ReactCurrentOwner: $b9040d2deeb360f4$var$K
};
function $b9040d2deeb360f4$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$S,
    forEach: function(a, b, e) {
        $b9040d2deeb360f4$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$p;
$b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$r;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$q;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$W;
$b9040d2deeb360f4$export$3ba232387fd5d6dd = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b9040d2deeb360f4$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$J.call(b, f) && !$b9040d2deeb360f4$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b9040d2deeb360f4$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$M;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$O;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$T
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$7568632d0d33d16d = function(a) {
    var b = $b9040d2deeb360f4$var$V.transition;
    $b9040d2deeb360f4$var$V.transition = {};
    try {
        a();
    } finally{
        $b9040d2deeb360f4$var$V.transition = b;
    }
};
$b9040d2deeb360f4$export$88948ce120ea2619 = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useContext(a);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6a7bc4e911dc01cf = function(a) {
    return $b9040d2deeb360f4$var$U.current.useDeferredValue(a);
};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useEffect(a, b);
};
$b9040d2deeb360f4$export$f680877a34711e37 = function() {
    return $b9040d2deeb360f4$var$U.current.useId();
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useImperativeHandle(a, b, e);
};
$b9040d2deeb360f4$export$aaabe4eda9ed9969 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useInsertionEffect(a, b);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useReducer(a, b, e);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$U.current.useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useState(a);
};
$b9040d2deeb360f4$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useSyncExternalStore(a, b, e);
};
$b9040d2deeb360f4$export$7b286972b8d8ccbf = function() {
    return $b9040d2deeb360f4$var$U.current.useTransition();
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("6EA3T", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4d82739dd229d539$export$ae55be85d98224ed; }, function (v) { return $4d82739dd229d539$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4d82739dd229d539$export$d39a5bbd09211389; }, function (v) { return $4d82739dd229d539$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4d82739dd229d539$export$882461b6382ed46c; }, function (v) { return $4d82739dd229d539$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4d82739dd229d539$export$466bfc07425424d5; }, function (v) { return $4d82739dd229d539$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4d82739dd229d539$export$cd75ccfd720a3cd4; }, function (v) { return $4d82739dd229d539$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4d82739dd229d539$export$fa8d919ba61d84db; }, function (v) { return $4d82739dd229d539$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4d82739dd229d539$export$757ceba2d55c277e; }, function (v) { return $4d82739dd229d539$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4d82739dd229d539$export$b3890eb0ae9dca99; }, function (v) { return $4d82739dd229d539$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4d82739dd229d539$export$502457920280e6be; }, function (v) { return $4d82739dd229d539$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4d82739dd229d539$export$c78a37762a8d58e1; }, function (v) { return $4d82739dd229d539$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4d82739dd229d539$export$dc54d992c10e8a18; }, function (v) { return $4d82739dd229d539$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4d82739dd229d539$export$83d89fbfd8236492; }, function (v) { return $4d82739dd229d539$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4d82739dd229d539$export$ae55be85d98224ed;
var $4d82739dd229d539$export$d39a5bbd09211389;
var $4d82739dd229d539$export$882461b6382ed46c;
var $4d82739dd229d539$export$466bfc07425424d5;
var $4d82739dd229d539$export$cd75ccfd720a3cd4;
var $4d82739dd229d539$export$fa8d919ba61d84db;
var $4d82739dd229d539$export$757ceba2d55c277e;
var $4d82739dd229d539$export$b3890eb0ae9dca99;
var $4d82739dd229d539$export$502457920280e6be;
var $4d82739dd229d539$export$c78a37762a8d58e1;
var $4d82739dd229d539$export$dc54d992c10e8a18;
var $4d82739dd229d539$export$83d89fbfd8236492;
"use strict";

var $7fPBF = parcelRequire("7fPBF");

var $33s19 = parcelRequire("33s19");
function $4d82739dd229d539$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4d82739dd229d539$var$da = new Set, $4d82739dd229d539$var$ea = {};
function $4d82739dd229d539$var$fa(a, b) {
    $4d82739dd229d539$var$ha(a, b);
    $4d82739dd229d539$var$ha(a + "Capture", b);
}
function $4d82739dd229d539$var$ha(a, b) {
    $4d82739dd229d539$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4d82739dd229d539$var$da.add(b[a]);
}
var $4d82739dd229d539$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4d82739dd229d539$var$ja = Object.prototype.hasOwnProperty, $4d82739dd229d539$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4d82739dd229d539$var$la = {}, $4d82739dd229d539$var$ma = {};
function $4d82739dd229d539$var$oa(a) {
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$ma, a)) return !0;
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$la, a)) return !1;
    if ($4d82739dd229d539$var$ka.test(a)) return $4d82739dd229d539$var$ma[a] = !0;
    $4d82739dd229d539$var$la[a] = !0;
    return !1;
}
function $4d82739dd229d539$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4d82739dd229d539$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4d82739dd229d539$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4d82739dd229d539$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4d82739dd229d539$var$ra = /[\-:]([a-z])/g;
function $4d82739dd229d539$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4d82739dd229d539$var$z.xlinkHref = new $4d82739dd229d539$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4d82739dd229d539$var$ta(a, b, c, d) {
    var e = $4d82739dd229d539$var$z.hasOwnProperty(b) ? $4d82739dd229d539$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4d82739dd229d539$var$qa(b, c, e, d) && (c = null), d || null === e ? $4d82739dd229d539$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4d82739dd229d539$var$ua = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4d82739dd229d539$var$va = Symbol.for("react.element"), $4d82739dd229d539$var$wa = Symbol.for("react.portal"), $4d82739dd229d539$var$ya = Symbol.for("react.fragment"), $4d82739dd229d539$var$za = Symbol.for("react.strict_mode"), $4d82739dd229d539$var$Aa = Symbol.for("react.profiler"), $4d82739dd229d539$var$Ba = Symbol.for("react.provider"), $4d82739dd229d539$var$Ca = Symbol.for("react.context"), $4d82739dd229d539$var$Da = Symbol.for("react.forward_ref"), $4d82739dd229d539$var$Ea = Symbol.for("react.suspense"), $4d82739dd229d539$var$Fa = Symbol.for("react.suspense_list"), $4d82739dd229d539$var$Ga = Symbol.for("react.memo"), $4d82739dd229d539$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4d82739dd229d539$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4d82739dd229d539$var$Ja = Symbol.iterator;
function $4d82739dd229d539$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d82739dd229d539$var$Ja && a[$4d82739dd229d539$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4d82739dd229d539$var$A = Object.assign, $4d82739dd229d539$var$La;
function $4d82739dd229d539$var$Ma(a) {
    if (void 0 === $4d82739dd229d539$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4d82739dd229d539$var$La = b && b[1] || "";
    }
    return "\n" + $4d82739dd229d539$var$La + a;
}
var $4d82739dd229d539$var$Na = !1;
function $4d82739dd229d539$var$Oa(a, b) {
    if (!a || $4d82739dd229d539$var$Na) return "";
    $4d82739dd229d539$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4d82739dd229d539$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4d82739dd229d539$var$Ma(a) : "";
}
function $4d82739dd229d539$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4d82739dd229d539$var$Ma(a.type);
        case 16:
            return $4d82739dd229d539$var$Ma("Lazy");
        case 13:
            return $4d82739dd229d539$var$Ma("Suspense");
        case 19:
            return $4d82739dd229d539$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4d82739dd229d539$var$Oa(a.type, !1), a;
        case 11:
            return a = $4d82739dd229d539$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4d82739dd229d539$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4d82739dd229d539$var$ya:
            return "Fragment";
        case $4d82739dd229d539$var$wa:
            return "Portal";
        case $4d82739dd229d539$var$Aa:
            return "Profiler";
        case $4d82739dd229d539$var$za:
            return "StrictMode";
        case $4d82739dd229d539$var$Ea:
            return "Suspense";
        case $4d82739dd229d539$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4d82739dd229d539$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4d82739dd229d539$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4d82739dd229d539$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4d82739dd229d539$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4d82739dd229d539$var$Qa(a.type) || "Memo";
        case $4d82739dd229d539$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4d82739dd229d539$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4d82739dd229d539$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4d82739dd229d539$var$Qa(b);
        case 8:
            return b === $4d82739dd229d539$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4d82739dd229d539$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4d82739dd229d539$var$Ua(a) {
    var b = $4d82739dd229d539$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4d82739dd229d539$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4d82739dd229d539$var$Ua(a));
}
function $4d82739dd229d539$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4d82739dd229d539$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4d82739dd229d539$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4d82739dd229d539$var$Ya(a, b) {
    var c = b.checked;
    return $4d82739dd229d539$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4d82739dd229d539$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4d82739dd229d539$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4d82739dd229d539$var$ab(a, b) {
    b = b.checked;
    null != b && $4d82739dd229d539$var$ta(a, "checked", b, !1);
}
function $4d82739dd229d539$var$bb(a, b) {
    $4d82739dd229d539$var$ab(a, b);
    var c = $4d82739dd229d539$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4d82739dd229d539$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4d82739dd229d539$var$cb(a, b.type, $4d82739dd229d539$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4d82739dd229d539$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4d82739dd229d539$var$cb(a, b, c) {
    if ("number" !== b || $4d82739dd229d539$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4d82739dd229d539$var$eb = Array.isArray;
function $4d82739dd229d539$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4d82739dd229d539$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4d82739dd229d539$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4d82739dd229d539$var$p(91));
    return $4d82739dd229d539$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4d82739dd229d539$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4d82739dd229d539$var$p(92));
            if ($4d82739dd229d539$var$eb(c)) {
                if (1 < c.length) throw Error($4d82739dd229d539$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4d82739dd229d539$var$Sa(c)
    };
}
function $4d82739dd229d539$var$ib(a, b) {
    var c = $4d82739dd229d539$var$Sa(b.value), d = $4d82739dd229d539$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4d82739dd229d539$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4d82739dd229d539$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4d82739dd229d539$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4d82739dd229d539$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4d82739dd229d539$var$mb, $4d82739dd229d539$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4d82739dd229d539$var$mb = $4d82739dd229d539$var$mb || document.createElement("div");
        $4d82739dd229d539$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4d82739dd229d539$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4d82739dd229d539$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4d82739dd229d539$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4d82739dd229d539$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4d82739dd229d539$var$pb).forEach(function(a) {
    $4d82739dd229d539$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4d82739dd229d539$var$pb[b] = $4d82739dd229d539$var$pb[a];
    });
});
function $4d82739dd229d539$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4d82739dd229d539$var$pb.hasOwnProperty(a) && $4d82739dd229d539$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4d82739dd229d539$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4d82739dd229d539$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4d82739dd229d539$var$tb = $4d82739dd229d539$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4d82739dd229d539$var$ub(a, b) {
    if (b) {
        if ($4d82739dd229d539$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4d82739dd229d539$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4d82739dd229d539$var$p(62));
    }
}
function $4d82739dd229d539$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4d82739dd229d539$var$wb = null;
function $4d82739dd229d539$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4d82739dd229d539$var$yb = null, $4d82739dd229d539$var$zb = null, $4d82739dd229d539$var$Ab = null;
function $4d82739dd229d539$var$Bb(a) {
    if (a = $4d82739dd229d539$var$Cb(a)) {
        if ("function" !== typeof $4d82739dd229d539$var$yb) throw Error($4d82739dd229d539$var$p(280));
        var b = a.stateNode;
        b && (b = $4d82739dd229d539$var$Db(b), $4d82739dd229d539$var$yb(a.stateNode, a.type, b));
    }
}
function $4d82739dd229d539$var$Eb(a) {
    $4d82739dd229d539$var$zb ? $4d82739dd229d539$var$Ab ? $4d82739dd229d539$var$Ab.push(a) : $4d82739dd229d539$var$Ab = [
        a
    ] : $4d82739dd229d539$var$zb = a;
}
function $4d82739dd229d539$var$Fb() {
    if ($4d82739dd229d539$var$zb) {
        var a = $4d82739dd229d539$var$zb, b = $4d82739dd229d539$var$Ab;
        $4d82739dd229d539$var$Ab = $4d82739dd229d539$var$zb = null;
        $4d82739dd229d539$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4d82739dd229d539$var$Bb(b[a]);
    }
}
function $4d82739dd229d539$var$Gb(a, b) {
    return a(b);
}
function $4d82739dd229d539$var$Hb() {}
var $4d82739dd229d539$var$Ib = !1;
function $4d82739dd229d539$var$Jb(a, b, c) {
    if ($4d82739dd229d539$var$Ib) return a(b, c);
    $4d82739dd229d539$var$Ib = !0;
    try {
        return $4d82739dd229d539$var$Gb(a, b, c);
    } finally{
        if ($4d82739dd229d539$var$Ib = !1, null !== $4d82739dd229d539$var$zb || null !== $4d82739dd229d539$var$Ab) $4d82739dd229d539$var$Hb(), $4d82739dd229d539$var$Fb();
    }
}
function $4d82739dd229d539$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4d82739dd229d539$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4d82739dd229d539$var$p(231, b, typeof c));
    return c;
}
var $4d82739dd229d539$var$Lb = !1;
if ($4d82739dd229d539$var$ia) try {
    var $4d82739dd229d539$var$Mb = {};
    Object.defineProperty($4d82739dd229d539$var$Mb, "passive", {
        get: function() {
            $4d82739dd229d539$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
    window.removeEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
} catch (a) {
    $4d82739dd229d539$var$Lb = !1;
}
function $4d82739dd229d539$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $4d82739dd229d539$var$Ob = !1, $4d82739dd229d539$var$Pb = null, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, $4d82739dd229d539$var$Sb = {
    onError: function(a) {
        $4d82739dd229d539$var$Ob = !0;
        $4d82739dd229d539$var$Pb = a;
    }
};
function $4d82739dd229d539$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Ob = !1;
    $4d82739dd229d539$var$Pb = null;
    $4d82739dd229d539$var$Nb.apply($4d82739dd229d539$var$Sb, arguments);
}
function $4d82739dd229d539$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Tb.apply(this, arguments);
    if ($4d82739dd229d539$var$Ob) {
        if ($4d82739dd229d539$var$Ob) {
            var l = $4d82739dd229d539$var$Pb;
            $4d82739dd229d539$var$Ob = !1;
            $4d82739dd229d539$var$Pb = null;
        } else throw Error($4d82739dd229d539$var$p(198));
        $4d82739dd229d539$var$Qb || ($4d82739dd229d539$var$Qb = !0, $4d82739dd229d539$var$Rb = l);
    }
}
function $4d82739dd229d539$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4d82739dd229d539$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4d82739dd229d539$var$Xb(a) {
    if ($4d82739dd229d539$var$Vb(a) !== a) throw Error($4d82739dd229d539$var$p(188));
}
function $4d82739dd229d539$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4d82739dd229d539$var$Vb(a);
        if (null === b) throw Error($4d82739dd229d539$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4d82739dd229d539$var$Xb(e), a;
                if (f === d) return $4d82739dd229d539$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4d82739dd229d539$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4d82739dd229d539$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4d82739dd229d539$var$p(190));
    }
    if (3 !== c.tag) throw Error($4d82739dd229d539$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4d82739dd229d539$var$Zb(a) {
    a = $4d82739dd229d539$var$Yb(a);
    return null !== a ? $4d82739dd229d539$var$$b(a) : null;
}
function $4d82739dd229d539$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4d82739dd229d539$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$ac = $33s19.unstable_scheduleCallback, $4d82739dd229d539$var$bc = $33s19.unstable_cancelCallback, $4d82739dd229d539$var$cc = $33s19.unstable_shouldYield, $4d82739dd229d539$var$dc = $33s19.unstable_requestPaint, $4d82739dd229d539$var$B = $33s19.unstable_now, $4d82739dd229d539$var$ec = $33s19.unstable_getCurrentPriorityLevel, $4d82739dd229d539$var$fc = $33s19.unstable_ImmediatePriority, $4d82739dd229d539$var$gc = $33s19.unstable_UserBlockingPriority, $4d82739dd229d539$var$hc = $33s19.unstable_NormalPriority, $4d82739dd229d539$var$ic = $33s19.unstable_LowPriority, $4d82739dd229d539$var$jc = $33s19.unstable_IdlePriority, $4d82739dd229d539$var$kc = null, $4d82739dd229d539$var$lc = null;
function $4d82739dd229d539$var$mc(a) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberRoot) try {
        $4d82739dd229d539$var$lc.onCommitFiberRoot($4d82739dd229d539$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $4d82739dd229d539$var$oc = Math.clz32 ? Math.clz32 : $4d82739dd229d539$var$nc, $4d82739dd229d539$var$pc = Math.log, $4d82739dd229d539$var$qc = Math.LN2;
function $4d82739dd229d539$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4d82739dd229d539$var$pc(a) / $4d82739dd229d539$var$qc | 0) | 0;
}
var $4d82739dd229d539$var$rc = 64, $4d82739dd229d539$var$sc = 4194304;
function $4d82739dd229d539$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4d82739dd229d539$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4d82739dd229d539$var$tc(h) : (f &= g, 0 !== f && (d = $4d82739dd229d539$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $4d82739dd229d539$var$tc(g) : 0 !== f && (d = $4d82739dd229d539$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4d82739dd229d539$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4d82739dd229d539$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4d82739dd229d539$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4d82739dd229d539$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4d82739dd229d539$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4d82739dd229d539$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4d82739dd229d539$var$yc() {
    var a = $4d82739dd229d539$var$rc;
    $4d82739dd229d539$var$rc <<= 1;
    0 === ($4d82739dd229d539$var$rc & 4194240) && ($4d82739dd229d539$var$rc = 64);
    return a;
}
function $4d82739dd229d539$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4d82739dd229d539$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4d82739dd229d539$var$oc(b);
    a[b] = c;
}
function $4d82739dd229d539$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4d82739dd229d539$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4d82739dd229d539$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4d82739dd229d539$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $4d82739dd229d539$var$C = 0;
function $4d82739dd229d539$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4d82739dd229d539$var$Ec, $4d82739dd229d539$var$Fc, $4d82739dd229d539$var$Gc, $4d82739dd229d539$var$Hc, $4d82739dd229d539$var$Ic, $4d82739dd229d539$var$Jc = !1, $4d82739dd229d539$var$Kc = [], $4d82739dd229d539$var$Lc = null, $4d82739dd229d539$var$Mc = null, $4d82739dd229d539$var$Nc = null, $4d82739dd229d539$var$Oc = new Map, $4d82739dd229d539$var$Pc = new Map, $4d82739dd229d539$var$Qc = [], $4d82739dd229d539$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4d82739dd229d539$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4d82739dd229d539$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4d82739dd229d539$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $4d82739dd229d539$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $4d82739dd229d539$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4d82739dd229d539$var$Pc.delete(b.pointerId);
    }
}
function $4d82739dd229d539$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4d82739dd229d539$var$Cb(b), null !== b && $4d82739dd229d539$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4d82739dd229d539$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4d82739dd229d539$var$Lc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $4d82739dd229d539$var$Mc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $4d82739dd229d539$var$Nc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4d82739dd229d539$var$Oc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4d82739dd229d539$var$Pc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4d82739dd229d539$var$Vc(a) {
    var b = $4d82739dd229d539$var$Wc(a.target);
    if (null !== b) {
        var c = $4d82739dd229d539$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4d82739dd229d539$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4d82739dd229d539$var$Ic(a.priority, function() {
                        $4d82739dd229d539$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4d82739dd229d539$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4d82739dd229d539$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4d82739dd229d539$var$wb = d;
            c.target.dispatchEvent(d);
            $4d82739dd229d539$var$wb = null;
        } else return b = $4d82739dd229d539$var$Cb(c), null !== b && $4d82739dd229d539$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4d82739dd229d539$var$Zc(a, b, c) {
    $4d82739dd229d539$var$Xc(a) && c.delete(b);
}
function $4d82739dd229d539$var$$c() {
    $4d82739dd229d539$var$Jc = !1;
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Lc) && ($4d82739dd229d539$var$Lc = null);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Mc) && ($4d82739dd229d539$var$Mc = null);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Nc) && ($4d82739dd229d539$var$Nc = null);
    $4d82739dd229d539$var$Oc.forEach($4d82739dd229d539$var$Zc);
    $4d82739dd229d539$var$Pc.forEach($4d82739dd229d539$var$Zc);
}
function $4d82739dd229d539$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4d82739dd229d539$var$Jc || ($4d82739dd229d539$var$Jc = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, $4d82739dd229d539$var$$c)));
}
function $4d82739dd229d539$var$bd(a) {
    function b(b) {
        return $4d82739dd229d539$var$ad(b, a);
    }
    if (0 < $4d82739dd229d539$var$Kc.length) {
        $4d82739dd229d539$var$ad($4d82739dd229d539$var$Kc[0], a);
        for(var c = 1; c < $4d82739dd229d539$var$Kc.length; c++){
            var d = $4d82739dd229d539$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Lc, a);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Mc, a);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Nc, a);
    $4d82739dd229d539$var$Oc.forEach(b);
    $4d82739dd229d539$var$Pc.forEach(b);
    for(c = 0; c < $4d82739dd229d539$var$Qc.length; c++)d = $4d82739dd229d539$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4d82739dd229d539$var$Qc.length && (c = $4d82739dd229d539$var$Qc[0], null === c.blockedOn);)$4d82739dd229d539$var$Vc(c), null === c.blockedOn && $4d82739dd229d539$var$Qc.shift();
}
var $4d82739dd229d539$var$cd = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$dd = !0;
function $4d82739dd229d539$var$ed(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$gd(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 4, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$fd(a, b, c, d) {
    if ($4d82739dd229d539$var$dd) {
        var e = $4d82739dd229d539$var$Yc(a, b, c, d);
        if (null === e) $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c), $4d82739dd229d539$var$Sc(a, d);
        else if ($4d82739dd229d539$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($4d82739dd229d539$var$Sc(a, d), b & 4 && -1 < $4d82739dd229d539$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $4d82739dd229d539$var$Cb(e);
                null !== f && $4d82739dd229d539$var$Ec(f);
                f = $4d82739dd229d539$var$Yc(a, b, c, d);
                null === f && $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4d82739dd229d539$var$hd(a, b, d, null, c);
    }
}
var $4d82739dd229d539$var$id = null;
function $4d82739dd229d539$var$Yc(a, b, c, d) {
    $4d82739dd229d539$var$id = null;
    a = $4d82739dd229d539$var$xb(d);
    a = $4d82739dd229d539$var$Wc(a);
    if (null !== a) {
        if (b = $4d82739dd229d539$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4d82739dd229d539$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4d82739dd229d539$var$id = a;
    return null;
}
function $4d82739dd229d539$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4d82739dd229d539$var$ec()){
                case $4d82739dd229d539$var$fc:
                    return 1;
                case $4d82739dd229d539$var$gc:
                    return 4;
                case $4d82739dd229d539$var$hc:
                case $4d82739dd229d539$var$ic:
                    return 16;
                case $4d82739dd229d539$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ld = null, $4d82739dd229d539$var$md = null;
function $4d82739dd229d539$var$nd() {
    if ($4d82739dd229d539$var$md) return $4d82739dd229d539$var$md;
    var a, b = $4d82739dd229d539$var$ld, c = b.length, d, e = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4d82739dd229d539$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4d82739dd229d539$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4d82739dd229d539$var$pd() {
    return !0;
}
function $4d82739dd229d539$var$qd() {
    return !1;
}
function $4d82739dd229d539$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4d82739dd229d539$var$pd : $4d82739dd229d539$var$qd;
        this.isPropagationStopped = $4d82739dd229d539$var$qd;
        return this;
    }
    $4d82739dd229d539$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4d82739dd229d539$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4d82739dd229d539$var$pd);
        },
        persist: function() {},
        isPersistent: $4d82739dd229d539$var$pd
    });
    return b;
}
var $4d82739dd229d539$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4d82739dd229d539$var$td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$sd), $4d82739dd229d539$var$ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    view: 0,
    detail: 0
}), $4d82739dd229d539$var$vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$ud), $4d82739dd229d539$var$wd, $4d82739dd229d539$var$xd, $4d82739dd229d539$var$yd, $4d82739dd229d539$var$Ad = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4d82739dd229d539$var$yd && ($4d82739dd229d539$var$yd && "mousemove" === a.type ? ($4d82739dd229d539$var$wd = a.screenX - $4d82739dd229d539$var$yd.screenX, $4d82739dd229d539$var$xd = a.screenY - $4d82739dd229d539$var$yd.screenY) : $4d82739dd229d539$var$xd = $4d82739dd229d539$var$wd = 0, $4d82739dd229d539$var$yd = a);
        return $4d82739dd229d539$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4d82739dd229d539$var$xd;
    }
}), $4d82739dd229d539$var$Bd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ad), $4d82739dd229d539$var$Cd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    dataTransfer: 0
}), $4d82739dd229d539$var$Dd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Cd), $4d82739dd229d539$var$Ed = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    relatedTarget: 0
}), $4d82739dd229d539$var$Fd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ed), $4d82739dd229d539$var$Gd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Hd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Gd), $4d82739dd229d539$var$Id = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4d82739dd229d539$var$Jd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Id), $4d82739dd229d539$var$Kd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    data: 0
}), $4d82739dd229d539$var$Ld = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Kd), $4d82739dd229d539$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4d82739dd229d539$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4d82739dd229d539$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4d82739dd229d539$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4d82739dd229d539$var$Od[a]) ? !!b[a] : !1;
}
function $4d82739dd229d539$var$zd() {
    return $4d82739dd229d539$var$Pd;
}
var $4d82739dd229d539$var$Qd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $4d82739dd229d539$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4d82739dd229d539$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4d82739dd229d539$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4d82739dd229d539$var$Rd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Qd), $4d82739dd229d539$var$Sd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4d82739dd229d539$var$Td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Sd), $4d82739dd229d539$var$Ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4d82739dd229d539$var$zd
}), $4d82739dd229d539$var$Vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ud), $4d82739dd229d539$var$Wd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Xd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Wd), $4d82739dd229d539$var$Yd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4d82739dd229d539$var$Zd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Yd), $4d82739dd229d539$var$$d = [
    9,
    13,
    27,
    32
], $4d82739dd229d539$var$ae = $4d82739dd229d539$var$ia && "CompositionEvent" in window, $4d82739dd229d539$var$be = null;
$4d82739dd229d539$var$ia && "documentMode" in document && ($4d82739dd229d539$var$be = document.documentMode);
var $4d82739dd229d539$var$ce = $4d82739dd229d539$var$ia && "TextEvent" in window && !$4d82739dd229d539$var$be, $4d82739dd229d539$var$de = $4d82739dd229d539$var$ia && (!$4d82739dd229d539$var$ae || $4d82739dd229d539$var$be && 8 < $4d82739dd229d539$var$be && 11 >= $4d82739dd229d539$var$be), $4d82739dd229d539$var$ee = String.fromCharCode(32), $4d82739dd229d539$var$fe = !1;
function $4d82739dd229d539$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4d82739dd229d539$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4d82739dd229d539$var$ie = !1;
function $4d82739dd229d539$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $4d82739dd229d539$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4d82739dd229d539$var$fe = !0;
            return $4d82739dd229d539$var$ee;
        case "textInput":
            return a = b.data, a === $4d82739dd229d539$var$ee && $4d82739dd229d539$var$fe ? null : a;
        default:
            return null;
    }
}
function $4d82739dd229d539$var$ke(a, b) {
    if ($4d82739dd229d539$var$ie) return "compositionend" === a || !$4d82739dd229d539$var$ae && $4d82739dd229d539$var$ge(a, b) ? (a = $4d82739dd229d539$var$nd(), $4d82739dd229d539$var$md = $4d82739dd229d539$var$ld = $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4d82739dd229d539$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4d82739dd229d539$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4d82739dd229d539$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $4d82739dd229d539$var$ne(a, b, c, d) {
    $4d82739dd229d539$var$Eb(d);
    b = $4d82739dd229d539$var$oe(b, "onChange");
    0 < b.length && (c = new $4d82739dd229d539$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4d82739dd229d539$var$pe = null, $4d82739dd229d539$var$qe = null;
function $4d82739dd229d539$var$re(a) {
    $4d82739dd229d539$var$se(a, 0);
}
function $4d82739dd229d539$var$te(a) {
    var b = $4d82739dd229d539$var$ue(a);
    if ($4d82739dd229d539$var$Wa(b)) return a;
}
function $4d82739dd229d539$var$ve(a, b) {
    if ("change" === a) return b;
}
var $4d82739dd229d539$var$we = !1;
if ($4d82739dd229d539$var$ia) {
    var $4d82739dd229d539$var$xe;
    if ($4d82739dd229d539$var$ia) {
        var $4d82739dd229d539$var$ye = "oninput" in document;
        if (!$4d82739dd229d539$var$ye) {
            var $4d82739dd229d539$var$ze = document.createElement("div");
            $4d82739dd229d539$var$ze.setAttribute("oninput", "return;");
            $4d82739dd229d539$var$ye = "function" === typeof $4d82739dd229d539$var$ze.oninput;
        }
        $4d82739dd229d539$var$xe = $4d82739dd229d539$var$ye;
    } else $4d82739dd229d539$var$xe = !1;
    $4d82739dd229d539$var$we = $4d82739dd229d539$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $4d82739dd229d539$var$Ae() {
    $4d82739dd229d539$var$pe && ($4d82739dd229d539$var$pe.detachEvent("onpropertychange", $4d82739dd229d539$var$Be), $4d82739dd229d539$var$qe = $4d82739dd229d539$var$pe = null);
}
function $4d82739dd229d539$var$Be(a) {
    if ("value" === a.propertyName && $4d82739dd229d539$var$te($4d82739dd229d539$var$qe)) {
        var b = [];
        $4d82739dd229d539$var$ne(b, $4d82739dd229d539$var$qe, a, $4d82739dd229d539$var$xb(a));
        $4d82739dd229d539$var$Jb($4d82739dd229d539$var$re, b);
    }
}
function $4d82739dd229d539$var$Ce(a, b, c) {
    "focusin" === a ? ($4d82739dd229d539$var$Ae(), $4d82739dd229d539$var$pe = b, $4d82739dd229d539$var$qe = c, $4d82739dd229d539$var$pe.attachEvent("onpropertychange", $4d82739dd229d539$var$Be)) : "focusout" === a && $4d82739dd229d539$var$Ae();
}
function $4d82739dd229d539$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4d82739dd229d539$var$te($4d82739dd229d539$var$qe);
}
function $4d82739dd229d539$var$Ee(a, b) {
    if ("click" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4d82739dd229d539$var$He = "function" === typeof Object.is ? Object.is : $4d82739dd229d539$var$Ge;
function $4d82739dd229d539$var$Ie(a, b) {
    if ($4d82739dd229d539$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4d82739dd229d539$var$ja.call(b, e) || !$4d82739dd229d539$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $4d82739dd229d539$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4d82739dd229d539$var$Ke(a, b) {
    var c = $4d82739dd229d539$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4d82739dd229d539$var$Je(c);
    }
}
function $4d82739dd229d539$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4d82739dd229d539$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4d82739dd229d539$var$Me() {
    for(var a = window, b = $4d82739dd229d539$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4d82739dd229d539$var$Xa(a.document);
    }
    return b;
}
function $4d82739dd229d539$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4d82739dd229d539$var$Oe(a) {
    var b = $4d82739dd229d539$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4d82739dd229d539$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4d82739dd229d539$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4d82739dd229d539$var$Ke(c, f);
                var g = $4d82739dd229d539$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4d82739dd229d539$var$Pe = $4d82739dd229d539$var$ia && "documentMode" in document && 11 >= document.documentMode, $4d82739dd229d539$var$Qe = null, $4d82739dd229d539$var$Re = null, $4d82739dd229d539$var$Se = null, $4d82739dd229d539$var$Te = !1;
function $4d82739dd229d539$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4d82739dd229d539$var$Te || null == $4d82739dd229d539$var$Qe || $4d82739dd229d539$var$Qe !== $4d82739dd229d539$var$Xa(d) || (d = $4d82739dd229d539$var$Qe, "selectionStart" in d && $4d82739dd229d539$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4d82739dd229d539$var$Se && $4d82739dd229d539$var$Ie($4d82739dd229d539$var$Se, d) || ($4d82739dd229d539$var$Se = d, d = $4d82739dd229d539$var$oe($4d82739dd229d539$var$Re, "onSelect"), 0 < d.length && (b = new $4d82739dd229d539$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4d82739dd229d539$var$Qe)));
}
function $4d82739dd229d539$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4d82739dd229d539$var$We = {
    animationend: $4d82739dd229d539$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $4d82739dd229d539$var$Ve("Animation", "AnimationIteration"),
    animationstart: $4d82739dd229d539$var$Ve("Animation", "AnimationStart"),
    transitionend: $4d82739dd229d539$var$Ve("Transition", "TransitionEnd")
}, $4d82739dd229d539$var$Xe = {}, $4d82739dd229d539$var$Ye = {};
$4d82739dd229d539$var$ia && ($4d82739dd229d539$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $4d82739dd229d539$var$We.animationend.animation, delete $4d82739dd229d539$var$We.animationiteration.animation, delete $4d82739dd229d539$var$We.animationstart.animation), "TransitionEvent" in window || delete $4d82739dd229d539$var$We.transitionend.transition);
function $4d82739dd229d539$var$Ze(a) {
    if ($4d82739dd229d539$var$Xe[a]) return $4d82739dd229d539$var$Xe[a];
    if (!$4d82739dd229d539$var$We[a]) return a;
    var b = $4d82739dd229d539$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4d82739dd229d539$var$Ye) return $4d82739dd229d539$var$Xe[a] = b[c];
    return a;
}
var $4d82739dd229d539$var$$e = $4d82739dd229d539$var$Ze("animationend"), $4d82739dd229d539$var$af = $4d82739dd229d539$var$Ze("animationiteration"), $4d82739dd229d539$var$bf = $4d82739dd229d539$var$Ze("animationstart"), $4d82739dd229d539$var$cf = $4d82739dd229d539$var$Ze("transitionend"), $4d82739dd229d539$var$df = new Map, $4d82739dd229d539$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4d82739dd229d539$var$ff(a, b) {
    $4d82739dd229d539$var$df.set(a, b);
    $4d82739dd229d539$var$fa(b, [
        a
    ]);
}
for(var $4d82739dd229d539$var$gf = 0; $4d82739dd229d539$var$gf < $4d82739dd229d539$var$ef.length; $4d82739dd229d539$var$gf++){
    var $4d82739dd229d539$var$hf = $4d82739dd229d539$var$ef[$4d82739dd229d539$var$gf], $4d82739dd229d539$var$jf = $4d82739dd229d539$var$hf.toLowerCase(), $4d82739dd229d539$var$kf = $4d82739dd229d539$var$hf[0].toUpperCase() + $4d82739dd229d539$var$hf.slice(1);
    $4d82739dd229d539$var$ff($4d82739dd229d539$var$jf, "on" + $4d82739dd229d539$var$kf);
}
$4d82739dd229d539$var$ff($4d82739dd229d539$var$$e, "onAnimationEnd");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$af, "onAnimationIteration");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$bf, "onAnimationStart");
$4d82739dd229d539$var$ff("dblclick", "onDoubleClick");
$4d82739dd229d539$var$ff("focusin", "onFocus");
$4d82739dd229d539$var$ff("focusout", "onBlur");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$cf, "onTransitionEnd");
$4d82739dd229d539$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4d82739dd229d539$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4d82739dd229d539$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4d82739dd229d539$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($4d82739dd229d539$var$lf));
function $4d82739dd229d539$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4d82739dd229d539$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4d82739dd229d539$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($4d82739dd229d539$var$Qb) throw a = $4d82739dd229d539$var$Rb, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, a;
}
function $4d82739dd229d539$var$D(a, b) {
    var c = b[$4d82739dd229d539$var$of];
    void 0 === c && (c = b[$4d82739dd229d539$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4d82739dd229d539$var$pf(b, a, 2, !1), c.add(d));
}
function $4d82739dd229d539$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4d82739dd229d539$var$pf(c, a, d, b);
}
var $4d82739dd229d539$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $4d82739dd229d539$var$sf(a) {
    if (!a[$4d82739dd229d539$var$rf]) {
        a[$4d82739dd229d539$var$rf] = !0;
        $4d82739dd229d539$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4d82739dd229d539$var$mf.has(b) || $4d82739dd229d539$var$qf(b, !1, a), $4d82739dd229d539$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4d82739dd229d539$var$rf] || (b[$4d82739dd229d539$var$rf] = !0, $4d82739dd229d539$var$qf("selectionchange", !1, b));
    }
}
function $4d82739dd229d539$var$pf(a, b, c, d) {
    switch($4d82739dd229d539$var$jd(b)){
        case 1:
            var e = $4d82739dd229d539$var$ed;
            break;
        case 4:
            e = $4d82739dd229d539$var$gd;
            break;
        default:
            e = $4d82739dd229d539$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4d82739dd229d539$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4d82739dd229d539$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4d82739dd229d539$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4d82739dd229d539$var$Jb(function() {
        var d = f, e = $4d82739dd229d539$var$xb(c), g = [];
        a: {
            var h = $4d82739dd229d539$var$df.get(a);
            if (void 0 !== h) {
                var k = $4d82739dd229d539$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $4d82739dd229d539$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4d82739dd229d539$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4d82739dd229d539$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4d82739dd229d539$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4d82739dd229d539$var$Vd;
                        break;
                    case $4d82739dd229d539$var$$e:
                    case $4d82739dd229d539$var$af:
                    case $4d82739dd229d539$var$bf:
                        k = $4d82739dd229d539$var$Hd;
                        break;
                    case $4d82739dd229d539$var$cf:
                        k = $4d82739dd229d539$var$Xd;
                        break;
                    case "scroll":
                        k = $4d82739dd229d539$var$vd;
                        break;
                    case "wheel":
                        k = $4d82739dd229d539$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4d82739dd229d539$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4d82739dd229d539$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $4d82739dd229d539$var$Kb(w, x), null != F && t.push($4d82739dd229d539$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4d82739dd229d539$var$wb && (n = c.relatedTarget || c.fromElement) && ($4d82739dd229d539$var$Wc(n) || n[$4d82739dd229d539$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $4d82739dd229d539$var$Wc(n) : null, null !== n && (J = $4d82739dd229d539$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $4d82739dd229d539$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $4d82739dd229d539$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $4d82739dd229d539$var$ue(k);
                        u = null == n ? h : $4d82739dd229d539$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $4d82739dd229d539$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $4d82739dd229d539$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $4d82739dd229d539$var$vf(F))u++;
                            for(; 0 < w - u;)t = $4d82739dd229d539$var$vf(t), w--;
                            for(; 0 < u - w;)x = $4d82739dd229d539$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $4d82739dd229d539$var$vf(t);
                                x = $4d82739dd229d539$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $4d82739dd229d539$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $4d82739dd229d539$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $4d82739dd229d539$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $4d82739dd229d539$var$ve;
                else if ($4d82739dd229d539$var$me(h)) {
                    if ($4d82739dd229d539$var$we) na = $4d82739dd229d539$var$Fe;
                    else {
                        na = $4d82739dd229d539$var$De;
                        var xa = $4d82739dd229d539$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $4d82739dd229d539$var$Ee);
                if (na && (na = na(a, d))) {
                    $4d82739dd229d539$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $4d82739dd229d539$var$cb(h, "number", h.value);
            }
            xa = d ? $4d82739dd229d539$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($4d82739dd229d539$var$me(xa) || "true" === xa.contentEditable) $4d82739dd229d539$var$Qe = xa, $4d82739dd229d539$var$Re = d, $4d82739dd229d539$var$Se = null;
                    break;
                case "focusout":
                    $4d82739dd229d539$var$Se = $4d82739dd229d539$var$Re = $4d82739dd229d539$var$Qe = null;
                    break;
                case "mousedown":
                    $4d82739dd229d539$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4d82739dd229d539$var$Te = !1;
                    $4d82739dd229d539$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($4d82739dd229d539$var$Pe) break;
                case "keydown":
                case "keyup":
                    $4d82739dd229d539$var$Ue(g, c, e);
            }
            var $a;
            if ($4d82739dd229d539$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $4d82739dd229d539$var$ie ? $4d82739dd229d539$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($4d82739dd229d539$var$de && "ko" !== c.locale && ($4d82739dd229d539$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $4d82739dd229d539$var$ie && ($a = $4d82739dd229d539$var$nd()) : ($4d82739dd229d539$var$kd = e, $4d82739dd229d539$var$ld = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, $4d82739dd229d539$var$ie = !0)), xa = $4d82739dd229d539$var$oe(d, ba), 0 < xa.length && (ba = new $4d82739dd229d539$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $4d82739dd229d539$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $4d82739dd229d539$var$ce ? $4d82739dd229d539$var$je(a, c) : $4d82739dd229d539$var$ke(a, c)) d = $4d82739dd229d539$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $4d82739dd229d539$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $4d82739dd229d539$var$se(g, b);
    });
}
function $4d82739dd229d539$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4d82739dd229d539$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4d82739dd229d539$var$Kb(a, c), null != f && d.unshift($4d82739dd229d539$var$tf(a, f, e)), f = $4d82739dd229d539$var$Kb(a, b), null != f && d.push($4d82739dd229d539$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4d82739dd229d539$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4d82739dd229d539$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.unshift($4d82739dd229d539$var$tf(c, k, h))) : e || (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.push($4d82739dd229d539$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4d82739dd229d539$var$xf = /\r\n?/g, $4d82739dd229d539$var$yf = /\u0000|\uFFFD/g;
function $4d82739dd229d539$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4d82739dd229d539$var$xf, "\n").replace($4d82739dd229d539$var$yf, "");
}
function $4d82739dd229d539$var$Af(a, b, c) {
    b = $4d82739dd229d539$var$zf(b);
    if ($4d82739dd229d539$var$zf(a) !== b && c) throw Error($4d82739dd229d539$var$p(425));
}
function $4d82739dd229d539$var$Bf() {}
var $4d82739dd229d539$var$Cf = null, $4d82739dd229d539$var$Df = null;
function $4d82739dd229d539$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4d82739dd229d539$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $4d82739dd229d539$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4d82739dd229d539$var$Hf = "function" === typeof Promise ? Promise : void 0, $4d82739dd229d539$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4d82739dd229d539$var$Hf ? function(a) {
    return $4d82739dd229d539$var$Hf.resolve(null).then(a).catch($4d82739dd229d539$var$If);
} : $4d82739dd229d539$var$Ff;
function $4d82739dd229d539$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4d82739dd229d539$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4d82739dd229d539$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4d82739dd229d539$var$bd(b);
}
function $4d82739dd229d539$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4d82739dd229d539$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nf = Math.random().toString(36).slice(2), $4d82739dd229d539$var$Of = "__reactFiber$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Pf = "__reactProps$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$uf = "__reactContainer$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$of = "__reactEvents$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Qf = "__reactListeners$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Rf = "__reactHandles$" + $4d82739dd229d539$var$Nf;
function $4d82739dd229d539$var$Wc(a) {
    var b = a[$4d82739dd229d539$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4d82739dd229d539$var$uf] || c[$4d82739dd229d539$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4d82739dd229d539$var$Mf(a); null !== a;){
                if (c = a[$4d82739dd229d539$var$Of]) return c;
                a = $4d82739dd229d539$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4d82739dd229d539$var$Cb(a) {
    a = a[$4d82739dd229d539$var$Of] || a[$4d82739dd229d539$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4d82739dd229d539$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4d82739dd229d539$var$p(33));
}
function $4d82739dd229d539$var$Db(a) {
    return a[$4d82739dd229d539$var$Pf] || null;
}
var $4d82739dd229d539$var$Sf = [], $4d82739dd229d539$var$Tf = -1;
function $4d82739dd229d539$var$Uf(a) {
    return {
        current: a
    };
}
function $4d82739dd229d539$var$E(a) {
    0 > $4d82739dd229d539$var$Tf || (a.current = $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf], $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = null, $4d82739dd229d539$var$Tf--);
}
function $4d82739dd229d539$var$G(a, b) {
    $4d82739dd229d539$var$Tf++;
    $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = a.current;
    a.current = b;
}
var $4d82739dd229d539$var$Vf = {}, $4d82739dd229d539$var$H = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Vf), $4d82739dd229d539$var$Wf = $4d82739dd229d539$var$Uf(!1), $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$Vf;
function $4d82739dd229d539$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4d82739dd229d539$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4d82739dd229d539$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4d82739dd229d539$var$$f() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
}
function $4d82739dd229d539$var$ag(a, b, c) {
    if ($4d82739dd229d539$var$H.current !== $4d82739dd229d539$var$Vf) throw Error($4d82739dd229d539$var$p(168));
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
function $4d82739dd229d539$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4d82739dd229d539$var$p(108, $4d82739dd229d539$var$Ra(a) || "Unknown", e));
    return $4d82739dd229d539$var$A({}, c, d);
}
function $4d82739dd229d539$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4d82739dd229d539$var$Vf;
    $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$H.current;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, $4d82739dd229d539$var$Wf.current);
    return !0;
}
function $4d82739dd229d539$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4d82739dd229d539$var$p(169));
    c ? (a = $4d82739dd229d539$var$bg(a, b, $4d82739dd229d539$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a)) : $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
var $4d82739dd229d539$var$eg = null, $4d82739dd229d539$var$fg = !1, $4d82739dd229d539$var$gg = !1;
function $4d82739dd229d539$var$hg(a) {
    null === $4d82739dd229d539$var$eg ? $4d82739dd229d539$var$eg = [
        a
    ] : $4d82739dd229d539$var$eg.push(a);
}
function $4d82739dd229d539$var$ig(a) {
    $4d82739dd229d539$var$fg = !0;
    $4d82739dd229d539$var$hg(a);
}
function $4d82739dd229d539$var$jg() {
    if (!$4d82739dd229d539$var$gg && null !== $4d82739dd229d539$var$eg) {
        $4d82739dd229d539$var$gg = !0;
        var a = 0, b = $4d82739dd229d539$var$C;
        try {
            var c = $4d82739dd229d539$var$eg;
            for($4d82739dd229d539$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4d82739dd229d539$var$eg = null;
            $4d82739dd229d539$var$fg = !1;
        } catch (e) {
            throw null !== $4d82739dd229d539$var$eg && ($4d82739dd229d539$var$eg = $4d82739dd229d539$var$eg.slice(a + 1)), $4d82739dd229d539$var$ac($4d82739dd229d539$var$fc, $4d82739dd229d539$var$jg), e;
        } finally{
            $4d82739dd229d539$var$C = b, $4d82739dd229d539$var$gg = !1;
        }
    }
    return null;
}
var $4d82739dd229d539$var$kg = [], $4d82739dd229d539$var$lg = 0, $4d82739dd229d539$var$mg = null, $4d82739dd229d539$var$ng = 0, $4d82739dd229d539$var$og = [], $4d82739dd229d539$var$pg = 0, $4d82739dd229d539$var$qg = null, $4d82739dd229d539$var$rg = 1, $4d82739dd229d539$var$sg = "";
function $4d82739dd229d539$var$tg(a, b) {
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$ng;
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$mg;
    $4d82739dd229d539$var$mg = a;
    $4d82739dd229d539$var$ng = b;
}
function $4d82739dd229d539$var$ug(a, b, c) {
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg;
    $4d82739dd229d539$var$qg = a;
    var d = $4d82739dd229d539$var$rg;
    a = $4d82739dd229d539$var$sg;
    var e = 32 - $4d82739dd229d539$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4d82739dd229d539$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4d82739dd229d539$var$rg = 1 << 32 - $4d82739dd229d539$var$oc(b) + e | c << e | d;
        $4d82739dd229d539$var$sg = f + a;
    } else $4d82739dd229d539$var$rg = 1 << f | c << e | d, $4d82739dd229d539$var$sg = a;
}
function $4d82739dd229d539$var$vg(a) {
    null !== a.return && ($4d82739dd229d539$var$tg(a, 1), $4d82739dd229d539$var$ug(a, 1, 0));
}
function $4d82739dd229d539$var$wg(a) {
    for(; a === $4d82739dd229d539$var$mg;)$4d82739dd229d539$var$mg = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null, $4d82739dd229d539$var$ng = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null;
    for(; a === $4d82739dd229d539$var$qg;)$4d82739dd229d539$var$qg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$sg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$rg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null;
}
var $4d82739dd229d539$var$xg = null, $4d82739dd229d539$var$yg = null, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$zg = null;
function $4d82739dd229d539$var$Ag(a, b) {
    var c = $4d82739dd229d539$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4d82739dd229d539$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4d82739dd229d539$var$qg ? {
                id: $4d82739dd229d539$var$rg,
                overflow: $4d82739dd229d539$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4d82739dd229d539$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4d82739dd229d539$var$Eg(a) {
    if ($4d82739dd229d539$var$I) {
        var b = $4d82739dd229d539$var$yg;
        if (b) {
            var c = b;
            if (!$4d82739dd229d539$var$Cg(a, b)) {
                if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
                b = $4d82739dd229d539$var$Lf(c.nextSibling);
                var d = $4d82739dd229d539$var$xg;
                b && $4d82739dd229d539$var$Cg(a, b) ? $4d82739dd229d539$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$xg = a);
            }
        } else {
            if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4d82739dd229d539$var$I = !1;
            $4d82739dd229d539$var$xg = a;
        }
    }
}
function $4d82739dd229d539$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4d82739dd229d539$var$xg = a;
}
function $4d82739dd229d539$var$Gg(a) {
    if (a !== $4d82739dd229d539$var$xg) return !1;
    if (!$4d82739dd229d539$var$I) return $4d82739dd229d539$var$Fg(a), $4d82739dd229d539$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4d82739dd229d539$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $4d82739dd229d539$var$yg)) {
        if ($4d82739dd229d539$var$Dg(a)) throw $4d82739dd229d539$var$Hg(), Error($4d82739dd229d539$var$p(418));
        for(; b;)$4d82739dd229d539$var$Ag(a, b), b = $4d82739dd229d539$var$Lf(b.nextSibling);
    }
    $4d82739dd229d539$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4d82739dd229d539$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4d82739dd229d539$var$yg = null;
        }
    } else $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg ? $4d82739dd229d539$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4d82739dd229d539$var$Hg() {
    for(var a = $4d82739dd229d539$var$yg; a;)a = $4d82739dd229d539$var$Lf(a.nextSibling);
}
function $4d82739dd229d539$var$Ig() {
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg = null;
    $4d82739dd229d539$var$I = !1;
}
function $4d82739dd229d539$var$Jg(a) {
    null === $4d82739dd229d539$var$zg ? $4d82739dd229d539$var$zg = [
        a
    ] : $4d82739dd229d539$var$zg.push(a);
}
var $4d82739dd229d539$var$Kg = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig;
function $4d82739dd229d539$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4d82739dd229d539$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4d82739dd229d539$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4d82739dd229d539$var$p(284));
        if (!c._owner) throw Error($4d82739dd229d539$var$p(290, a));
    }
    return a;
}
function $4d82739dd229d539$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4d82739dd229d539$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4d82739dd229d539$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $4d82739dd229d539$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4d82739dd229d539$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4d82739dd229d539$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4d82739dd229d539$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $4d82739dd229d539$var$Lg(a, b, c), d.return = a, d;
        d = $4d82739dd229d539$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4d82739dd229d539$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4d82739dd229d539$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4d82739dd229d539$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4d82739dd229d539$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c = $4d82739dd229d539$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $4d82739dd229d539$var$Lg(a, null, b), c.return = a, c;
                case $4d82739dd229d539$var$wa:
                    return b = $4d82739dd229d539$var$Sg(b, a.mode, c), b.return = a, b;
                case $4d82739dd229d539$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4d82739dd229d539$var$eb(b) || $4d82739dd229d539$var$Ka(b)) return b = $4d82739dd229d539$var$Tg(b, a.mode, c, null), b.return = a, b;
            $4d82739dd229d539$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4d82739dd229d539$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4d82739dd229d539$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4d82739dd229d539$var$eb(c) || $4d82739dd229d539$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $4d82739dd229d539$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4d82739dd229d539$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4d82739dd229d539$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4d82739dd229d539$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($4d82739dd229d539$var$eb(d) || $4d82739dd229d539$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4d82739dd229d539$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $4d82739dd229d539$var$Ka(h);
        if ("function" !== typeof l) throw Error($4d82739dd229d539$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4d82739dd229d539$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4d82739dd229d539$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4d82739dd229d539$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4d82739dd229d539$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4d82739dd229d539$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4d82739dd229d539$var$ya ? (d = $4d82739dd229d539$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4d82739dd229d539$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $4d82739dd229d539$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4d82739dd229d539$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4d82739dd229d539$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4d82739dd229d539$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($4d82739dd229d539$var$eb(f)) return n(a, d, f, h);
            if ($4d82739dd229d539$var$Ka(f)) return t(a, d, f, h);
            $4d82739dd229d539$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4d82739dd229d539$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $4d82739dd229d539$var$Ug = $4d82739dd229d539$var$Og(!0), $4d82739dd229d539$var$Vg = $4d82739dd229d539$var$Og(!1), $4d82739dd229d539$var$Wg = $4d82739dd229d539$var$Uf(null), $4d82739dd229d539$var$Xg = null, $4d82739dd229d539$var$Yg = null, $4d82739dd229d539$var$Zg = null;
function $4d82739dd229d539$var$$g() {
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Xg = null;
}
function $4d82739dd229d539$var$ah(a) {
    var b = $4d82739dd229d539$var$Wg.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wg);
    a._currentValue = b;
}
function $4d82739dd229d539$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4d82739dd229d539$var$ch(a, b) {
    $4d82739dd229d539$var$Xg = a;
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4d82739dd229d539$var$dh = !0), a.firstContext = null);
}
function $4d82739dd229d539$var$eh(a) {
    var b = a._currentValue;
    if ($4d82739dd229d539$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4d82739dd229d539$var$Yg) {
            if (null === $4d82739dd229d539$var$Xg) throw Error($4d82739dd229d539$var$p(308));
            $4d82739dd229d539$var$Yg = a;
            $4d82739dd229d539$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Yg.next = a;
    }
    return b;
}
var $4d82739dd229d539$var$fh = null;
function $4d82739dd229d539$var$gh(a) {
    null === $4d82739dd229d539$var$fh ? $4d82739dd229d539$var$fh = [
        a
    ] : $4d82739dd229d539$var$fh.push(a);
}
function $4d82739dd229d539$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4d82739dd229d539$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4d82739dd229d539$var$ih(a, d);
}
function $4d82739dd229d539$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4d82739dd229d539$var$jh = !1;
function $4d82739dd229d539$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4d82739dd229d539$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4d82739dd229d539$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4d82739dd229d539$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4d82739dd229d539$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4d82739dd229d539$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4d82739dd229d539$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4d82739dd229d539$var$ih(a, c);
}
function $4d82739dd229d539$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
function $4d82739dd229d539$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4d82739dd229d539$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $4d82739dd229d539$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $4d82739dd229d539$var$A({}, q, r);
                            break a;
                        case 2:
                            $4d82739dd229d539$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4d82739dd229d539$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4d82739dd229d539$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4d82739dd229d539$var$p(191, e));
            e.call(d);
        }
    }
}
var $4d82739dd229d539$var$th = {}, $4d82739dd229d539$var$uh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$vh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$wh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th);
function $4d82739dd229d539$var$xh(a) {
    if (a === $4d82739dd229d539$var$th) throw Error($4d82739dd229d539$var$p(174));
    return a;
}
function $4d82739dd229d539$var$yh(a, b) {
    $4d82739dd229d539$var$G($4d82739dd229d539$var$wh, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, $4d82739dd229d539$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4d82739dd229d539$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4d82739dd229d539$var$lb(b, a);
    }
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, b);
}
function $4d82739dd229d539$var$zh() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$vh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$wh);
}
function $4d82739dd229d539$var$Ah(a) {
    $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
    var b = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
    var c = $4d82739dd229d539$var$lb(b, a.type);
    b !== c && ($4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a), $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, c));
}
function $4d82739dd229d539$var$Bh(a) {
    $4d82739dd229d539$var$vh.current === a && ($4d82739dd229d539$var$E($4d82739dd229d539$var$uh), $4d82739dd229d539$var$E($4d82739dd229d539$var$vh));
}
var $4d82739dd229d539$var$L = $4d82739dd229d539$var$Uf(0);
function $4d82739dd229d539$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$Dh = [];
function $4d82739dd229d539$var$Eh() {
    for(var a = 0; a < $4d82739dd229d539$var$Dh.length; a++)$4d82739dd229d539$var$Dh[a]._workInProgressVersionPrimary = null;
    $4d82739dd229d539$var$Dh.length = 0;
}
var $4d82739dd229d539$var$Fh = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$Gh = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$Hh = 0, $4d82739dd229d539$var$M = null, $4d82739dd229d539$var$N = null, $4d82739dd229d539$var$O = null, $4d82739dd229d539$var$Ih = !1, $4d82739dd229d539$var$Jh = !1, $4d82739dd229d539$var$Kh = 0, $4d82739dd229d539$var$Lh = 0;
function $4d82739dd229d539$var$P() {
    throw Error($4d82739dd229d539$var$p(321));
}
function $4d82739dd229d539$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4d82739dd229d539$var$He(a[c], b[c])) return !1;
    return !0;
}
function $4d82739dd229d539$var$Nh(a, b, c, d, e, f) {
    $4d82739dd229d539$var$Hh = f;
    $4d82739dd229d539$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4d82739dd229d539$var$Fh.current = null === a || null === a.memoizedState ? $4d82739dd229d539$var$Oh : $4d82739dd229d539$var$Ph;
    a = c(d, e);
    if ($4d82739dd229d539$var$Jh) {
        f = 0;
        do {
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            if (25 <= f) throw Error($4d82739dd229d539$var$p(301));
            f += 1;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
            b.updateQueue = null;
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Qh;
            a = c(d, e);
        }while ($4d82739dd229d539$var$Jh);
    }
    $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
    b = null !== $4d82739dd229d539$var$N && null !== $4d82739dd229d539$var$N.next;
    $4d82739dd229d539$var$Hh = 0;
    $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
    $4d82739dd229d539$var$Ih = !1;
    if (b) throw Error($4d82739dd229d539$var$p(300));
    return a;
}
function $4d82739dd229d539$var$Sh() {
    var a = 0 !== $4d82739dd229d539$var$Kh;
    $4d82739dd229d539$var$Kh = 0;
    return a;
}
function $4d82739dd229d539$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Uh() {
    if (null === $4d82739dd229d539$var$N) {
        var a = $4d82739dd229d539$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4d82739dd229d539$var$N.next;
    var b = null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState : $4d82739dd229d539$var$O.next;
    if (null !== b) $4d82739dd229d539$var$O = b, $4d82739dd229d539$var$N = a;
    else {
        if (null === a) throw Error($4d82739dd229d539$var$p(310));
        $4d82739dd229d539$var$N = a;
        a = {
            memoizedState: $4d82739dd229d539$var$N.memoizedState,
            baseState: $4d82739dd229d539$var$N.baseState,
            baseQueue: $4d82739dd229d539$var$N.baseQueue,
            queue: $4d82739dd229d539$var$N.queue,
            next: null
        };
        null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    }
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4d82739dd229d539$var$Wh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4d82739dd229d539$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($4d82739dd229d539$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4d82739dd229d539$var$M.lanes |= m;
                $4d82739dd229d539$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4d82739dd229d539$var$He(d, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4d82739dd229d539$var$M.lanes |= f, $4d82739dd229d539$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4d82739dd229d539$var$Xh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4d82739dd229d539$var$He(f, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4d82739dd229d539$var$Yh() {}
function $4d82739dd229d539$var$Zh(a, b) {
    var c = $4d82739dd229d539$var$M, d = $4d82739dd229d539$var$Uh(), e = b(), f = !$4d82739dd229d539$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $4d82739dd229d539$var$dh = !0);
    d = d.queue;
    $4d82739dd229d539$var$$h($4d82739dd229d539$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4d82739dd229d539$var$O && $4d82739dd229d539$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
        0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(c, b, e);
    }
    return e;
}
function $4d82739dd229d539$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4d82739dd229d539$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
}
function $4d82739dd229d539$var$ai(a, b, c) {
    return c(function() {
        $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
    });
}
function $4d82739dd229d539$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4d82739dd229d539$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $4d82739dd229d539$var$fi(a) {
    var b = $4d82739dd229d539$var$ih(a, 1);
    null !== b && $4d82739dd229d539$var$gi(b, a, 1, -1);
}
function $4d82739dd229d539$var$hi(a) {
    var b = $4d82739dd229d539$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4d82739dd229d539$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4d82739dd229d539$var$ii.bind(null, $4d82739dd229d539$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4d82739dd229d539$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4d82739dd229d539$var$ji() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$ki(a, b, c, d) {
    var e = $4d82739dd229d539$var$Th();
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4d82739dd229d539$var$li(a, b, c, d) {
    var e = $4d82739dd229d539$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4d82739dd229d539$var$N) {
        var g = $4d82739dd229d539$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $4d82739dd229d539$var$Mh(d, g.deps)) {
            e.memoizedState = $4d82739dd229d539$var$bi(b, c, f, d);
            return;
        }
    }
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, f, d);
}
function $4d82739dd229d539$var$mi(a, b) {
    return $4d82739dd229d539$var$ki(8390656, 8, a, b);
}
function $4d82739dd229d539$var$$h(a, b) {
    return $4d82739dd229d539$var$li(2048, 8, a, b);
}
function $4d82739dd229d539$var$ni(a, b) {
    return $4d82739dd229d539$var$li(4, 2, a, b);
}
function $4d82739dd229d539$var$oi(a, b) {
    return $4d82739dd229d539$var$li(4, 4, a, b);
}
function $4d82739dd229d539$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4d82739dd229d539$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4d82739dd229d539$var$li(4, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
}
function $4d82739dd229d539$var$ri() {}
function $4d82739dd229d539$var$si(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ti(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ui(a, b, c) {
    if (0 === ($4d82739dd229d539$var$Hh & 21)) return a.baseState && (a.baseState = !1, $4d82739dd229d539$var$dh = !0), a.memoizedState = c;
    $4d82739dd229d539$var$He(c, b) || (c = $4d82739dd229d539$var$yc(), $4d82739dd229d539$var$M.lanes |= c, $4d82739dd229d539$var$rh |= c, a.baseState = !0);
    return b;
}
function $4d82739dd229d539$var$vi(a, b) {
    var c = $4d82739dd229d539$var$C;
    $4d82739dd229d539$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4d82739dd229d539$var$Gh.transition;
    $4d82739dd229d539$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$Gh.transition = d;
    }
}
function $4d82739dd229d539$var$wi() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$xi(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, c);
    else if (c = $4d82739dd229d539$var$hh(a, b, c, d), null !== c) {
        var e = $4d82739dd229d539$var$R();
        $4d82739dd229d539$var$gi(c, a, d, e);
        $4d82739dd229d539$var$Bi(c, b, d);
    }
}
function $4d82739dd229d539$var$ii(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4d82739dd229d539$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4d82739dd229d539$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4d82739dd229d539$var$hh(a, b, e, d);
        null !== c && (e = $4d82739dd229d539$var$R(), $4d82739dd229d539$var$gi(c, a, d, e), $4d82739dd229d539$var$Bi(c, b, d));
    }
}
function $4d82739dd229d539$var$zi(a) {
    var b = a.alternate;
    return a === $4d82739dd229d539$var$M || null !== b && b === $4d82739dd229d539$var$M;
}
function $4d82739dd229d539$var$Ai(a, b) {
    $4d82739dd229d539$var$Jh = $4d82739dd229d539$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4d82739dd229d539$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
var $4d82739dd229d539$var$Rh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$P,
    useContext: $4d82739dd229d539$var$P,
    useEffect: $4d82739dd229d539$var$P,
    useImperativeHandle: $4d82739dd229d539$var$P,
    useInsertionEffect: $4d82739dd229d539$var$P,
    useLayoutEffect: $4d82739dd229d539$var$P,
    useMemo: $4d82739dd229d539$var$P,
    useReducer: $4d82739dd229d539$var$P,
    useRef: $4d82739dd229d539$var$P,
    useState: $4d82739dd229d539$var$P,
    useDebugValue: $4d82739dd229d539$var$P,
    useDeferredValue: $4d82739dd229d539$var$P,
    useTransition: $4d82739dd229d539$var$P,
    useMutableSource: $4d82739dd229d539$var$P,
    useSyncExternalStore: $4d82739dd229d539$var$P,
    useId: $4d82739dd229d539$var$P,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Oh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: function(a, b) {
        $4d82739dd229d539$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4d82739dd229d539$var$ki(4194308, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4d82739dd229d539$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4d82739dd229d539$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4d82739dd229d539$var$xi.bind(null, $4d82739dd229d539$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4d82739dd229d539$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4d82739dd229d539$var$hi,
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        return $4d82739dd229d539$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$hi(!1), b = a[0];
        a = $4d82739dd229d539$var$vi.bind(null, a[1]);
        $4d82739dd229d539$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4d82739dd229d539$var$M, e = $4d82739dd229d539$var$Th();
        if ($4d82739dd229d539$var$I) {
            if (void 0 === c) throw Error($4d82739dd229d539$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
            0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4d82739dd229d539$var$mi($4d82739dd229d539$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4d82739dd229d539$var$Th(), b = $4d82739dd229d539$var$Q.identifierPrefix;
        if ($4d82739dd229d539$var$I) {
            var c = $4d82739dd229d539$var$sg;
            var d = $4d82739dd229d539$var$rg;
            c = (d & ~(1 << 32 - $4d82739dd229d539$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4d82739dd229d539$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4d82739dd229d539$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Ph = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Wh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Qh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Xh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return null === $4d82739dd229d539$var$N ? b.memoizedState = a : $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
};
function $4d82739dd229d539$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $4d82739dd229d539$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $4d82739dd229d539$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4d82739dd229d539$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4d82739dd229d539$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4d82739dd229d539$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4d82739dd229d539$var$R(), d = $4d82739dd229d539$var$yi(a), e = $4d82739dd229d539$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4d82739dd229d539$var$nh(a, e, d);
        null !== b && ($4d82739dd229d539$var$gi(b, a, d, c), $4d82739dd229d539$var$oh(b, a, d));
    }
};
function $4d82739dd229d539$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4d82739dd229d539$var$Ie(c, d) || !$4d82739dd229d539$var$Ie(e, f) : !0;
}
function $4d82739dd229d539$var$Gi(a, b, c) {
    var d = !1, e = $4d82739dd229d539$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4d82739dd229d539$var$eh(f) : (e = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4d82739dd229d539$var$Yf(a, e) : $4d82739dd229d539$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4d82739dd229d539$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4d82739dd229d539$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4d82739dd229d539$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $4d82739dd229d539$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $4d82739dd229d539$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4d82739dd229d539$var$eh(f) : (f = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, e.context = $4d82739dd229d539$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4d82739dd229d539$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4d82739dd229d539$var$Ei.enqueueReplaceState(e, e.state, null), $4d82739dd229d539$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4d82739dd229d539$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $4d82739dd229d539$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4d82739dd229d539$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4d82739dd229d539$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4d82739dd229d539$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $4d82739dd229d539$var$Ni(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4d82739dd229d539$var$Oi || ($4d82739dd229d539$var$Oi = !0, $4d82739dd229d539$var$Pi = d);
        $4d82739dd229d539$var$Li(a, b);
    };
    return c;
}
function $4d82739dd229d539$var$Qi(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4d82739dd229d539$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4d82739dd229d539$var$Li(a, b);
        "function" !== typeof d && (null === $4d82739dd229d539$var$Ri ? $4d82739dd229d539$var$Ri = new Set([
            this
        ]) : $4d82739dd229d539$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4d82739dd229d539$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4d82739dd229d539$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $4d82739dd229d539$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $4d82739dd229d539$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4d82739dd229d539$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4d82739dd229d539$var$mh(-1, 1), b.tag = 2, $4d82739dd229d539$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4d82739dd229d539$var$Wi = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$dh = !1;
function $4d82739dd229d539$var$Xi(a, b, c, d) {
    b.child = null === a ? $4d82739dd229d539$var$Vg(b, null, c, d) : $4d82739dd229d539$var$Ug(b, a.child, c, d);
}
function $4d82739dd229d539$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4d82739dd229d539$var$ch(b, e);
    d = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    c = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && c && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, d, e);
    return b.child;
}
function $4d82739dd229d539$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4d82739dd229d539$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4d82739dd229d539$var$bj(a, b, f, d, e);
        a = $4d82739dd229d539$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4d82739dd229d539$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $4d82739dd229d539$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $4d82739dd229d539$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4d82739dd229d539$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4d82739dd229d539$var$Ie(f, d) && a.ref === b.ref) {
            if ($4d82739dd229d539$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4d82739dd229d539$var$dh = !0);
            else return b.lanes = a.lanes, $4d82739dd229d539$var$Zi(a, b, e);
        }
    }
    return $4d82739dd229d539$var$cj(a, b, c, d, e);
}
function $4d82739dd229d539$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj);
            $4d82739dd229d539$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= d;
    $4d82739dd229d539$var$Xi(a, b, e, c);
    return b.child;
}
function $4d82739dd229d539$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4d82739dd229d539$var$cj(a, b, c, d, e) {
    var f = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current;
    f = $4d82739dd229d539$var$Yf(b, f);
    $4d82739dd229d539$var$ch(b, e);
    c = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    d = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && d && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, c, e);
    return b.child;
}
function $4d82739dd229d539$var$hj(a, b, c, d, e) {
    if ($4d82739dd229d539$var$Zf(c)) {
        var f = !0;
        $4d82739dd229d539$var$cg(b);
    } else f = !1;
    $4d82739dd229d539$var$ch(b, e);
    if (null === b.stateNode) $4d82739dd229d539$var$ij(a, b), $4d82739dd229d539$var$Gi(b, c, d), $4d82739dd229d539$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4d82739dd229d539$var$eh(l) : (l = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, l = $4d82739dd229d539$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4d82739dd229d539$var$Hi(b, g, d, l);
        $4d82739dd229d539$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof m && ($4d82739dd229d539$var$Di(b, c, m, d), k = b.memoizedState), (h = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4d82739dd229d539$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4d82739dd229d539$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4d82739dd229d539$var$eh(k) : (k = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, k = $4d82739dd229d539$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4d82739dd229d539$var$Hi(b, g, d, k);
        $4d82739dd229d539$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof y && ($4d82739dd229d539$var$Di(b, c, y, d), n = b.memoizedState), (l = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4d82739dd229d539$var$jj(a, b, c, d, f, e);
}
function $4d82739dd229d539$var$jj(a, b, c, d, e, f) {
    $4d82739dd229d539$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4d82739dd229d539$var$dg(b, c, !1), $4d82739dd229d539$var$Zi(a, b, f);
    d = b.stateNode;
    $4d82739dd229d539$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $4d82739dd229d539$var$Ug(b, a.child, null, f), b.child = $4d82739dd229d539$var$Ug(b, null, h, f)) : $4d82739dd229d539$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $4d82739dd229d539$var$dg(b, c, !0);
    return b.child;
}
function $4d82739dd229d539$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4d82739dd229d539$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4d82739dd229d539$var$ag(a, b.context, !1);
    $4d82739dd229d539$var$yh(a, b.containerInfo);
}
function $4d82739dd229d539$var$lj(a, b, c, d, e) {
    $4d82739dd229d539$var$Ig();
    $4d82739dd229d539$var$Jg(e);
    b.flags |= 256;
    $4d82739dd229d539$var$Xi(a, b, c, d);
    return b.child;
}
var $4d82739dd229d539$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4d82739dd229d539$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4d82739dd229d539$var$oj(a, b, c) {
    var d = b.pendingProps, e = $4d82739dd229d539$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, e & 1);
    if (null === a) {
        $4d82739dd229d539$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $4d82739dd229d539$var$pj(g, d, 0, null), a = $4d82739dd229d539$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4d82739dd229d539$var$nj(c), b.memoizedState = $4d82739dd229d539$var$mj, a) : $4d82739dd229d539$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4d82739dd229d539$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $4d82739dd229d539$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4d82739dd229d539$var$Pg(h, f) : (f = $4d82739dd229d539$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4d82739dd229d539$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4d82739dd229d539$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4d82739dd229d539$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4d82739dd229d539$var$qj(a, b) {
    b = $4d82739dd229d539$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4d82739dd229d539$var$sj(a, b, c, d) {
    null !== d && $4d82739dd229d539$var$Jg(d);
    $4d82739dd229d539$var$Ug(b, a.child, null, c);
    a = $4d82739dd229d539$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4d82739dd229d539$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(422))), $4d82739dd229d539$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4d82739dd229d539$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4d82739dd229d539$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4d82739dd229d539$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $4d82739dd229d539$var$nj(g);
        b.memoizedState = $4d82739dd229d539$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4d82739dd229d539$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4d82739dd229d539$var$p(419));
        d = $4d82739dd229d539$var$Ki(f, d, void 0);
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4d82739dd229d539$var$dh || h) {
        d = $4d82739dd229d539$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4d82739dd229d539$var$ih(a, e), $4d82739dd229d539$var$gi(d, a, e, -1));
        }
        $4d82739dd229d539$var$tj();
        d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(421)));
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4d82739dd229d539$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(e.nextSibling);
    $4d82739dd229d539$var$xg = b;
    $4d82739dd229d539$var$I = !0;
    $4d82739dd229d539$var$zg = null;
    null !== a && ($4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg, $4d82739dd229d539$var$rg = a.id, $4d82739dd229d539$var$sg = a.overflow, $4d82739dd229d539$var$qg = b);
    b = $4d82739dd229d539$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4d82739dd229d539$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4d82739dd229d539$var$bh(a.return, b, c);
}
function $4d82739dd229d539$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4d82739dd229d539$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4d82739dd229d539$var$Xi(a, b, d.children, c);
    d = $4d82739dd229d539$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4d82739dd229d539$var$vj(a, c, b);
            else if (19 === a.tag) $4d82739dd229d539$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4d82739dd229d539$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4d82739dd229d539$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4d82739dd229d539$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4d82739dd229d539$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $4d82739dd229d539$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4d82739dd229d539$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4d82739dd229d539$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4d82739dd229d539$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4d82739dd229d539$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4d82739dd229d539$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $4d82739dd229d539$var$kj(b);
            $4d82739dd229d539$var$Ig();
            break;
        case 5:
            $4d82739dd229d539$var$Ah(b);
            break;
        case 1:
            $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$cg(b);
            break;
        case 4:
            $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4d82739dd229d539$var$oj(a, b, c);
                $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
                a = $4d82739dd229d539$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4d82739dd229d539$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4d82739dd229d539$var$dj(a, b, c);
    }
    return $4d82739dd229d539$var$Zi(a, b, c);
}
var $4d82739dd229d539$var$zj, $4d82739dd229d539$var$Aj, $4d82739dd229d539$var$Bj, $4d82739dd229d539$var$Cj;
$4d82739dd229d539$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4d82739dd229d539$var$Aj = function() {};
$4d82739dd229d539$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $4d82739dd229d539$var$Ya(a, e);
                d = $4d82739dd229d539$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4d82739dd229d539$var$A({}, e, {
                    value: void 0
                });
                d = $4d82739dd229d539$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4d82739dd229d539$var$gb(a, e);
                d = $4d82739dd229d539$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
        }
        $4d82739dd229d539$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4d82739dd229d539$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4d82739dd229d539$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4d82739dd229d539$var$Dj(a, b) {
    if (!$4d82739dd229d539$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4d82739dd229d539$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4d82739dd229d539$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4d82739dd229d539$var$S(b), null;
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4d82739dd229d539$var$zh();
            $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
            $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
            $4d82739dd229d539$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4d82739dd229d539$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null));
            $4d82739dd229d539$var$Aj(a, b);
            $4d82739dd229d539$var$S(b);
            return null;
        case 5:
            $4d82739dd229d539$var$Bh(b);
            var e = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4d82739dd229d539$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                    $4d82739dd229d539$var$S(b);
                    return null;
                }
                a = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    d[$4d82739dd229d539$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $4d82739dd229d539$var$D("cancel", d);
                            $4d82739dd229d539$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], d);
                            break;
                        case "source":
                            $4d82739dd229d539$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4d82739dd229d539$var$D("error", d);
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "details":
                            $4d82739dd229d539$var$D("toggle", d);
                            break;
                        case "input":
                            $4d82739dd229d539$var$Za(d, f);
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$hb(d, f), $4d82739dd229d539$var$D("invalid", d);
                    }
                    $4d82739dd229d539$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $4d82739dd229d539$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4d82739dd229d539$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $4d82739dd229d539$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4d82739dd229d539$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4d82739dd229d539$var$Of] = b;
                    a[$4d82739dd229d539$var$Pf] = d;
                    $4d82739dd229d539$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4d82739dd229d539$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4d82739dd229d539$var$D("cancel", a);
                                $4d82739dd229d539$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4d82739dd229d539$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4d82739dd229d539$var$D("error", a);
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $4d82739dd229d539$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4d82739dd229d539$var$Za(a, d);
                                e = $4d82739dd229d539$var$Ya(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4d82739dd229d539$var$A({}, d, {
                                    value: void 0
                                });
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$hb(a, d);
                                e = $4d82739dd229d539$var$gb(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4d82739dd229d539$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4d82739dd229d539$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4d82739dd229d539$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4d82739dd229d539$var$ob(a, k) : "number" === typeof k && $4d82739dd229d539$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4d82739dd229d539$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4d82739dd229d539$var$D("scroll", a) : null != k && $4d82739dd229d539$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4d82739dd229d539$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4d82739dd229d539$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4d82739dd229d539$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4d82739dd229d539$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                c = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
                $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $4d82739dd229d539$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$4d82739dd229d539$var$Of] = b, b.stateNode = d;
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4d82739dd229d539$var$I && null !== $4d82739dd229d539$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4d82739dd229d539$var$Hg(), $4d82739dd229d539$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $4d82739dd229d539$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4d82739dd229d539$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4d82739dd229d539$var$p(317));
                        f[$4d82739dd229d539$var$Of] = b;
                    } else $4d82739dd229d539$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $4d82739dd229d539$var$S(b);
                    f = !1;
                } else null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4d82739dd229d539$var$L.current & 1) ? 0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 3) : $4d82739dd229d539$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4d82739dd229d539$var$S(b);
            return null;
        case 4:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$Aj(a, b), null === a && $4d82739dd229d539$var$sf(b.stateNode.containerInfo), $4d82739dd229d539$var$S(b), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), $4d82739dd229d539$var$S(b), null;
        case 17:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 19:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            f = b.memoizedState;
            if (null === f) return $4d82739dd229d539$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4d82739dd229d539$var$Dj(f, !1);
                else {
                    if (0 !== $4d82739dd229d539$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4d82739dd229d539$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4d82739dd229d539$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4d82739dd229d539$var$B() > $4d82739dd229d539$var$Gj && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4d82739dd229d539$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $4d82739dd229d539$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4d82739dd229d539$var$I) return $4d82739dd229d539$var$S(b), null;
                    } else 2 * $4d82739dd229d539$var$B() - f.renderingStartTime > $4d82739dd229d539$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4d82739dd229d539$var$B(), b.sibling = null, c = $4d82739dd229d539$var$L.current, $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d ? c & 1 | 2 : c & 1), b;
            $4d82739dd229d539$var$S(b);
            return null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4d82739dd229d539$var$fj & 1073741824) && ($4d82739dd229d539$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4d82739dd229d539$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
}
function $4d82739dd229d539$var$Ij(a, b) {
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4d82739dd229d539$var$Bh(b), null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4d82739dd229d539$var$p(340));
                $4d82739dd229d539$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $4d82739dd229d539$var$E($4d82739dd229d539$var$L), null;
        case 4:
            return $4d82739dd229d539$var$zh(), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$Jj = !1, $4d82739dd229d539$var$U = !1, $4d82739dd229d539$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $4d82739dd229d539$var$V = null;
function $4d82739dd229d539$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $4d82739dd229d539$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4d82739dd229d539$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $4d82739dd229d539$var$W(a, b, d);
    }
}
var $4d82739dd229d539$var$Nj = !1;
function $4d82739dd229d539$var$Oj(a, b) {
    $4d82739dd229d539$var$Cf = $4d82739dd229d539$var$dd;
    a = $4d82739dd229d539$var$Me();
    if ($4d82739dd229d539$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4d82739dd229d539$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $4d82739dd229d539$var$dd = !1;
    for($4d82739dd229d539$var$V = b; null !== $4d82739dd229d539$var$V;)if (b = $4d82739dd229d539$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4d82739dd229d539$var$V = a;
    else for(; null !== $4d82739dd229d539$var$V;){
        b = $4d82739dd229d539$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $4d82739dd229d539$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(163));
            }
        } catch (F) {
            $4d82739dd229d539$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4d82739dd229d539$var$V = a;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
    n = $4d82739dd229d539$var$Nj;
    $4d82739dd229d539$var$Nj = !1;
    return n;
}
function $4d82739dd229d539$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $4d82739dd229d539$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4d82739dd229d539$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $4d82739dd229d539$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $4d82739dd229d539$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4d82739dd229d539$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4d82739dd229d539$var$Of], delete b[$4d82739dd229d539$var$Pf], delete b[$4d82739dd229d539$var$of], delete b[$4d82739dd229d539$var$Qf], delete b[$4d82739dd229d539$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4d82739dd229d539$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4d82739dd229d539$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4d82739dd229d539$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4d82739dd229d539$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4d82739dd229d539$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Vj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Vj(a, b, c), a = a.sibling;
}
function $4d82739dd229d539$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Wj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Wj(a, b, c), a = a.sibling;
}
var $4d82739dd229d539$var$X = null, $4d82739dd229d539$var$Xj = !1;
function $4d82739dd229d539$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$4d82739dd229d539$var$Zj(a, b, c), c = c.sibling;
}
function $4d82739dd229d539$var$Zj(a, b, c) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberUnmount) try {
        $4d82739dd229d539$var$lc.onCommitFiberUnmount($4d82739dd229d539$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4d82739dd229d539$var$U || $4d82739dd229d539$var$Lj(c, b);
        case 6:
            var d = $4d82739dd229d539$var$X, e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4d82739dd229d539$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? $4d82739dd229d539$var$Kf(a.parentNode, c) : 1 === a.nodeType && $4d82739dd229d539$var$Kf(a, c), $4d82739dd229d539$var$bd(a)) : $4d82739dd229d539$var$Kf($4d82739dd229d539$var$X, c.stateNode));
            break;
        case 4:
            d = $4d82739dd229d539$var$X;
            e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = c.stateNode.containerInfo;
            $4d82739dd229d539$var$Xj = !0;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4d82739dd229d539$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4d82739dd229d539$var$Mj(c, b, g) : 0 !== (f & 4) && $4d82739dd229d539$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 1:
            if (!$4d82739dd229d539$var$U && ($4d82739dd229d539$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $4d82739dd229d539$var$W(c, b, h);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 21:
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4d82739dd229d539$var$U = (d = $4d82739dd229d539$var$U) || null !== c.memoizedState, $4d82739dd229d539$var$Yj(a, b, c), $4d82739dd229d539$var$U = d) : $4d82739dd229d539$var$Yj(a, b, c);
            break;
        default:
            $4d82739dd229d539$var$Yj(a, b, c);
    }
}
function $4d82739dd229d539$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4d82739dd229d539$var$Kj);
        b.forEach(function(b) {
            var d = $4d82739dd229d539$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $4d82739dd229d539$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4d82739dd229d539$var$X = h.stateNode;
                        $4d82739dd229d539$var$Xj = !1;
                        break a;
                    case 3:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                    case 4:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4d82739dd229d539$var$X) throw Error($4d82739dd229d539$var$p(160));
            $4d82739dd229d539$var$Zj(f, g, e);
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4d82739dd229d539$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4d82739dd229d539$var$dk(b, a), b = b.sibling;
}
function $4d82739dd229d539$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                try {
                    $4d82739dd229d539$var$Pj(3, a, a.return), $4d82739dd229d539$var$Qj(3, a);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
                try {
                    $4d82739dd229d539$var$Pj(5, a, a.return);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            break;
        case 5:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4d82739dd229d539$var$ob(e, "");
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4d82739dd229d539$var$ab(e, f);
                    $4d82739dd229d539$var$vb(h, g);
                    var l = $4d82739dd229d539$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $4d82739dd229d539$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $4d82739dd229d539$var$nb(e, q) : "children" === m ? $4d82739dd229d539$var$ob(e, q) : $4d82739dd229d539$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $4d82739dd229d539$var$bb(e, f);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $4d82739dd229d539$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4d82739dd229d539$var$fb(e, !!f.multiple, f.defaultValue, !0) : $4d82739dd229d539$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4d82739dd229d539$var$Pf] = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4d82739dd229d539$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4d82739dd229d539$var$bd(b.containerInfo);
            } catch (t) {
                $4d82739dd229d539$var$W(a, a.return, t);
            }
            break;
        case 4:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            break;
        case 13:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4d82739dd229d539$var$fk = $4d82739dd229d539$var$B()));
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4d82739dd229d539$var$U = (l = $4d82739dd229d539$var$U) || m, $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$U = l) : $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($4d82739dd229d539$var$V = a, m = a.child; null !== m;){
                    for(q = $4d82739dd229d539$var$V = m; null !== $4d82739dd229d539$var$V;){
                        r = $4d82739dd229d539$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $4d82739dd229d539$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $4d82739dd229d539$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4d82739dd229d539$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $4d82739dd229d539$var$V = y) : $4d82739dd229d539$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4d82739dd229d539$var$rb("display", g));
                            } catch (t) {
                                $4d82739dd229d539$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $4d82739dd229d539$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 21:
            break;
        default:
            $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$ek(a);
    }
}
function $4d82739dd229d539$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4d82739dd229d539$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4d82739dd229d539$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4d82739dd229d539$var$ob(e, ""), d.flags &= -33);
                    var f = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(161));
            }
        } catch (k) {
            $4d82739dd229d539$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4d82739dd229d539$var$hk(a, b, c) {
    $4d82739dd229d539$var$V = a;
    $4d82739dd229d539$var$ik(a, b, c);
}
function $4d82739dd229d539$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4d82739dd229d539$var$V;){
        var e = $4d82739dd229d539$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4d82739dd229d539$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4d82739dd229d539$var$U;
                h = $4d82739dd229d539$var$Jj;
                var l = $4d82739dd229d539$var$U;
                $4d82739dd229d539$var$Jj = g;
                if (($4d82739dd229d539$var$U = k) && !l) for($4d82739dd229d539$var$V = e; null !== $4d82739dd229d539$var$V;)g = $4d82739dd229d539$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4d82739dd229d539$var$jk(e) : null !== k ? (k.return = g, $4d82739dd229d539$var$V = k) : $4d82739dd229d539$var$jk(e);
                for(; null !== f;)$4d82739dd229d539$var$V = f, $4d82739dd229d539$var$ik(f, b, c), f = f.sibling;
                $4d82739dd229d539$var$V = e;
                $4d82739dd229d539$var$Jj = h;
                $4d82739dd229d539$var$U = l;
            }
            $4d82739dd229d539$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4d82739dd229d539$var$V = f) : $4d82739dd229d539$var$kk(a, b, c);
    }
}
function $4d82739dd229d539$var$kk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $4d82739dd229d539$var$U || $4d82739dd229d539$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4d82739dd229d539$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4d82739dd229d539$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $4d82739dd229d539$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $4d82739dd229d539$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $4d82739dd229d539$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4d82739dd229d539$var$p(163));
                }
                $4d82739dd229d539$var$U || b.flags & 512 && $4d82739dd229d539$var$Rj(b);
            } catch (r) {
                $4d82739dd229d539$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$gk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$jk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $4d82739dd229d539$var$Qj(4, b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $4d82739dd229d539$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $4d82739dd229d539$var$W(b, b.return, k);
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $4d82739dd229d539$var$V = h;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
var $4d82739dd229d539$var$lk = Math.ceil, $4d82739dd229d539$var$mk = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$nk = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$ok = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$K = 0, $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Y = null, $4d82739dd229d539$var$Z = 0, $4d82739dd229d539$var$fj = 0, $4d82739dd229d539$var$ej = $4d82739dd229d539$var$Uf(0), $4d82739dd229d539$var$T = 0, $4d82739dd229d539$var$pk = null, $4d82739dd229d539$var$rh = 0, $4d82739dd229d539$var$qk = 0, $4d82739dd229d539$var$rk = 0, $4d82739dd229d539$var$sk = null, $4d82739dd229d539$var$tk = null, $4d82739dd229d539$var$fk = 0, $4d82739dd229d539$var$Gj = Infinity, $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Oi = !1, $4d82739dd229d539$var$Pi = null, $4d82739dd229d539$var$Ri = null, $4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = null, $4d82739dd229d539$var$xk = 0, $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, $4d82739dd229d539$var$Ak = -1, $4d82739dd229d539$var$Bk = 0;
function $4d82739dd229d539$var$R() {
    return 0 !== ($4d82739dd229d539$var$K & 6) ? $4d82739dd229d539$var$B() : -1 !== $4d82739dd229d539$var$Ak ? $4d82739dd229d539$var$Ak : $4d82739dd229d539$var$Ak = $4d82739dd229d539$var$B();
}
function $4d82739dd229d539$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4d82739dd229d539$var$K & 2) && 0 !== $4d82739dd229d539$var$Z) return $4d82739dd229d539$var$Z & -$4d82739dd229d539$var$Z;
    if (null !== $4d82739dd229d539$var$Kg.transition) return 0 === $4d82739dd229d539$var$Bk && ($4d82739dd229d539$var$Bk = $4d82739dd229d539$var$yc()), $4d82739dd229d539$var$Bk;
    a = $4d82739dd229d539$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4d82739dd229d539$var$jd(a.type);
    return a;
}
function $4d82739dd229d539$var$gi(a, b, c, d) {
    if (50 < $4d82739dd229d539$var$yk) throw $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, Error($4d82739dd229d539$var$p(185));
    $4d82739dd229d539$var$Ac(a, c, d);
    if (0 === ($4d82739dd229d539$var$K & 2) || a !== $4d82739dd229d539$var$Q) a === $4d82739dd229d539$var$Q && (0 === ($4d82739dd229d539$var$K & 2) && ($4d82739dd229d539$var$qk |= c), 4 === $4d82739dd229d539$var$T && $4d82739dd229d539$var$Ck(a, $4d82739dd229d539$var$Z)), $4d82739dd229d539$var$Dk(a, d), 1 === c && 0 === $4d82739dd229d539$var$K && 0 === (b.mode & 1) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
}
function $4d82739dd229d539$var$Dk(a, b) {
    var c = a.callbackNode;
    $4d82739dd229d539$var$wc(a, b);
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) null !== c && $4d82739dd229d539$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4d82739dd229d539$var$bc(c);
        if (1 === b) 0 === a.tag ? $4d82739dd229d539$var$ig($4d82739dd229d539$var$Ek.bind(null, a)) : $4d82739dd229d539$var$hg($4d82739dd229d539$var$Ek.bind(null, a)), $4d82739dd229d539$var$Jf(function() {
            0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
        }), c = null;
        else {
            switch($4d82739dd229d539$var$Dc(d)){
                case 1:
                    c = $4d82739dd229d539$var$fc;
                    break;
                case 4:
                    c = $4d82739dd229d539$var$gc;
                    break;
                case 16:
                    c = $4d82739dd229d539$var$hc;
                    break;
                case 536870912:
                    c = $4d82739dd229d539$var$jc;
                    break;
                default:
                    c = $4d82739dd229d539$var$hc;
            }
            c = $4d82739dd229d539$var$Fk(c, $4d82739dd229d539$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4d82739dd229d539$var$Gk(a, b) {
    $4d82739dd229d539$var$Ak = -1;
    $4d82739dd229d539$var$Bk = 0;
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    var c = a.callbackNode;
    if ($4d82739dd229d539$var$Hk() && a.callbackNode !== c) return null;
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4d82739dd229d539$var$Ik(a, d);
    else {
        b = d;
        var e = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 2;
        var f = $4d82739dd229d539$var$Jk();
        if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$Kk(a, b);
        for(;;)try {
            $4d82739dd229d539$var$Lk();
            break;
        } catch (h) {
            $4d82739dd229d539$var$Mk(a, h);
        }
        $4d82739dd229d539$var$$g();
        $4d82739dd229d539$var$mk.current = f;
        $4d82739dd229d539$var$K = e;
        null !== $4d82739dd229d539$var$Y ? b = 0 : ($4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0, b = $4d82739dd229d539$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4d82739dd229d539$var$xc(a), 0 !== e && (d = e, b = $4d82739dd229d539$var$Nk(a, e)));
        if (1 === b) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
        if (6 === b) $4d82739dd229d539$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4d82739dd229d539$var$Ok(e) && (b = $4d82739dd229d539$var$Ik(a, d), 2 === b && (f = $4d82739dd229d539$var$xc(a), 0 !== f && (d = f, b = $4d82739dd229d539$var$Nk(a, f))), 1 === b)) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4d82739dd229d539$var$p(345));
                case 2:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 3:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $4d82739dd229d539$var$fk + 500 - $4d82739dd229d539$var$B(), 10 < b)) {
                        if (0 !== $4d82739dd229d539$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4d82739dd229d539$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), b);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 4:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $4d82739dd229d539$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $4d82739dd229d539$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4d82739dd229d539$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), d);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 5:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(329));
            }
        }
    }
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return a.callbackNode === c ? $4d82739dd229d539$var$Gk.bind(null, a) : null;
}
function $4d82739dd229d539$var$Nk(a, b) {
    var c = $4d82739dd229d539$var$sk;
    a.current.memoizedState.isDehydrated && ($4d82739dd229d539$var$Kk(a, b).flags |= 256);
    a = $4d82739dd229d539$var$Ik(a, b);
    2 !== a && (b = $4d82739dd229d539$var$tk, $4d82739dd229d539$var$tk = c, null !== b && $4d82739dd229d539$var$Fj(b));
    return a;
}
function $4d82739dd229d539$var$Fj(a) {
    null === $4d82739dd229d539$var$tk ? $4d82739dd229d539$var$tk = a : $4d82739dd229d539$var$tk.push.apply($4d82739dd229d539$var$tk, a);
}
function $4d82739dd229d539$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4d82739dd229d539$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4d82739dd229d539$var$Ck(a, b) {
    b &= ~$4d82739dd229d539$var$rk;
    b &= ~$4d82739dd229d539$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4d82739dd229d539$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4d82739dd229d539$var$Ek(a) {
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$uc(a, 0);
    if (0 === (b & 1)) return $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), null;
    var c = $4d82739dd229d539$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4d82739dd229d539$var$xc(a);
        0 !== d && (b = d, c = $4d82739dd229d539$var$Nk(a, d));
    }
    if (1 === c) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, b), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
    if (6 === c) throw Error($4d82739dd229d539$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return null;
}
function $4d82739dd229d539$var$Qk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4d82739dd229d539$var$K = c, 0 === $4d82739dd229d539$var$K && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
    }
}
function $4d82739dd229d539$var$Rk(a) {
    null !== $4d82739dd229d539$var$wk && 0 === $4d82739dd229d539$var$wk.tag && 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    var c = $4d82739dd229d539$var$ok.transition, d = $4d82739dd229d539$var$C;
    try {
        if ($4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, a) return a();
    } finally{
        $4d82739dd229d539$var$C = d, $4d82739dd229d539$var$ok.transition = c, $4d82739dd229d539$var$K = b, 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
    }
}
function $4d82739dd229d539$var$Hj() {
    $4d82739dd229d539$var$fj = $4d82739dd229d539$var$ej.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$ej);
}
function $4d82739dd229d539$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4d82739dd229d539$var$Gf(c));
    if (null !== $4d82739dd229d539$var$Y) for(c = $4d82739dd229d539$var$Y.return; null !== c;){
        var d = c;
        $4d82739dd229d539$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4d82739dd229d539$var$$f();
                break;
            case 3:
                $4d82739dd229d539$var$zh();
                $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
                $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
                $4d82739dd229d539$var$Eh();
                break;
            case 5:
                $4d82739dd229d539$var$Bh(d);
                break;
            case 4:
                $4d82739dd229d539$var$zh();
                break;
            case 13:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 19:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 10:
                $4d82739dd229d539$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $4d82739dd229d539$var$Hj();
        }
        c = c.return;
    }
    $4d82739dd229d539$var$Q = a;
    $4d82739dd229d539$var$Y = a = $4d82739dd229d539$var$Pg(a.current, null);
    $4d82739dd229d539$var$Z = $4d82739dd229d539$var$fj = b;
    $4d82739dd229d539$var$T = 0;
    $4d82739dd229d539$var$pk = null;
    $4d82739dd229d539$var$rk = $4d82739dd229d539$var$qk = $4d82739dd229d539$var$rh = 0;
    $4d82739dd229d539$var$tk = $4d82739dd229d539$var$sk = null;
    if (null !== $4d82739dd229d539$var$fh) {
        for(b = 0; b < $4d82739dd229d539$var$fh.length; b++)if (c = $4d82739dd229d539$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4d82739dd229d539$var$fh = null;
    }
    return a;
}
function $4d82739dd229d539$var$Mk(a, b) {
    do {
        var c = $4d82739dd229d539$var$Y;
        try {
            $4d82739dd229d539$var$$g();
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
            if ($4d82739dd229d539$var$Ih) {
                for(var d = $4d82739dd229d539$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4d82739dd229d539$var$Ih = !1;
            }
            $4d82739dd229d539$var$Hh = 0;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            $4d82739dd229d539$var$nk.current = null;
            if (null === c || null === c.return) {
                $4d82739dd229d539$var$T = 1;
                $4d82739dd229d539$var$pk = b;
                $4d82739dd229d539$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $4d82739dd229d539$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $4d82739dd229d539$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $4d82739dd229d539$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $4d82739dd229d539$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4d82739dd229d539$var$Si(f, l, b);
                            $4d82739dd229d539$var$tj();
                            break a;
                        }
                        k = Error($4d82739dd229d539$var$p(426));
                    }
                } else if ($4d82739dd229d539$var$I && h.mode & 1) {
                    var J = $4d82739dd229d539$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $4d82739dd229d539$var$Vi(J, g, h, f, b);
                        $4d82739dd229d539$var$Jg($4d82739dd229d539$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $4d82739dd229d539$var$Ji(k, h);
                4 !== $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 2);
                null === $4d82739dd229d539$var$sk ? $4d82739dd229d539$var$sk = [
                    f
                ] : $4d82739dd229d539$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $4d82739dd229d539$var$Ni(f, k, b);
                            $4d82739dd229d539$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $4d82739dd229d539$var$Qi(f, h, b);
                                $4d82739dd229d539$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $4d82739dd229d539$var$Sk(c);
        } catch (na) {
            b = na;
            $4d82739dd229d539$var$Y === c && null !== c && ($4d82739dd229d539$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4d82739dd229d539$var$Jk() {
    var a = $4d82739dd229d539$var$mk.current;
    $4d82739dd229d539$var$mk.current = $4d82739dd229d539$var$Rh;
    return null === a ? $4d82739dd229d539$var$Rh : a;
}
function $4d82739dd229d539$var$tj() {
    if (0 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T || 2 === $4d82739dd229d539$var$T) $4d82739dd229d539$var$T = 4;
    null === $4d82739dd229d539$var$Q || 0 === ($4d82739dd229d539$var$rh & 268435455) && 0 === ($4d82739dd229d539$var$qk & 268435455) || $4d82739dd229d539$var$Ck($4d82739dd229d539$var$Q, $4d82739dd229d539$var$Z);
}
function $4d82739dd229d539$var$Ik(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 2;
    var d = $4d82739dd229d539$var$Jk();
    if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Kk(a, b);
    for(;;)try {
        $4d82739dd229d539$var$Tk();
        break;
    } catch (e) {
        $4d82739dd229d539$var$Mk(a, e);
    }
    $4d82739dd229d539$var$$g();
    $4d82739dd229d539$var$K = c;
    $4d82739dd229d539$var$mk.current = d;
    if (null !== $4d82739dd229d539$var$Y) throw Error($4d82739dd229d539$var$p(261));
    $4d82739dd229d539$var$Q = null;
    $4d82739dd229d539$var$Z = 0;
    return $4d82739dd229d539$var$T;
}
function $4d82739dd229d539$var$Tk() {
    for(; null !== $4d82739dd229d539$var$Y;)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Lk() {
    for(; null !== $4d82739dd229d539$var$Y && !$4d82739dd229d539$var$cc();)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Uk(a) {
    var b = $4d82739dd229d539$var$Vk(a.alternate, a, $4d82739dd229d539$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4d82739dd229d539$var$Sk(a) : $4d82739dd229d539$var$Y = b;
    $4d82739dd229d539$var$nk.current = null;
}
function $4d82739dd229d539$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $4d82739dd229d539$var$Ej(c, b, $4d82739dd229d539$var$fj), null !== c) {
                $4d82739dd229d539$var$Y = c;
                return;
            }
        } else {
            c = $4d82739dd229d539$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4d82739dd229d539$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4d82739dd229d539$var$T = 6;
                $4d82739dd229d539$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4d82739dd229d539$var$Y = b;
            return;
        }
        $4d82739dd229d539$var$Y = b = a;
    }while (null !== b);
    0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 5);
}
function $4d82739dd229d539$var$Pk(a, b, c) {
    var d = $4d82739dd229d539$var$C, e = $4d82739dd229d539$var$ok.transition;
    try {
        $4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$Wk(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$ok.transition = e, $4d82739dd229d539$var$C = d;
    }
    return null;
}
function $4d82739dd229d539$var$Wk(a, b, c, d) {
    do $4d82739dd229d539$var$Hk();
    while (null !== $4d82739dd229d539$var$wk);
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4d82739dd229d539$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4d82739dd229d539$var$Bc(a, f);
    a === $4d82739dd229d539$var$Q && ($4d82739dd229d539$var$Y = $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4d82739dd229d539$var$vk || ($4d82739dd229d539$var$vk = !0, $4d82739dd229d539$var$Fk($4d82739dd229d539$var$hc, function() {
        $4d82739dd229d539$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4d82739dd229d539$var$ok.transition;
        $4d82739dd229d539$var$ok.transition = null;
        var g = $4d82739dd229d539$var$C;
        $4d82739dd229d539$var$C = 1;
        var h = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 4;
        $4d82739dd229d539$var$nk.current = null;
        $4d82739dd229d539$var$Oj(a, c);
        $4d82739dd229d539$var$dk(c, a);
        $4d82739dd229d539$var$Oe($4d82739dd229d539$var$Df);
        $4d82739dd229d539$var$dd = !!$4d82739dd229d539$var$Cf;
        $4d82739dd229d539$var$Df = $4d82739dd229d539$var$Cf = null;
        a.current = c;
        $4d82739dd229d539$var$hk(c, a, e);
        $4d82739dd229d539$var$dc();
        $4d82739dd229d539$var$K = h;
        $4d82739dd229d539$var$C = g;
        $4d82739dd229d539$var$ok.transition = f;
    } else a.current = c;
    $4d82739dd229d539$var$vk && ($4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = a, $4d82739dd229d539$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($4d82739dd229d539$var$Ri = null);
    $4d82739dd229d539$var$mc(c.stateNode, d);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4d82739dd229d539$var$Oi) throw $4d82739dd229d539$var$Oi = !1, a = $4d82739dd229d539$var$Pi, $4d82739dd229d539$var$Pi = null, a;
    0 !== ($4d82739dd229d539$var$xk & 1) && 0 !== a.tag && $4d82739dd229d539$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $4d82739dd229d539$var$zk ? $4d82739dd229d539$var$yk++ : ($4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = a) : $4d82739dd229d539$var$yk = 0;
    $4d82739dd229d539$var$jg();
    return null;
}
function $4d82739dd229d539$var$Hk() {
    if (null !== $4d82739dd229d539$var$wk) {
        var a = $4d82739dd229d539$var$Dc($4d82739dd229d539$var$xk), b = $4d82739dd229d539$var$ok.transition, c = $4d82739dd229d539$var$C;
        try {
            $4d82739dd229d539$var$ok.transition = null;
            $4d82739dd229d539$var$C = 16 > a ? 16 : a;
            if (null === $4d82739dd229d539$var$wk) var d = !1;
            else {
                a = $4d82739dd229d539$var$wk;
                $4d82739dd229d539$var$wk = null;
                $4d82739dd229d539$var$xk = 0;
                if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(331));
                var e = $4d82739dd229d539$var$K;
                $4d82739dd229d539$var$K |= 4;
                for($4d82739dd229d539$var$V = a.current; null !== $4d82739dd229d539$var$V;){
                    var f = $4d82739dd229d539$var$V, g = f.child;
                    if (0 !== ($4d82739dd229d539$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4d82739dd229d539$var$V = l; null !== $4d82739dd229d539$var$V;){
                                    var m = $4d82739dd229d539$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $4d82739dd229d539$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $4d82739dd229d539$var$V = q;
                                    else for(; null !== $4d82739dd229d539$var$V;){
                                        m = $4d82739dd229d539$var$V;
                                        var r = m.sibling, y = m.return;
                                        $4d82739dd229d539$var$Sj(m);
                                        if (m === l) {
                                            $4d82739dd229d539$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $4d82739dd229d539$var$V = r;
                                            break;
                                        }
                                        $4d82739dd229d539$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $4d82739dd229d539$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4d82739dd229d539$var$V = g;
                    else b: for(; null !== $4d82739dd229d539$var$V;){
                        f = $4d82739dd229d539$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $4d82739dd229d539$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $4d82739dd229d539$var$V = x;
                            break b;
                        }
                        $4d82739dd229d539$var$V = f.return;
                    }
                }
                var w = a.current;
                for($4d82739dd229d539$var$V = w; null !== $4d82739dd229d539$var$V;){
                    g = $4d82739dd229d539$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $4d82739dd229d539$var$V = u;
                    else b: for(g = w; null !== $4d82739dd229d539$var$V;){
                        h = $4d82739dd229d539$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $4d82739dd229d539$var$Qj(9, h);
                            }
                        } catch (na) {
                            $4d82739dd229d539$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $4d82739dd229d539$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $4d82739dd229d539$var$V = F;
                            break b;
                        }
                        $4d82739dd229d539$var$V = h.return;
                    }
                }
                $4d82739dd229d539$var$K = e;
                $4d82739dd229d539$var$jg();
                if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onPostCommitFiberRoot) try {
                    $4d82739dd229d539$var$lc.onPostCommitFiberRoot($4d82739dd229d539$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$ok.transition = b;
        }
    }
    return !1;
}
function $4d82739dd229d539$var$Xk(a, b, c) {
    b = $4d82739dd229d539$var$Ji(c, b);
    b = $4d82739dd229d539$var$Ni(a, b, 1);
    a = $4d82739dd229d539$var$nh(a, b, 1);
    b = $4d82739dd229d539$var$R();
    null !== a && ($4d82739dd229d539$var$Ac(a, 1, b), $4d82739dd229d539$var$Dk(a, b));
}
function $4d82739dd229d539$var$W(a, b, c) {
    if (3 === a.tag) $4d82739dd229d539$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4d82739dd229d539$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(d))) {
                a = $4d82739dd229d539$var$Ji(c, a);
                a = $4d82739dd229d539$var$Qi(b, a, 1);
                b = $4d82739dd229d539$var$nh(b, a, 1);
                a = $4d82739dd229d539$var$R();
                null !== b && ($4d82739dd229d539$var$Ac(b, 1, a), $4d82739dd229d539$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4d82739dd229d539$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4d82739dd229d539$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $4d82739dd229d539$var$Q === a && ($4d82739dd229d539$var$Z & c) === c && (4 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$Z & 130023424) === $4d82739dd229d539$var$Z && 500 > $4d82739dd229d539$var$B() - $4d82739dd229d539$var$fk ? $4d82739dd229d539$var$Kk(a, 0) : $4d82739dd229d539$var$rk |= c);
    $4d82739dd229d539$var$Dk(a, b);
}
function $4d82739dd229d539$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4d82739dd229d539$var$sc, $4d82739dd229d539$var$sc <<= 1, 0 === ($4d82739dd229d539$var$sc & 130023424) && ($4d82739dd229d539$var$sc = 4194304)));
    var c = $4d82739dd229d539$var$R();
    a = $4d82739dd229d539$var$ih(a, b);
    null !== a && ($4d82739dd229d539$var$Ac(a, b, c), $4d82739dd229d539$var$Dk(a, c));
}
function $4d82739dd229d539$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4d82739dd229d539$var$Yk(a, c);
}
function $4d82739dd229d539$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4d82739dd229d539$var$p(314));
    }
    null !== d && d.delete(b);
    $4d82739dd229d539$var$Yk(a, c);
}
var $4d82739dd229d539$var$Vk;
$4d82739dd229d539$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4d82739dd229d539$var$Wf.current) $4d82739dd229d539$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$yj(a, b, c);
            $4d82739dd229d539$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$I && 0 !== (b.flags & 1048576) && $4d82739dd229d539$var$ug(b, $4d82739dd229d539$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4d82739dd229d539$var$ij(a, b);
            a = b.pendingProps;
            var e = $4d82739dd229d539$var$Yf(b, $4d82739dd229d539$var$H.current);
            $4d82739dd229d539$var$ch(b, c);
            e = $4d82739dd229d539$var$Nh(null, b, d, a, e, c);
            var f = $4d82739dd229d539$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4d82739dd229d539$var$Zf(d) ? (f = !0, $4d82739dd229d539$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4d82739dd229d539$var$kh(b), e.updater = $4d82739dd229d539$var$Ei, b.stateNode = e, e._reactInternals = b, $4d82739dd229d539$var$Ii(b, d, a, c), b = $4d82739dd229d539$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $4d82739dd229d539$var$I && f && $4d82739dd229d539$var$vg(b), $4d82739dd229d539$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4d82739dd229d539$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4d82739dd229d539$var$Zk(d);
                a = $4d82739dd229d539$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $4d82739dd229d539$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4d82739dd229d539$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4d82739dd229d539$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4d82739dd229d539$var$$i(null, b, d, $4d82739dd229d539$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($4d82739dd229d539$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $4d82739dd229d539$var$kj(b);
                if (null === a) throw Error($4d82739dd229d539$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4d82739dd229d539$var$lh(a, b);
                $4d82739dd229d539$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(423)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(424)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else for($4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.stateNode.containerInfo.firstChild), $4d82739dd229d539$var$xg = b, $4d82739dd229d539$var$I = !0, $4d82739dd229d539$var$zg = null, c = $4d82739dd229d539$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4d82739dd229d539$var$Ig();
                    if (d === e) {
                        b = $4d82739dd229d539$var$Zi(a, b, c);
                        break a;
                    }
                    $4d82739dd229d539$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4d82739dd229d539$var$Ah(b), null === a && $4d82739dd229d539$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4d82739dd229d539$var$Ef(d, e) ? g = null : null !== f && $4d82739dd229d539$var$Ef(d, f) && (b.flags |= 32), $4d82739dd229d539$var$gj(a, b), $4d82739dd229d539$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $4d82739dd229d539$var$Eg(b), null;
        case 13:
            return $4d82739dd229d539$var$oj(a, b, c);
        case 4:
            return $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4d82739dd229d539$var$Ug(b, null, d, c) : $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$Yi(a, b, d, e, c);
        case 7:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4d82739dd229d539$var$He(f.value, g)) {
                        if (f.children === e.children && !$4d82739dd229d539$var$Wf.current) {
                            b = $4d82739dd229d539$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4d82739dd229d539$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4d82739dd229d539$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4d82739dd229d539$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4d82739dd229d539$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4d82739dd229d539$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4d82739dd229d539$var$ch(b, c), e = $4d82739dd229d539$var$eh(e), d = d(e), b.flags |= 1, $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4d82739dd229d539$var$Ci(d, b.pendingProps), e = $4d82739dd229d539$var$Ci(d.type, e), $4d82739dd229d539$var$$i(a, b, d, e, c);
        case 15:
            return $4d82739dd229d539$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$ij(a, b), b.tag = 1, $4d82739dd229d539$var$Zf(d) ? (a = !0, $4d82739dd229d539$var$cg(b)) : a = !1, $4d82739dd229d539$var$ch(b, c), $4d82739dd229d539$var$Gi(b, d, e), $4d82739dd229d539$var$Ii(b, d, e, c), $4d82739dd229d539$var$jj(null, b, d, !0, a, c);
        case 19:
            return $4d82739dd229d539$var$xj(a, b, c);
        case 22:
            return $4d82739dd229d539$var$dj(a, b, c);
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
};
function $4d82739dd229d539$var$Fk(a, b) {
    return $4d82739dd229d539$var$ac(a, b);
}
function $4d82739dd229d539$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4d82739dd229d539$var$Bg(a, b, c, d) {
    return new $4d82739dd229d539$var$$k(a, b, c, d);
}
function $4d82739dd229d539$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4d82739dd229d539$var$Zk(a) {
    if ("function" === typeof a) return $4d82739dd229d539$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4d82739dd229d539$var$Da) return 11;
        if (a === $4d82739dd229d539$var$Ga) return 14;
    }
    return 2;
}
function $4d82739dd229d539$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $4d82739dd229d539$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4d82739dd229d539$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4d82739dd229d539$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4d82739dd229d539$var$ya:
            return $4d82739dd229d539$var$Tg(c.children, e, f, b);
        case $4d82739dd229d539$var$za:
            g = 8;
            e |= 8;
            break;
        case $4d82739dd229d539$var$Aa:
            return a = $4d82739dd229d539$var$Bg(12, c, b, e | 2), a.elementType = $4d82739dd229d539$var$Aa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ea:
            return a = $4d82739dd229d539$var$Bg(13, c, b, e), a.elementType = $4d82739dd229d539$var$Ea, a.lanes = f, a;
        case $4d82739dd229d539$var$Fa:
            return a = $4d82739dd229d539$var$Bg(19, c, b, e), a.elementType = $4d82739dd229d539$var$Fa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ia:
            return $4d82739dd229d539$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4d82739dd229d539$var$Ba:
                    g = 10;
                    break a;
                case $4d82739dd229d539$var$Ca:
                    g = 9;
                    break a;
                case $4d82739dd229d539$var$Da:
                    g = 11;
                    break a;
                case $4d82739dd229d539$var$Ga:
                    g = 14;
                    break a;
                case $4d82739dd229d539$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4d82739dd229d539$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4d82739dd229d539$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4d82739dd229d539$var$Tg(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$pj(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(22, a, d, b);
    a.elementType = $4d82739dd229d539$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4d82739dd229d539$var$Qg(a, b, c) {
    a = $4d82739dd229d539$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$Sg(a, b, c) {
    b = $4d82739dd229d539$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4d82739dd229d539$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4d82739dd229d539$var$zc(0);
    this.expirationTimes = $4d82739dd229d539$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4d82739dd229d539$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $4d82739dd229d539$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $4d82739dd229d539$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $4d82739dd229d539$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4d82739dd229d539$var$kh(f);
    return a;
}
function $4d82739dd229d539$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4d82739dd229d539$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4d82739dd229d539$var$dl(a) {
    if (!a) return $4d82739dd229d539$var$Vf;
    a = a._reactInternals;
    a: {
        if ($4d82739dd229d539$var$Vb(a) !== a || 1 !== a.tag) throw Error($4d82739dd229d539$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4d82739dd229d539$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4d82739dd229d539$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4d82739dd229d539$var$Zf(c)) return $4d82739dd229d539$var$bg(a, c, b);
    }
    return b;
}
function $4d82739dd229d539$var$el(a, b, c, d, e, f, g, h, k) {
    a = $4d82739dd229d539$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $4d82739dd229d539$var$dl(null);
    c = a.current;
    d = $4d82739dd229d539$var$R();
    e = $4d82739dd229d539$var$yi(c);
    f = $4d82739dd229d539$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4d82739dd229d539$var$nh(c, f, e);
    a.current.lanes = e;
    $4d82739dd229d539$var$Ac(a, e, d);
    $4d82739dd229d539$var$Dk(a, d);
    return a;
}
function $4d82739dd229d539$var$fl(a, b, c, d) {
    var e = b.current, f = $4d82739dd229d539$var$R(), g = $4d82739dd229d539$var$yi(e);
    c = $4d82739dd229d539$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4d82739dd229d539$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4d82739dd229d539$var$nh(e, b, g);
    null !== a && ($4d82739dd229d539$var$gi(a, e, g, f), $4d82739dd229d539$var$oh(a, e, g));
    return g;
}
function $4d82739dd229d539$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4d82739dd229d539$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4d82739dd229d539$var$il(a, b) {
    $4d82739dd229d539$var$hl(a, b);
    (a = a.alternate) && $4d82739dd229d539$var$hl(a, b);
}
function $4d82739dd229d539$var$jl() {
    return null;
}
var $4d82739dd229d539$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4d82739dd229d539$var$ll(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.render = $4d82739dd229d539$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4d82739dd229d539$var$p(409));
    $4d82739dd229d539$var$fl(a, b, null, null);
};
$4d82739dd229d539$var$ml.prototype.unmount = $4d82739dd229d539$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4d82739dd229d539$var$Rk(function() {
            $4d82739dd229d539$var$fl(null, a, null, null);
        });
        b[$4d82739dd229d539$var$uf] = null;
    }
};
function $4d82739dd229d539$var$ml(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4d82739dd229d539$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4d82739dd229d539$var$Qc.length && 0 !== b && b < $4d82739dd229d539$var$Qc[c].priority; c++);
        $4d82739dd229d539$var$Qc.splice(c, 0, a);
        0 === c && $4d82739dd229d539$var$Vc(a);
    }
};
function $4d82739dd229d539$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4d82739dd229d539$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4d82739dd229d539$var$pl() {}
function $4d82739dd229d539$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4d82739dd229d539$var$gl(g);
                f.call(a);
            };
        }
        var g = $4d82739dd229d539$var$el(b, d, a, 0, null, !1, !1, "", $4d82739dd229d539$var$pl);
        a._reactRootContainer = g;
        a[$4d82739dd229d539$var$uf] = g.current;
        $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
        $4d82739dd229d539$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4d82739dd229d539$var$gl(k);
            h.call(a);
        };
    }
    var k = $4d82739dd229d539$var$bl(a, 0, !1, null, null, !1, !1, "", $4d82739dd229d539$var$pl);
    a._reactRootContainer = k;
    a[$4d82739dd229d539$var$uf] = k.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    $4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$fl(b, k, c, d);
    });
    return k;
}
function $4d82739dd229d539$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4d82739dd229d539$var$gl(g);
                h.call(a);
            };
        }
        $4d82739dd229d539$var$fl(b, g, a, e);
    } else g = $4d82739dd229d539$var$ql(c, b, a, e, d);
    return $4d82739dd229d539$var$gl(g);
}
$4d82739dd229d539$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4d82739dd229d539$var$tc(b.pendingLanes);
                0 !== c && ($4d82739dd229d539$var$Cc(b, c | 1), $4d82739dd229d539$var$Dk(b, $4d82739dd229d539$var$B()), 0 === ($4d82739dd229d539$var$K & 6) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$jg()));
            }
            break;
        case 13:
            $4d82739dd229d539$var$Rk(function() {
                var b = $4d82739dd229d539$var$ih(a, 1);
                if (null !== b) {
                    var c = $4d82739dd229d539$var$R();
                    $4d82739dd229d539$var$gi(b, a, 1, c);
                }
            }), $4d82739dd229d539$var$il(a, 1);
    }
};
$4d82739dd229d539$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$ih(a, 134217728);
        if (null !== b) {
            var c = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(b, a, 134217728, c);
        }
        $4d82739dd229d539$var$il(a, 134217728);
    }
};
$4d82739dd229d539$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$yi(a), c = $4d82739dd229d539$var$ih(a, b);
        if (null !== c) {
            var d = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(c, a, b, d);
        }
        $4d82739dd229d539$var$il(a, b);
    }
};
$4d82739dd229d539$var$Hc = function() {
    return $4d82739dd229d539$var$C;
};
$4d82739dd229d539$var$Ic = function(a, b) {
    var c = $4d82739dd229d539$var$C;
    try {
        return $4d82739dd229d539$var$C = a, b();
    } finally{
        $4d82739dd229d539$var$C = c;
    }
};
$4d82739dd229d539$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4d82739dd229d539$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4d82739dd229d539$var$Db(d);
                        if (!e) throw Error($4d82739dd229d539$var$p(90));
                        $4d82739dd229d539$var$Wa(d);
                        $4d82739dd229d539$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4d82739dd229d539$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $4d82739dd229d539$var$fb(a, !!c.multiple, b, !1);
    }
};
$4d82739dd229d539$var$Gb = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$var$Hb = $4d82739dd229d539$var$Rk;
var $4d82739dd229d539$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $4d82739dd229d539$var$Cb,
        $4d82739dd229d539$var$ue,
        $4d82739dd229d539$var$Db,
        $4d82739dd229d539$var$Eb,
        $4d82739dd229d539$var$Fb,
        $4d82739dd229d539$var$Qk
    ]
}, $4d82739dd229d539$var$tl = {
    findFiberByHostInstance: $4d82739dd229d539$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $4d82739dd229d539$var$ul = {
    bundleType: $4d82739dd229d539$var$tl.bundleType,
    version: $4d82739dd229d539$var$tl.version,
    rendererPackageName: $4d82739dd229d539$var$tl.rendererPackageName,
    rendererConfig: $4d82739dd229d539$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4d82739dd229d539$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4d82739dd229d539$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4d82739dd229d539$var$tl.findFiberByHostInstance || $4d82739dd229d539$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4d82739dd229d539$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4d82739dd229d539$var$vl.isDisabled && $4d82739dd229d539$var$vl.supportsFiber) try {
        $4d82739dd229d539$var$kc = $4d82739dd229d539$var$vl.inject($4d82739dd229d539$var$ul), $4d82739dd229d539$var$lc = $4d82739dd229d539$var$vl;
    } catch (a) {}
}
$4d82739dd229d539$export$ae55be85d98224ed = $4d82739dd229d539$var$sl;
$4d82739dd229d539$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4d82739dd229d539$var$nl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$cl(a, b, null, c);
};
$4d82739dd229d539$export$882461b6382ed46c = function(a, b) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(299));
    var c = !1, d = "", e = $4d82739dd229d539$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4d82739dd229d539$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $4d82739dd229d539$var$ll(b);
};
$4d82739dd229d539$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4d82739dd229d539$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4d82739dd229d539$var$p(268, a));
    }
    a = $4d82739dd229d539$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4d82739dd229d539$export$cd75ccfd720a3cd4 = function(a) {
    return $4d82739dd229d539$var$Rk(a);
};
$4d82739dd229d539$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !0, c);
};
$4d82739dd229d539$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4d82739dd229d539$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4d82739dd229d539$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4d82739dd229d539$var$ml(b);
};
$4d82739dd229d539$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !1, c);
};
$4d82739dd229d539$export$502457920280e6be = function(a) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(40));
    return a._reactRootContainer ? ($4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4d82739dd229d539$var$uf] = null;
        });
    }), !0) : !1;
};
$4d82739dd229d539$export$c78a37762a8d58e1 = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4d82739dd229d539$var$ol(c)) throw Error($4d82739dd229d539$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4d82739dd229d539$var$p(38));
    return $4d82739dd229d539$var$rl(a, b, c, !1, d);
};
$4d82739dd229d539$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("33s19", function(module, exports) {
"use strict";

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$cf845f2c119da08a;
"use strict";
function $749777fefd570b40$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $749777fefd570b40$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $749777fefd570b40$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $749777fefd570b40$var$g(C, c)) n < e && 0 > $749777fefd570b40$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $749777fefd570b40$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $749777fefd570b40$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
var $749777fefd570b40$var$r = [], $749777fefd570b40$var$t = [], $749777fefd570b40$var$u = 1, $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = 3, $749777fefd570b40$var$z = !1, $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = !1, $749777fefd570b40$var$D = "function" === typeof setTimeout ? setTimeout : null, $749777fefd570b40$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $749777fefd570b40$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $749777fefd570b40$var$G(a) {
    for(var b = $749777fefd570b40$var$h($749777fefd570b40$var$t); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$k($749777fefd570b40$var$t);
        else if (b.startTime <= a) $749777fefd570b40$var$k($749777fefd570b40$var$t), b.sortIndex = b.expirationTime, $749777fefd570b40$var$f($749777fefd570b40$var$r, b);
        else break;
        b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
    }
}
function $749777fefd570b40$var$H(a) {
    $749777fefd570b40$var$B = !1;
    $749777fefd570b40$var$G(a);
    if (!$749777fefd570b40$var$A) {
        if (null !== $749777fefd570b40$var$h($749777fefd570b40$var$r)) $749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J);
        else {
            var b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== b && $749777fefd570b40$var$K($749777fefd570b40$var$H, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$J(a, b) {
    $749777fefd570b40$var$A = !1;
    $749777fefd570b40$var$B && ($749777fefd570b40$var$B = !1, $749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1);
    $749777fefd570b40$var$z = !0;
    var c = $749777fefd570b40$var$y;
    try {
        $749777fefd570b40$var$G(b);
        for($749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r); null !== $749777fefd570b40$var$v && (!($749777fefd570b40$var$v.expirationTime > b) || a && !$749777fefd570b40$var$M());){
            var d = $749777fefd570b40$var$v.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$v.callback = null;
                $749777fefd570b40$var$y = $749777fefd570b40$var$v.priorityLevel;
                var e = d($749777fefd570b40$var$v.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$v.callback = e : $749777fefd570b40$var$v === $749777fefd570b40$var$h($749777fefd570b40$var$r) && $749777fefd570b40$var$k($749777fefd570b40$var$r);
                $749777fefd570b40$var$G(b);
            } else $749777fefd570b40$var$k($749777fefd570b40$var$r);
            $749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r);
        }
        if (null !== $749777fefd570b40$var$v) var w = !0;
        else {
            var m = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== m && $749777fefd570b40$var$K($749777fefd570b40$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = c, $749777fefd570b40$var$z = !1;
    }
}
var $749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$L = -1, $749777fefd570b40$var$P = 5, $749777fefd570b40$var$Q = -1;
function $749777fefd570b40$var$M() {
    return $749777fefd570b40$export$c4744153514ff05d() - $749777fefd570b40$var$Q < $749777fefd570b40$var$P ? !1 : !0;
}
function $749777fefd570b40$var$R() {
    if (null !== $749777fefd570b40$var$O) {
        var a = $749777fefd570b40$export$c4744153514ff05d();
        $749777fefd570b40$var$Q = a;
        var b = !0;
        try {
            b = $749777fefd570b40$var$O(!0, a);
        } finally{
            b ? $749777fefd570b40$var$S() : ($749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null);
        }
    } else $749777fefd570b40$var$N = !1;
}
var $749777fefd570b40$var$S;
if ("function" === typeof $749777fefd570b40$var$F) $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$F($749777fefd570b40$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $749777fefd570b40$var$T = new MessageChannel, $749777fefd570b40$var$U = $749777fefd570b40$var$T.port2;
    $749777fefd570b40$var$T.port1.onmessage = $749777fefd570b40$var$R;
    $749777fefd570b40$var$S = function() {
        $749777fefd570b40$var$U.postMessage(null);
    };
} else $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$D($749777fefd570b40$var$R, 0);
};
function $749777fefd570b40$var$I(a) {
    $749777fefd570b40$var$O = a;
    $749777fefd570b40$var$N || ($749777fefd570b40$var$N = !0, $749777fefd570b40$var$S());
}
function $749777fefd570b40$var$K(a, b) {
    $749777fefd570b40$var$L = $749777fefd570b40$var$D(function() {
        a($749777fefd570b40$export$c4744153514ff05d());
    }, b);
}
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J));
};
$749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$y;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$h($749777fefd570b40$var$r);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$y;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = function() {};
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$f($749777fefd570b40$var$t, a), null === $749777fefd570b40$var$h($749777fefd570b40$var$r) && a === $749777fefd570b40$var$h($749777fefd570b40$var$t) && ($749777fefd570b40$var$B ? ($749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1) : $749777fefd570b40$var$B = !0, $749777fefd570b40$var$K($749777fefd570b40$var$H, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$f($749777fefd570b40$var$r, a), $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J)));
    return a;
};
$749777fefd570b40$export$b5836b71941fa3ed = $749777fefd570b40$var$M;
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$y;
    return function() {
        var c = $749777fefd570b40$var$y;
        $749777fefd570b40$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$y = c;
        }
    };
};

});



parcelRegister("BkELc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("a4yCM")).default; });

var $a4yCM = parcelRequire("a4yCM");

});
parcelRegister("a4yCM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01e4784db554ab3b$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $01e4784db554ab3b$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});


parcelRegister("akaBm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("6Be3X")).default; });

var $6Be3X = parcelRequire("6Be3X");

});
parcelRegister("6Be3X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ce11b585f518174$export$2e2bcd8739ae039; });
function $4ce11b585f518174$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $4ce11b585f518174$export$2e2bcd8739ae039 = $4ce11b585f518174$var$clamp;

});


parcelRegister("3oWWu", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $27a155bcdd967657$export$2b8d127b894957b9; }, function (v) { return $27a155bcdd967657$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $27a155bcdd967657$export$cea3a54a6425200c; }, function (v) { return $27a155bcdd967657$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $27a155bcdd967657$export$a7c73072b1a182ae; }, function (v) { return $27a155bcdd967657$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $27a155bcdd967657$export$9f27bc3417b4524d; }, function (v) { return $27a155bcdd967657$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $27a155bcdd967657$export$db77ccec0bb4ccac; }, function (v) { return $27a155bcdd967657$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $27a155bcdd967657$export$8392c0c9d3dcbd35; }, function (v) { return $27a155bcdd967657$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $27a155bcdd967657$export$ffb0004e005737fa; }, function (v) { return $27a155bcdd967657$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $27a155bcdd967657$export$b624eff549462981; }, function (v) { return $27a155bcdd967657$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $27a155bcdd967657$export$7897aa7841a5380c; }, function (v) { return $27a155bcdd967657$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $27a155bcdd967657$export$602eac185826482c; }, function (v) { return $27a155bcdd967657$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $27a155bcdd967657$export$e2c29f18771995cb; }, function (v) { return $27a155bcdd967657$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $27a155bcdd967657$export$5f8d39834fd61797; }, function (v) { return $27a155bcdd967657$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $27a155bcdd967657$export$74bf444e3cd11ea5; }, function (v) { return $27a155bcdd967657$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $27a155bcdd967657$export$92387174baf9b227; }, function (v) { return $27a155bcdd967657$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $27a155bcdd967657$export$ec112efeb987d9c6; }, function (v) { return $27a155bcdd967657$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $27a155bcdd967657$export$b706b080d889d2c9; }, function (v) { return $27a155bcdd967657$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $27a155bcdd967657$export$5be5a87408f70ddc; }, function (v) { return $27a155bcdd967657$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $27a155bcdd967657$export$45a5e7f76e0caa8d; }, function (v) { return $27a155bcdd967657$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $27a155bcdd967657$export$455c2e768291efa6; }, function (v) { return $27a155bcdd967657$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $27a155bcdd967657$export$9522e17588c12572; }, function (v) { return $27a155bcdd967657$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $27a155bcdd967657$export$2110ac352bb060b9; }, function (v) { return $27a155bcdd967657$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $27a155bcdd967657$export$56885ab8b9c456ab; }, function (v) { return $27a155bcdd967657$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $27a155bcdd967657$export$d927fcb6adf8f9de; }, function (v) { return $27a155bcdd967657$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $27a155bcdd967657$export$b82d16f27459e05a; }, function (v) { return $27a155bcdd967657$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $27a155bcdd967657$export$522c17b4f5e123e8; }, function (v) { return $27a155bcdd967657$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $27a155bcdd967657$export$1aabd8a0274ecfd6; }, function (v) { return $27a155bcdd967657$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $27a155bcdd967657$export$9b621391a187a31a; }, function (v) { return $27a155bcdd967657$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $27a155bcdd967657$export$f5bbd400c2f4426f; }, function (v) { return $27a155bcdd967657$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $27a155bcdd967657$export$2b8d127b894957b9;
var $27a155bcdd967657$export$cea3a54a6425200c;
var $27a155bcdd967657$export$a7c73072b1a182ae;
var $27a155bcdd967657$export$9f27bc3417b4524d;
var $27a155bcdd967657$export$db77ccec0bb4ccac;
var $27a155bcdd967657$export$8392c0c9d3dcbd35;
var $27a155bcdd967657$export$ffb0004e005737fa;
var $27a155bcdd967657$export$b624eff549462981;
var $27a155bcdd967657$export$7897aa7841a5380c;
var $27a155bcdd967657$export$602eac185826482c;
var $27a155bcdd967657$export$e2c29f18771995cb;
var $27a155bcdd967657$export$5f8d39834fd61797;
var $27a155bcdd967657$export$74bf444e3cd11ea5;
var $27a155bcdd967657$export$92387174baf9b227;
var $27a155bcdd967657$export$ec112efeb987d9c6;
var $27a155bcdd967657$export$b706b080d889d2c9;
var $27a155bcdd967657$export$5be5a87408f70ddc;
var $27a155bcdd967657$export$45a5e7f76e0caa8d;
var $27a155bcdd967657$export$455c2e768291efa6;
var $27a155bcdd967657$export$9522e17588c12572;
var $27a155bcdd967657$export$2110ac352bb060b9;
var $27a155bcdd967657$export$56885ab8b9c456ab;
var $27a155bcdd967657$export$d927fcb6adf8f9de;
var $27a155bcdd967657$export$b82d16f27459e05a;
var $27a155bcdd967657$export$522c17b4f5e123e8;
var $27a155bcdd967657$export$1aabd8a0274ecfd6;
var $27a155bcdd967657$export$9b621391a187a31a;
var $27a155bcdd967657$export$f5bbd400c2f4426f;
"use strict";
var $27a155bcdd967657$var$b = "function" === typeof Symbol && Symbol.for, $27a155bcdd967657$var$c = $27a155bcdd967657$var$b ? Symbol.for("react.element") : 60103, $27a155bcdd967657$var$d = $27a155bcdd967657$var$b ? Symbol.for("react.portal") : 60106, $27a155bcdd967657$var$e = $27a155bcdd967657$var$b ? Symbol.for("react.fragment") : 60107, $27a155bcdd967657$var$f = $27a155bcdd967657$var$b ? Symbol.for("react.strict_mode") : 60108, $27a155bcdd967657$var$g = $27a155bcdd967657$var$b ? Symbol.for("react.profiler") : 60114, $27a155bcdd967657$var$h = $27a155bcdd967657$var$b ? Symbol.for("react.provider") : 60109, $27a155bcdd967657$var$k = $27a155bcdd967657$var$b ? Symbol.for("react.context") : 60110, $27a155bcdd967657$var$l = $27a155bcdd967657$var$b ? Symbol.for("react.async_mode") : 60111, $27a155bcdd967657$var$m = $27a155bcdd967657$var$b ? Symbol.for("react.concurrent_mode") : 60111, $27a155bcdd967657$var$n = $27a155bcdd967657$var$b ? Symbol.for("react.forward_ref") : 60112, $27a155bcdd967657$var$p = $27a155bcdd967657$var$b ? Symbol.for("react.suspense") : 60113, $27a155bcdd967657$var$q = $27a155bcdd967657$var$b ? Symbol.for("react.suspense_list") : 60120, $27a155bcdd967657$var$r = $27a155bcdd967657$var$b ? Symbol.for("react.memo") : 60115, $27a155bcdd967657$var$t = $27a155bcdd967657$var$b ? Symbol.for("react.lazy") : 60116, $27a155bcdd967657$var$v = $27a155bcdd967657$var$b ? Symbol.for("react.block") : 60121, $27a155bcdd967657$var$w = $27a155bcdd967657$var$b ? Symbol.for("react.fundamental") : 60117, $27a155bcdd967657$var$x = $27a155bcdd967657$var$b ? Symbol.for("react.responder") : 60118, $27a155bcdd967657$var$y = $27a155bcdd967657$var$b ? Symbol.for("react.scope") : 60119;
function $27a155bcdd967657$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $27a155bcdd967657$var$c:
                switch(a = a.type, a){
                    case $27a155bcdd967657$var$l:
                    case $27a155bcdd967657$var$m:
                    case $27a155bcdd967657$var$e:
                    case $27a155bcdd967657$var$g:
                    case $27a155bcdd967657$var$f:
                    case $27a155bcdd967657$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $27a155bcdd967657$var$k:
                            case $27a155bcdd967657$var$n:
                            case $27a155bcdd967657$var$t:
                            case $27a155bcdd967657$var$r:
                            case $27a155bcdd967657$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $27a155bcdd967657$var$d:
                return u;
        }
    }
}
function $27a155bcdd967657$var$A(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$m;
}
$27a155bcdd967657$export$2b8d127b894957b9 = $27a155bcdd967657$var$l;
$27a155bcdd967657$export$cea3a54a6425200c = $27a155bcdd967657$var$m;
$27a155bcdd967657$export$a7c73072b1a182ae = $27a155bcdd967657$var$k;
$27a155bcdd967657$export$9f27bc3417b4524d = $27a155bcdd967657$var$h;
$27a155bcdd967657$export$db77ccec0bb4ccac = $27a155bcdd967657$var$c;
$27a155bcdd967657$export$8392c0c9d3dcbd35 = $27a155bcdd967657$var$n;
$27a155bcdd967657$export$ffb0004e005737fa = $27a155bcdd967657$var$e;
$27a155bcdd967657$export$b624eff549462981 = $27a155bcdd967657$var$t;
$27a155bcdd967657$export$7897aa7841a5380c = $27a155bcdd967657$var$r;
$27a155bcdd967657$export$602eac185826482c = $27a155bcdd967657$var$d;
$27a155bcdd967657$export$e2c29f18771995cb = $27a155bcdd967657$var$g;
$27a155bcdd967657$export$5f8d39834fd61797 = $27a155bcdd967657$var$f;
$27a155bcdd967657$export$74bf444e3cd11ea5 = $27a155bcdd967657$var$p;
$27a155bcdd967657$export$92387174baf9b227 = function(a) {
    return $27a155bcdd967657$var$A(a) || $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$l;
};
$27a155bcdd967657$export$ec112efeb987d9c6 = $27a155bcdd967657$var$A;
$27a155bcdd967657$export$b706b080d889d2c9 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$k;
};
$27a155bcdd967657$export$5be5a87408f70ddc = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$h;
};
$27a155bcdd967657$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $27a155bcdd967657$var$c;
};
$27a155bcdd967657$export$455c2e768291efa6 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$n;
};
$27a155bcdd967657$export$9522e17588c12572 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$e;
};
$27a155bcdd967657$export$2110ac352bb060b9 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$t;
};
$27a155bcdd967657$export$56885ab8b9c456ab = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$r;
};
$27a155bcdd967657$export$d927fcb6adf8f9de = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$d;
};
$27a155bcdd967657$export$b82d16f27459e05a = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$g;
};
$27a155bcdd967657$export$522c17b4f5e123e8 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$f;
};
$27a155bcdd967657$export$1aabd8a0274ecfd6 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$p;
};
$27a155bcdd967657$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $27a155bcdd967657$var$e || a === $27a155bcdd967657$var$m || a === $27a155bcdd967657$var$g || a === $27a155bcdd967657$var$f || a === $27a155bcdd967657$var$p || a === $27a155bcdd967657$var$q || "object" === typeof a && null !== a && (a.$$typeof === $27a155bcdd967657$var$t || a.$$typeof === $27a155bcdd967657$var$r || a.$$typeof === $27a155bcdd967657$var$h || a.$$typeof === $27a155bcdd967657$var$k || a.$$typeof === $27a155bcdd967657$var$n || a.$$typeof === $27a155bcdd967657$var$w || a.$$typeof === $27a155bcdd967657$var$x || a.$$typeof === $27a155bcdd967657$var$y || a.$$typeof === $27a155bcdd967657$var$v);
};
$27a155bcdd967657$export$f5bbd400c2f4426f = $27a155bcdd967657$var$z;

});

parcelRegister("cvBp9", function(module, exports) {
function $91b5651481cc9d5c$var$_extends() {
    module.exports = $91b5651481cc9d5c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $91b5651481cc9d5c$var$_extends.apply(this, arguments);
}
module.exports = $91b5651481cc9d5c$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5VCcJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $450fe936b88a7a32$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $450fe936b88a7a32$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("hpTPt")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("bpHMA")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("bpHMA")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("e6xq6")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("5tMhb")).default; });
/**
 * @mui/styled-engine v5.15.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $cbgs6 = parcelRequire("cbgs6");
parcelRequire("bpHMA");
var $hpTPt = parcelRequire("hpTPt");
var $bpHMA = parcelRequire("bpHMA");

var $e6xq6 = parcelRequire("e6xq6");

var $5tMhb = parcelRequire("5tMhb");
"use client";
function $450fe936b88a7a32$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $cbgs6.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $450fe936b88a7a32$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("cbgs6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8de346382d86c747$export$2e2bcd8739ae039; });

var $2MQws = parcelRequire("2MQws");
parcelRequire("cvBp9");
parcelRequire("7fPBF");
parcelRequire("9YmaI");

parcelRequire("6g0AG");
parcelRequire("3kqr7");
parcelRequire("fjS7T");
var $8de346382d86c747$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $8de346382d86c747$export$2e2bcd8739ae039 = (0, $2MQws.default).bind();
$8de346382d86c747$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $8de346382d86c747$export$2e2bcd8739ae039[tagName] = $8de346382d86c747$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("2MQws", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2078ce513e00dfd7$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $9YmaI = parcelRequire("9YmaI");
parcelRequire("bpHMA");
var $hpTPt = parcelRequire("hpTPt");

var $6g0AG = parcelRequire("6g0AG");

var $3kqr7 = parcelRequire("3kqr7");

var $fjS7T = parcelRequire("fjS7T");
var $2078ce513e00dfd7$var$testOmitPropsOnStringTag = (0, $9YmaI.default);
var $2078ce513e00dfd7$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $2078ce513e00dfd7$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $2078ce513e00dfd7$var$testOmitPropsOnStringTag : $2078ce513e00dfd7$var$testOmitPropsOnComponent;
};
var $2078ce513e00dfd7$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $2078ce513e00dfd7$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $2078ce513e00dfd7$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $6g0AG.registerStyles)(cache, serialized, isStringTag);
    (0, $fjS7T.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $6g0AG.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $2078ce513e00dfd7$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $2078ce513e00dfd7$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $2078ce513e00dfd7$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $hpTPt.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $7fPBF.useContext((0, $hpTPt.T));
            }
            if (typeof props.className === "string") className = (0, $6g0AG.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $3kqr7.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $2078ce513e00dfd7$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($2078ce513e00dfd7$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $7fPBF.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $kY3Ke.default)({}, options, nextOptions, {
                shouldForwardProp: $2078ce513e00dfd7$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("kY3Ke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f43c50d92a19d876$export$2e2bcd8739ae039; });
function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f43c50d92a19d876$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("9YmaI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $742aea85e4e67b26$export$2e2bcd8739ae039; });

var $4AWAi = parcelRequire("4AWAi");
var $742aea85e4e67b26$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $742aea85e4e67b26$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $4AWAi.default)(function(prop) {
    return $742aea85e4e67b26$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("4AWAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3587f7e2ed7416b3$export$2e2bcd8739ae039; });
function $3587f7e2ed7416b3$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("bpHMA", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $84f3fdd51733d70b$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $84f3fdd51733d70b$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $84f3fdd51733d70b$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("hpTPt")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("hpTPt")).w; });

var $hpTPt = parcelRequire("hpTPt");

var $7fPBF = parcelRequire("7fPBF");

var $6g0AG = parcelRequire("6g0AG");

var $fjS7T = parcelRequire("fjS7T");

var $3kqr7 = parcelRequire("3kqr7");
parcelRequire("10euI");
parcelRequire("cvBp9");
parcelRequire("lT6zG");

parcelRequire("8Ae2G");
var $84f3fdd51733d70b$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $84f3fdd51733d70b$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $hpTPt.h).call(props, "css")) // $FlowFixMe
    return $7fPBF.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $hpTPt.E);
    createElementArgArray[1] = (0, $hpTPt.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $7fPBF.createElement.apply(null, createElementArgArray);
};
var $84f3fdd51733d70b$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $84f3fdd51733d70b$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $hpTPt.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $3kqr7.serializeStyles)([
        styles
    ], undefined, $7fPBF.useContext((0, $hpTPt.T)));
    if (!(0, $hpTPt.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $7fPBF.useRef();
    (0, $fjS7T.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $fjS7T.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $6g0AG.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $84f3fdd51733d70b$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $3kqr7.serializeStyles)(args);
}
var $84f3fdd51733d70b$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $84f3fdd51733d70b$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $84f3fdd51733d70b$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $84f3fdd51733d70b$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $6g0AG.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $84f3fdd51733d70b$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $fjS7T.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $6g0AG.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $84f3fdd51733d70b$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $hpTPt.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $3kqr7.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $6g0AG.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $84f3fdd51733d70b$var$merge(cache.registered, css, $84f3fdd51733d70b$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $7fPBF.useContext((0, $hpTPt.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($84f3fdd51733d70b$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $84f3fdd51733d70b$var$isBrowser, $84f3fdd51733d70b$var$isTestEnv, $84f3fdd51733d70b$var$globalContext, $84f3fdd51733d70b$var$globalKey;

});
parcelRegister("hpTPt", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $cae013ffcc17fa1e$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $cae013ffcc17fa1e$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $cae013ffcc17fa1e$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $cae013ffcc17fa1e$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $cae013ffcc17fa1e$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $cae013ffcc17fa1e$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $cae013ffcc17fa1e$export$a9c23c6ac3fc3eca; });

var $7fPBF = parcelRequire("7fPBF");

var $10euI = parcelRequire("10euI");

var $kY3Ke = parcelRequire("kY3Ke");

var $lT6zG = parcelRequire("lT6zG");

var $haRds = parcelRequire("haRds");

var $6g0AG = parcelRequire("6g0AG");

var $3kqr7 = parcelRequire("3kqr7");

var $fjS7T = parcelRequire("fjS7T");
var $cae013ffcc17fa1e$export$23f2a1d2818174ef = true;
var $cae013ffcc17fa1e$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $cae013ffcc17fa1e$var$EmotionCacheContext = /* #__PURE__ */ $7fPBF.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $10euI.default)({
    key: "css"
}) : null);
var $cae013ffcc17fa1e$export$e7094788287c5e9b = $cae013ffcc17fa1e$var$EmotionCacheContext.Provider;
var $cae013ffcc17fa1e$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $7fPBF.useContext)($cae013ffcc17fa1e$var$EmotionCacheContext);
};
var $cae013ffcc17fa1e$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7fPBF.useContext)($cae013ffcc17fa1e$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$cae013ffcc17fa1e$export$23f2a1d2818174ef) $cae013ffcc17fa1e$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $7fPBF.useContext)($cae013ffcc17fa1e$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $10euI.default)({
                key: "css"
            });
            return /*#__PURE__*/ $7fPBF.createElement($cae013ffcc17fa1e$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $cae013ffcc17fa1e$export$971d5caa766a69d7 = /* #__PURE__ */ $7fPBF.createContext({});
var $cae013ffcc17fa1e$export$3b14a55fb2447963 = function useTheme() {
    return $7fPBF.useContext($cae013ffcc17fa1e$export$971d5caa766a69d7);
};
var $cae013ffcc17fa1e$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $kY3Ke.default)({}, outerTheme, theme);
};
var $cae013ffcc17fa1e$var$createCacheWithTheme = /* #__PURE__ */ (0, $lT6zG.default)(function(outerTheme) {
    return (0, $lT6zG.default)(function(theme) {
        return $cae013ffcc17fa1e$var$getTheme(outerTheme, theme);
    });
});
var $cae013ffcc17fa1e$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $7fPBF.useContext($cae013ffcc17fa1e$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $cae013ffcc17fa1e$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7fPBF.createElement($cae013ffcc17fa1e$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $cae013ffcc17fa1e$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $7fPBF.useContext($cae013ffcc17fa1e$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $7fPBF.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $haRds.default)(WithTheme, Component);
}
var $cae013ffcc17fa1e$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $cae013ffcc17fa1e$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $cae013ffcc17fa1e$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $cae013ffcc17fa1e$var$getLastPart(match[1]);
    return undefined;
};
var $cae013ffcc17fa1e$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $cae013ffcc17fa1e$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $cae013ffcc17fa1e$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $cae013ffcc17fa1e$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($cae013ffcc17fa1e$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $cae013ffcc17fa1e$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $cae013ffcc17fa1e$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $cae013ffcc17fa1e$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $cae013ffcc17fa1e$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($cae013ffcc17fa1e$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$cae013ffcc17fa1e$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $cae013ffcc17fa1e$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $6g0AG.registerStyles)(cache, serialized, isStringTag);
    (0, $fjS7T.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $6g0AG.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $cae013ffcc17fa1e$var$Emotion = /* #__PURE__ */ $cae013ffcc17fa1e$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$cae013ffcc17fa1e$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $6g0AG.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $3kqr7.serializeStyles)(registeredStyles, undefined, $7fPBF.useContext($cae013ffcc17fa1e$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($cae013ffcc17fa1e$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $cae013ffcc17fa1e$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($cae013ffcc17fa1e$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $7fPBF.createElement(WrappedComponent, newProps));
});
var $cae013ffcc17fa1e$export$a9c23c6ac3fc3eca = $cae013ffcc17fa1e$var$Emotion;

});
parcelRegister("10euI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bb108cf9f15301b$export$2e2bcd8739ae039; });

var $67tST = parcelRequire("67tST");

var $cByrN = parcelRequire("cByrN");
parcelRequire("lT6zG");
parcelRequire("4AWAi");
var $0bb108cf9f15301b$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $cByrN.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $cByrN.token)(character)) break;
        (0, $cByrN.next)();
    }
    return (0, $cByrN.slice)(begin, (0, $cByrN.position));
};
var $0bb108cf9f15301b$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $cByrN.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $cByrN.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $0bb108cf9f15301b$var$identifierWithPointTracking((0, $cByrN.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $cByrN.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $cByrN.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $cByrN.from)(character);
    }
    while (character = (0, $cByrN.next)());
    return parsed;
};
var $0bb108cf9f15301b$var$getRules = function getRules(value, points) {
    return (0, $cByrN.dealloc)($0bb108cf9f15301b$var$toRules((0, $cByrN.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $0bb108cf9f15301b$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $0bb108cf9f15301b$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$0bb108cf9f15301b$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $0bb108cf9f15301b$var$fixedElements.set(element, true);
    var points = [];
    var rules = $0bb108cf9f15301b$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $0bb108cf9f15301b$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $0bb108cf9f15301b$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $0bb108cf9f15301b$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($0bb108cf9f15301b$var$ignoreFlag) > -1;
};
var $0bb108cf9f15301b$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($0bb108cf9f15301b$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $0bb108cf9f15301b$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $0bb108cf9f15301b$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$0bb108cf9f15301b$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $0bb108cf9f15301b$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $0bb108cf9f15301b$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$0bb108cf9f15301b$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $0bb108cf9f15301b$var$nullifyElement(element);
    } else if ($0bb108cf9f15301b$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $0bb108cf9f15301b$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $0bb108cf9f15301b$var$prefix(value, length) {
    switch((0, $cByrN.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $cByrN.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $cByrN.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MOZ) + value + (0, $cByrN.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + value + value;
        // order
        case 6165:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.replace)(value, /(\w+).+(:[^]+)/, (0, $cByrN.WEBKIT) + "box-$1$2" + (0, $cByrN.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + "flex-item-" + (0, $cByrN.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + "flex-line-pack" + (0, $cByrN.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $cByrN.WEBKIT) + "box-" + (0, $cByrN.replace)(value, "-grow", "") + (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $cByrN.WEBKIT) + (0, $cByrN.replace)(value, /([^-])(transform)/g, "$1" + (0, $cByrN.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $cByrN.replace)((0, $cByrN.replace)((0, $cByrN.replace)(value, /(zoom-|grab)/, (0, $cByrN.WEBKIT) + "$1"), /(image-set)/, (0, $cByrN.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $cByrN.replace)(value, /(image-set\([^]*)/, (0, $cByrN.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $cByrN.replace)((0, $cByrN.replace)(value, /(.+:)(flex-)?(.*)/, (0, $cByrN.WEBKIT) + "box-pack:$3" + (0, $cByrN.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $cByrN.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $cByrN.replace)(value, /(.+)-inline(.+)/, (0, $cByrN.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $cByrN.strlen)(value) - 1 - length > 6) switch((0, $cByrN.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $cByrN.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $cByrN.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $cByrN.WEBKIT) + "$2-$3" + "$1" + (0, $cByrN.MOZ) + ((0, $cByrN.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $cByrN.indexof)(value, "stretch") ? $0bb108cf9f15301b$var$prefix((0, $cByrN.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $cByrN.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $cByrN.charat)(value, (0, $cByrN.strlen)(value) - 3 - (~(0, $cByrN.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $cByrN.replace)(value, ":", ":" + (0, $cByrN.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $cByrN.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $cByrN.WEBKIT) + ((0, $cByrN.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $cByrN.WEBKIT) + "$2$3" + "$1" + (0, $cByrN.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $cByrN.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + value + value;
    }
    return value;
}
var $0bb108cf9f15301b$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $cByrN.DECLARATION:
                element["return"] = $0bb108cf9f15301b$var$prefix(element.value, element.length);
                break;
            case 0, $cByrN.KEYFRAMES:
                return (0, $cByrN.serialize)([
                    (0, $cByrN.copy)(element, {
                        value: (0, $cByrN.replace)(element.value, "@", "@" + (0, $cByrN.WEBKIT))
                    })
                ], callback);
            case 0, $cByrN.RULESET:
                if (element.length) return (0, $cByrN.combine)(element.props, function(value) {
                    switch((0, $cByrN.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $cByrN.serialize)([
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(read-\w+)/, ":" + (0, $cByrN.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $cByrN.serialize)([
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, ":" + (0, $cByrN.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, ":" + (0, $cByrN.MOZ) + "$1")
                                    ]
                                }),
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, (0, $cByrN.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $0bb108cf9f15301b$var$defaultStylisPlugins = [
    $0bb108cf9f15301b$var$prefixer
];
var $0bb108cf9f15301b$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $0bb108cf9f15301b$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $0bb108cf9f15301b$var$compat,
        $0bb108cf9f15301b$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $cByrN.stringify),
        (0, $cByrN.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $cByrN.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $cByrN.serialize)((0, $cByrN.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $67tST.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("67tST", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $474a93eda108ec7a$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $474a93eda108ec7a$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $474a93eda108ec7a$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $474a93eda108ec7a$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($474a93eda108ec7a$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $474a93eda108ec7a$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("cByrN", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $83f8df0fc4bef2f6$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $83f8df0fc4bef2f6$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $83f8df0fc4bef2f6$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $83f8df0fc4bef2f6$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $83f8df0fc4bef2f6$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $83f8df0fc4bef2f6$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $83f8df0fc4bef2f6$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $83f8df0fc4bef2f6$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $83f8df0fc4bef2f6$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $83f8df0fc4bef2f6$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $83f8df0fc4bef2f6$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $83f8df0fc4bef2f6$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $83f8df0fc4bef2f6$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $83f8df0fc4bef2f6$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $83f8df0fc4bef2f6$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $83f8df0fc4bef2f6$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $83f8df0fc4bef2f6$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $83f8df0fc4bef2f6$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $83f8df0fc4bef2f6$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $83f8df0fc4bef2f6$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $83f8df0fc4bef2f6$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $83f8df0fc4bef2f6$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $83f8df0fc4bef2f6$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $83f8df0fc4bef2f6$export$38bcb760f1d4871c; });
var $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 = "-ms-";
var $83f8df0fc4bef2f6$export$2c0f367103c8d01c = "-moz-";
var $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 = "-webkit-";
var $83f8df0fc4bef2f6$export$a29989082612d0d9 = "comm";
var $83f8df0fc4bef2f6$export$aa3a2e812ca8570d = "rule";
var $83f8df0fc4bef2f6$export$527d108ccf083c2b = "decl";
var $83f8df0fc4bef2f6$export$d3d35020fa5b54f0 = "@page";
var $83f8df0fc4bef2f6$export$500415a86c544f73 = "@media";
var $83f8df0fc4bef2f6$export$a763edbf796b780a = "@import";
var $83f8df0fc4bef2f6$export$2790aeb8b4e5c826 = "@charset";
var $83f8df0fc4bef2f6$export$1cc683e23b84b133 = "@viewport";
var $83f8df0fc4bef2f6$export$9447a5efea57e862 = "@supports";
var $83f8df0fc4bef2f6$export$ef011b4e114b1fba = "@document";
var $83f8df0fc4bef2f6$export$6aad947bda0f3f46 = "@namespace";
var $83f8df0fc4bef2f6$export$b44a8529a35fcb60 = "@keyframes";
var $83f8df0fc4bef2f6$export$2c16de31893252e6 = "@font-face";
var $83f8df0fc4bef2f6$export$3d846dd52e150c6f = "@counter-style";
var $83f8df0fc4bef2f6$export$22314bfbb57653fe = "@font-feature-values";
var $83f8df0fc4bef2f6$export$d773506282b3cfe6 = "@layer";
var $83f8df0fc4bef2f6$export$2335f513bbd82c6d = Math.abs;
var $83f8df0fc4bef2f6$export$6788812c4e6611e6 = String.fromCharCode;
var $83f8df0fc4bef2f6$export$e6e34fd1f2686227 = Object.assign;
function $83f8df0fc4bef2f6$export$d6af199866bfb566(e, r) {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 1)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 2)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 3) : 0;
}
function $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $83f8df0fc4bef2f6$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $83f8df0fc4bef2f6$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $83f8df0fc4bef2f6$export$36776f635604f274(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$f9084667e487ed46(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $83f8df0fc4bef2f6$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = 1;
var $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1;
var $83f8df0fc4bef2f6$export$f24224f1c91d8156 = 0;
var $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0;
var $83f8df0fc4bef2f6$export$c0306caf338ac095 = 0;
var $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "";
function $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c,
        column: $83f8df0fc4bef2f6$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $83f8df0fc4bef2f6$export$784d13d8ee351f07(e, r) {
    return $83f8df0fc4bef2f6$export$e6e34fd1f2686227($83f8df0fc4bef2f6$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $83f8df0fc4bef2f6$export$eba6f6f03b0a92e7() {
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$232faf9add678146() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 > 0 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, --$83f8df0fc4bef2f6$export$5880b8b5730aff45) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3--, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c--;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 < $83f8df0fc4bef2f6$export$f24224f1c91d8156 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45++) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3++, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c++;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$e88cb2efb12ae807() {
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, r) {
    return $83f8df0fc4bef2f6$export$2f35ab04d2335697($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, e, r);
}
function $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $83f8df0fc4bef2f6$export$2de70f21292aac9e(e) {
    return $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$f24224f1c91d8156 = $83f8df0fc4bef2f6$export$36776f635604f274($83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = e), $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0, [];
}
function $83f8df0fc4bef2f6$export$45918ac1574455b1(e) {
    return $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "", e;
}
function $83f8df0fc4bef2f6$export$410ac95b9ec204b8(e) {
    return $83f8df0fc4bef2f6$export$87c2784dc9fc4ab($83f8df0fc4bef2f6$export$58adb3bec8346d0f($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1, $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1($83f8df0fc4bef2f6$export$2de70f21292aac9e(e)));
}
function $83f8df0fc4bef2f6$export$7af1228ff777d175(e) {
    while($83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 33) $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    else break;
    return $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) > 2 || $83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095)){
        case 0:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
            break;
        default:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
    }
    return e;
}
function $83f8df0fc4bef2f6$export$955ba06d119e085e(e, r) {
    while(--r && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 48 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 102 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 57 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 65 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 70 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 97) break;
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$e88cb2efb12ae807() + (r < 6 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() == 32 && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() == 32));
}
function $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$c0306caf338ac095){
        case e:
            return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12($83f8df0fc4bef2f6$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
            break;
    }
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$4254d4e2b3745c4c(e, r) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 57) break;
    else if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 84 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $83f8df0fc4bef2f6$export$58adb3bec8346d0f(r, $83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1) + "*" + $83f8df0fc4bef2f6$export$6788812c4e6611e6(e === 47 ? e : $83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
}
function $83f8df0fc4bef2f6$export$c2ab62c7bf24634(e) {
    while(!$83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()))$83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$ef7acd7185315e22(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $83f8df0fc4bef2f6$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $83f8df0fc4bef2f6$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($83f8df0fc4bef2f6$export$f8e21b1e77979a08(j += $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $83f8df0fc4bef2f6$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $83f8df0fc4bef2f6$export$955ba06d119e085e($83f8df0fc4bef2f6$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$4a34f930e789283c($83f8df0fc4bef2f6$export$4254d4e2b3745c4c($83f8df0fc4bef2f6$export$48cfd1e771a65c4f(), $83f8df0fc4bef2f6$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $83f8df0fc4bef2f6$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $83f8df0fc4bef2f6$export$36776f635604f274(j) - l) $83f8df0fc4bef2f6$export$10d8903dec122b9d(p > 32 ? $83f8df0fc4bef2f6$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $83f8df0fc4bef2f6$export$f8483753829ec8f3($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d(y = $83f8df0fc4bef2f6$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, y, y, n && $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $83f8df0fc4bef2f6$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $83f8df0fc4bef2f6$export$232faf9add678146() == 125) continue;
            }
            switch(j += $83f8df0fc4bef2f6$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($83f8df0fc4bef2f6$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 45) j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
                    v = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e(), o = l = $83f8df0fc4bef2f6$export$36776f635604f274(g = j += $83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $83f8df0fc4bef2f6$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $83f8df0fc4bef2f6$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, v + 1, v = $83f8df0fc4bef2f6$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, s === 0 ? $83f8df0fc4bef2f6$export$aa3a2e812ca8570d : i, f, o, l);
}
function $83f8df0fc4bef2f6$export$4a34f930e789283c(e, r, a) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$a29989082612d0d9, $83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$eba6f6f03b0a92e7()), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $83f8df0fc4bef2f6$export$f8483753829ec8f3(e, r, a, n) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$527d108ccf083c2b, $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 0, n), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n, c, s) {
    switch($83f8df0fc4bef2f6$export$d6af199866bfb566(n, c)){
        case 5103:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-$1$2" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-item-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-line-pack" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-grow", "") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-pack:$3" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-column-align" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(s, "span") ? $83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) : +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) - +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($83f8df0fc4bef2f6$export$36776f635604f274(n) - 1 - c > 6) switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n, "stretch") ? $83f8df0fc4bef2f6$export$82e9f45cca5ba907($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 6) === 121) return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, $83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $83f8df0fc4bef2f6$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $83f8df0fc4bef2f6$export$a763edbf796b780a:
        case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $83f8df0fc4bef2f6$export$a29989082612d0d9:
            return "";
        case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $83f8df0fc4bef2f6$export$36776f635604f274(a = $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $83f8df0fc4bef2f6$export$5a7767152ae0305f(e) {
    var r = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $83f8df0fc4bef2f6$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $83f8df0fc4bef2f6$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
                n.return = $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
                return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                    $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                        value: $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
                if (n.length) return $83f8df0fc4bef2f6$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($83f8df0fc4bef2f6$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $83f8df0fc4bef2f6$export$76a88f7de6507443(e) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $83f8df0fc4bef2f6$export$1be1fc439b849fdf($83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($83f8df0fc4bef2f6$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $83f8df0fc4bef2f6$export$2f35ab04d2335697(r, 1, $83f8df0fc4bef2f6$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $83f8df0fc4bef2f6$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $83f8df0fc4bef2f6$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("lT6zG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fef3d59b736200bc$export$2e2bcd8739ae039; });
var $fef3d59b736200bc$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRegister("haRds", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c80ca66c64e3fad5$export$2e2bcd8739ae039; });

var $8Ae2G = parcelRequire("8Ae2G");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $c80ca66c64e3fad5$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(targetComponent, sourceComponent);
};

});
parcelRegister("8Ae2G", function(module, exports) {
"use strict";

var $dOv1V = parcelRequire("dOv1V");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $63fc9407ef8fcdfe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $63fc9407ef8fcdfe$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$TYPE_STATICS = {};
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dOv1V.ForwardRef] = $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS;
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dOv1V.Memo] = $63fc9407ef8fcdfe$var$MEMO_STATICS;
function $63fc9407ef8fcdfe$var$getStatics(component) {
    // React v16.11 and below
    if ($dOv1V.isMemo(component)) return $63fc9407ef8fcdfe$var$MEMO_STATICS;
     // React v16.12 and above
    return $63fc9407ef8fcdfe$var$TYPE_STATICS[component["$$typeof"]] || $63fc9407ef8fcdfe$var$REACT_STATICS;
}
var $63fc9407ef8fcdfe$var$defineProperty = Object.defineProperty;
var $63fc9407ef8fcdfe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $63fc9407ef8fcdfe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $63fc9407ef8fcdfe$var$getPrototypeOf = Object.getPrototypeOf;
var $63fc9407ef8fcdfe$var$objectPrototype = Object.prototype;
function $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($63fc9407ef8fcdfe$var$objectPrototype) {
            var inheritedComponent = $63fc9407ef8fcdfe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $63fc9407ef8fcdfe$var$objectPrototype) $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $63fc9407ef8fcdfe$var$getOwnPropertyNames(sourceComponent);
        if ($63fc9407ef8fcdfe$var$getOwnPropertySymbols) keys = keys.concat($63fc9407ef8fcdfe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $63fc9407ef8fcdfe$var$getStatics(targetComponent);
        var sourceStatics = $63fc9407ef8fcdfe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$63fc9407ef8fcdfe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $63fc9407ef8fcdfe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $63fc9407ef8fcdfe$var$hoistNonReactStatics;

});
parcelRegister("dOv1V", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3oWWu"));

});



parcelRegister("6g0AG", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $48e4b1fcfcd646c1$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $48e4b1fcfcd646c1$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $48e4b1fcfcd646c1$export$6f077d94b33a01aa; });
var $48e4b1fcfcd646c1$var$isBrowser = true;
function $48e4b1fcfcd646c1$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $48e4b1fcfcd646c1$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $48e4b1fcfcd646c1$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $48e4b1fcfcd646c1$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $48e4b1fcfcd646c1$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("3kqr7", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $26c7bf120a29b208$export$6321afa313b251b5; });

var $1OEsj = parcelRequire("1OEsj");

var $cfR4M = parcelRequire("cfR4M");

var $4AWAi = parcelRequire("4AWAi");
var $26c7bf120a29b208$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $26c7bf120a29b208$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $26c7bf120a29b208$var$hyphenateRegex = /[A-Z]|^ms/g;
var $26c7bf120a29b208$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $26c7bf120a29b208$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $26c7bf120a29b208$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $26c7bf120a29b208$var$processStyleName = /* #__PURE__ */ (0, $4AWAi.default)(function(styleName) {
    return $26c7bf120a29b208$var$isCustomProperty(styleName) ? styleName : styleName.replace($26c7bf120a29b208$var$hyphenateRegex, "-$&").toLowerCase();
});
var $26c7bf120a29b208$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($26c7bf120a29b208$var$animationRegex, function(match, p1, p2) {
                $26c7bf120a29b208$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $26c7bf120a29b208$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cfR4M.default)[key] !== 1 && !$26c7bf120a29b208$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $26c7bf120a29b208$var$contentValuePattern, $26c7bf120a29b208$var$contentValues, $26c7bf120a29b208$var$oldProcessStyleValue, $26c7bf120a29b208$var$msPattern, $26c7bf120a29b208$var$hyphenPattern, $26c7bf120a29b208$var$hyphenatedCache;
var $26c7bf120a29b208$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $26c7bf120a29b208$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $26c7bf120a29b208$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $26c7bf120a29b208$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $26c7bf120a29b208$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $26c7bf120a29b208$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $26c7bf120a29b208$var$cursor;
                var result = interpolation(mergedProps);
                $26c7bf120a29b208$var$cursor = previousCursor;
                return $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $26c7bf120a29b208$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($26c7bf120a29b208$var$isProcessableValue(value)) string += $26c7bf120a29b208$var$processStyleName(_key) + ":" + $26c7bf120a29b208$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($26c7bf120a29b208$var$isProcessableValue(value[_i])) string += $26c7bf120a29b208$var$processStyleName(_key) + ":" + $26c7bf120a29b208$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $26c7bf120a29b208$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $26c7bf120a29b208$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $26c7bf120a29b208$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $26c7bf120a29b208$var$cursor;
var $26c7bf120a29b208$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $26c7bf120a29b208$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $26c7bf120a29b208$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $26c7bf120a29b208$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $1OEsj.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $26c7bf120a29b208$var$cursor
    };
};

});
parcelRegister("1OEsj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1529d79d9aa6f066$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1529d79d9aa6f066$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cfR4M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039; });
var $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("fjS7T", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $b2729db54ba7ee9b$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $b2729db54ba7ee9b$export$811a713a7276cb9d; });

var $7fPBF = parcelRequire("7fPBF");
var $b2729db54ba7ee9b$var$syncFallback = function syncFallback(create) {
    return create();
};
var $b2729db54ba7ee9b$var$useInsertionEffect = $7fPBF.useInsertionEffect ? $7fPBF.useInsertionEffect : false;
var $b2729db54ba7ee9b$export$db21c7ffa21794e7 = $b2729db54ba7ee9b$var$useInsertionEffect || $b2729db54ba7ee9b$var$syncFallback;
var $b2729db54ba7ee9b$export$811a713a7276cb9d = $b2729db54ba7ee9b$var$useInsertionEffect || $7fPBF.useLayoutEffect;

});





parcelRegister("e6xq6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a44b8cbd62c27155$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");


var $hpTPt = parcelRequire("hpTPt");

var $10euI = parcelRequire("10euI");

var $bbzbN = parcelRequire("bbzbN");
"use client";
let $a44b8cbd62c27155$var$cache;
if (typeof document === "object") $a44b8cbd62c27155$var$cache = (0, $10euI.default)({
    key: "css",
    prepend: true
});
function $a44b8cbd62c27155$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $a44b8cbd62c27155$var$cache ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hpTPt.C), {
        value: $a44b8cbd62c27155$var$cache,
        children: children
    }) : children;
}

});
parcelRegister("bbzbN", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2nzLi"));

});


parcelRegister("5tMhb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fd51bd676aa60b7$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");


var $bpHMA = parcelRequire("bpHMA");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $3fd51bd676aa60b7$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $3fd51bd676aa60b7$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($3fd51bd676aa60b7$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bpHMA.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("1ifJj", function(module, exports) {
function $0f13ac86de1755d2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $0f13ac86de1755d2$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8acLz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("7Qp2B")).default; });

var $7Qp2B = parcelRequire("7Qp2B");

});
parcelRegister("7Qp2B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b60d055a057e060$export$2e2bcd8739ae039; });

var $a4yCM = parcelRequire("a4yCM");
function $5b60d055a057e060$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $a4yCM.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("lEDQA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("8UC1m")).default; });

var $8UC1m = parcelRequire("8UC1m");
$parcel$exportWildcard(module.exports, $8UC1m);

});
parcelRegister("8UC1m", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $67d10be253a5f87e$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $67d10be253a5f87e$export$2e2bcd8739ae039; });

var $j2VHG = parcelRequire("j2VHG");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $67d10be253a5f87e$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $67d10be253a5f87e$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($67d10be253a5f87e$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function $67d10be253a5f87e$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || $67d10be253a5f87e$export$aad197c7121a6651(Component) || fallback;
}
function $67d10be253a5f87e$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $67d10be253a5f87e$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $67d10be253a5f87e$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $67d10be253a5f87e$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $j2VHG.ForwardRef:
            return $67d10be253a5f87e$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $j2VHG.Memo:
            return $67d10be253a5f87e$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("j2VHG", function(module, exports) {
"use strict";

module.exports = (parcelRequire("45MkT"));

});
parcelRegister("45MkT", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $2fad1f91101d4119$export$a7c73072b1a182ae; }, function (v) { return $2fad1f91101d4119$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2fad1f91101d4119$export$9f27bc3417b4524d; }, function (v) { return $2fad1f91101d4119$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2fad1f91101d4119$export$db77ccec0bb4ccac; }, function (v) { return $2fad1f91101d4119$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2fad1f91101d4119$export$8392c0c9d3dcbd35; }, function (v) { return $2fad1f91101d4119$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2fad1f91101d4119$export$ffb0004e005737fa; }, function (v) { return $2fad1f91101d4119$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2fad1f91101d4119$export$b624eff549462981; }, function (v) { return $2fad1f91101d4119$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2fad1f91101d4119$export$7897aa7841a5380c; }, function (v) { return $2fad1f91101d4119$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2fad1f91101d4119$export$602eac185826482c; }, function (v) { return $2fad1f91101d4119$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2fad1f91101d4119$export$e2c29f18771995cb; }, function (v) { return $2fad1f91101d4119$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2fad1f91101d4119$export$5f8d39834fd61797; }, function (v) { return $2fad1f91101d4119$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2fad1f91101d4119$export$74bf444e3cd11ea5; }, function (v) { return $2fad1f91101d4119$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $2fad1f91101d4119$export$998bcd577473dd93; }, function (v) { return $2fad1f91101d4119$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2fad1f91101d4119$export$92387174baf9b227; }, function (v) { return $2fad1f91101d4119$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2fad1f91101d4119$export$ec112efeb987d9c6; }, function (v) { return $2fad1f91101d4119$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2fad1f91101d4119$export$b706b080d889d2c9; }, function (v) { return $2fad1f91101d4119$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2fad1f91101d4119$export$5be5a87408f70ddc; }, function (v) { return $2fad1f91101d4119$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2fad1f91101d4119$export$45a5e7f76e0caa8d; }, function (v) { return $2fad1f91101d4119$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2fad1f91101d4119$export$455c2e768291efa6; }, function (v) { return $2fad1f91101d4119$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2fad1f91101d4119$export$9522e17588c12572; }, function (v) { return $2fad1f91101d4119$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2fad1f91101d4119$export$2110ac352bb060b9; }, function (v) { return $2fad1f91101d4119$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2fad1f91101d4119$export$56885ab8b9c456ab; }, function (v) { return $2fad1f91101d4119$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2fad1f91101d4119$export$d927fcb6adf8f9de; }, function (v) { return $2fad1f91101d4119$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2fad1f91101d4119$export$b82d16f27459e05a; }, function (v) { return $2fad1f91101d4119$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2fad1f91101d4119$export$522c17b4f5e123e8; }, function (v) { return $2fad1f91101d4119$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2fad1f91101d4119$export$1aabd8a0274ecfd6; }, function (v) { return $2fad1f91101d4119$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $2fad1f91101d4119$export$3d6c20d97e46b957; }, function (v) { return $2fad1f91101d4119$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2fad1f91101d4119$export$9b621391a187a31a; }, function (v) { return $2fad1f91101d4119$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2fad1f91101d4119$export$f5bbd400c2f4426f; }, function (v) { return $2fad1f91101d4119$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2fad1f91101d4119$export$a7c73072b1a182ae;
var $2fad1f91101d4119$export$9f27bc3417b4524d;
var $2fad1f91101d4119$export$db77ccec0bb4ccac;
var $2fad1f91101d4119$export$8392c0c9d3dcbd35;
var $2fad1f91101d4119$export$ffb0004e005737fa;
var $2fad1f91101d4119$export$b624eff549462981;
var $2fad1f91101d4119$export$7897aa7841a5380c;
var $2fad1f91101d4119$export$602eac185826482c;
var $2fad1f91101d4119$export$e2c29f18771995cb;
var $2fad1f91101d4119$export$5f8d39834fd61797;
var $2fad1f91101d4119$export$74bf444e3cd11ea5;
var $2fad1f91101d4119$export$998bcd577473dd93;
var $2fad1f91101d4119$export$92387174baf9b227;
var $2fad1f91101d4119$export$ec112efeb987d9c6;
var $2fad1f91101d4119$export$b706b080d889d2c9;
var $2fad1f91101d4119$export$5be5a87408f70ddc;
var $2fad1f91101d4119$export$45a5e7f76e0caa8d;
var $2fad1f91101d4119$export$455c2e768291efa6;
var $2fad1f91101d4119$export$9522e17588c12572;
var $2fad1f91101d4119$export$2110ac352bb060b9;
var $2fad1f91101d4119$export$56885ab8b9c456ab;
var $2fad1f91101d4119$export$d927fcb6adf8f9de;
var $2fad1f91101d4119$export$b82d16f27459e05a;
var $2fad1f91101d4119$export$522c17b4f5e123e8;
var $2fad1f91101d4119$export$1aabd8a0274ecfd6;
var $2fad1f91101d4119$export$3d6c20d97e46b957;
var $2fad1f91101d4119$export$9b621391a187a31a;
var $2fad1f91101d4119$export$f5bbd400c2f4426f;
"use strict";
var $2fad1f91101d4119$var$b = Symbol.for("react.element"), $2fad1f91101d4119$var$c = Symbol.for("react.portal"), $2fad1f91101d4119$var$d = Symbol.for("react.fragment"), $2fad1f91101d4119$var$e = Symbol.for("react.strict_mode"), $2fad1f91101d4119$var$f = Symbol.for("react.profiler"), $2fad1f91101d4119$var$g = Symbol.for("react.provider"), $2fad1f91101d4119$var$h = Symbol.for("react.context"), $2fad1f91101d4119$var$k = Symbol.for("react.server_context"), $2fad1f91101d4119$var$l = Symbol.for("react.forward_ref"), $2fad1f91101d4119$var$m = Symbol.for("react.suspense"), $2fad1f91101d4119$var$n = Symbol.for("react.suspense_list"), $2fad1f91101d4119$var$p = Symbol.for("react.memo"), $2fad1f91101d4119$var$q = Symbol.for("react.lazy"), $2fad1f91101d4119$var$t = Symbol.for("react.offscreen"), $2fad1f91101d4119$var$u;
$2fad1f91101d4119$var$u = Symbol.for("react.module.reference");
function $2fad1f91101d4119$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $2fad1f91101d4119$var$b:
                switch(a = a.type, a){
                    case $2fad1f91101d4119$var$d:
                    case $2fad1f91101d4119$var$f:
                    case $2fad1f91101d4119$var$e:
                    case $2fad1f91101d4119$var$m:
                    case $2fad1f91101d4119$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2fad1f91101d4119$var$k:
                            case $2fad1f91101d4119$var$h:
                            case $2fad1f91101d4119$var$l:
                            case $2fad1f91101d4119$var$q:
                            case $2fad1f91101d4119$var$p:
                            case $2fad1f91101d4119$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $2fad1f91101d4119$var$c:
                return r;
        }
    }
}
$2fad1f91101d4119$export$a7c73072b1a182ae = $2fad1f91101d4119$var$h;
$2fad1f91101d4119$export$9f27bc3417b4524d = $2fad1f91101d4119$var$g;
$2fad1f91101d4119$export$db77ccec0bb4ccac = $2fad1f91101d4119$var$b;
$2fad1f91101d4119$export$8392c0c9d3dcbd35 = $2fad1f91101d4119$var$l;
$2fad1f91101d4119$export$ffb0004e005737fa = $2fad1f91101d4119$var$d;
$2fad1f91101d4119$export$b624eff549462981 = $2fad1f91101d4119$var$q;
$2fad1f91101d4119$export$7897aa7841a5380c = $2fad1f91101d4119$var$p;
$2fad1f91101d4119$export$602eac185826482c = $2fad1f91101d4119$var$c;
$2fad1f91101d4119$export$e2c29f18771995cb = $2fad1f91101d4119$var$f;
$2fad1f91101d4119$export$5f8d39834fd61797 = $2fad1f91101d4119$var$e;
$2fad1f91101d4119$export$74bf444e3cd11ea5 = $2fad1f91101d4119$var$m;
$2fad1f91101d4119$export$998bcd577473dd93 = $2fad1f91101d4119$var$n;
$2fad1f91101d4119$export$92387174baf9b227 = function() {
    return !1;
};
$2fad1f91101d4119$export$ec112efeb987d9c6 = function() {
    return !1;
};
$2fad1f91101d4119$export$b706b080d889d2c9 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$h;
};
$2fad1f91101d4119$export$5be5a87408f70ddc = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$g;
};
$2fad1f91101d4119$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2fad1f91101d4119$var$b;
};
$2fad1f91101d4119$export$455c2e768291efa6 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$l;
};
$2fad1f91101d4119$export$9522e17588c12572 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$d;
};
$2fad1f91101d4119$export$2110ac352bb060b9 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$q;
};
$2fad1f91101d4119$export$56885ab8b9c456ab = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$p;
};
$2fad1f91101d4119$export$d927fcb6adf8f9de = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$c;
};
$2fad1f91101d4119$export$b82d16f27459e05a = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$f;
};
$2fad1f91101d4119$export$522c17b4f5e123e8 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$e;
};
$2fad1f91101d4119$export$1aabd8a0274ecfd6 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$m;
};
$2fad1f91101d4119$export$3d6c20d97e46b957 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$n;
};
$2fad1f91101d4119$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2fad1f91101d4119$var$d || a === $2fad1f91101d4119$var$f || a === $2fad1f91101d4119$var$e || a === $2fad1f91101d4119$var$m || a === $2fad1f91101d4119$var$n || a === $2fad1f91101d4119$var$t || "object" === typeof a && null !== a && (a.$$typeof === $2fad1f91101d4119$var$q || a.$$typeof === $2fad1f91101d4119$var$p || a.$$typeof === $2fad1f91101d4119$var$g || a.$$typeof === $2fad1f91101d4119$var$h || a.$$typeof === $2fad1f91101d4119$var$l || a.$$typeof === $2fad1f91101d4119$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$2fad1f91101d4119$export$f5bbd400c2f4426f = $2fad1f91101d4119$var$v;

});




parcelRegister("eqNKX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("2G6xE")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("iZrRs")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("56TFl")).default; });

var $2G6xE = parcelRequire("2G6xE");

var $iZrRs = parcelRequire("iZrRs");

var $56TFl = parcelRequire("56TFl");

});
parcelRegister("2G6xE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f34940f58017e5f$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $l1GiU = parcelRequire("l1GiU");

var $iZrRs = parcelRequire("iZrRs");

var $l8Cag = parcelRequire("l8Cag");

var $GLqnW = parcelRequire("GLqnW");

var $8M6a3 = parcelRequire("8M6a3");

var $hXGiu = parcelRequire("hXGiu");

var $56TFl = parcelRequire("56TFl");
const $1f34940f58017e5f$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $1f34940f58017e5f$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $cFLic.default)(options, $1f34940f58017e5f$var$_excluded);
    const breakpoints = (0, $iZrRs.default)(breakpointsInput);
    const spacing = (0, $GLqnW.default)(spacingInput);
    let muiTheme = (0, $l1GiU.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $kY3Ke.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $kY3Ke.default)({}, (0, $l8Cag.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $56TFl.default);
    muiTheme = args.reduce((acc, argument)=>(0, $l1GiU.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $kY3Ke.default)({}, (0, $hXGiu.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $8M6a3.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $1f34940f58017e5f$export$2e2bcd8739ae039 = $1f34940f58017e5f$var$createTheme;

});
parcelRegister("cFLic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939dffaddf93a85b$export$2e2bcd8739ae039; });
function $939dffaddf93a85b$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("l1GiU", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $f4ea81aab05cdee0$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $f4ea81aab05cdee0$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
function $f4ea81aab05cdee0$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $f4ea81aab05cdee0$var$deepClone(source) {
    if (!$f4ea81aab05cdee0$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $f4ea81aab05cdee0$var$deepClone(source[key]);
    });
    return output;
}
function $f4ea81aab05cdee0$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $kY3Ke.default)({}, target) : target;
    if ($f4ea81aab05cdee0$export$53b83ca8eaab0383(target) && $f4ea81aab05cdee0$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($f4ea81aab05cdee0$export$53b83ca8eaab0383(source[key]) && key in target && $f4ea81aab05cdee0$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $f4ea81aab05cdee0$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $f4ea81aab05cdee0$export$53b83ca8eaab0383(source[key]) ? $f4ea81aab05cdee0$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("iZrRs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd33892704fa9f8b$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
const $dd33892704fa9f8b$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $dd33892704fa9f8b$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $dd33892704fa9f8b$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $kY3Ke.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $dd33892704fa9f8b$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $cFLic.default)(breakpoints, $dd33892704fa9f8b$var$_excluded);
    const sortedValues = $dd33892704fa9f8b$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $kY3Ke.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("l8Cag", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f637f3037d6dee04$export$2e2bcd8739ae039; });
const $f637f3037d6dee04$var$shape = {
    borderRadius: 4
};
var $f637f3037d6dee04$export$2e2bcd8739ae039 = $f637f3037d6dee04$var$shape;

});

parcelRegister("GLqnW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0808b5e3ab0ab6d4$export$2e2bcd8739ae039; });

var $5z69T = parcelRequire("5z69T");
function $0808b5e3ab0ab6d4$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $5z69T.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("5z69T", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $40d4ff9e66a5531b$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $40d4ff9e66a5531b$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $40d4ff9e66a5531b$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $40d4ff9e66a5531b$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $40d4ff9e66a5531b$export$6f98e8eaf0be1996; });


var $cvrkU = parcelRequire("cvrkU");

var $190Wm = parcelRequire("190Wm");

var $4So0q = parcelRequire("4So0q");

var $dMDTp = parcelRequire("dMDTp");
const $40d4ff9e66a5531b$var$properties = {
    m: "margin",
    p: "padding"
};
const $40d4ff9e66a5531b$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $40d4ff9e66a5531b$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $40d4ff9e66a5531b$var$getCssProperties = (0, $dMDTp.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($40d4ff9e66a5531b$var$aliases[prop]) prop = $40d4ff9e66a5531b$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $40d4ff9e66a5531b$var$properties[a];
    const direction = $40d4ff9e66a5531b$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $40d4ff9e66a5531b$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $40d4ff9e66a5531b$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $40d4ff9e66a5531b$var$spacingKeys = [
    ...$40d4ff9e66a5531b$export$aab52a0dde05ad8a,
    ...$40d4ff9e66a5531b$export$f8397d44f03ab6ad
];
function $40d4ff9e66a5531b$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $190Wm.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $40d4ff9e66a5531b$export$1def6f833384e3d1(theme) {
    return $40d4ff9e66a5531b$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $40d4ff9e66a5531b$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $40d4ff9e66a5531b$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $40d4ff9e66a5531b$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $40d4ff9e66a5531b$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $40d4ff9e66a5531b$var$getCssProperties(prop);
    const styleFromPropValue = $40d4ff9e66a5531b$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $cvrkU.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $40d4ff9e66a5531b$var$style(props, keys) {
    const transformer = $40d4ff9e66a5531b$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$40d4ff9e66a5531b$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $4So0q.default), {});
}
function $40d4ff9e66a5531b$export$7ede87f9b603dd3c(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$export$aab52a0dde05ad8a);
}
$40d4ff9e66a5531b$export$7ede87f9b603dd3c.propTypes = {};
$40d4ff9e66a5531b$export$7ede87f9b603dd3c.filterProps = $40d4ff9e66a5531b$export$aab52a0dde05ad8a;
function $40d4ff9e66a5531b$export$6f98e8eaf0be1996(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$export$f8397d44f03ab6ad);
}
$40d4ff9e66a5531b$export$6f98e8eaf0be1996.propTypes = {};
$40d4ff9e66a5531b$export$6f98e8eaf0be1996.filterProps = $40d4ff9e66a5531b$export$f8397d44f03ab6ad;
function $40d4ff9e66a5531b$var$spacing(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$var$spacingKeys);
}
$40d4ff9e66a5531b$var$spacing.propTypes = {};
$40d4ff9e66a5531b$var$spacing.filterProps = $40d4ff9e66a5531b$var$spacingKeys;
var $40d4ff9e66a5531b$export$2e2bcd8739ae039 = $40d4ff9e66a5531b$var$spacing;

});
parcelRegister("cvrkU", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $91ad95ac62846a03$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $91ad95ac62846a03$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $91ad95ac62846a03$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $91ad95ac62846a03$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $91ad95ac62846a03$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $91ad95ac62846a03$export$980e6a259d807490; });

var $kY3Ke = parcelRequire("kY3Ke");


var $l1GiU = parcelRequire("l1GiU");

var $4So0q = parcelRequire("4So0q");
const $91ad95ac62846a03$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $91ad95ac62846a03$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$91ad95ac62846a03$export$68c286be0e7e55b7[key]}px)`
};
function $91ad95ac62846a03$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $91ad95ac62846a03$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $91ad95ac62846a03$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $kY3Ke.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $4So0q.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $91ad95ac62846a03$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $91ad95ac62846a03$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $91ad95ac62846a03$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $91ad95ac62846a03$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $l1GiU.default)(prev, next), {});
    return $91ad95ac62846a03$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $91ad95ac62846a03$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $91ad95ac62846a03$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $91ad95ac62846a03$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $91ad95ac62846a03$export$2e2bcd8739ae039 = $91ad95ac62846a03$var$breakpoints;

});
parcelRegister("4So0q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38ced3a04f47cab4$export$2e2bcd8739ae039; });

var $l1GiU = parcelRequire("l1GiU");
function $38ced3a04f47cab4$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $l1GiU.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $38ced3a04f47cab4$export$2e2bcd8739ae039 = $38ced3a04f47cab4$var$merge;

});


parcelRegister("190Wm", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $0d575c74131361b5$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $0d575c74131361b5$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $0d575c74131361b5$export$2e2bcd8739ae039; });

var $7Qp2B = parcelRequire("7Qp2B");


var $cvrkU = parcelRequire("cvrkU");
function $0d575c74131361b5$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $0d575c74131361b5$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $0d575c74131361b5$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $0d575c74131361b5$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $7Qp2B.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $0d575c74131361b5$export$2e2bcd8739ae039 = $0d575c74131361b5$var$style;

});

parcelRegister("dMDTp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a08eb3ea758ca121$export$2e2bcd8739ae039; });
function $a08eb3ea758ca121$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("8M6a3", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $663795ec7cbfcd06$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $663795ec7cbfcd06$export$2e2bcd8739ae039; });

var $7Qp2B = parcelRequire("7Qp2B");

var $4So0q = parcelRequire("4So0q");

var $190Wm = parcelRequire("190Wm");

var $cvrkU = parcelRequire("cvrkU");

var $hXGiu = parcelRequire("hXGiu");
function $663795ec7cbfcd06$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $663795ec7cbfcd06$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $663795ec7cbfcd06$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $190Wm.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $190Wm.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $190Wm.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $7Qp2B.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $hXGiu.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $cvrkU.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $663795ec7cbfcd06$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $4So0q.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $cvrkU.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($663795ec7cbfcd06$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $4So0q.default)(css, breakpointsValues);
                        }
                    } else css = (0, $4So0q.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $cvrkU.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $663795ec7cbfcd06$var$styleFunctionSx = $663795ec7cbfcd06$export$7d53d8bf2911e013();
$663795ec7cbfcd06$var$styleFunctionSx.filterProps = [
    "sx"
];
var $663795ec7cbfcd06$export$2e2bcd8739ae039 = $663795ec7cbfcd06$var$styleFunctionSx;

});
parcelRegister("hXGiu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d138c1b003d294d5$export$2e2bcd8739ae039; });

var $5z69T = parcelRequire("5z69T");

var $brmMH = parcelRequire("brmMH");

var $aoYMG = parcelRequire("aoYMG");

var $lzsJx = parcelRequire("lzsJx");

var $8LvXe = parcelRequire("8LvXe");
const $d138c1b003d294d5$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $brmMH.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $brmMH.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $brmMH.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $brmMH.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $brmMH.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $brmMH.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $brmMH.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $lzsJx.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $lzsJx.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $lzsJx.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $5z69T.padding)
    },
    pt: {
        style: (0, $5z69T.padding)
    },
    pr: {
        style: (0, $5z69T.padding)
    },
    pb: {
        style: (0, $5z69T.padding)
    },
    pl: {
        style: (0, $5z69T.padding)
    },
    px: {
        style: (0, $5z69T.padding)
    },
    py: {
        style: (0, $5z69T.padding)
    },
    padding: {
        style: (0, $5z69T.padding)
    },
    paddingTop: {
        style: (0, $5z69T.padding)
    },
    paddingRight: {
        style: (0, $5z69T.padding)
    },
    paddingBottom: {
        style: (0, $5z69T.padding)
    },
    paddingLeft: {
        style: (0, $5z69T.padding)
    },
    paddingX: {
        style: (0, $5z69T.padding)
    },
    paddingY: {
        style: (0, $5z69T.padding)
    },
    paddingInline: {
        style: (0, $5z69T.padding)
    },
    paddingInlineStart: {
        style: (0, $5z69T.padding)
    },
    paddingInlineEnd: {
        style: (0, $5z69T.padding)
    },
    paddingBlock: {
        style: (0, $5z69T.padding)
    },
    paddingBlockStart: {
        style: (0, $5z69T.padding)
    },
    paddingBlockEnd: {
        style: (0, $5z69T.padding)
    },
    m: {
        style: (0, $5z69T.margin)
    },
    mt: {
        style: (0, $5z69T.margin)
    },
    mr: {
        style: (0, $5z69T.margin)
    },
    mb: {
        style: (0, $5z69T.margin)
    },
    ml: {
        style: (0, $5z69T.margin)
    },
    mx: {
        style: (0, $5z69T.margin)
    },
    my: {
        style: (0, $5z69T.margin)
    },
    margin: {
        style: (0, $5z69T.margin)
    },
    marginTop: {
        style: (0, $5z69T.margin)
    },
    marginRight: {
        style: (0, $5z69T.margin)
    },
    marginBottom: {
        style: (0, $5z69T.margin)
    },
    marginLeft: {
        style: (0, $5z69T.margin)
    },
    marginX: {
        style: (0, $5z69T.margin)
    },
    marginY: {
        style: (0, $5z69T.margin)
    },
    marginInline: {
        style: (0, $5z69T.margin)
    },
    marginInlineStart: {
        style: (0, $5z69T.margin)
    },
    marginInlineEnd: {
        style: (0, $5z69T.margin)
    },
    marginBlock: {
        style: (0, $5z69T.margin)
    },
    marginBlockStart: {
        style: (0, $5z69T.margin)
    },
    marginBlockEnd: {
        style: (0, $5z69T.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $aoYMG.gap)
    },
    rowGap: {
        style: (0, $aoYMG.rowGap)
    },
    columnGap: {
        style: (0, $aoYMG.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $8LvXe.sizingTransform)
    },
    maxWidth: {
        style: (0, $8LvXe.maxWidth)
    },
    minWidth: {
        transform: (0, $8LvXe.sizingTransform)
    },
    height: {
        transform: (0, $8LvXe.sizingTransform)
    },
    maxHeight: {
        transform: (0, $8LvXe.sizingTransform)
    },
    minHeight: {
        transform: (0, $8LvXe.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $d138c1b003d294d5$export$2e2bcd8739ae039 = $d138c1b003d294d5$var$defaultSxConfig;

});
parcelRegister("brmMH", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $8543e3d4e0a2f626$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $8543e3d4e0a2f626$export$7a57f79000377ca2; });


var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $5z69T = parcelRequire("5z69T");

var $cvrkU = parcelRequire("cvrkU");
function $8543e3d4e0a2f626$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $8543e3d4e0a2f626$var$createBorderStyle(prop, transform) {
    return (0, $190Wm.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $8543e3d4e0a2f626$export$1edee58a52776cd9 = $8543e3d4e0a2f626$var$createBorderStyle("border", $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$f9a7b6bd24892946 = $8543e3d4e0a2f626$var$createBorderStyle("borderTop", $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$5abca33e6be905d2 = $8543e3d4e0a2f626$var$createBorderStyle("borderRight", $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$e2ce9f12a980a822 = $8543e3d4e0a2f626$var$createBorderStyle("borderBottom", $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$47658cca1a909427 = $8543e3d4e0a2f626$var$createBorderStyle("borderLeft", $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$e7fb0694ba2404fc = $8543e3d4e0a2f626$var$createBorderStyle("borderColor");
const $8543e3d4e0a2f626$export$126a92c968acdb85 = $8543e3d4e0a2f626$var$createBorderStyle("borderTopColor");
const $8543e3d4e0a2f626$export$85cc51cb8fbb8c0e = $8543e3d4e0a2f626$var$createBorderStyle("borderRightColor");
const $8543e3d4e0a2f626$export$340b0327727f6d1a = $8543e3d4e0a2f626$var$createBorderStyle("borderBottomColor");
const $8543e3d4e0a2f626$export$60beef91a985b4bf = $8543e3d4e0a2f626$var$createBorderStyle("borderLeftColor");
const $8543e3d4e0a2f626$export$f9258c55612cbed7 = $8543e3d4e0a2f626$var$createBorderStyle("outline", $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$621fe586efeb64b9 = $8543e3d4e0a2f626$var$createBorderStyle("outlineColor");
const $8543e3d4e0a2f626$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$8543e3d4e0a2f626$export$7a57f79000377ca2.propTypes = {};
$8543e3d4e0a2f626$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $8543e3d4e0a2f626$var$borders = (0, $eB9d8.default)($8543e3d4e0a2f626$export$1edee58a52776cd9, $8543e3d4e0a2f626$export$f9a7b6bd24892946, $8543e3d4e0a2f626$export$5abca33e6be905d2, $8543e3d4e0a2f626$export$e2ce9f12a980a822, $8543e3d4e0a2f626$export$47658cca1a909427, $8543e3d4e0a2f626$export$e7fb0694ba2404fc, $8543e3d4e0a2f626$export$126a92c968acdb85, $8543e3d4e0a2f626$export$85cc51cb8fbb8c0e, $8543e3d4e0a2f626$export$340b0327727f6d1a, $8543e3d4e0a2f626$export$60beef91a985b4bf, $8543e3d4e0a2f626$export$7a57f79000377ca2, $8543e3d4e0a2f626$export$f9258c55612cbed7, $8543e3d4e0a2f626$export$621fe586efeb64b9);
var $8543e3d4e0a2f626$export$2e2bcd8739ae039 = $8543e3d4e0a2f626$var$borders;

});
parcelRegister("eB9d8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa0baa79cee865b3$export$2e2bcd8739ae039; });

var $4So0q = parcelRequire("4So0q");
function $aa0baa79cee865b3$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $4So0q.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $aa0baa79cee865b3$export$2e2bcd8739ae039 = $aa0baa79cee865b3$var$compose;

});


parcelRegister("aoYMG", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $792b4bc41110be3c$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $792b4bc41110be3c$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $792b4bc41110be3c$export$8a833ffa5f5dbeda; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $5z69T = parcelRequire("5z69T");

var $cvrkU = parcelRequire("cvrkU");

const $792b4bc41110be3c$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$5df9adcb0db95e1e.propTypes = {};
$792b4bc41110be3c$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $792b4bc41110be3c$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$ec60d70ff941a580.propTypes = {};
$792b4bc41110be3c$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $792b4bc41110be3c$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$8a833ffa5f5dbeda.propTypes = {};
$792b4bc41110be3c$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $792b4bc41110be3c$export$baf44164ca3a34e8 = (0, $190Wm.default)({
    prop: "gridColumn"
});
const $792b4bc41110be3c$export$8f7213a1cd01e832 = (0, $190Wm.default)({
    prop: "gridRow"
});
const $792b4bc41110be3c$export$b0e0abbc49ba668 = (0, $190Wm.default)({
    prop: "gridAutoFlow"
});
const $792b4bc41110be3c$export$bcd8b929d4b4142 = (0, $190Wm.default)({
    prop: "gridAutoColumns"
});
const $792b4bc41110be3c$export$e5039a674e14c828 = (0, $190Wm.default)({
    prop: "gridAutoRows"
});
const $792b4bc41110be3c$export$42bd9088661ffb03 = (0, $190Wm.default)({
    prop: "gridTemplateColumns"
});
const $792b4bc41110be3c$export$920682ae05b999bc = (0, $190Wm.default)({
    prop: "gridTemplateRows"
});
const $792b4bc41110be3c$export$1b88fbdd482fd33a = (0, $190Wm.default)({
    prop: "gridTemplateAreas"
});
const $792b4bc41110be3c$export$bdb486e40d52d26f = (0, $190Wm.default)({
    prop: "gridArea"
});
const $792b4bc41110be3c$var$grid = (0, $eB9d8.default)($792b4bc41110be3c$export$5df9adcb0db95e1e, $792b4bc41110be3c$export$ec60d70ff941a580, $792b4bc41110be3c$export$8a833ffa5f5dbeda, $792b4bc41110be3c$export$baf44164ca3a34e8, $792b4bc41110be3c$export$8f7213a1cd01e832, $792b4bc41110be3c$export$b0e0abbc49ba668, $792b4bc41110be3c$export$bcd8b929d4b4142, $792b4bc41110be3c$export$e5039a674e14c828, $792b4bc41110be3c$export$42bd9088661ffb03, $792b4bc41110be3c$export$920682ae05b999bc, $792b4bc41110be3c$export$1b88fbdd482fd33a, $792b4bc41110be3c$export$bdb486e40d52d26f);
var $792b4bc41110be3c$export$2e2bcd8739ae039 = $792b4bc41110be3c$var$grid;

});

parcelRegister("lzsJx", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $fb4327c08e40e84e$export$dbaffd4420ea0ac6; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");
function $fb4327c08e40e84e$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $fb4327c08e40e84e$export$35e9368ef982300f = (0, $190Wm.default)({
    prop: "color",
    themeKey: "palette",
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$export$2506f56c10355b33 = (0, $190Wm.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$export$8c5a050822fd698c = (0, $190Wm.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$var$palette = (0, $eB9d8.default)($fb4327c08e40e84e$export$35e9368ef982300f, $fb4327c08e40e84e$export$2506f56c10355b33, $fb4327c08e40e84e$export$8c5a050822fd698c);
var $fb4327c08e40e84e$export$2e2bcd8739ae039 = $fb4327c08e40e84e$var$palette;

});

parcelRegister("8LvXe", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $661b7ffebb8ef134$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $661b7ffebb8ef134$export$488fda99655ff65a; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $cvrkU = parcelRequire("cvrkU");
function $661b7ffebb8ef134$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $661b7ffebb8ef134$export$7e3df82ee760448c = (0, $190Wm.default)({
    prop: "width",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $cvrkU.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $661b7ffebb8ef134$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$661b7ffebb8ef134$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $661b7ffebb8ef134$export$ee148fbbe8357dd2 = (0, $190Wm.default)({
    prop: "minWidth",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$ac607276a8fe9f0a = (0, $190Wm.default)({
    prop: "height",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$dc0d8bd0b94f8570 = (0, $190Wm.default)({
    prop: "maxHeight",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$a43cf604e12f3b17 = (0, $190Wm.default)({
    prop: "minHeight",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$ffed9f14fb65e276 = (0, $190Wm.default)({
    prop: "size",
    cssProperty: "width",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$905076ed6620e671 = (0, $190Wm.default)({
    prop: "size",
    cssProperty: "height",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$6ccc93f785106a58 = (0, $190Wm.default)({
    prop: "boxSizing"
});
const $661b7ffebb8ef134$var$sizing = (0, $eB9d8.default)($661b7ffebb8ef134$export$7e3df82ee760448c, $661b7ffebb8ef134$export$488fda99655ff65a, $661b7ffebb8ef134$export$ee148fbbe8357dd2, $661b7ffebb8ef134$export$ac607276a8fe9f0a, $661b7ffebb8ef134$export$dc0d8bd0b94f8570, $661b7ffebb8ef134$export$a43cf604e12f3b17, $661b7ffebb8ef134$export$6ccc93f785106a58);
var $661b7ffebb8ef134$export$2e2bcd8739ae039 = $661b7ffebb8ef134$var$sizing;

});



parcelRegister("56TFl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b88b157d6186746$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $3b88b157d6186746$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("3aVNX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("8M6a3")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("8M6a3")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("mqrnX")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("hXGiu")).default; });

var $8M6a3 = parcelRequire("8M6a3");

var $mqrnX = parcelRequire("mqrnX");

var $hXGiu = parcelRequire("hXGiu");

});
parcelRegister("mqrnX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $043690c2de8ba6fa$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $l1GiU = parcelRequire("l1GiU");

var $hXGiu = parcelRequire("hXGiu");
const $043690c2de8ba6fa$var$_excluded = [
    "sx"
];
const $043690c2de8ba6fa$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $hXGiu.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $043690c2de8ba6fa$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $cFLic.default)(props, $043690c2de8ba6fa$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $043690c2de8ba6fa$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $l1GiU.isPlainObject)(result)) return systemProps;
        return (0, $kY3Ke.default)({}, systemProps, result);
    };
    else finalSx = (0, $kY3Ke.default)({}, systemProps, inSx);
    return (0, $kY3Ke.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("3xowt", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6PKLM.default;
    }
});

var $6PKLM = parcelRequire("6PKLM");

});
parcelRegister("6PKLM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f9bc8f83648f682$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $freJ2 = parcelRequire("freJ2");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $4f9bc8f83648f682$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $freJ2.default), (0, $kY3Ke.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $freJ2.default).muiName;
    return /*#__PURE__*/ $7fPBF.memo(/*#__PURE__*/ $7fPBF.forwardRef(Component));
}

});
parcelRegister("freJ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3d4ccc5f426d62a$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");

var $b6UUh = parcelRequire("b6UUh");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $6VWZo = parcelRequire("6VWZo");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $b3d4ccc5f426d62a$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $b3d4ccc5f426d62a$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $b6UUh.default)(color)}`,
            `fontSize${(0, $b6UUh.default)(fontSize)}`
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $6VWZo.getSvgIconUtilityClass), classes);
};
const $b3d4ccc5f426d62a$var$SvgIconRoot = (0, $kDBhE.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
            styles[`fontSize${(0, $b6UUh.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $b3d4ccc5f426d62a$var$SvgIcon = /*#__PURE__*/ $7fPBF.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $cFLic.default)(props, $b3d4ccc5f426d62a$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $7fPBF.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $b3d4ccc5f426d62a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($b3d4ccc5f426d62a$var$SvgIconRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $bbzbN.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$b3d4ccc5f426d62a$var$SvgIcon.muiName = "SvgIcon";
var $b3d4ccc5f426d62a$export$2e2bcd8739ae039 = $b3d4ccc5f426d62a$var$SvgIcon;

});
parcelRegister("hngXp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07a883fe7c352c85$export$2e2bcd8739ae039; });
function $07a883fe7c352c85$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $07a883fe7c352c85$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $07a883fe7c352c85$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $07a883fe7c352c85$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $07a883fe7c352c85$export$2e2bcd8739ae039 = $07a883fe7c352c85$export$4f5d2d50c9deca37;

});

parcelRegister("fsUVx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b425a11005f01ee3$export$2e2bcd8739ae039; });
function $b425a11005f01ee3$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("b6UUh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $816c65c0e1f7082c$export$2e2bcd8739ae039; });

var $7Qp2B = parcelRequire("7Qp2B");
var $816c65c0e1f7082c$export$2e2bcd8739ae039 = (0, $7Qp2B.default);

});

parcelRegister("5j2OD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dd0e9417d40119e$export$2e2bcd8739ae039; });

var $9HPC7 = parcelRequire("9HPC7");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");
"use client";
function $3dd0e9417d40119e$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $9HPC7.default)({
        props: props,
        name: name,
        defaultTheme: $9P91Y.default,
        themeId: (0, $jwhZE.default)
    });
}

});
parcelRegister("9HPC7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71102aa90e2b2620$export$2e2bcd8739ae039; });

var $38WAi = parcelRequire("38WAi");

var $4kWyf = parcelRequire("4kWyf");
"use client";
function $71102aa90e2b2620$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $4kWyf.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $38WAi.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("38WAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $249f9015c4a2303b$export$2e2bcd8739ae039; });

var $78FIu = parcelRequire("78FIu");
function $249f9015c4a2303b$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $78FIu.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("78FIu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5329a3c88fb523ba$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
function $5329a3c88fb523ba$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $kY3Ke.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $kY3Ke.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $kY3Ke.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $5329a3c88fb523ba$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("4kWyf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $328672c8d07e1c59$export$2e2bcd8739ae039; });

var $2G6xE = parcelRequire("2G6xE");

var $84PRT = parcelRequire("84PRT");
"use client";
const $328672c8d07e1c59$export$35e57303dbd8a66 = (0, $2G6xE.default)();
function $328672c8d07e1c59$var$useTheme(defaultTheme = $328672c8d07e1c59$export$35e57303dbd8a66) {
    return (0, $84PRT.default)(defaultTheme);
}
var $328672c8d07e1c59$export$2e2bcd8739ae039 = $328672c8d07e1c59$var$useTheme;

});
parcelRegister("84PRT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e16ee62ac64bb0b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("bpHMA");
var $hpTPt = parcelRequire("hpTPt");
"use client";
function $5e16ee62ac64bb0b$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $5e16ee62ac64bb0b$var$useTheme(defaultTheme = null) {
    const contextTheme = $7fPBF.useContext((0, $hpTPt.T));
    return !contextTheme || $5e16ee62ac64bb0b$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $5e16ee62ac64bb0b$export$2e2bcd8739ae039 = $5e16ee62ac64bb0b$var$useTheme;

});



parcelRegister("9P91Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $726fe1d2377a5002$export$2e2bcd8739ae039; });

var $hmhHQ = parcelRequire("hmhHQ");
"use client";
const $726fe1d2377a5002$var$defaultTheme = (0, $hmhHQ.default)();
var $726fe1d2377a5002$export$2e2bcd8739ae039 = $726fe1d2377a5002$var$defaultTheme;

});
parcelRegister("hmhHQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca3239ce6bf6e490$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $a4yCM = parcelRequire("a4yCM");

var $l1GiU = parcelRequire("l1GiU");

var $hXGiu = parcelRequire("hXGiu");
var $8M6a3 = parcelRequire("8M6a3");

var $2G6xE = parcelRequire("2G6xE");


var $oPCQw = parcelRequire("oPCQw");

var $G7KID = parcelRequire("G7KID");

var $5vuSA = parcelRequire("5vuSA");

var $3jGgo = parcelRequire("3jGgo");

var $kjiCM = parcelRequire("kjiCM");

var $eGmqa = parcelRequire("eGmqa");
const $ca3239ce6bf6e490$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $ca3239ce6bf6e490$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $cFLic.default)(options, $ca3239ce6bf6e490$var$_excluded);
    if (options.vars) throw new Error((0, $a4yCM.default)(18));
    const palette = (0, $G7KID.default)(paletteInput);
    const systemTheme = (0, $2G6xE.default)(options);
    let muiTheme = (0, $l1GiU.default)(systemTheme, {
        mixins: (0, $oPCQw.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $3jGgo.default).slice(),
        typography: (0, $5vuSA.default)(palette, typographyInput),
        transitions: (0, $kjiCM.default)(transitionsInput),
        zIndex: (0, $kY3Ke.default)({}, (0, $eGmqa.default))
    });
    muiTheme = (0, $l1GiU.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $l1GiU.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $kY3Ke.default)({}, (0, $hXGiu.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $8M6a3.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $ca3239ce6bf6e490$var$warnedOnce = false;
function $ca3239ce6bf6e490$export$c469355549431d9b(...args) {
    return $ca3239ce6bf6e490$var$createTheme(...args);
}
var $ca3239ce6bf6e490$export$2e2bcd8739ae039 = $ca3239ce6bf6e490$var$createTheme;

});
parcelRegister("oPCQw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04aa49c3b5b31b02$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
function $04aa49c3b5b31b02$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $kY3Ke.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("G7KID", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07e9efd96a5c6f8a$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $a4yCM = parcelRequire("a4yCM");

var $l1GiU = parcelRequire("l1GiU");

var $7jL4F = parcelRequire("7jL4F");

var $6akYf = parcelRequire("6akYf");

var $2nhXL = parcelRequire("2nhXL");

var $3Ctzq = parcelRequire("3Ctzq");

var $9PTBs = parcelRequire("9PTBs");

var $5WQac = parcelRequire("5WQac");

var $gal31 = parcelRequire("gal31");

var $1Btry = parcelRequire("1Btry");

var $hnm6Q = parcelRequire("hnm6Q");
const $07e9efd96a5c6f8a$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $07e9efd96a5c6f8a$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $6akYf.default).white,
        default: (0, $6akYf.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $07e9efd96a5c6f8a$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $6akYf.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $6akYf.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $07e9efd96a5c6f8a$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $7jL4F.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $7jL4F.darken)(intent.main, tonalOffsetDark);
    }
}
function $07e9efd96a5c6f8a$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $gal31.default)[200],
        light: (0, $gal31.default)[50],
        dark: (0, $gal31.default)[400]
    };
    return {
        main: (0, $gal31.default)[700],
        light: (0, $gal31.default)[400],
        dark: (0, $gal31.default)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $3Ctzq.default)[200],
        light: (0, $3Ctzq.default)[50],
        dark: (0, $3Ctzq.default)[400]
    };
    return {
        main: (0, $3Ctzq.default)[500],
        light: (0, $3Ctzq.default)[300],
        dark: (0, $3Ctzq.default)[700]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $9PTBs.default)[500],
        light: (0, $9PTBs.default)[300],
        dark: (0, $9PTBs.default)[700]
    };
    return {
        main: (0, $9PTBs.default)[700],
        light: (0, $9PTBs.default)[400],
        dark: (0, $9PTBs.default)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $1Btry.default)[400],
        light: (0, $1Btry.default)[300],
        dark: (0, $1Btry.default)[700]
    };
    return {
        main: (0, $1Btry.default)[700],
        light: (0, $1Btry.default)[500],
        dark: (0, $1Btry.default)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $hnm6Q.default)[400],
        light: (0, $hnm6Q.default)[300],
        dark: (0, $hnm6Q.default)[700]
    };
    return {
        main: (0, $hnm6Q.default)[800],
        light: (0, $hnm6Q.default)[500],
        dark: (0, $hnm6Q.default)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $5WQac.default)[400],
        light: (0, $5WQac.default)[300],
        dark: (0, $5WQac.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $5WQac.default)[500],
        dark: (0, $5WQac.default)[900]
    };
}
function $07e9efd96a5c6f8a$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $cFLic.default)(palette, $07e9efd96a5c6f8a$var$_excluded);
    const primary = palette.primary || $07e9efd96a5c6f8a$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $07e9efd96a5c6f8a$var$getDefaultSecondary(mode);
    const error = palette.error || $07e9efd96a5c6f8a$var$getDefaultError(mode);
    const info = palette.info || $07e9efd96a5c6f8a$var$getDefaultInfo(mode);
    const success = palette.success || $07e9efd96a5c6f8a$var$getDefaultSuccess(mode);
    const warning = palette.warning || $07e9efd96a5c6f8a$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $7jL4F.getContrastRatio)(background, $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary : $07e9efd96a5c6f8a$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $kY3Ke.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $a4yCM.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $a4yCM.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $07e9efd96a5c6f8a$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $07e9efd96a5c6f8a$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $07e9efd96a5c6f8a$export$55ce6f3a06c59543,
        light: $07e9efd96a5c6f8a$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $l1GiU.default)((0, $kY3Ke.default)({
        // A collection of common colors.
        common: (0, $kY3Ke.default)({}, (0, $6akYf.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $2nhXL.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("7jL4F", function(module, exports) {
"use strict";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $553ed2baba4347ed$var$alpha;
module.exports.blend = $553ed2baba4347ed$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $553ed2baba4347ed$var$darken;
module.exports.decomposeColor = $553ed2baba4347ed$var$decomposeColor;
module.exports.emphasize = $553ed2baba4347ed$var$emphasize;
module.exports.getContrastRatio = $553ed2baba4347ed$var$getContrastRatio;
module.exports.getLuminance = $553ed2baba4347ed$var$getLuminance;
module.exports.hexToRgb = $553ed2baba4347ed$var$hexToRgb;
module.exports.hslToRgb = $553ed2baba4347ed$var$hslToRgb;
module.exports.lighten = $553ed2baba4347ed$var$lighten;
module.exports.private_safeAlpha = $553ed2baba4347ed$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $553ed2baba4347ed$var$private_safeDarken;
module.exports.private_safeEmphasize = $553ed2baba4347ed$var$private_safeEmphasize;
module.exports.private_safeLighten = $553ed2baba4347ed$var$private_safeLighten;
module.exports.recomposeColor = $553ed2baba4347ed$var$recomposeColor;
module.exports.rgbToHex = $553ed2baba4347ed$var$rgbToHex;

var $553ed2baba4347ed$var$_formatMuiErrorMessage2 = $62qsu((parcelRequire("BkELc")));

var $553ed2baba4347ed$var$_clamp = $62qsu((parcelRequire("akaBm")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $553ed2baba4347ed$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $553ed2baba4347ed$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $553ed2baba4347ed$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $553ed2baba4347ed$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $553ed2baba4347ed$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $553ed2baba4347ed$var$decomposeColor($553ed2baba4347ed$var$hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $553ed2baba4347ed$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $553ed2baba4347ed$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $553ed2baba4347ed$var$colorChannel = (color)=>{
    const decomposedColor = $553ed2baba4347ed$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
module.exports.colorChannel = $553ed2baba4347ed$var$colorChannel;
const $553ed2baba4347ed$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $553ed2baba4347ed$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $553ed2baba4347ed$var$private_safeColorChannel;
function $553ed2baba4347ed$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $553ed2baba4347ed$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $553ed2baba4347ed$var$decomposeColor(color);
    return `#${values.map((n, i)=>$553ed2baba4347ed$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $553ed2baba4347ed$var$hslToRgb(color) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $553ed2baba4347ed$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $553ed2baba4347ed$var$getLuminance(color) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $553ed2baba4347ed$var$decomposeColor($553ed2baba4347ed$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $553ed2baba4347ed$var$getContrastRatio(foreground, background) {
    const lumA = $553ed2baba4347ed$var$getLuminance(foreground);
    const lumB = $553ed2baba4347ed$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $553ed2baba4347ed$var$alpha(color, value) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    value = $553ed2baba4347ed$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $553ed2baba4347ed$var$recomposeColor(color);
}
function $553ed2baba4347ed$var$private_safeAlpha(color, value, warning) {
    try {
        return $553ed2baba4347ed$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $553ed2baba4347ed$var$darken(color, coefficient) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    coefficient = $553ed2baba4347ed$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $553ed2baba4347ed$var$recomposeColor(color);
}
function $553ed2baba4347ed$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $553ed2baba4347ed$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $553ed2baba4347ed$var$lighten(color, coefficient) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    coefficient = $553ed2baba4347ed$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $553ed2baba4347ed$var$recomposeColor(color);
}
function $553ed2baba4347ed$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $553ed2baba4347ed$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $553ed2baba4347ed$var$emphasize(color, coefficient = 0.15) {
    return $553ed2baba4347ed$var$getLuminance(color) > 0.5 ? $553ed2baba4347ed$var$darken(color, coefficient) : $553ed2baba4347ed$var$lighten(color, coefficient);
}
function $553ed2baba4347ed$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $553ed2baba4347ed$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $553ed2baba4347ed$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $553ed2baba4347ed$var$decomposeColor(background);
    const overlayColor = $553ed2baba4347ed$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $553ed2baba4347ed$var$recomposeColor({
        type: "rgb",
        values: rgb
    });
}

});
parcelRegister("62qsu", function(module, exports) {
function $4657741705a128f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $4657741705a128f0$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6akYf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47d3f19e39b3b144$export$2e2bcd8739ae039; });
const $47d3f19e39b3b144$var$common = {
    black: "#000",
    white: "#fff"
};
var $47d3f19e39b3b144$export$2e2bcd8739ae039 = $47d3f19e39b3b144$var$common;

});

parcelRegister("2nhXL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1baba9d0f229a247$export$2e2bcd8739ae039; });
const $1baba9d0f229a247$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $1baba9d0f229a247$export$2e2bcd8739ae039 = $1baba9d0f229a247$var$grey;

});

parcelRegister("3Ctzq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a2bdbc6cce4aa96$export$2e2bcd8739ae039; });
const $2a2bdbc6cce4aa96$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $2a2bdbc6cce4aa96$export$2e2bcd8739ae039 = $2a2bdbc6cce4aa96$var$purple;

});

parcelRegister("9PTBs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72940215fdf862f4$export$2e2bcd8739ae039; });
const $72940215fdf862f4$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $72940215fdf862f4$export$2e2bcd8739ae039 = $72940215fdf862f4$var$red;

});

parcelRegister("5WQac", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $454ad523c90fa85d$export$2e2bcd8739ae039; });
const $454ad523c90fa85d$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $454ad523c90fa85d$export$2e2bcd8739ae039 = $454ad523c90fa85d$var$orange;

});

parcelRegister("gal31", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc4de82bafd68977$export$2e2bcd8739ae039; });
const $bc4de82bafd68977$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $bc4de82bafd68977$export$2e2bcd8739ae039 = $bc4de82bafd68977$var$blue;

});

parcelRegister("1Btry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12b015f9ee6c8f9f$export$2e2bcd8739ae039; });
const $12b015f9ee6c8f9f$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $12b015f9ee6c8f9f$export$2e2bcd8739ae039 = $12b015f9ee6c8f9f$var$lightBlue;

});

parcelRegister("hnm6Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca65bc19996a7eac$export$2e2bcd8739ae039; });
const $ca65bc19996a7eac$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $ca65bc19996a7eac$export$2e2bcd8739ae039 = $ca65bc19996a7eac$var$green;

});


parcelRegister("5vuSA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4027cd084802bc60$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $l1GiU = parcelRequire("l1GiU");
const $4027cd084802bc60$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $4027cd084802bc60$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $4027cd084802bc60$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $4027cd084802bc60$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $4027cd084802bc60$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $4027cd084802bc60$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $cFLic.default)(_ref, $4027cd084802bc60$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $kY3Ke.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $4027cd084802bc60$var$defaultFontFamily ? {
            letterSpacing: `${$4027cd084802bc60$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $4027cd084802bc60$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $4027cd084802bc60$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $l1GiU.default)((0, $kY3Ke.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("3jGgo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26a3ee12a0d43232$export$2e2bcd8739ae039; });
const $26a3ee12a0d43232$var$shadowKeyUmbraOpacity = 0.2;
const $26a3ee12a0d43232$var$shadowKeyPenumbraOpacity = 0.14;
const $26a3ee12a0d43232$var$shadowAmbientShadowOpacity = 0.12;
function $26a3ee12a0d43232$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $26a3ee12a0d43232$var$shadows = [
    "none",
    $26a3ee12a0d43232$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $26a3ee12a0d43232$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $26a3ee12a0d43232$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $26a3ee12a0d43232$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $26a3ee12a0d43232$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $26a3ee12a0d43232$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $26a3ee12a0d43232$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $26a3ee12a0d43232$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $26a3ee12a0d43232$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $26a3ee12a0d43232$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $26a3ee12a0d43232$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $26a3ee12a0d43232$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $26a3ee12a0d43232$export$2e2bcd8739ae039 = $26a3ee12a0d43232$var$shadows;

});

parcelRegister("kjiCM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec94076b9ecccee1$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
const $ec94076b9ecccee1$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $ec94076b9ecccee1$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $ec94076b9ecccee1$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $ec94076b9ecccee1$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $ec94076b9ecccee1$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $ec94076b9ecccee1$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $kY3Ke.default)({}, $ec94076b9ecccee1$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $kY3Ke.default)({}, $ec94076b9ecccee1$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $cFLic.default)(options, $ec94076b9ecccee1$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $ec94076b9ecccee1$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $ec94076b9ecccee1$var$formatMs(delay)}`).join(",");
    };
    return (0, $kY3Ke.default)({
        getAutoHeightDuration: $ec94076b9ecccee1$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("eGmqa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab06614e124e32b2$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $ab06614e124e32b2$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $ab06614e124e32b2$export$2e2bcd8739ae039 = $ab06614e124e32b2$var$zIndex;

});



parcelRegister("jwhZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e35ef6915a224202$export$2e2bcd8739ae039; });
var $e35ef6915a224202$export$2e2bcd8739ae039 = "$$material";

});


parcelRegister("kDBhE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0645ef192f222f7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "rootShouldForwardProp", function () { return (parcelRequire("HgAeG")).default; });

var $9xny7 = parcelRequire("9xny7");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");

var $HgAeG = parcelRequire("HgAeG");

var $yfUan = parcelRequire("yfUan");
"use client";
const $f0645ef192f222f7$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($9xny7)))({
    themeId: (0, $jwhZE.default),
    defaultTheme: $9P91Y.default,
    rootShouldForwardProp: $HgAeG.default
});
var $f0645ef192f222f7$export$2e2bcd8739ae039 = $f0645ef192f222f7$var$styled;

});
parcelRegister("9xny7", function(module, exports) {
"use strict";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f197680cb170281$var$createStyled;
module.exports.shouldForwardProp = $6f197680cb170281$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $6f197680cb170281$var$_extends2 = $62qsu((parcelRequire("cvBp9")));

var $6f197680cb170281$var$_objectWithoutPropertiesLoose2 = $62qsu((parcelRequire("1ifJj")));

var $6f197680cb170281$var$_styledEngine = $6f197680cb170281$var$_interopRequireWildcard((parcelRequire("5VCcJ")));

var $l1GiU = parcelRequire("l1GiU");

var $6f197680cb170281$var$_capitalize = $62qsu((parcelRequire("8acLz")));

var $6f197680cb170281$var$_getDisplayName = $62qsu((parcelRequire("lEDQA")));

var $6f197680cb170281$var$_createTheme = $62qsu((parcelRequire("eqNKX")));

var $6f197680cb170281$var$_styleFunctionSx = $62qsu((parcelRequire("3aVNX")));
const $6f197680cb170281$var$_excluded = [
    "ownerState"
], $6f197680cb170281$var$_excluded2 = [
    "variants"
], $6f197680cb170281$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $6f197680cb170281$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6f197680cb170281$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $6f197680cb170281$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $6f197680cb170281$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $6f197680cb170281$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $6f197680cb170281$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $6f197680cb170281$var$shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $6f197680cb170281$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $6f197680cb170281$var$_createTheme.default)();
const $6f197680cb170281$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $6f197680cb170281$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $6f197680cb170281$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $6f197680cb170281$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $6f197680cb170281$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $6f197680cb170281$var$_objectWithoutPropertiesLoose2.default)(_ref, $6f197680cb170281$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $6f197680cb170281$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$6f197680cb170281$var$processStyleArg(resolvedStyle, (0, $6f197680cb170281$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $6f197680cb170281$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $6f197680cb170281$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $6f197680cb170281$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $6f197680cb170281$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $6f197680cb170281$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $6f197680cb170281$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $6f197680cb170281$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $6f197680cb170281$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $6f197680cb170281$var$_styleFunctionSx.default)((0, $6f197680cb170281$var$_extends2.default)({}, props, {
            theme: $6f197680cb170281$var$resolveTheme((0, $6f197680cb170281$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $6f197680cb170281$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $6f197680cb170281$var$defaultOverridesResolver($6f197680cb170281$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $6f197680cb170281$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $6f197680cb170281$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $6f197680cb170281$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($6f197680cb170281$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $6f197680cb170281$var$_styledEngine.default)(tag, (0, $6f197680cb170281$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $l1GiU.isPlainObject)(stylesArg)) return (props)=>$6f197680cb170281$var$processStyleArg(stylesArg, (0, $6f197680cb170281$var$_extends2.default)({}, props, {
                    theme: $6f197680cb170281$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $6f197680cb170281$var$resolveTheme((0, $6f197680cb170281$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $6f197680cb170281$var$processStyleArg(slotStyle, (0, $6f197680cb170281$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $6f197680cb170281$var$resolveTheme((0, $6f197680cb170281$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $6f197680cb170281$var$processStyleArg({
                    variants: themeVariants
                }, (0, $6f197680cb170281$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});

parcelRegister("HgAeG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0820e164eb5fbaff$export$2e2bcd8739ae039; });

var $yfUan = parcelRequire("yfUan");
const $0820e164eb5fbaff$var$rootShouldForwardProp = (prop)=>(0, $yfUan.default)(prop) && prop !== "classes";
var $0820e164eb5fbaff$export$2e2bcd8739ae039 = $0820e164eb5fbaff$var$rootShouldForwardProp;

});
parcelRegister("yfUan", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $066f83798075d563$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $066f83798075d563$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $066f83798075d563$export$2e2bcd8739ae039 = $066f83798075d563$var$slotShouldForwardProp;

});



parcelRegister("6VWZo", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $50c5d2f6ad13a504$export$c7c50641356bdfa5; });

var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $50c5d2f6ad13a504$export$c7c50641356bdfa5(slot) {
    return (0, $jzxpm.default)("MuiSvgIcon", slot);
}
const $50c5d2f6ad13a504$var$svgIconClasses = (0, $9UILM.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $50c5d2f6ad13a504$export$2e2bcd8739ae039 = $50c5d2f6ad13a504$var$svgIconClasses;

});
parcelRegister("9UILM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $737c1255a9b2933f$export$2e2bcd8739ae039; });

var $jzxpm = parcelRequire("jzxpm");
function $737c1255a9b2933f$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $jzxpm.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("jzxpm", function(module, exports) {

$parcel$export(module.exports, "globalStateClasses", function () { return $e3fb335e7a274d11$export$9d6b9120de57c54; });
$parcel$export(module.exports, "default", function () { return $e3fb335e7a274d11$export$2e2bcd8739ae039; });

var $7GMGX = parcelRequire("7GMGX");
const $e3fb335e7a274d11$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $e3fb335e7a274d11$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $e3fb335e7a274d11$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $7GMGX.default).generate(componentName)}-${slot}`;
}
function $e3fb335e7a274d11$export$34c0130b1f3e8ae3(slot) {
    return $e3fb335e7a274d11$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("7GMGX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $599239dc9390bfb2$export$2e2bcd8739ae039; });
const $599239dc9390bfb2$var$defaultGenerator = (componentName)=>componentName;
const $599239dc9390bfb2$var$createClassNameGenerator = ()=>{
    let generate = $599239dc9390bfb2$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $599239dc9390bfb2$var$defaultGenerator;
        }
    };
};
const $599239dc9390bfb2$var$ClassNameGenerator = $599239dc9390bfb2$var$createClassNameGenerator();
var $599239dc9390bfb2$export$2e2bcd8739ae039 = $599239dc9390bfb2$var$ClassNameGenerator;

});








var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
var $f11ec298ebcca059$exports = {};

$parcel$export($f11ec298ebcca059$exports, "createRoot", function () { return $f11ec298ebcca059$export$882461b6382ed46c; }, function (v) { return $f11ec298ebcca059$export$882461b6382ed46c = v; });
$parcel$export($f11ec298ebcca059$exports, "hydrateRoot", function () { return $f11ec298ebcca059$export$757ceba2d55c277e; }, function (v) { return $f11ec298ebcca059$export$757ceba2d55c277e = v; });
var $f11ec298ebcca059$export$882461b6382ed46c;
var $f11ec298ebcca059$export$757ceba2d55c277e;
"use strict";
var $b4ba1c853f6e1116$exports = {};
"use strict";
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

$b4ba1c853f6e1116$exports = (parcelRequire("6EA3T"));


var $f11ec298ebcca059$var$i;
$f11ec298ebcca059$export$882461b6382ed46c = $b4ba1c853f6e1116$exports.createRoot;
$f11ec298ebcca059$export$757ceba2d55c277e = $b4ba1c853f6e1116$exports.hydrateRoot;




var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
/**
 * React Router DOM v6.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");

/**
 * React Router v6.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");
/**
 * @remix-run/router v1.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $55100129ab36ed65$var$_extends() {
    $55100129ab36ed65$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $55100129ab36ed65$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $55100129ab36ed65$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($55100129ab36ed65$export$e19cd5f9376f8cee || ($55100129ab36ed65$export$e19cd5f9376f8cee = {}));
const $55100129ab36ed65$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $55100129ab36ed65$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $55100129ab36ed65$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $55100129ab36ed65$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $55100129ab36ed65$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $55100129ab36ed65$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $55100129ab36ed65$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $55100129ab36ed65$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $55100129ab36ed65$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $55100129ab36ed65$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $55100129ab36ed65$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $55100129ab36ed65$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $55100129ab36ed65$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $55100129ab36ed65$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $55100129ab36ed65$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $55100129ab36ed65$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($55100129ab36ed65$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $55100129ab36ed65$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $55100129ab36ed65$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($55100129ab36ed65$var$ResultType || ($55100129ab36ed65$var$ResultType = {}));
const $55100129ab36ed65$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $55100129ab36ed65$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $55100129ab36ed65$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $55100129ab36ed65$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($55100129ab36ed65$var$isIndexRoute(route)) {
            let indexRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $55100129ab36ed65$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $55100129ab36ed65$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $55100129ab36ed65$var$flattenRoutes(routes);
    $55100129ab36ed65$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $55100129ab36ed65$var$decodePath(pathname);
        matches = $55100129ab36ed65$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $55100129ab36ed65$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $55100129ab36ed65$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $55100129ab36ed65$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $55100129ab36ed65$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $55100129ab36ed65$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $55100129ab36ed65$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $55100129ab36ed65$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $55100129ab36ed65$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $55100129ab36ed65$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $55100129ab36ed65$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $55100129ab36ed65$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $55100129ab36ed65$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $55100129ab36ed65$var$paramRe = /^:[\w-]+$/;
const $55100129ab36ed65$var$dynamicSegmentValue = 3;
const $55100129ab36ed65$var$indexRouteValue = 2;
const $55100129ab36ed65$var$emptySegmentValue = 1;
const $55100129ab36ed65$var$staticSegmentValue = 10;
const $55100129ab36ed65$var$splatPenalty = -2;
const $55100129ab36ed65$var$isSplat = (s)=>s === "*";
function $55100129ab36ed65$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($55100129ab36ed65$var$isSplat)) initialScore += $55100129ab36ed65$var$splatPenalty;
    if (index) initialScore += $55100129ab36ed65$var$indexRouteValue;
    return segments.filter((s)=>!$55100129ab36ed65$var$isSplat(s)).reduce((score, segment)=>score + ($55100129ab36ed65$var$paramRe.test(segment) ? $55100129ab36ed65$var$dynamicSegmentValue : segment === "" ? $55100129ab36ed65$var$emptySegmentValue : $55100129ab36ed65$var$staticSegmentValue), initialScore);
}
function $55100129ab36ed65$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $55100129ab36ed65$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $55100129ab36ed65$export$a5c6d149b50c1d86($55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $55100129ab36ed65$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $55100129ab36ed65$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $55100129ab36ed65$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $55100129ab36ed65$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $55100129ab36ed65$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $55100129ab36ed65$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $55100129ab36ed65$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $55100129ab36ed65$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $55100129ab36ed65$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $55100129ab36ed65$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $55100129ab36ed65$var$normalizeSearch(search),
        hash: $55100129ab36ed65$var$normalizeHash(hash)
    };
}
function $55100129ab36ed65$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $55100129ab36ed65$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $55100129ab36ed65$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $55100129ab36ed65$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $55100129ab36ed65$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $55100129ab36ed65$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $55100129ab36ed65$export$8ccf933b0513f8d0(toArg);
    else {
        to = $55100129ab36ed65$var$_extends({}, toArg);
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $55100129ab36ed65$var$getInvalidPathError("?", "pathname", "search", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "pathname", "hash", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $55100129ab36ed65$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $55100129ab36ed65$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $55100129ab36ed65$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $55100129ab36ed65$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $55100129ab36ed65$export$42a99a7a4bc0e76a extends Error {
}
class $55100129ab36ed65$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $55100129ab36ed65$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $55100129ab36ed65$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $55100129ab36ed65$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $55100129ab36ed65$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $55100129ab36ed65$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $55100129ab36ed65$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $55100129ab36ed65$var$unwrapTrackedPromise(value) {
    if (!$55100129ab36ed65$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $55100129ab36ed65$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $55100129ab36ed65$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $55100129ab36ed65$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $55100129ab36ed65$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $55100129ab36ed65$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $55100129ab36ed65$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $55100129ab36ed65$var$validMutationMethods = new Set($55100129ab36ed65$var$validMutationMethodsArr);
const $55100129ab36ed65$var$validRequestMethodsArr = [
    "get",
    ...$55100129ab36ed65$var$validMutationMethodsArr
];
const $55100129ab36ed65$var$validRequestMethods = new Set($55100129ab36ed65$var$validRequestMethodsArr);
const $55100129ab36ed65$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $55100129ab36ed65$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $55100129ab36ed65$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $55100129ab36ed65$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $55100129ab36ed65$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $55100129ab36ed65$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $55100129ab36ed65$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $55100129ab36ed65$var$defaultDataStrategy;
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $55100129ab36ed65$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $55100129ab36ed65$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$55100129ab36ed65$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($55100129ab36ed65$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $55100129ab36ed65$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $55100129ab36ed65$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $55100129ab36ed65$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($55100129ab36ed65$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $55100129ab36ed65$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $55100129ab36ed65$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $55100129ab36ed65$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $55100129ab36ed65$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $55100129ab36ed65$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $55100129ab36ed65$var$findNearestBoundary(matches).route.id,
            {
                type: $55100129ab36ed65$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $55100129ab36ed65$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = $55100129ab36ed65$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $55100129ab36ed65$var$_extends({
            matches: matches
        }, $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $55100129ab36ed65$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $55100129ab36ed65$var$ResultType.error,
            error: $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $55100129ab36ed65$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isDeferredResult(result)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            return {
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $55100129ab36ed65$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $55100129ab36ed65$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $55100129ab36ed65$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData;
            if (pendingActionResult && !$55100129ab36ed65$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
            // would be a breaking change to use any.
            // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
            actionData = {
                [pendingActionResult[0]]: pendingActionResult[1].data
            };
            else if (state.actionData) {
                if (Object.keys(state.actionData).length === 0) actionData = null;
                else actionData = state.actionData;
            }
            updateState($55100129ab36ed65$var$_extends({
                navigation: loadingNavigation
            }, actionData !== undefined ? {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $55100129ab36ed65$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $55100129ab36ed65$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $55100129ab36ed65$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($55100129ab36ed65$var$isRedirectResult(actionResult) || $55100129ab36ed65$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($55100129ab36ed65$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $55100129ab36ed65$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($55100129ab36ed65$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($55100129ab36ed65$var$isDeferredResult(actionResult)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $55100129ab36ed65$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $55100129ab36ed65$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $55100129ab36ed65$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $55100129ab36ed65$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $55100129ab36ed65$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $55100129ab36ed65$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $55100129ab36ed65$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($55100129ab36ed65$var$isDeferredResult(result)) result = await $55100129ab36ed65$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $55100129ab36ed65$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $55100129ab36ed65$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $55100129ab36ed65$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $55100129ab36ed65$export$e19cd5f9376f8cee.Replace : $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $55100129ab36ed65$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($55100129ab36ed65$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $55100129ab36ed65$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $55100129ab36ed65$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $55100129ab36ed65$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $55100129ab36ed65$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($55100129ab36ed65$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $55100129ab36ed65$var$ResultType.redirect,
                        response: $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $55100129ab36ed65$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: $55100129ab36ed65$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $55100129ab36ed65$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $55100129ab36ed65$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $55100129ab36ed65$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $55100129ab36ed65$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $55100129ab36ed65$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $55100129ab36ed65$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $55100129ab36ed65$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$55100129ab36ed65$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $55100129ab36ed65$export$4d0306f8f6a4585b = Symbol("deferred");
function $55100129ab36ed65$export$3336b097a6fbc59a(routes, opts) {
    $55100129ab36ed65$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD") {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $55100129ab36ed65$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $55100129ab36ed65$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $55100129ab36ed65$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, null, false, match);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$55100129ab36ed65$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $55100129ab36ed65$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($55100129ab36ed65$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $55100129ab36ed65$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $55100129ab36ed65$var$isResponse(result) ? result : $55100129ab36ed65$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($55100129ab36ed65$var$isHandlerResult(e) && $55100129ab36ed65$var$isResponse(e.result)) {
                if (e.type === $55100129ab36ed65$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($55100129ab36ed65$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            let error = $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($55100129ab36ed65$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $55100129ab36ed65$var$_extends({}, context, {
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $55100129ab36ed65$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $55100129ab36ed65$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $55100129ab36ed65$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $55100129ab36ed65$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $55100129ab36ed65$var$callDataStrategyImpl(unstable_dataStrategy || $55100129ab36ed65$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($55100129ab36ed65$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($55100129ab36ed65$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $55100129ab36ed65$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $55100129ab36ed65$export$fec11da027c70692(routes, context, error) {
    let newContext = $55100129ab36ed65$var$_extends({}, context, {
        statusCode: $55100129ab36ed65$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $55100129ab36ed65$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $55100129ab36ed65$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $55100129ab36ed65$export$cae722b0cc860f13(to ? to : ".", $55100129ab36ed65$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$55100129ab36ed65$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $55100129ab36ed65$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $55100129ab36ed65$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $55100129ab36ed65$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$55100129ab36ed65$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$55100129ab36ed65$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $55100129ab36ed65$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $55100129ab36ed65$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $55100129ab36ed65$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($55100129ab36ed65$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $55100129ab36ed65$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $55100129ab36ed65$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $55100129ab36ed65$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $55100129ab36ed65$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($55100129ab36ed65$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $55100129ab36ed65$var$shouldRevalidateLoader(match, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $55100129ab36ed65$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $55100129ab36ed65$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $55100129ab36ed65$var$shouldRevalidateLoader(fetcherMatch, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $55100129ab36ed65$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $55100129ab36ed65$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $55100129ab36ed65$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $55100129ab36ed65$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $55100129ab36ed65$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$55100129ab36ed65$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $55100129ab36ed65$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $55100129ab36ed65$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $55100129ab36ed65$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $55100129ab36ed65$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $55100129ab36ed65$var$ResultType.data,
                    result: undefined
                });
            };
            return $55100129ab36ed65$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$55100129ab36ed65$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $55100129ab36ed65$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $55100129ab36ed65$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $55100129ab36ed65$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $55100129ab36ed65$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $55100129ab36ed65$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $55100129ab36ed65$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $55100129ab36ed65$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($55100129ab36ed65$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $55100129ab36ed65$var$ResultType.error,
                error: e
            };
        }
        if (type === $55100129ab36ed65$var$ResultType.error) return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: new $55100129ab36ed65$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $55100129ab36ed65$var$ResultType.error) return {
        type: $55100129ab36ed65$var$ResultType.error,
        error: result,
        statusCode: $55100129ab36ed65$export$972111febbeef05b(result) ? result.status : status
    };
    if ($55100129ab36ed65$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $55100129ab36ed65$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $55100129ab36ed65$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $55100129ab36ed65$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $55100129ab36ed65$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $55100129ab36ed65$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($55100129ab36ed65$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $55100129ab36ed65$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $55100129ab36ed65$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $55100129ab36ed65$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($55100129ab36ed65$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $55100129ab36ed65$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $55100129ab36ed65$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($55100129ab36ed65$var$isErrorResult(result)) {
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $55100129ab36ed65$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($55100129ab36ed65$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($55100129ab36ed65$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $55100129ab36ed65$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $55100129ab36ed65$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $55100129ab36ed65$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $55100129ab36ed65$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $55100129ab36ed65$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $55100129ab36ed65$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $55100129ab36ed65$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($55100129ab36ed65$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $55100129ab36ed65$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(path) : path;
    return $55100129ab36ed65$export$fe53371bee54353d($55100129ab36ed65$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $55100129ab36ed65$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $55100129ab36ed65$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $55100129ab36ed65$var$ResultType.data || result.type === $55100129ab36ed65$var$ResultType.error);
}
function $55100129ab36ed65$var$isRedirectHandlerResult(result) {
    return $55100129ab36ed65$var$isResponse(result.result) && $55100129ab36ed65$var$redirectStatusCodes.has(result.result.status);
}
function $55100129ab36ed65$var$isDeferredResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.deferred;
}
function $55100129ab36ed65$var$isErrorResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.error;
}
function $55100129ab36ed65$var$isRedirectResult(result) {
    return (result && result.type) === $55100129ab36ed65$var$ResultType.redirect;
}
function $55100129ab36ed65$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $55100129ab36ed65$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $55100129ab36ed65$var$isRedirectResponse(result) {
    if (!$55100129ab36ed65$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $55100129ab36ed65$var$isValidMethod(method) {
    return $55100129ab36ed65$var$validRequestMethods.has(method.toLowerCase());
}
function $55100129ab36ed65$var$isMutationMethod(method) {
    return $55100129ab36ed65$var$validMutationMethods.has(method.toLowerCase());
}
async function $55100129ab36ed65$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($55100129ab36ed65$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $55100129ab36ed65$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $55100129ab36ed65$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $55100129ab36ed65$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $55100129ab36ed65$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $55100129ab36ed65$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $55100129ab36ed65$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $55100129ab36ed65$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $55100129ab36ed65$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $55100129ab36ed65$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $55100129ab36ed65$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $55100129ab36ed65$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $55100129ab36ed65$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $55100129ab36ed65$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $55100129ab36ed65$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $55100129ab36ed65$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $d9fd026bfea79ab9$var$_extends() {
    $d9fd026bfea79ab9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9fd026bfea79ab9$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $d9fd026bfea79ab9$export$3add0d5dce533e2e = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$145dfa71566a64dc = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$var$AwaitContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $d9fd026bfea79ab9$export$26749e8557646306 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$c7914228fb69b0f5 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$9072aa6dd1f93057 = /*#__PURE__*/ $7fPBF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $d9fd026bfea79ab9$var$RouteErrorContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $d9fd026bfea79ab9$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $d9fd026bfea79ab9$export$9c954a9d03d32f4a() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $d9fd026bfea79ab9$export$45d76561a5302f2b() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $d9fd026bfea79ab9$export$1b3f31771c5d07c() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $d9fd026bfea79ab9$export$6c330e8992e8a295(pattern) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $d9fd026bfea79ab9$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $7fPBF.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $d9fd026bfea79ab9$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $d9fd026bfea79ab9$var$useNavigateStable() : $d9fd026bfea79ab9$var$useNavigateUnstable();
}
function $d9fd026bfea79ab9$var$useNavigateUnstable() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$OutletContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $d9fd026bfea79ab9$export$4138103a3ae699cc() {
    return $7fPBF.useContext($d9fd026bfea79ab9$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $d9fd026bfea79ab9$export$a3be3530d8e40d0b(context) {
    let outlet = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $d9fd026bfea79ab9$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $d9fd026bfea79ab9$export$5d3fca4a98652595(routes, locationArg) {
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: parentMatches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $55100129ab36ed65$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $d9fd026bfea79ab9$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $d9fd026bfea79ab9$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $d9fd026bfea79ab9$var$DefaultErrorComponent() {
    let error = $d9fd026bfea79ab9$export$ed527bf60f6e05f2();
    let message = (0, $55100129ab36ed65$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $7fPBF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $7fPBF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $d9fd026bfea79ab9$var$defaultErrorElement = /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DefaultErrorComponent, null);
class $d9fd026bfea79ab9$var$RenderErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $d9fd026bfea79ab9$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $d9fd026bfea79ab9$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $d9fd026bfea79ab9$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $d9fd026bfea79ab9$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $7fPBF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $d9fd026bfea79ab9$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($d9fd026bfea79ab9$var$DataRouterHook || {});
var $d9fd026bfea79ab9$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($d9fd026bfea79ab9$var$DataRouterStateHook || {});
function $d9fd026bfea79ab9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $d9fd026bfea79ab9$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $d9fd026bfea79ab9$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext($d9fd026bfea79ab9$export$145dfa71566a64dc);
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
function $d9fd026bfea79ab9$var$useRouteContext(hookName) {
    let route = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $d9fd026bfea79ab9$var$useCurrentRouteId(hookName) {
    let route = $d9fd026bfea79ab9$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $d9fd026bfea79ab9$export$5fc8298006ad9e58() {
    return $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $d9fd026bfea79ab9$export$d0fd4b7106de2769() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $d9fd026bfea79ab9$export$600dc272ed516c15() {
    let dataRouterContext = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseRevalidator);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRevalidator);
    return $7fPBF.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $d9fd026bfea79ab9$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseMatches);
    return $7fPBF.useMemo(()=>matches.map((m)=>(0, $55100129ab36ed65$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $d9fd026bfea79ab9$export$1448a5050d252c4d() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $d9fd026bfea79ab9$export$fd5d37484eab868d(routeId) {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $d9fd026bfea79ab9$export$fdc00f3f26066d5e() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseActionData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $d9fd026bfea79ab9$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $7fPBF.useContext($d9fd026bfea79ab9$var$RouteErrorContext);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$78a72ddb39bdd145() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$17f53340677d5831() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $d9fd026bfea79ab9$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $d9fd026bfea79ab9$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseBlocker);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $7fPBF.useState("");
    let blockerFunction = $7fPBF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $d9fd026bfea79ab9$var$_extends({}, currentLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $d9fd026bfea79ab9$var$_extends({}, nextLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $7fPBF.useEffect(()=>{
        let key = String(++$d9fd026bfea79ab9$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $7fPBF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $55100129ab36ed65$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $d9fd026bfea79ab9$var$useNavigateStable() {
    let { router: router } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseNavigateStable);
    let id = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $d9fd026bfea79ab9$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$alreadyWarned = {};
function $d9fd026bfea79ab9$var$warningOnce(key, cond, message) {
    if (!cond && !$d9fd026bfea79ab9$var$alreadyWarned[key]) $d9fd026bfea79ab9$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d9fd026bfea79ab9$var$START_TRANSITION = "startTransition";
const $d9fd026bfea79ab9$var$startTransitionImpl = $7fPBF[$d9fd026bfea79ab9$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d9fd026bfea79ab9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        if (v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl) $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7fPBF.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $d9fd026bfea79ab9$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $d9fd026bfea79ab9$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl ? $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $d9fd026bfea79ab9$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let navigate = $d9fd026bfea79ab9$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, (0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7fPBF.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $d9fd026bfea79ab9$export$910ae8079b2c2852(props) {
    return $d9fd026bfea79ab9$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $d9fd026bfea79ab9$export$e7b0ac011bb776c6(_props) {
    (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $d9fd026bfea79ab9$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7fPBF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $d9fd026bfea79ab9$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $7fPBF.useMemo(()=>{
        let trailingPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $d9fd026bfea79ab9$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $d9fd026bfea79ab9$export$5d3fca4a98652595($d9fd026bfea79ab9$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $d9fd026bfea79ab9$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$ResolveAwait, null, children));
}
var $d9fd026bfea79ab9$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($d9fd026bfea79ab9$var$AwaitRenderStatus || {});
const $d9fd026bfea79ab9$var$neverSettledPromise = new Promise(()=>{});
class $d9fd026bfea79ab9$var$AwaitErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $d9fd026bfea79ab9$var$AwaitRenderStatus.error : promise._data !== undefined ? $d9fd026bfea79ab9$var$AwaitRenderStatus.success : $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && promise._error instanceof (0, $55100129ab36ed65$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $d9fd026bfea79ab9$var$neverSettledPromise;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $d9fd026bfea79ab9$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $d9fd026bfea79ab9$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $d9fd026bfea79ab9$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $7fPBF.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7fPBF.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $d9fd026bfea79ab9$export$e7b0ac011bb776c6) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $d9fd026bfea79ab9$export$daf73786167a7f72(matches) {
    return $d9fd026bfea79ab9$var$_renderMatches(matches);
}
function $d9fd026bfea79ab9$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $7fPBF.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $7fPBF.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $7fPBF.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $d9fd026bfea79ab9$export$f30f7e456d254e83(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d9fd026bfea79ab9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $d9fd026bfea79ab9$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy
    }).initialize();
}



function $a0cf24fd73ae067c$var$_extends() {
    $a0cf24fd73ae067c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a0cf24fd73ae067c$var$_extends.apply(this, arguments);
}
function $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a0cf24fd73ae067c$var$defaultMethod = "get";
const $a0cf24fd73ae067c$var$defaultEncType = "application/x-www-form-urlencoded";
function $a0cf24fd73ae067c$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $a0cf24fd73ae067c$var$isButtonElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $a0cf24fd73ae067c$var$isFormElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $a0cf24fd73ae067c$var$isInputElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $a0cf24fd73ae067c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$a0cf24fd73ae067c$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $a0cf24fd73ae067c$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = null;
function $a0cf24fd73ae067c$var$isFormDataSubmitterSupported() {
    if ($a0cf24fd73ae067c$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = true;
    }
    return $a0cf24fd73ae067c$var$_formDataSupportsSubmitter;
}
const $a0cf24fd73ae067c$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $a0cf24fd73ae067c$var$getFormEncType(encType) {
    if (encType != null && !$a0cf24fd73ae067c$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($a0cf24fd73ae067c$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        formData = new FormData(target);
    } else if ($a0cf24fd73ae067c$var$isButtonElement(target) || $a0cf24fd73ae067c$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("formenctype")) || $a0cf24fd73ae067c$var$getFormEncType(form.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$a0cf24fd73ae067c$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($a0cf24fd73ae067c$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $a0cf24fd73ae067c$var$defaultMethod;
        action = null;
        encType = $a0cf24fd73ae067c$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $a0cf24fd73ae067c$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $a0cf24fd73ae067c$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $a0cf24fd73ae067c$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $a0cf24fd73ae067c$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $a0cf24fd73ae067c$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $a0cf24fd73ae067c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $a0cf24fd73ae067c$var$_extends({}, state, {
        errors: $a0cf24fd73ae067c$var$deserializeErrors(state.errors)
    });
    return state;
}
function $a0cf24fd73ae067c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $55100129ab36ed65$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $a0cf24fd73ae067c$export$7ad602f0e94e62d1 = /*#__PURE__*/ $7fPBF.createContext({
    isTransitioning: false
});
const $a0cf24fd73ae067c$export$148fd98d095596d4 = /*#__PURE__*/ $7fPBF.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a0cf24fd73ae067c$var$START_TRANSITION = "startTransition";
const $a0cf24fd73ae067c$var$startTransitionImpl = $7fPBF[$a0cf24fd73ae067c$var$START_TRANSITION];
const $a0cf24fd73ae067c$var$FLUSH_SYNC = "flushSync";
const $a0cf24fd73ae067c$var$flushSyncImpl = $b4ba1c853f6e1116$exports[$a0cf24fd73ae067c$var$FLUSH_SYNC];
const $a0cf24fd73ae067c$var$USE_ID = "useId";
const $a0cf24fd73ae067c$var$useIdImpl = $7fPBF[$a0cf24fd73ae067c$var$USE_ID];
function $a0cf24fd73ae067c$var$startTransitionSafe(cb) {
    if ($a0cf24fd73ae067c$var$startTransitionImpl) $a0cf24fd73ae067c$var$startTransitionImpl(cb);
    else cb();
}
function $a0cf24fd73ae067c$var$flushSyncSafe(cb) {
    if ($a0cf24fd73ae067c$var$flushSyncImpl) $a0cf24fd73ae067c$var$flushSyncImpl(cb);
    else cb();
}
class $a0cf24fd73ae067c$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a0cf24fd73ae067c$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let [pendingState, setPendingState] = $7fPBF.useState();
    let [vtContext, setVtContext] = $7fPBF.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7fPBF.useState();
    let [transition, setTransition] = $7fPBF.useState();
    let [interruption, setInterruption] = $7fPBF.useState();
    let fetcherData = $7fPBF.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $7fPBF.useCallback((cb)=>{
        if (v7_startTransition) $a0cf24fd73ae067c$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $7fPBF.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $a0cf24fd73ae067c$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $a0cf24fd73ae067c$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $a0cf24fd73ae067c$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $a0cf24fd73ae067c$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $a0cf24fd73ae067c$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $7fPBF.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $a0cf24fd73ae067c$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $7fPBF.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $7fPBF.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $a0cf24fd73ae067c$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $d9fd026bfea79ab9$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $a0cf24fd73ae067c$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $a0cf24fd73ae067c$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $a0cf24fd73ae067c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $a0cf24fd73ae067c$export$a6c7ac8248d6e38a = /*#__PURE__*/ $7fPBF.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref7, $a0cf24fd73ae067c$var$_excluded);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($a0cf24fd73ae067c$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $d9fd026bfea79ab9$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $a0cf24fd73ae067c$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $7fPBF.createElement("a", $a0cf24fd73ae067c$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $a0cf24fd73ae067c$export$b0d92dbee9b5b60d = /*#__PURE__*/ $7fPBF.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref8, $a0cf24fd73ae067c$var$_excluded2);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let routerState = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $a0cf24fd73ae067c$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a6c7ac8248d6e38a, $a0cf24fd73ae067c$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $a0cf24fd73ae067c$export$a7fed597f4b8afd8 = /*#__PURE__*/ $7fPBF.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $a0cf24fd73ae067c$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref9, $a0cf24fd73ae067c$var$_excluded3);
    let submit = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let formAction = $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $7fPBF.createElement("form", $a0cf24fd73ae067c$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $a0cf24fd73ae067c$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $a0cf24fd73ae067c$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $a0cf24fd73ae067c$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($a0cf24fd73ae067c$var$DataRouterHook || ($a0cf24fd73ae067c$var$DataRouterHook = {}));
var $a0cf24fd73ae067c$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($a0cf24fd73ae067c$var$DataRouterStateHook || ($a0cf24fd73ae067c$var$DataRouterStateHook = {}));
// Internal hooks
function $a0cf24fd73ae067c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $a0cf24fd73ae067c$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e));
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $a0cf24fd73ae067c$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $a0cf24fd73ae067c$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $7fPBF.useCallback((event)=>{
        if ($a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $55100129ab36ed65$export$fe53371bee54353d)(location) === (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $a0cf24fd73ae067c$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $7fPBF.useRef($a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7fPBF.useRef(false);
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let searchParams = $7fPBF.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $a0cf24fd73ae067c$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let setSearchParams = $7fPBF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $a0cf24fd73ae067c$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $a0cf24fd73ae067c$var$fetcherId = 0;
let $a0cf24fd73ae067c$var$getUniqueFetcherId = ()=>"__" + String(++$a0cf24fd73ae067c$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $a0cf24fd73ae067c$export$47c85c6e3a081d3() {
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let currentRouteId = (0, $d9fd026bfea79ab9$export$5fc8298006ad9e58)();
    return $7fPBF.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $a0cf24fd73ae067c$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $a0cf24fd73ae067c$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let routeContext = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    !routeContext && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $a0cf24fd73ae067c$var$_extends({}, (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $a0cf24fd73ae067c$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseFetcher);
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $7fPBF.useContext($a0cf24fd73ae067c$export$148fd98d095596d4);
    let route = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $a0cf24fd73ae067c$var$useIdImpl ? $a0cf24fd73ae067c$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $7fPBF.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($a0cf24fd73ae067c$var$getUniqueFetcherId());
    // Registration/cleanup
    $7fPBF.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $7fPBF.useCallback((href, opts)=>{
        !routeId && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let submit = $7fPBF.useCallback((target, opts)=>{
        submitImpl(target, $a0cf24fd73ae067c$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $7fPBF.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a7fed597f4b8afd8, $a0cf24fd73ae067c$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $55100129ab36ed65$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7fPBF.useMemo(()=>$a0cf24fd73ae067c$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $a0cf24fd73ae067c$export$fa996778a3a31087() {
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $a0cf24fd73ae067c$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $a0cf24fd73ae067c$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $a0cf24fd73ae067c$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let matches = (0, $d9fd026bfea79ab9$export$2378eb7f5ff86053)();
    let navigation = (0, $d9fd026bfea79ab9$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $7fPBF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $a0cf24fd73ae067c$var$usePageHide($7fPBF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $a0cf24fd73ae067c$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($a0cf24fd73ae067c$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $a0cf24fd73ae067c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($a0cf24fd73ae067c$var$_extends({}, location, {
                    pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($a0cf24fd73ae067c$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $a0cf24fd73ae067c$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $d9fd026bfea79ab9$export$b273b3273281a049)(when);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $a0cf24fd73ae067c$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $7fPBF.useContext($a0cf24fd73ae067c$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.useViewTransitionState);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $hmhHQ = parcelRequire("hmhHQ");
var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");
parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
const $c21ce0253dc11cd3$var$ThemeContext = /*#__PURE__*/ $7fPBF.createContext(null);
var $c21ce0253dc11cd3$export$2e2bcd8739ae039 = $c21ce0253dc11cd3$var$ThemeContext;


function $b5dba0f0f3e50f8f$export$2e2bcd8739ae039() {
    const theme = $7fPBF.useContext((0, $c21ce0253dc11cd3$export$2e2bcd8739ae039));
    return theme;
}


var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");




const $24ebfb3bf89f6ffe$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $24ebfb3bf89f6ffe$export$2e2bcd8739ae039 = $24ebfb3bf89f6ffe$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $bbzbN = parcelRequire("bbzbN");
function $f311b16c4b43b6fd$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $kY3Ke.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $f311b16c4b43b6fd$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $b5dba0f0f3e50f8f$export$2e2bcd8739ae039)();
    const theme = $7fPBF.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $f311b16c4b43b6fd$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $24ebfb3bf89f6ffe$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c21ce0253dc11cd3$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $f311b16c4b43b6fd$export$2e2bcd8739ae039 = $f311b16c4b43b6fd$var$ThemeProvider;



parcelRequire("bpHMA");
var $hpTPt = parcelRequire("hpTPt");

var $84PRT = parcelRequire("84PRT");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $bbzbN = parcelRequire("bbzbN");
const $ef654b446fc390d6$var$_excluded = [
    "value"
];
const $ef654b446fc390d6$var$RtlContext = /*#__PURE__*/ $7fPBF.createContext();
function $ef654b446fc390d6$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $cFLic.default)(_ref, $ef654b446fc390d6$var$_excluded);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($ef654b446fc390d6$var$RtlContext.Provider, (0, $kY3Ke.default)({
        value: value != null ? value : true
    }, props));
}
const $ef654b446fc390d6$export$b2dd014b6c321cb = ()=>{
    const value = $7fPBF.useContext($ef654b446fc390d6$var$RtlContext);
    return value != null ? value : false;
};
var $ef654b446fc390d6$export$2e2bcd8739ae039 = $ef654b446fc390d6$var$RtlProvider;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $cac97cfcc46fa531$var$EMPTY_THEME = {};
function $cac97cfcc46fa531$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $7fPBF.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $kY3Ke.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $kY3Ke.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $kY3Ke.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $cac97cfcc46fa531$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $84PRT.default)($cac97cfcc46fa531$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $b5dba0f0f3e50f8f$export$2e2bcd8739ae039)() || $cac97cfcc46fa531$var$EMPTY_THEME;
    const engineTheme = $cac97cfcc46fa531$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $cac97cfcc46fa531$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === "rtl";
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f311b16c4b43b6fd$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hpTPt.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ef654b446fc390d6$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: children
            })
        })
    });
}
var $cac97cfcc46fa531$export$2e2bcd8739ae039 = $cac97cfcc46fa531$var$ThemeProvider;



var $jwhZE = parcelRequire("jwhZE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $b8226d5132dedede$var$_excluded = [
    "theme"
];
function $b8226d5132dedede$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $cFLic.default)(_ref, $b8226d5132dedede$var$_excluded);
    const scopedTheme = themeInput[0, $jwhZE.default];
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cac97cfcc46fa531$export$2e2bcd8739ae039), (0, $kY3Ke.default)({}, props, {
        themeId: scopedTheme ? (0, $jwhZE.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}



var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $5j2OD = parcelRequire("5j2OD");

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");

parcelRequire("7fPBF");


var $5tMhb = parcelRequire("5tMhb");

var $4kWyf = parcelRequire("4kWyf");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $ee13700d4d997375$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $4kWyf.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5tMhb.default), {
        styles: globalStyles
    });
}
var $ee13700d4d997375$export$2e2bcd8739ae039 = $ee13700d4d997375$var$GlobalStyles;



var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $a50e20ff7f02e09b$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ee13700d4d997375$export$2e2bcd8739ae039), (0, $kY3Ke.default)({}, props, {
        defaultTheme: (0, $9P91Y.default),
        themeId: (0, $jwhZE.default)
    }));
}
var $a50e20ff7f02e09b$export$2e2bcd8739ae039 = $a50e20ff7f02e09b$var$GlobalStyles;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $81465d564338b8cb$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $kY3Ke.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $81465d564338b8cb$export$32180ef41b15b513 = (theme)=>(0, $kY3Ke.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $81465d564338b8cb$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, "")] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $kY3Ke.default)({
        html: $81465d564338b8cb$export$c0bb0b647f701bb5(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $kY3Ke.default)({
            margin: 0
        }, $81465d564338b8cb$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $81465d564338b8cb$var$CssBaseline(inProps) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a50e20ff7f02e09b$export$2e2bcd8739ae039), {
                styles: (theme)=>$81465d564338b8cb$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $81465d564338b8cb$export$2e2bcd8739ae039 = $81465d564338b8cb$var$CssBaseline;



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");

var $5VCcJ = parcelRequire("5VCcJ");

var $8M6a3 = parcelRequire("8M6a3");
var $mqrnX = parcelRequire("mqrnX");

var $4kWyf = parcelRequire("4kWyf");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $bd7b6b8695507478$var$_excluded = [
    "className",
    "component"
];
function $bd7b6b8695507478$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $5VCcJ.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $8M6a3.default));
    const Box = /*#__PURE__*/ $7fPBF.forwardRef(function Box(inProps, ref) {
        const theme = (0, $4kWyf.default)(defaultTheme);
        const _extendSxProp = (0, $mqrnX.default)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $cFLic.default)(_extendSxProp, $bd7b6b8695507478$var$_excluded);
        return /*#__PURE__*/ (0, $bbzbN.jsx)(BoxRoot, (0, $kY3Ke.default)({
            as: component,
            ref: ref,
            className: (0, $hngXp.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $7GMGX = parcelRequire("7GMGX");

var $hmhHQ = parcelRequire("hmhHQ");

var $jwhZE = parcelRequire("jwhZE");

var $9UILM = parcelRequire("9UILM");
const $9dbabfa00f5ea67f$var$boxClasses = (0, $9UILM.default)("MuiBox", [
    "root"
]);
var $9dbabfa00f5ea67f$export$2e2bcd8739ae039 = $9dbabfa00f5ea67f$var$boxClasses;


"use client";
const $77ec199cefd4182a$var$defaultTheme = (0, $hmhHQ.default)();
const $77ec199cefd4182a$var$Box = (0, $bd7b6b8695507478$export$2e2bcd8739ae039)({
    themeId: (0, $jwhZE.default),
    defaultTheme: $77ec199cefd4182a$var$defaultTheme,
    defaultClassName: (0, $9dbabfa00f5ea67f$export$2e2bcd8739ae039).root,
    generateClassName: (0, $7GMGX.default).generate
});
var $77ec199cefd4182a$export$2e2bcd8739ae039 = $77ec199cefd4182a$var$Box;



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");


var $kDBhE = parcelRequire("kDBhE");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");



var $fsUVx = parcelRequire("fsUVx");

var $7jL4F = parcelRequire("7jL4F");

var $kDBhE = parcelRequire("kDBhE");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $8fa7ddbbf42193a7$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $8fa7ddbbf42193a7$export$2e2bcd8739ae039 = $8fa7ddbbf42193a7$var$getOverlayAlpha;



var $5j2OD = parcelRequire("5j2OD");


var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $bde3e2fffcaea664$export$29cdb466b9b6f20b(slot) {
    return (0, $jzxpm.default)("MuiPaper", slot);
}
const $bde3e2fffcaea664$var$paperClasses = (0, $9UILM.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $bde3e2fffcaea664$export$2e2bcd8739ae039 = $bde3e2fffcaea664$var$paperClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $74e245c78e363f11$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $74e245c78e363f11$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $bde3e2fffcaea664$export$29cdb466b9b6f20b), classes);
};
const $74e245c78e363f11$var$PaperRoot = (0, $kDBhE.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $kY3Ke.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $kY3Ke.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $7jL4F.alpha)("#fff", (0, $8fa7ddbbf42193a7$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $7jL4F.alpha)("#fff", (0, $8fa7ddbbf42193a7$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $74e245c78e363f11$var$Paper = /*#__PURE__*/ $7fPBF.forwardRef(function Paper(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $cFLic.default)(props, $74e245c78e363f11$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $74e245c78e363f11$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($74e245c78e363f11$var$PaperRoot, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref
    }, other));
});
var $74e245c78e363f11$export$2e2bcd8739ae039 = $74e245c78e363f11$var$Paper;



var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $8f7c5161bc7a509f$export$47a2da616e55e8e9(slot) {
    return (0, $jzxpm.default)("MuiAppBar", slot);
}
const $8f7c5161bc7a509f$var$appBarClasses = (0, $9UILM.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning"
]);
var $8f7c5161bc7a509f$export$2e2bcd8739ae039 = $8f7c5161bc7a509f$var$appBarClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $5c04bc14285128b0$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $5c04bc14285128b0$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $b6UUh.default)(color)}`,
            `position${(0, $b6UUh.default)(position)}`
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $8f7c5161bc7a509f$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $5c04bc14285128b0$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(")", "")}, ${var2})` : var2;
const $5c04bc14285128b0$var$AppBarRoot = (0, $kDBhE.default)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $b6UUh.default)(ownerState.position)}`],
            styles[`color${(0, $b6UUh.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $kY3Ke.default)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, $kY3Ke.default)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, $kY3Ke.default)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, $kY3Ke.default)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: "var(--AppBar-background)",
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
const $5c04bc14285128b0$var$AppBar = /*#__PURE__*/ $7fPBF.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className: className, color: color = "primary", enableColorOnDark: enableColorOnDark = false, position: position = "fixed" } = props, other = (0, $cFLic.default)(props, $5c04bc14285128b0$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $5c04bc14285128b0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($5c04bc14285128b0$var$AppBarRoot, (0, $kY3Ke.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $hngXp.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
var $5c04bc14285128b0$export$2e2bcd8739ae039 = $5c04bc14285128b0$var$AppBar;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $dc304ab6922390a3$export$b12cb262231eef32(slot) {
    return (0, $jzxpm.default)("MuiToolbar", slot);
}
const $dc304ab6922390a3$var$toolbarClasses = (0, $9UILM.default)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $dc304ab6922390a3$export$2e2bcd8739ae039 = $dc304ab6922390a3$var$toolbarClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $4356b5696745688a$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $4356b5696745688a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $dc304ab6922390a3$export$b12cb262231eef32), classes);
};
const $4356b5696745688a$var$ToolbarRoot = (0, $kDBhE.default)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === "dense" && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === "regular" && theme.mixins.toolbar);
const $4356b5696745688a$var$Toolbar = /*#__PURE__*/ $7fPBF.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className: className, component: component = "div", disableGutters: disableGutters = false, variant: variant = "regular" } = props, other = (0, $cFLic.default)(props, $4356b5696745688a$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $4356b5696745688a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($4356b5696745688a$var$ToolbarRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $4356b5696745688a$export$2e2bcd8739ae039 = $4356b5696745688a$var$Toolbar;




var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("j2VHG");


var $hngXp = parcelRequire("hngXp");


var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $78cfb6b4689e3d24$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $52155878109bdfb9$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $7fPBF.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $78cfb6b4689e3d24$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}



var $kY3Ke = parcelRequire("kY3Ke");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $59c589404b20ab2d$export$e28348cc2430497(element) {
    return typeof element === "string";
}


function $465892a610f5fa03$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $59c589404b20ab2d$export$e28348cc2430497)(elementType)) return otherProps;
    return (0, $kY3Ke.default)({}, otherProps, {
        ownerState: (0, $kY3Ke.default)({}, otherProps.ownerState, ownerState)
    });
}



var $kY3Ke = parcelRequire("kY3Ke");

var $hngXp = parcelRequire("hngXp");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $676085a836f199f4$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $38b4de40642d32ce$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $27e8a811df72cf86$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $hngXp.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $kY3Ke.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $kY3Ke.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $676085a836f199f4$export$24d5698b57eff81c)((0, $kY3Ke.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $38b4de40642d32ce$export$2ac0fa4d3a39be45)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $38b4de40642d32ce$export$2ac0fa4d3a39be45)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $hngXp.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $kY3Ke.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $kY3Ke.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $029d34f88c9482cd$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}


"use client";
const $699e2a22f1708389$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $699e2a22f1708389$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $cFLic.default)(parameters, $699e2a22f1708389$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $029d34f88c9482cd$export$308c24034cde71de)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $27e8a811df72cf86$export$b01d1e419b049226)((0, $kY3Ke.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $52155878109bdfb9$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $465892a610f5fa03$export$b089efb01a7bdf50)(elementType, (0, $kY3Ke.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $fsUVx = parcelRequire("fsUVx");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $mqrnX = parcelRequire("mqrnX");

var $fsUVx = parcelRequire("fsUVx");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");

var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $d9914d0380157c73$export$24c1f8f60cbac79e(slot) {
    return (0, $jzxpm.default)("MuiTypography", slot);
}
const $d9914d0380157c73$var$typographyClasses = (0, $9UILM.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $d9914d0380157c73$export$2e2bcd8739ae039 = $d9914d0380157c73$var$typographyClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $26f68e516ee75fc4$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $26f68e516ee75fc4$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $b6UUh.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $d9914d0380157c73$export$24c1f8f60cbac79e), classes);
};
const $26f68e516ee75fc4$export$140e2f5526d3cad8 = (0, $kDBhE.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $b6UUh.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $26f68e516ee75fc4$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $26f68e516ee75fc4$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $26f68e516ee75fc4$var$transformDeprecatedColors = (color)=>{
    return $26f68e516ee75fc4$var$colorTransformations[color] || color;
};
const $26f68e516ee75fc4$var$Typography = /*#__PURE__*/ $7fPBF.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $26f68e516ee75fc4$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $mqrnX.default)((0, $kY3Ke.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $26f68e516ee75fc4$var$defaultVariantMapping } = props, other = (0, $cFLic.default)(props, $26f68e516ee75fc4$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $26f68e516ee75fc4$var$defaultVariantMapping[variant]) || "span";
    const classes = $26f68e516ee75fc4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($26f68e516ee75fc4$export$140e2f5526d3cad8, (0, $kY3Ke.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className)
    }, other));
});
var $26f68e516ee75fc4$export$2e2bcd8739ae039 = $26f68e516ee75fc4$var$Typography;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");


var $7jL4F = parcelRequire("7jL4F");

var $kDBhE = parcelRequire("kDBhE");
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $bf5ccaae290cc05e$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz");



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");



var $fsUVx = parcelRequire("fsUVx");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

"use client";
var $4f30d4c1188a58e6$export$2e2bcd8739ae039 = (0, $52155878109bdfb9$export$2e2bcd8739ae039);



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $f7f8f12b8c6feb2f$var$useEnhancedEffect = typeof window !== "undefined" ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $f7f8f12b8c6feb2f$export$2e2bcd8739ae039 = $f7f8f12b8c6feb2f$var$useEnhancedEffect;


"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $f3c1f2021d65e015$var$useEventCallback(fn) {
    const ref = $7fPBF.useRef(fn);
    (0, $f7f8f12b8c6feb2f$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $7fPBF.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $f3c1f2021d65e015$export$2e2bcd8739ae039 = $f3c1f2021d65e015$var$useEventCallback;


"use client";
var $16db65b1f19e65f7$export$2e2bcd8739ae039 = (0, $f3c1f2021d65e015$export$2e2bcd8739ae039);



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
"use client";
const $b6c57e373da972b8$var$UNINITIALIZED = {};
function $b6c57e373da972b8$export$2e2bcd8739ae039(init, initArg) {
    const ref = $7fPBF.useRef($b6c57e373da972b8$var$UNINITIALIZED);
    if (ref.current === $b6c57e373da972b8$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $7fPBF = parcelRequire("7fPBF");
"use client";
const $4a342c5cc7e780d6$var$EMPTY = [];
function $4a342c5cc7e780d6$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $7fPBF.useEffect(fn, $4a342c5cc7e780d6$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


"use client";
class $c687181065d3a58c$export$786b4da70f00938b {
    static create() {
        return new $c687181065d3a58c$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
}
function $c687181065d3a58c$export$2e2bcd8739ae039() {
    const timeout = (0, $b6c57e373da972b8$export$2e2bcd8739ae039)($c687181065d3a58c$export$786b4da70f00938b.create).current;
    (0, $4a342c5cc7e780d6$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


"use client";
let $f9235f5fb5126f4b$var$hadKeyboardEvent = true;
let $f9235f5fb5126f4b$var$hadFocusVisibleRecently = false;
const $f9235f5fb5126f4b$var$hadFocusVisibleRecentlyTimeout = new (0, $c687181065d3a58c$export$786b4da70f00938b)();
const $f9235f5fb5126f4b$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $f9235f5fb5126f4b$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $f9235f5fb5126f4b$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $f9235f5fb5126f4b$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $f9235f5fb5126f4b$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $f9235f5fb5126f4b$var$handlePointerDown() {
    $f9235f5fb5126f4b$var$hadKeyboardEvent = false;
}
function $f9235f5fb5126f4b$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($f9235f5fb5126f4b$var$hadFocusVisibleRecently) $f9235f5fb5126f4b$var$hadKeyboardEvent = true;
    }
}
function $f9235f5fb5126f4b$var$prepare(doc) {
    doc.addEventListener("keydown", $f9235f5fb5126f4b$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $f9235f5fb5126f4b$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $f9235f5fb5126f4b$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $f9235f5fb5126f4b$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $f9235f5fb5126f4b$var$handleVisibilityChange, true);
}
function $f9235f5fb5126f4b$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $f9235f5fb5126f4b$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $f9235f5fb5126f4b$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $f9235f5fb5126f4b$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $f9235f5fb5126f4b$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $f9235f5fb5126f4b$var$handleVisibilityChange, true);
}
function $f9235f5fb5126f4b$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $f9235f5fb5126f4b$var$hadKeyboardEvent || $f9235f5fb5126f4b$var$focusTriggersKeyboardModality(target);
}
function $f9235f5fb5126f4b$export$2e2bcd8739ae039() {
    const ref = $7fPBF.useCallback((node)=>{
        if (node != null) $f9235f5fb5126f4b$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $7fPBF.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $f9235f5fb5126f4b$var$hadFocusVisibleRecently = true;
            $f9235f5fb5126f4b$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $f9235f5fb5126f4b$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($f9235f5fb5126f4b$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


"use client";
var $77c51d9bab7ec5dd$export$2e2bcd8739ae039 = (0, $f9235f5fb5126f4b$export$2e2bcd8739ae039);



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
function $298ff58efa174465$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $da27c96857818bcc$export$2e2bcd8739ae039(o, p) {
    $da27c96857818bcc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $da27c96857818bcc$export$2e2bcd8739ae039(o, p);
}


function $146ee816144a450d$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $da27c96857818bcc$export$2e2bcd8739ae039)(subClass, superClass);
}




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $61c94efb1735eff6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);



var $7fPBF = parcelRequire("7fPBF");
function $2a31251aa5f7eb4f$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $7fPBF.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $7fPBF.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $2a31251aa5f7eb4f$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $2a31251aa5f7eb4f$export$fa71e2345c31d7a2(props, onExited) {
    return $2a31251aa5f7eb4f$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $2a31251aa5f7eb4f$var$getProp(child, "appear", props),
            enter: $2a31251aa5f7eb4f$var$getProp(child, "enter", props),
            exit: $2a31251aa5f7eb4f$var$getProp(child, "exit", props)
        });
    });
}
function $2a31251aa5f7eb4f$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $2a31251aa5f7eb4f$export$bbc8a025727ea824(nextProps.children);
    var children = $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $7fPBF.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $7fPBF.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $2a31251aa5f7eb4f$var$getProp(child, "exit", nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $7fPBF.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $2a31251aa5f7eb4f$var$getProp(child, "exit", nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $30921f11ad4ef55c$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $30921f11ad4ef55c$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $30921f11ad4ef55c$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $146ee816144a450d$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $2a31251aa5f7eb4f$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $2a31251aa5f7eb4f$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $2a31251aa5f7eb4f$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $kY3Ke.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $cFLic.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $30921f11ad4ef55c$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$30921f11ad4ef55c$var$TransitionGroup.propTypes = {};
$30921f11ad4ef55c$var$TransitionGroup.defaultProps = $30921f11ad4ef55c$var$defaultProps;
var $30921f11ad4ef55c$export$2e2bcd8739ae039 = $30921f11ad4ef55c$var$TransitionGroup;



var $hngXp = parcelRequire("hngXp");

var $bpHMA = parcelRequire("bpHMA");


var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $3d4a0ced9cf2c3c7$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $7fPBF.useState(false);
    const rippleClassName = (0, $hngXp.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $hngXp.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $7fPBF.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: childClassName
        })
    });
}
var $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039 = $3d4a0ced9cf2c3c7$var$Ripple;



var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $fbda7a0931c56f58$export$b464606f735ab902(slot) {
    return (0, $jzxpm.default)("MuiTouchRipple", slot);
}
const $fbda7a0931c56f58$var$touchRippleClasses = (0, $9UILM.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $fbda7a0931c56f58$export$2e2bcd8739ae039 = $fbda7a0931c56f58$var$touchRippleClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
let $3f5ffa895ad4456e$var$_ = (t)=>t, $3f5ffa895ad4456e$var$t, $3f5ffa895ad4456e$var$t1, $3f5ffa895ad4456e$var$t2, $3f5ffa895ad4456e$var$t3;
const $3f5ffa895ad4456e$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $3f5ffa895ad4456e$var$_1 = (t)=>t, $3f5ffa895ad4456e$var$_t, $3f5ffa895ad4456e$var$_t2, $3f5ffa895ad4456e$var$_t3, $3f5ffa895ad4456e$var$_t4;
const $3f5ffa895ad4456e$var$DURATION = 550;
const $3f5ffa895ad4456e$export$95d0c9356b2231a3 = 80;
const $3f5ffa895ad4456e$var$enterKeyframe = (0, $bpHMA.keyframes)($3f5ffa895ad4456e$var$_t || ($3f5ffa895ad4456e$var$_t = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t || ($3f5ffa895ad4456e$var$t = $3f5ffa895ad4456e$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`))));
const $3f5ffa895ad4456e$var$exitKeyframe = (0, $bpHMA.keyframes)($3f5ffa895ad4456e$var$_t2 || ($3f5ffa895ad4456e$var$_t2 = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t1 || ($3f5ffa895ad4456e$var$t1 = $3f5ffa895ad4456e$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`))));
const $3f5ffa895ad4456e$var$pulsateKeyframe = (0, $bpHMA.keyframes)($3f5ffa895ad4456e$var$_t3 || ($3f5ffa895ad4456e$var$_t3 = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t2 || ($3f5ffa895ad4456e$var$t2 = $3f5ffa895ad4456e$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`))));
const $3f5ffa895ad4456e$export$f6b7418508c72c25 = (0, $kDBhE.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $3f5ffa895ad4456e$export$676cfe7b12693c4b = (0, $kDBhE.default)((0, $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($3f5ffa895ad4456e$var$_t4 || ($3f5ffa895ad4456e$var$_t4 = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t3 || ($3f5ffa895ad4456e$var$t3 = $3f5ffa895ad4456e$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).rippleVisible, $3f5ffa895ad4456e$var$enterKeyframe, $3f5ffa895ad4456e$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).child, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childLeaving, $3f5ffa895ad4456e$var$exitKeyframe, $3f5ffa895ad4456e$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childPulsate, $3f5ffa895ad4456e$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $3f5ffa895ad4456e$var$TouchRipple = /*#__PURE__*/ $7fPBF.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $cFLic.default)(props, $3f5ffa895ad4456e$var$_excluded);
    const [ripples, setRipples] = $7fPBF.useState([]);
    const nextKey = $7fPBF.useRef(0);
    const rippleCallback = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $7fPBF.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $c687181065d3a58c$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $7fPBF.useRef(null);
    const container = $7fPBF.useRef(null);
    const startCommit = $7fPBF.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $bbzbN.jsx)($3f5ffa895ad4456e$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $hngXp.default)(classes.ripple, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $hngXp.default)(classes.rippleVisible, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $hngXp.default)(classes.ripplePulsate, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $hngXp.default)(classes.child, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $hngXp.default)(classes.childLeaving, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $hngXp.default)(classes.childPulsate, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $3f5ffa895ad4456e$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $7fPBF.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($3f5ffa895ad4456e$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $7fPBF.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $7fPBF.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $7fPBF.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($3f5ffa895ad4456e$export$f6b7418508c72c25, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)((0, $fbda7a0931c56f58$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $30921f11ad4ef55c$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $3f5ffa895ad4456e$export$2e2bcd8739ae039 = $3f5ffa895ad4456e$var$TouchRipple;



var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $d365e8bde1350eb0$export$fccb0498dcd99783(slot) {
    return (0, $jzxpm.default)("MuiButtonBase", slot);
}
const $d365e8bde1350eb0$var$buttonBaseClasses = (0, $9UILM.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $d365e8bde1350eb0$export$2e2bcd8739ae039 = $d365e8bde1350eb0$var$buttonBaseClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $2d0c76ae9ca5c817$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $2d0c76ae9ca5c817$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $fsUVx.default)(slots, (0, $d365e8bde1350eb0$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36 = (0, $kDBhE.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $d365e8bde1350eb0$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $2d0c76ae9ca5c817$var$ButtonBase = /*#__PURE__*/ $7fPBF.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $cFLic.default)(props, $2d0c76ae9ca5c817$var$_excluded);
    const buttonRef = $7fPBF.useRef(null);
    const rippleRef = $7fPBF.useRef(null);
    const handleRippleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $77c51d9bab7ec5dd$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $7fPBF.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $7fPBF.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $7fPBF.useState(false);
    $7fPBF.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $7fPBF.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $7fPBF.useRef(false);
    const handleKeyDown = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $2d0c76ae9ca5c817$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36, (0, $kY3Ke.default)({
        as: ComponentProp,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $bbzbN.jsx)((0, $3f5ffa895ad4456e$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $2d0c76ae9ca5c817$export$2e2bcd8739ae039 = $2d0c76ae9ca5c817$var$ButtonBase;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $b9b83b4d3c9e8b74$var$_excluded = [
    "slots",
    "slotProps"
];
const $b9b83b4d3c9e8b74$var$BreadcrumbCollapsedButton = (0, $kDBhE.default)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039))(({ theme: theme })=>(0, $kY3Ke.default)({
        display: "flex",
        marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
        marginRight: `calc(${theme.spacing(1)} * 0.5)`
    }, theme.palette.mode === "light" ? {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[700]
    } : {
        backgroundColor: theme.palette.grey[700],
        color: theme.palette.grey[100]
    }, {
        borderRadius: 2,
        "&:hover, &:focus": (0, $kY3Ke.default)({}, theme.palette.mode === "light" ? {
            backgroundColor: theme.palette.grey[200]
        } : {
            backgroundColor: theme.palette.grey[600]
        }),
        "&:active": (0, $kY3Ke.default)({
            boxShadow: theme.shadows[0]
        }, theme.palette.mode === "light" ? {
            backgroundColor: (0, $7jL4F.emphasize)(theme.palette.grey[200], 0.12)
        } : {
            backgroundColor: (0, $7jL4F.emphasize)(theme.palette.grey[600], 0.12)
        })
    }));
const $b9b83b4d3c9e8b74$var$BreadcrumbCollapsedIcon = (0, $kDBhE.default)((0, $bf5ccaae290cc05e$export$2e2bcd8739ae039))({
    width: 24,
    height: 16
});
/**
 * @ignore - internal component.
 */ function $b9b83b4d3c9e8b74$var$BreadcrumbCollapsed(props) {
    const { slots: slots = {}, slotProps: slotProps = {} } = props, otherProps = (0, $cFLic.default)(props, $b9b83b4d3c9e8b74$var$_excluded);
    const ownerState = props;
    return /*#__PURE__*/ (0, $bbzbN.jsx)("li", {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($b9b83b4d3c9e8b74$var$BreadcrumbCollapsedButton, (0, $kY3Ke.default)({
            focusRipple: true
        }, otherProps, {
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)($b9b83b4d3c9e8b74$var$BreadcrumbCollapsedIcon, (0, $kY3Ke.default)({
                as: slots.CollapsedIcon,
                ownerState: ownerState
            }, slotProps.collapsedIcon))
        }))
    });
}
var $b9b83b4d3c9e8b74$export$2e2bcd8739ae039 = $b9b83b4d3c9e8b74$var$BreadcrumbCollapsed;



var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $e85bea44bd9c3da4$export$17261110b18c8084(slot) {
    return (0, $jzxpm.default)("MuiBreadcrumbs", slot);
}
const $e85bea44bd9c3da4$var$breadcrumbsClasses = (0, $9UILM.default)("MuiBreadcrumbs", [
    "root",
    "ol",
    "li",
    "separator"
]);
var $e85bea44bd9c3da4$export$2e2bcd8739ae039 = $e85bea44bd9c3da4$var$breadcrumbsClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $9d7afcdf99dc1f56$var$_excluded = [
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "expandText",
    "itemsAfterCollapse",
    "itemsBeforeCollapse",
    "maxItems",
    "separator"
];
const $9d7afcdf99dc1f56$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        li: [
            "li"
        ],
        ol: [
            "ol"
        ],
        separator: [
            "separator"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $e85bea44bd9c3da4$export$17261110b18c8084), classes);
};
const $9d7afcdf99dc1f56$var$BreadcrumbsRoot = (0, $kDBhE.default)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    name: "MuiBreadcrumbs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, $e85bea44bd9c3da4$export$2e2bcd8739ae039).li}`]: styles.li
            },
            styles.root
        ];
    }
})({});
const $9d7afcdf99dc1f56$var$BreadcrumbsOl = (0, $kDBhE.default)("ol", {
    name: "MuiBreadcrumbs",
    slot: "Ol",
    overridesResolver: (props, styles)=>styles.ol
})({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
});
const $9d7afcdf99dc1f56$var$BreadcrumbsSeparator = (0, $kDBhE.default)("li", {
    name: "MuiBreadcrumbs",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})({
    display: "flex",
    userSelect: "none",
    marginLeft: 8,
    marginRight: 8
});
function $9d7afcdf99dc1f56$var$insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index)=>{
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ (0, $bbzbN.jsx)($9d7afcdf99dc1f56$var$BreadcrumbsSeparator, {
            "aria-hidden": true,
            className: className,
            ownerState: ownerState,
            children: separator
        }, `separator-${index}`));
        else acc.push(current);
        return acc;
    }, []);
}
const $9d7afcdf99dc1f56$var$Breadcrumbs = /*#__PURE__*/ $7fPBF.forwardRef(function Breadcrumbs(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiBreadcrumbs"
    });
    const { children: children, className: className, component: component = "nav", slots: slots = {}, slotProps: slotProps = {}, expandText: expandText = "Show path", itemsAfterCollapse: itemsAfterCollapse = 1, itemsBeforeCollapse: itemsBeforeCollapse = 1, maxItems: maxItems = 8, separator: separator = "/" } = props, other = (0, $cFLic.default)(props, $9d7afcdf99dc1f56$var$_excluded);
    const [expanded, setExpanded] = $7fPBF.useState(false);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        expanded: expanded,
        expandText: expandText,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        maxItems: maxItems,
        separator: separator
    });
    const classes = $9d7afcdf99dc1f56$var$useUtilityClasses(ownerState);
    const collapsedIconSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: slots.CollapsedIcon,
        externalSlotProps: slotProps.collapsedIcon,
        ownerState: ownerState
    });
    const listRef = $7fPBF.useRef(null);
    const renderItemsBeforeAndAfter = (allItems)=>{
        const handleClickExpand = ()=>{
            setExpanded(true);
            // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
            // By moving it to some link/button at least we have some announcement.
            const focusable = listRef.current.querySelector("a[href],button,[tabindex]");
            if (focusable) focusable.focus();
        };
        // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        return [
            ...allItems.slice(0, itemsBeforeCollapse),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b9b83b4d3c9e8b74$export$2e2bcd8739ae039), {
                "aria-label": expandText,
                slots: {
                    CollapsedIcon: slots.CollapsedIcon
                },
                slotProps: {
                    collapsedIcon: collapsedIconSlotProps
                },
                onClick: handleClickExpand
            }, "ellipsis"),
            ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
        ];
    };
    const allItems = $7fPBF.Children.toArray(children).filter((child)=>{
        return /*#__PURE__*/ $7fPBF.isValidElement(child);
    }).map((child, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)("li", {
            className: classes.li,
            children: child
        }, `child-${index}`));
    return /*#__PURE__*/ (0, $bbzbN.jsx)($9d7afcdf99dc1f56$var$BreadcrumbsRoot, (0, $kY3Ke.default)({
        ref: ref,
        component: component,
        color: "text.secondary",
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($9d7afcdf99dc1f56$var$BreadcrumbsOl, {
            className: classes.ol,
            ref: listRef,
            ownerState: ownerState,
            children: $9d7afcdf99dc1f56$var$insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
        })
    }));
});
var $9d7afcdf99dc1f56$export$2e2bcd8739ae039 = $9d7afcdf99dc1f56$var$Breadcrumbs;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $78FIu = parcelRequire("78FIu");

var $fsUVx = parcelRequire("fsUVx");

var $7jL4F = parcelRequire("7jL4F");

var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $5j2OD = parcelRequire("5j2OD");


var $b6UUh = parcelRequire("b6UUh");

var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $bf96407f1f5b4126$export$5a6f9035944c8119(slot) {
    return (0, $jzxpm.default)("MuiButton", slot);
}
const $bf96407f1f5b4126$var$buttonClasses = (0, $9UILM.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorError",
    "colorInfo",
    "colorWarning",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "icon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $bf96407f1f5b4126$export$2e2bcd8739ae039 = $bf96407f1f5b4126$var$buttonClasses;



var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $40ed7573a59c2be9$var$ButtonGroupContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40ed7573a59c2be9$export$2e2bcd8739ae039 = $40ed7573a59c2be9$var$ButtonGroupContext;



var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $e319f5c3a4402058$var$ButtonGroupButtonContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $e319f5c3a4402058$export$2e2bcd8739ae039 = $e319f5c3a4402058$var$ButtonGroupButtonContext;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $45be1777d6a28263$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $45be1777d6a28263$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $b6UUh.default)(color)}`,
            `size${(0, $b6UUh.default)(size)}`,
            `${variant}Size${(0, $b6UUh.default)(size)}`,
            `color${(0, $b6UUh.default)(color)}`,
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "icon",
            "startIcon",
            `iconSize${(0, $b6UUh.default)(size)}`
        ],
        endIcon: [
            "icon",
            "endIcon",
            `iconSize${(0, $b6UUh.default)(size)}`
        ]
    };
    const composedClasses = (0, $fsUVx.default)(slots, (0, $bf96407f1f5b4126$export$5a6f9035944c8119), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $45be1777d6a28263$var$commonIconStyles = (ownerState)=>(0, $kY3Ke.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $45be1777d6a28263$var$ButtonRoot = (0, $kDBhE.default)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $b6UUh.default)(ownerState.color)}`],
            styles[`size${(0, $b6UUh.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $b6UUh.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $kY3Ke.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $kY3Ke.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7jL4F.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7jL4F.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7jL4F.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $kY3Ke.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).focusVisible}`]: (0, $kY3Ke.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).disabled}`]: (0, $kY3Ke.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $7jL4F.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $45be1777d6a28263$var$ButtonStartIcon = (0, $kDBhE.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $45be1777d6a28263$var$commonIconStyles(ownerState)));
const $45be1777d6a28263$var$ButtonEndIcon = (0, $kDBhE.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $45be1777d6a28263$var$commonIconStyles(ownerState)));
const $45be1777d6a28263$var$Button = /*#__PURE__*/ $7fPBF.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $7fPBF.useContext((0, $40ed7573a59c2be9$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $7fPBF.useContext((0, $e319f5c3a4402058$export$2e2bcd8739ae039));
    const resolvedProps = (0, $78FIu.default)(contextProps, inProps);
    const props = (0, $5j2OD.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $cFLic.default)(props, $45be1777d6a28263$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $45be1777d6a28263$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($45be1777d6a28263$var$ButtonRoot, (0, $kY3Ke.default)({
        ownerState: ownerState,
        className: (0, $hngXp.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $hngXp.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $45be1777d6a28263$export$2e2bcd8739ae039 = $45be1777d6a28263$var$Button;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $fsUVx = parcelRequire("fsUVx");

var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");




var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $8f730237ea7fc559$export$d6efab9620b78fec(slot) {
    return (0, $jzxpm.default)("MuiLink", slot);
}
const $8f730237ea7fc559$var$linkClasses = (0, $9UILM.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $8f730237ea7fc559$export$2e2bcd8739ae039 = $8f730237ea7fc559$var$linkClasses;



var $190Wm = parcelRequire("190Wm");

var $7jL4F = parcelRequire("7jL4F");
const $09cadfdec33133b7$export$c4e140d5d351182b = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $09cadfdec33133b7$var$transformDeprecatedColors = (color)=>{
    return $09cadfdec33133b7$export$c4e140d5d351182b[color] || color;
};
const $09cadfdec33133b7$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $09cadfdec33133b7$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $190Wm.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $190Wm.getPath)(theme, `palette.${transformedColor}Channel`);
    if ("vars" in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $7jL4F.alpha)(color, 0.4);
};
var $09cadfdec33133b7$export$2e2bcd8739ae039 = $09cadfdec33133b7$var$getTextDecoration;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $375541c69d4ec6b6$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $375541c69d4ec6b6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, $b6UUh.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $8f730237ea7fc559$export$d6efab9620b78fec), classes);
};
const $375541c69d4ec6b6$var$LinkRoot = (0, $kDBhE.default)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $b6UUh.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $kY3Ke.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && (0, $kY3Ke.default)({
        textDecoration: "underline"
    }, ownerState.color !== "inherit" && {
        textDecorationColor: (0, $09cadfdec33133b7$export$2e2bcd8739ae039)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }), ownerState.component === "button" && {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        [`&.${(0, $8f730237ea7fc559$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: "auto"
        }
    });
});
const $375541c69d4ec6b6$var$Link = /*#__PURE__*/ $7fPBF.forwardRef(function Link(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiLink"
    });
    const { className: className, color: color = "primary", component: component = "a", onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = "always", variant: variant = "inherit", sx: sx } = props, other = (0, $cFLic.default)(props, $375541c69d4ec6b6$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $77c51d9bab7ec5dd$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $7fPBF.useState(false);
    const handlerRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $375541c69d4ec6b6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($375541c69d4ec6b6$var$LinkRoot, (0, $kY3Ke.default)({
        color: color,
        className: (0, $hngXp.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $09cadfdec33133b7$export$c4e140d5d351182b)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $375541c69d4ec6b6$export$2e2bcd8739ae039 = $375541c69d4ec6b6$var$Link;


var $1a153d1cefca9971$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($1a153d1cefca9971$exports, "__esModule", {
    value: true
});
$1a153d1cefca9971$exports.default = void 0;

var $1a153d1cefca9971$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $1a153d1cefca9971$var$_default = $1a153d1cefca9971$exports.default = (0, $1a153d1cefca9971$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
}), "Home");


var $ae07dac9a1bf69b5$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($ae07dac9a1bf69b5$exports, "__esModule", {
    value: true
});
$ae07dac9a1bf69b5$exports.default = void 0;

var $ae07dac9a1bf69b5$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $ae07dac9a1bf69b5$var$_default = $ae07dac9a1bf69b5$exports.default = (0, $ae07dac9a1bf69b5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2m0 14H3V5h18zm-5-6-7 4V7z"
}), "OndemandVideo");



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");

var $7fPBF = parcelRequire("7fPBF");
"use client";
let $67dd8d1013271871$var$globalId = 0;
function $67dd8d1013271871$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $7fPBF.useState(idOverride);
    const id = idOverride || defaultId;
    $7fPBF.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $67dd8d1013271871$var$globalId += 1;
            setDefaultId(`mui-${$67dd8d1013271871$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $67dd8d1013271871$var$maybeReactUseId = $7fPBF["useId".toString()];
function $67dd8d1013271871$export$2e2bcd8739ae039(idOverride) {
    if ($67dd8d1013271871$var$maybeReactUseId !== undefined) {
        const reactId = $67dd8d1013271871$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $67dd8d1013271871$var$useGlobalId(idOverride);
}



var $b6UUh = parcelRequire("b6UUh");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");




var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");
function $cac0a17fea472264$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $fa98246ea42de8cb$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




function $66b23e3809994643$export$2e2bcd8739ae039(node) {
    const doc = (0, $cac0a17fea472264$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}

// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $d5ff8c68944ff1f6$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


// Is a vertical scrollbar displayed?
function $0cc83ef1bfdc25eb$var$isOverflowing(container) {
    const doc = (0, $cac0a17fea472264$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $66b23e3809994643$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $0cc83ef1bfdc25eb$var$getPaddingRight(element) {
    return parseInt((0, $66b23e3809994643$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $0cc83ef1bfdc25eb$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $0cc83ef1bfdc25eb$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$0cc83ef1bfdc25eb$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96(element, show);
    });
}
function $0cc83ef1bfdc25eb$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $0cc83ef1bfdc25eb$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($0cc83ef1bfdc25eb$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $d5ff8c68944ff1f6$export$2e2bcd8739ae039)((0, $cac0a17fea472264$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$0cc83ef1bfdc25eb$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $cac0a17fea472264$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$0cc83ef1bfdc25eb$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $cac0a17fea472264$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $66b23e3809994643$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $0cc83ef1bfdc25eb$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $0cc83ef1bfdc25eb$export$ce11c4ecd08cea67 {
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $0cc83ef1bfdc25eb$var$getHiddenSiblings(container);
        $0cc83ef1bfdc25eb$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $0cc83ef1bfdc25eb$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $0cc83ef1bfdc25eb$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $0cc83ef1bfdc25eb$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $0cc83ef1bfdc25eb$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $0cc83ef1bfdc25eb$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
}


"use client";
function $0aaff92e83b421f6$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $0aaff92e83b421f6$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $0aaff92e83b421f6$var$defaultManager = new (0, $0cc83ef1bfdc25eb$export$ce11c4ecd08cea67)();
function $0aaff92e83b421f6$export$33ffd74ebf07f060(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $0aaff92e83b421f6$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $7fPBF.useRef({});
    const mountNodeRef = $7fPBF.useRef(null);
    const modalRef = $7fPBF.useRef(null);
    const handleRef = (0, $52155878109bdfb9$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $7fPBF.useState(!open);
    const hasTransition = $0aaff92e83b421f6$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $cac0a17fea472264$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $f3c1f2021d65e015$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $0aaff92e83b421f6$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $7fPBF.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $f3c1f2021d65e015$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $7fPBF.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $7fPBF.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $676085a836f199f4$export$24d5698b57eff81c)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $kY3Ke.default)({}, propsEventHandlers, otherHandlers);
        return (0, $kY3Ke.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $kY3Ke.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $fa98246ea42de8cb$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $fa98246ea42de8cb$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}



var $fsUVx = parcelRequire("fsUVx");

var $7fPBF = parcelRequire("7fPBF");



var $bbzbN = parcelRequire("bbzbN");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $820d2e8c6ed0c158$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $820d2e8c6ed0c158$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $820d2e8c6ed0c158$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $820d2e8c6ed0c158$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $820d2e8c6ed0c158$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $820d2e8c6ed0c158$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($820d2e8c6ed0c158$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $820d2e8c6ed0c158$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$820d2e8c6ed0c158$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $820d2e8c6ed0c158$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $820d2e8c6ed0c158$export$34eba2437817a67b(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $820d2e8c6ed0c158$var$defaultGetTabbable, isEnabled: isEnabled = $820d2e8c6ed0c158$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $7fPBF.useRef(false);
    const sentinelStart = $7fPBF.useRef(null);
    const sentinelEnd = $7fPBF.useRef(null);
    const nodeToRestore = $7fPBF.useRef(null);
    const reactFocusEventTarget = $7fPBF.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $7fPBF.useRef(false);
    const rootRef = $7fPBF.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $52155878109bdfb9$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $cac0a17fea472264$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $cac0a17fea472264$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $7fPBF.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}



var $7fPBF = parcelRequire("7fPBF");




var $bbzbN = parcelRequire("bbzbN");
"use client";
function $af6f301d1bc38583$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $af6f301d1bc38583$export$602eac185826482c = /*#__PURE__*/ $7fPBF.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $7fPBF.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $52155878109bdfb9$export$2e2bcd8739ae039)(/*#__PURE__*/ $7fPBF.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $f7f8f12b8c6feb2f$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($af6f301d1bc38583$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $f7f8f12b8c6feb2f$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $78cfb6b4689e3d24$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $78cfb6b4689e3d24$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $7fPBF.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $7fPBF.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
        children: mountNode ? /*#__PURE__*/ $b4ba1c853f6e1116$exports.createPortal(children, mountNode) : mountNode
    });
});



var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $cFLic = parcelRequire("cFLic");



var $7fPBF = parcelRequire("7fPBF");

var $8a9a7006a9b8efe4$export$2e2bcd8739ae039 = {
    disabled: false
};




var $f1bbb084f2fb10b7$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $623678cbb6daf054$export$bb38bb9a1161268 = "unmounted";
var $623678cbb6daf054$export$84cbff306f539230 = "exited";
var $623678cbb6daf054$export$df38205c966be359 = "entering";
var $623678cbb6daf054$export$78e9e6e3e014d60a = "entered";
var $623678cbb6daf054$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $623678cbb6daf054$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $146ee816144a450d$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $623678cbb6daf054$export$84cbff306f539230;
                _this.appearStatus = $623678cbb6daf054$export$df38205c966be359;
            } else initialStatus = $623678cbb6daf054$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $623678cbb6daf054$export$bb38bb9a1161268;
        else initialStatus = $623678cbb6daf054$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $623678cbb6daf054$export$bb38bb9a1161268) return {
            status: $623678cbb6daf054$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $623678cbb6daf054$export$df38205c966be359 && status !== $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$df38205c966be359;
            } else if (status === $623678cbb6daf054$export$df38205c966be359 || status === $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $623678cbb6daf054$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $f1bbb084f2fb10b7$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $623678cbb6daf054$export$84cbff306f539230) this.setState({
            status: $623678cbb6daf054$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $8a9a7006a9b8efe4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $623678cbb6daf054$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $623678cbb6daf054$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $8a9a7006a9b8efe4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $623678cbb6daf054$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $623678cbb6daf054$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $623678cbb6daf054$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $cFLic.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$623678cbb6daf054$var$Transition.contextType = (0, $61c94efb1735eff6$export$2e2bcd8739ae039);
$623678cbb6daf054$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $623678cbb6daf054$var$noop() {}
$623678cbb6daf054$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $623678cbb6daf054$var$noop,
    onEntering: $623678cbb6daf054$var$noop,
    onEntered: $623678cbb6daf054$var$noop,
    onExit: $623678cbb6daf054$var$noop,
    onExiting: $623678cbb6daf054$var$noop,
    onExited: $623678cbb6daf054$var$noop
};
$623678cbb6daf054$var$Transition.UNMOUNTED = $623678cbb6daf054$export$bb38bb9a1161268;
$623678cbb6daf054$var$Transition.EXITED = $623678cbb6daf054$export$84cbff306f539230;
$623678cbb6daf054$var$Transition.ENTERING = $623678cbb6daf054$export$df38205c966be359;
$623678cbb6daf054$var$Transition.ENTERED = $623678cbb6daf054$export$78e9e6e3e014d60a;
$623678cbb6daf054$var$Transition.EXITING = $623678cbb6daf054$export$4aacc83d4d59139f;
var $623678cbb6daf054$export$2e2bcd8739ae039 = $623678cbb6daf054$var$Transition;



parcelRequire("7fPBF");

var $4kWyf = parcelRequire("4kWyf");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");
"use client";
function $bc16b792e42cac5d$export$2e2bcd8739ae039() {
    const theme = (0, $4kWyf.default)((0, $9P91Y.default));
    return theme[0, $jwhZE.default] || theme;
}


const $1ae2edacd7be6319$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $1ae2edacd7be6319$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $bbzbN = parcelRequire("bbzbN");
"use client";
const $68214be7242cbfc8$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $68214be7242cbfc8$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $68214be7242cbfc8$var$Fade = /*#__PURE__*/ $7fPBF.forwardRef(function Fade(props, ref) {
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $623678cbb6daf054$export$2e2bcd8739ae039) } = props, other = (0, $cFLic.default)(props, $68214be7242cbfc8$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $1ae2edacd7be6319$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
                style: (0, $kY3Ke.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $68214be7242cbfc8$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $68214be7242cbfc8$export$2e2bcd8739ae039 = $68214be7242cbfc8$var$Fade;



var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $36421d1d94159248$export$9927a91fd93152bd(slot) {
    return (0, $jzxpm.default)("MuiBackdrop", slot);
}
const $36421d1d94159248$var$backdropClasses = (0, $9UILM.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $36421d1d94159248$export$2e2bcd8739ae039 = $36421d1d94159248$var$backdropClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e70e583d684cb5f4$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $e70e583d684cb5f4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $36421d1d94159248$export$9927a91fd93152bd), classes);
};
const $e70e583d684cb5f4$var$BackdropRoot = (0, $kDBhE.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $e70e583d684cb5f4$var$Backdrop = /*#__PURE__*/ $7fPBF.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $68214be7242cbfc8$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $cFLic.default)(props, $e70e583d684cb5f4$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $e70e583d684cb5f4$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($e70e583d684cb5f4$var$BackdropRoot, (0, $kY3Ke.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $hngXp.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $kY3Ke.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $e70e583d684cb5f4$export$2e2bcd8739ae039 = $e70e583d684cb5f4$var$Backdrop;



var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $1581382eb39c1df6$export$67960e22b12a638d(slot) {
    return (0, $jzxpm.default)("MuiModal", slot);
}
const $1581382eb39c1df6$var$modalClasses = (0, $9UILM.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $1581382eb39c1df6$export$2e2bcd8739ae039 = $1581382eb39c1df6$var$modalClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $a65b89a1133e1fe4$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $a65b89a1133e1fe4$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $1581382eb39c1df6$export$67960e22b12a638d), classes);
};
const $a65b89a1133e1fe4$var$ModalRoot = (0, $kDBhE.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $a65b89a1133e1fe4$var$ModalBackdrop = (0, $kDBhE.default)((0, $e70e583d684cb5f4$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $a65b89a1133e1fe4$var$Modal = /*#__PURE__*/ $7fPBF.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $5j2OD.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $a65b89a1133e1fe4$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $cFLic.default)(props, $a65b89a1133e1fe4$var$_excluded);
    const propsWithDefaults = (0, $kY3Ke.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $0aaff92e83b421f6$export$33ffd74ebf07f060)((0, $kY3Ke.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $kY3Ke.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $a65b89a1133e1fe4$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $a65b89a1133e1fe4$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $hngXp.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $kY3Ke.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $hngXp.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $af6f301d1bc38583$export$602eac185826482c), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)(RootSlot, (0, $kY3Ke.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $bbzbN.jsx)(BackdropSlot, (0, $kY3Ke.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $820d2e8c6ed0c158$export$34eba2437817a67b), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $7fPBF.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $a65b89a1133e1fe4$export$2e2bcd8739ae039 = $a65b89a1133e1fe4$var$Modal;





var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $8523c8ab2139cf2c$export$2177af0aa15c34c2(slot) {
    return (0, $jzxpm.default)("MuiDialog", slot);
}
const $8523c8ab2139cf2c$var$dialogClasses = (0, $9UILM.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $8523c8ab2139cf2c$export$2e2bcd8739ae039 = $8523c8ab2139cf2c$var$dialogClasses;



var $7fPBF = parcelRequire("7fPBF");
const $40596d25b0f9c334$var$DialogContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40596d25b0f9c334$export$2e2bcd8739ae039 = $40596d25b0f9c334$var$DialogContext;





var $bbzbN = parcelRequire("bbzbN");
"use client";
const $7f096abd658f7c85$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $7f096abd658f7c85$var$DialogBackdrop = (0, $kDBhE.default)((0, $e70e583d684cb5f4$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $7f096abd658f7c85$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $b6UUh.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $b6UUh.default)(scroll)}`,
            `paperWidth${(0, $b6UUh.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $8523c8ab2139cf2c$export$2177af0aa15c34c2), classes);
};
const $7f096abd658f7c85$var$DialogRoot = (0, $kDBhE.default)((0, $a65b89a1133e1fe4$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $7f096abd658f7c85$var$DialogContainer = (0, $kDBhE.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $b6UUh.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&::after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $7f096abd658f7c85$var$DialogPaper = (0, $kDBhE.default)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $b6UUh.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $b6UUh.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $7f096abd658f7c85$var$Dialog = /*#__PURE__*/ $7fPBF.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $74e245c78e363f11$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $68214be7242cbfc8$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $cFLic.default)(props, $7f096abd658f7c85$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $7f096abd658f7c85$var$useUtilityClasses(ownerState);
    const backdropClick = $7fPBF.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $67dd8d1013271871$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $7fPBF.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7f096abd658f7c85$var$DialogRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $7f096abd658f7c85$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $kY3Ke.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)($7f096abd658f7c85$var$DialogContainer, {
                className: (0, $hngXp.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)($7f096abd658f7c85$var$DialogPaper, (0, $kY3Ke.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $hngXp.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $40596d25b0f9c334$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $7f096abd658f7c85$export$2e2bcd8739ae039 = $7f096abd658f7c85$var$Dialog;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $64f614045184fa19$export$61b0ee1f05fb344e(slot) {
    return (0, $jzxpm.default)("MuiDialogContent", slot);
}
const $64f614045184fa19$var$dialogContentClasses = (0, $9UILM.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $64f614045184fa19$export$2e2bcd8739ae039 = $64f614045184fa19$var$dialogContentClasses;



var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $18611d95980659c6$export$f5d2ec7e4c47e088(slot) {
    return (0, $jzxpm.default)("MuiDialogTitle", slot);
}
const $18611d95980659c6$var$dialogTitleClasses = (0, $9UILM.default)("MuiDialogTitle", [
    "root"
]);
var $18611d95980659c6$export$2e2bcd8739ae039 = $18611d95980659c6$var$dialogTitleClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $634ad3fd5060cf75$var$_excluded = [
    "className",
    "dividers"
];
const $634ad3fd5060cf75$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $64f614045184fa19$export$61b0ee1f05fb344e), classes);
};
const $634ad3fd5060cf75$var$DialogContentRoot = (0, $kDBhE.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $18611d95980659c6$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $634ad3fd5060cf75$var$DialogContent = /*#__PURE__*/ $7fPBF.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $cFLic.default)(props, $634ad3fd5060cf75$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        dividers: dividers
    });
    const classes = $634ad3fd5060cf75$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($634ad3fd5060cf75$var$DialogContentRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $634ad3fd5060cf75$export$2e2bcd8739ae039 = $634ad3fd5060cf75$var$DialogContent;



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");


var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $ac75506ecdb312f1$var$_excluded = [
    "className",
    "id"
];
const $ac75506ecdb312f1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $18611d95980659c6$export$f5d2ec7e4c47e088), classes);
};
const $ac75506ecdb312f1$var$DialogTitleRoot = (0, $kDBhE.default)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $ac75506ecdb312f1$var$DialogTitle = /*#__PURE__*/ $7fPBF.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className, id: idProp } = props, other = (0, $cFLic.default)(props, $ac75506ecdb312f1$var$_excluded);
    const ownerState = props;
    const classes = $ac75506ecdb312f1$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $7fPBF.useContext((0, $40596d25b0f9c334$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $bbzbN.jsx)($ac75506ecdb312f1$var$DialogTitleRoot, (0, $kY3Ke.default)({
        component: "h2",
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $ac75506ecdb312f1$export$2e2bcd8739ae039 = $ac75506ecdb312f1$var$DialogTitle;




var $942113eac31b108a$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($942113eac31b108a$exports, "__esModule", {
    value: true
});
$942113eac31b108a$exports.default = void 0;

var $942113eac31b108a$var$React = $942113eac31b108a$var$_interopRequireWildcard((parcelRequire("7fPBF")));

var $942113eac31b108a$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
function $942113eac31b108a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($942113eac31b108a$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $942113eac31b108a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $942113eac31b108a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var $942113eac31b108a$var$_default = $942113eac31b108a$exports.default = (0, $942113eac31b108a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 1.27a11 11 0 00-3.48 21.46c.55.09.73-.28.73-.55v-1.84c-3.03.64-3.67-1.46-3.67-1.46-.55-1.29-1.28-1.65-1.28-1.65-.92-.65.1-.65.1-.65 1.1 0 1.73 1.1 1.73 1.1.92 1.65 2.57 1.2 3.21.92a2 2 0 01.64-1.47c-2.47-.27-5.04-1.19-5.04-5.5 0-1.1.46-2.1 1.2-2.84a3.76 3.76 0 010-2.93s.91-.28 3.11 1.1c1.8-.49 3.7-.49 5.5 0 2.1-1.38 3.02-1.1 3.02-1.1a3.76 3.76 0 010 2.93c.83.74 1.2 1.74 1.2 2.94 0 4.21-2.57 5.13-5.04 5.4.45.37.82.92.82 2.02v3.03c0 .27.1.64.73.55A11 11 0 0012 1.27"
}), "GitHub");


function $40fb36ef15db9a46$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $7f096abd658f7c85$export$2e2bcd8739ae039), {
        open: props.isOpen,
        onClose: props.handleClose,
        scroll: "paper",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ac75506ecdb312f1$export$2e2bcd8739ae039), {
                children: "About This Site"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                        gutterBottom: true,
                        children: "This site is made to translate streams in their entirety. Why a separate site instead of other alternatives like using YouTube's captioning function or making a clip? Very rarely do channels allow users to make captions for their streams, and making clips of full streams gets a little deep into the gray zone. With this, you can enjoy translated streams while also contributing to VOD views for the original channel."
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                        gutterBottom: true,
                        children: "Can you use the translations on this site to make clips? Yes, please do so! Making clips that can best capture our oshi's charming moments is itself an art, and the goal is always to best promote them. The subtitle files are available to download, so feel free to use them!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                children: [
                    "More info can be found on the",
                    " ",
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $375541c69d4ec6b6$export$2e2bcd8739ae039), {
                        underline: "hover",
                        href: "https://github.com/BAUtran0/youtube_external_subtitle_browser",
                        children: [
                            "GitHub Page ",
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($942113eac31b108a$exports))), {
                                fontSize: "inherit",
                                sx: {
                                    mr: "0.5em"
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


var $bd3aff14b6b91f7a$exports = {};
$bd3aff14b6b91f7a$exports = new URL("logo.974c068c.gif", import.meta.url).toString();


function $e7713da642e42c71$export$2e2bcd8739ae039() {
    const [isAboutSiteModalOpen, setIsAboutSiteModalOpen] = (0, $7fPBF.useState)(false);
    const renderVideoBreadcrumbs = ()=>{
        const splitPath = window.location.pathname.split("/");
        if (splitPath.length == 3 && splitPath[1] == "video") return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $375541c69d4ec6b6$export$2e2bcd8739ae039), {
            underline: "hover",
            sx: {
                display: "flex",
                alignItems: "center"
            },
            href: `/video/${splitPath[2]}`,
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ae07dac9a1bf69b5$exports))), {
                    sx: {
                        mr: 0.5
                    },
                    fontSize: "inherit"
                }),
                " Video Player (",
                `${splitPath[2]}`,
                ")"
            ]
        });
        return null;
    };
    const handleClickAboutSite = ()=>{
        setIsAboutSiteModalOpen(true);
    };
    const handleOnCloseAboutSite = ()=>{
        setIsAboutSiteModalOpen(false);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5c04bc14285128b0$export$2e2bcd8739ae039), {
                position: "static",
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $4356b5696745688a$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            display: "flex",
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
                                    href: "/",
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bd3aff14b6b91f7a$exports))),
                                        style: {
                                            paddingRight: "1em"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $9d7afcdf99dc1f56$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $375541c69d4ec6b6$export$2e2bcd8739ae039), {
                                            underline: "hover",
                                            sx: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            href: "/",
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1a153d1cefca9971$exports))), {
                                                    sx: {
                                                        mr: 0.5
                                                    },
                                                    fontSize: "inherit"
                                                }),
                                                " Home"
                                            ]
                                        }),
                                        renderVideoBreadcrumbs()
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                            onClick: handleClickAboutSite,
                            children: "About"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4356b5696745688a$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $40fb36ef15db9a46$export$2e2bcd8739ae039), {
                isOpen: isAboutSiteModalOpen,
                handleClose: handleOnCloseAboutSite
            })
        ]
    });
}



var $bbzbN = parcelRequire("bbzbN");


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $l1GiU = parcelRequire("l1GiU");

var $jzxpm = parcelRequire("jzxpm");

var $fsUVx = parcelRequire("fsUVx");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $5VCcJ = parcelRequire("5VCcJ");

var $l1GiU = parcelRequire("l1GiU");



var $2G6xE = parcelRequire("2G6xE");

var $8M6a3 = parcelRequire("8M6a3");
const $0aa19929000e58fe$var$_excluded = [
    "ownerState"
], $0aa19929000e58fe$var$_excluded2 = [
    "variants"
], $0aa19929000e58fe$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $0aa19929000e58fe$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $0aa19929000e58fe$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $0aa19929000e58fe$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $0aa19929000e58fe$export$35e57303dbd8a66 = (0, $2G6xE.default)();
const $0aa19929000e58fe$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $0aa19929000e58fe$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $0aa19929000e58fe$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $0aa19929000e58fe$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $0aa19929000e58fe$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $cFLic.default)(_ref, $0aa19929000e58fe$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $kY3Ke.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$0aa19929000e58fe$var$processStyleArg(resolvedStyle, (0, $kY3Ke.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $cFLic.default)(resolvedStylesArg, $0aa19929000e58fe$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $kY3Ke.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $kY3Ke.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $0aa19929000e58fe$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $0aa19929000e58fe$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $0aa19929000e58fe$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $0aa19929000e58fe$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $8M6a3.default)((0, $kY3Ke.default)({}, props, {
            theme: $0aa19929000e58fe$var$resolveTheme((0, $kY3Ke.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $5VCcJ.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $0aa19929000e58fe$var$defaultOverridesResolver($0aa19929000e58fe$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $cFLic.default)(inputOptions, $0aa19929000e58fe$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $0aa19929000e58fe$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($0aa19929000e58fe$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $5VCcJ.default)(tag, (0, $kY3Ke.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $l1GiU.isPlainObject)(stylesArg)) return (props)=>$0aa19929000e58fe$var$processStyleArg(stylesArg, (0, $kY3Ke.default)({}, props, {
                    theme: $0aa19929000e58fe$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $0aa19929000e58fe$var$resolveTheme((0, $kY3Ke.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $0aa19929000e58fe$var$processStyleArg(slotStyle, (0, $kY3Ke.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $0aa19929000e58fe$var$resolveTheme((0, $kY3Ke.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $0aa19929000e58fe$var$processStyleArg({
                    variants: themeVariants
                }, (0, $kY3Ke.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $81df530a7daa801f$var$styled = (0, $0aa19929000e58fe$export$2e2bcd8739ae039)();
var $81df530a7daa801f$export$2e2bcd8739ae039 = $81df530a7daa801f$var$styled;



var $9HPC7 = parcelRequire("9HPC7");

var $mqrnX = parcelRequire("mqrnX");

var $2G6xE = parcelRequire("2G6xE");

var $cvrkU = parcelRequire("cvrkU");

var $5z69T = parcelRequire("5z69T");

var $bbzbN = parcelRequire("bbzbN");
const $dbad31c7655ddfe7$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $dbad31c7655ddfe7$var$defaultTheme = (0, $2G6xE.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $dbad31c7655ddfe7$var$defaultCreateStyledComponent = (0, $81df530a7daa801f$export$2e2bcd8739ae039)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $dbad31c7655ddfe7$var$useThemePropsDefault(props) {
    return (0, $9HPC7.default)({
        props: props,
        name: "MuiStack",
        defaultTheme: $dbad31c7655ddfe7$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $dbad31c7655ddfe7$var$joinChildren(children, separator) {
    const childrenArray = $7fPBF.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $7fPBF.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $dbad31c7655ddfe7$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $dbad31c7655ddfe7$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $kY3Ke.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $cvrkU.handleBreakpoints)({
        theme: theme
    }, (0, $cvrkU.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $5z69T.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $cvrkU.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $cvrkU.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $5z69T.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${$dbad31c7655ddfe7$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $5z69T.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $l1GiU.default)(styles, (0, $cvrkU.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $cvrkU.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $dbad31c7655ddfe7$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $dbad31c7655ddfe7$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $dbad31c7655ddfe7$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $fsUVx.default)(slots, (slot)=>(0, $jzxpm.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($dbad31c7655ddfe7$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $7fPBF.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $mqrnX.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $cFLic.default)(props, $dbad31c7655ddfe7$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $bbzbN.jsx)(StackRoot, (0, $kY3Ke.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $hngXp.default)(classes.root, className)
        }, other, {
            children: divider ? $dbad31c7655ddfe7$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");
"use client";
const $cde6d60726777b50$var$Stack = (0, $dbad31c7655ddfe7$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $kDBhE.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $5j2OD.default)({
            props: inProps,
            name: "MuiStack"
        })
});
var $cde6d60726777b50$export$2e2bcd8739ae039 = $cde6d60726777b50$var$Stack;



var $7fPBF = parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
var $615652efb7481f32$exports = {};
!function(t, e) {
    $615652efb7481f32$exports = e();
}($615652efb7481f32$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});




var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $fsUVx = parcelRequire("fsUVx");



var $7jL4F = parcelRequire("7jL4F");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");


var $7fPBF = parcelRequire("7fPBF");
function $df988254f818111e$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $7fPBF.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $6926d37cb7ff7774$export$2e2bcd8739ae039 = (0, $df988254f818111e$export$2e2bcd8739ae039);



"use client";
var $cfde3819487a0686$export$2e2bcd8739ae039 = (0, $f7f8f12b8c6feb2f$export$2e2bcd8739ae039);




var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * @ignore - internal component.
 */ const $94e271e17fd22222$var$ListContext = /*#__PURE__*/ $7fPBF.createContext({});
var $94e271e17fd22222$export$2e2bcd8739ae039 = $94e271e17fd22222$var$ListContext;



var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $0ca5a1e6788dced6$export$5682c366c0c669d9(slot) {
    return (0, $jzxpm.default)("MuiListItem", slot);
}
const $0ca5a1e6788dced6$var$listItemClasses = (0, $9UILM.default)("MuiListItem", [
    "root",
    "container",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "padding",
    "button",
    "secondaryAction",
    "selected"
]);
var $0ca5a1e6788dced6$export$2e2bcd8739ae039 = $0ca5a1e6788dced6$var$listItemClasses;



var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $5af8cd7874d684d8$export$c09531d8563c67a5(slot) {
    return (0, $jzxpm.default)("MuiListItemButton", slot);
}
const $5af8cd7874d684d8$var$listItemButtonClasses = (0, $9UILM.default)("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $5af8cd7874d684d8$export$2e2bcd8739ae039 = $5af8cd7874d684d8$var$listItemButtonClasses;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");


var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $90836af743b99227$export$ccdb26aeba48a86e(slot) {
    return (0, $jzxpm.default)("MuiListItemSecondaryAction", slot);
}
const $90836af743b99227$var$listItemSecondaryActionClasses = (0, $9UILM.default)("MuiListItemSecondaryAction", [
    "root",
    "disableGutters"
]);
var $90836af743b99227$export$2e2bcd8739ae039 = $90836af743b99227$var$listItemSecondaryActionClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $a4e848490d2ab66f$var$_excluded = [
    "className"
];
const $a4e848490d2ab66f$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $90836af743b99227$export$ccdb26aeba48a86e), classes);
};
const $a4e848490d2ab66f$var$ListItemSecondaryActionRoot = (0, $kDBhE.default)("div", {
    name: "MuiListItemSecondaryAction",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: "absolute",
        right: 16,
        top: "50%",
        transform: "translateY(-50%)"
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $a4e848490d2ab66f$var$ListItemSecondaryAction = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiListItemSecondaryAction"
    });
    const { className: className } = props, other = (0, $cFLic.default)(props, $a4e848490d2ab66f$var$_excluded);
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $a4e848490d2ab66f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($a4e848490d2ab66f$var$ListItemSecondaryActionRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$a4e848490d2ab66f$var$ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
var $a4e848490d2ab66f$export$2e2bcd8739ae039 = $a4e848490d2ab66f$var$ListItemSecondaryAction;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $2c1b031ce0fa2278$var$_excluded = [
    "className"
], $2c1b031ce0fa2278$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $2c1b031ce0fa2278$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $2c1b031ce0fa2278$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            !disablePadding && "padding",
            divider && "divider",
            disabled && "disabled",
            button && "button",
            alignItems === "flex-start" && "alignItemsFlexStart",
            hasSecondaryAction && "secondaryAction",
            selected && "selected"
        ],
        container: [
            "container"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $0ca5a1e6788dced6$export$5682c366c0c669d9), classes);
};
const $2c1b031ce0fa2278$export$aed538f7519abe89 = (0, $kDBhE.default)("div", {
    name: "MuiListItem",
    slot: "Root",
    overridesResolver: $2c1b031ce0fa2278$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left"
    }, !ownerState.disablePadding && (0, $kY3Ke.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.button && {
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $2c1b031ce0fa2278$var$ListItemContainer = (0, $kDBhE.default)("li", {
    name: "MuiListItem",
    slot: "Container",
    overridesResolver: (props, styles)=>styles.container
})({
    position: "relative"
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $2c1b031ce0fa2278$var$ListItem = /*#__PURE__*/ $7fPBF.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiListItem"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = "li", ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $cFLic.default)(props.ContainerProps, $2c1b031ce0fa2278$var$_excluded), other = (0, $cFLic.default)(props, $2c1b031ce0fa2278$var$_excluded2);
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $7fPBF.useRef(null);
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $7fPBF.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $2c1b031ce0fa2278$var$useUtilityClasses(ownerState);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $2c1b031ce0fa2278$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $hngXp.default)((0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)($2c1b031ce0fa2278$var$ListItemContainer, (0, $kY3Ke.default)({
                as: ContainerComponent,
                className: (0, $hngXp.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)(Root, (0, $kY3Ke.default)({}, rootProps, !(0, $59c589404b20ab2d$export$e28348cc2430497)(Root) && {
                        as: Component,
                        ownerState: (0, $kY3Ke.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)(Root, (0, $kY3Ke.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $59c589404b20ab2d$export$e28348cc2430497)(Root) && {
            ownerState: (0, $kY3Ke.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a4e848490d2ab66f$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $2c1b031ce0fa2278$export$2e2bcd8739ae039 = $2c1b031ce0fa2278$var$ListItem;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $7a8a9052410fb062$export$81478e24460c57f2(slot) {
    return (0, $jzxpm.default)("MuiListItemIcon", slot);
}
const $7a8a9052410fb062$var$listItemIconClasses = (0, $9UILM.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $7a8a9052410fb062$export$2e2bcd8739ae039 = $7a8a9052410fb062$var$listItemIconClasses;




var $bbzbN = parcelRequire("bbzbN");
"use client";
const $3b977dfc67db1ec5$var$_excluded = [
    "className"
];
const $3b977dfc67db1ec5$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $7a8a9052410fb062$export$81478e24460c57f2), classes);
};
const $3b977dfc67db1ec5$var$ListItemIconRoot = (0, $kDBhE.default)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: "inline-flex"
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $3b977dfc67db1ec5$var$ListItemIcon = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiListItemIcon"
    });
    const { className: className } = props, other = (0, $cFLic.default)(props, $3b977dfc67db1ec5$var$_excluded);
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const ownerState = (0, $kY3Ke.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $3b977dfc67db1ec5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($3b977dfc67db1ec5$var$ListItemIconRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $3b977dfc67db1ec5$export$2e2bcd8739ae039 = $3b977dfc67db1ec5$var$ListItemIcon;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");



var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $2a8a1c268392e331$export$1061006a0db3aeb5(slot) {
    return (0, $jzxpm.default)("MuiListItemText", slot);
}
const $2a8a1c268392e331$var$listItemTextClasses = (0, $9UILM.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $2a8a1c268392e331$export$2e2bcd8739ae039 = $2a8a1c268392e331$var$listItemTextClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $9dc4208e00f56723$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $9dc4208e00f56723$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $2a8a1c268392e331$export$1061006a0db3aeb5), classes);
};
const $9dc4208e00f56723$var$ListItemTextRoot = (0, $kDBhE.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $9dc4208e00f56723$var$ListItemText = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $cFLic.default)(props, $9dc4208e00f56723$var$_excluded);
    const { dense: dense } = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $9dc4208e00f56723$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $26f68e516ee75fc4$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $26f68e516ee75fc4$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($9dc4208e00f56723$var$ListItemTextRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $9dc4208e00f56723$export$2e2bcd8739ae039 = $9dc4208e00f56723$var$ListItemText;




var $kDBhE = parcelRequire("kDBhE");


const $8ec0c955b9f9a345$var$PORT = "15161";
const $8ec0c955b9f9a345$export$c3ee1e672e1e24e7 = "https://bautl.aenbien.com";


const $b05263b340695109$var$Item = (0, $kDBhE.default)((0, $74e245c78e363f11$export$2e2bcd8739ae039))(({ theme: theme })=>({
        backgroundColor: "#1A2027",
        ...theme.typography.body2,
        padding: theme.spacing(1),
        marginTop: theme.spacing(0.5),
        marginBottom: theme.spacing(0.5),
        textAlign: "center",
        color: theme.palette.text.secondary,
        transition: "background 0.3s",
        ":hover": {
            backgroundColor: "#39414a"
        }
    }));
function $b05263b340695109$export$2e2bcd8739ae039(props) {
    let [thumbnailImage, setThumbnailImage] = (0, $7fPBF.useState)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const handleOnClick = ()=>navigate(`/video/${props.videoId}`);
    (0, $7fPBF.useEffect)(()=>{
        fetch(`${(0, $8ec0c955b9f9a345$export$c3ee1e672e1e24e7)}/static/thumbnails/${props.videoId}.jpg`).then((response)=>response.blob()).then((data)=>setThumbnailImage(URL.createObjectURL(data)));
    }, []);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($b05263b340695109$var$Item, {
        onClick: handleOnClick,
        sx: {
            cursor: "pointer",
            paddingTop: "1em"
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                        style: {
                            maxHeight: "10vh"
                        },
                        src: thumbnailImage
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
                            sx: {
                                paddingLeft: "2em"
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                                variant: "h5",
                                children: props.name
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                            style: {
                                textAlign: "right"
                            },
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).unix(props.createdTimestamp).format("YYYY-MM-DD")
                        })
                    ]
                })
            ]
        })
    });
}



function $23ddf6ce993318dd$export$2e2bcd8739ae039() {
    let [streamList, setStreamList] = (0, $7fPBF.useState)([]);
    (0, $7fPBF.useEffect)(()=>{
        fetch(`${(0, $8ec0c955b9f9a345$export$c3ee1e672e1e24e7)}/api/get_stream_list`).then((response)=>response.json()).then((data)=>setStreamList(data.stream_list));
    }, []);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
        width: "100%",
        children: streamList.map((stream, _)=>{
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b05263b340695109$export$2e2bcd8739ae039), {
                name: stream.name,
                videoId: stream.video_id,
                createdTimestamp: stream.created_timestamp
            }, stream.video_id);
        })
    });
}


function $2edbd157720007ec$export$2e2bcd8739ae039() {
    const HomeContainer = (0, $kDBhE.default)((0, $77ec199cefd4182a$export$2e2bcd8739ae039))(({ theme: theme })=>({
            backgroundColor: "#1A2027",
            ...theme.typography.body2,
            padding: theme.spacing(1),
            textAlign: "center",
            color: theme.palette.text.secondary,
            borderRadius: 5
        }));
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e7713da642e42c71$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)(HomeContainer, {
                maxWidth: 960,
                width: "100%",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $23ddf6ce993318dd$export$2e2bcd8739ae039), {})
            })
        ]
    });
}



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");


var $kDBhE = parcelRequire("kDBhE");




var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");

var $7jL4F = parcelRequire("7jL4F");

var $7fPBF = parcelRequire("7fPBF");
function $5bbedad9f52da8be$export$2e2bcd8739ae039(children) {
    return $7fPBF.Children.toArray(children).filter((child)=>/*#__PURE__*/ $7fPBF.isValidElement(child));
}



var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $94403c25c532988f$export$b85c003f960b1f3a(slot) {
    return (0, $jzxpm.default)("MuiButtonGroup", slot);
}
const $94403c25c532988f$var$buttonGroupClasses = (0, $9UILM.default)("MuiButtonGroup", [
    "root",
    "contained",
    "outlined",
    "text",
    "disableElevation",
    "disabled",
    "firstButton",
    "fullWidth",
    "vertical",
    "grouped",
    "groupedHorizontal",
    "groupedVertical",
    "groupedText",
    "groupedTextHorizontal",
    "groupedTextVertical",
    "groupedTextPrimary",
    "groupedTextSecondary",
    "groupedOutlined",
    "groupedOutlinedHorizontal",
    "groupedOutlinedVertical",
    "groupedOutlinedPrimary",
    "groupedOutlinedSecondary",
    "groupedContained",
    "groupedContainedHorizontal",
    "groupedContainedVertical",
    "groupedContainedPrimary",
    "groupedContainedSecondary",
    "lastButton",
    "middleButton"
]);
var $94403c25c532988f$export$2e2bcd8739ae039 = $94403c25c532988f$var$buttonGroupClasses;





var $bbzbN = parcelRequire("bbzbN");
"use client";
const $078cc07d54c9b00d$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "disableRipple",
    "fullWidth",
    "orientation",
    "size",
    "variant"
];
const $078cc07d54c9b00d$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $b6UUh.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $b6UUh.default)(ownerState.variant)}`]
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $b6UUh.default)(ownerState.variant)}${(0, $b6UUh.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $b6UUh.default)(ownerState.variant)}${(0, $b6UUh.default)(ownerState.color)}`]
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === "vertical" && styles.vertical
    ];
};
const $078cc07d54c9b00d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            orientation === "vertical" && "vertical",
            fullWidth && "fullWidth",
            disableElevation && "disableElevation"
        ],
        grouped: [
            "grouped",
            `grouped${(0, $b6UUh.default)(orientation)}`,
            `grouped${(0, $b6UUh.default)(variant)}`,
            `grouped${(0, $b6UUh.default)(variant)}${(0, $b6UUh.default)(orientation)}`,
            `grouped${(0, $b6UUh.default)(variant)}${(0, $b6UUh.default)(color)}`,
            disabled && "disabled"
        ],
        firstButton: [
            "firstButton"
        ],
        lastButton: [
            "lastButton"
        ],
        middleButton: [
            "middleButton"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $94403c25c532988f$export$b85c003f960b1f3a), classes);
};
const $078cc07d54c9b00d$var$ButtonGroupRoot = (0, $kDBhE.default)("div", {
    name: "MuiButtonGroup",
    slot: "Root",
    overridesResolver: $078cc07d54c9b00d$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "inline-flex",
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.variant === "contained" && {
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.disableElevation && {
        boxShadow: "none"
    }, ownerState.fullWidth && {
        width: "100%"
    }, ownerState.orientation === "vertical" && {
        flexDirection: "column"
    }, {
        [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).grouped}`]: (0, $kY3Ke.default)({
            minWidth: 40,
            "&:hover": (0, $kY3Ke.default)({}, ownerState.variant === "contained" && {
                boxShadow: "none"
            })
        }, ownerState.variant === "contained" && {
            boxShadow: "none"
        }),
        [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).firstButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: (0, $kY3Ke.default)({}, ownerState.orientation === "horizontal" && {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        }, ownerState.orientation === "vertical" && {
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0
        }, ownerState.variant === "text" && ownerState.orientation === "horizontal" && {
            borderRight: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
            [`&.${(0, $94403c25c532988f$export$2e2bcd8739ae039).disabled}`]: {
                borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === "text" && ownerState.orientation === "vertical" && {
            borderBottom: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
            [`&.${(0, $94403c25c532988f$export$2e2bcd8739ae039).disabled}`]: {
                borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            borderColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $7jL4F.alpha)(theme.palette[ownerState.color].main, 0.5)
        }, ownerState.variant === "outlined" && ownerState.orientation === "horizontal" && {
            borderRightColor: "transparent"
        }, ownerState.variant === "outlined" && ownerState.orientation === "vertical" && {
            borderBottomColor: "transparent"
        }, ownerState.variant === "contained" && ownerState.orientation === "horizontal" && {
            borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
            [`&.${(0, $94403c25c532988f$export$2e2bcd8739ae039).disabled}`]: {
                borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === "contained" && ownerState.orientation === "vertical" && {
            borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
            [`&.${(0, $94403c25c532988f$export$2e2bcd8739ae039).disabled}`]: {
                borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            borderColor: (theme.vars || theme).palette[ownerState.color].dark
        }, {
            "&:hover": (0, $kY3Ke.default)({}, ownerState.variant === "outlined" && ownerState.orientation === "horizontal" && {
                borderRightColor: "currentColor"
            }, ownerState.variant === "outlined" && ownerState.orientation === "vertical" && {
                borderBottomColor: "currentColor"
            })
        }),
        [`& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).lastButton},& .${(0, $94403c25c532988f$export$2e2bcd8739ae039).middleButton}`]: (0, $kY3Ke.default)({}, ownerState.orientation === "horizontal" && {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }, ownerState.orientation === "vertical" && {
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0
        }, ownerState.variant === "outlined" && ownerState.orientation === "horizontal" && {
            marginLeft: -1
        }, ownerState.variant === "outlined" && ownerState.orientation === "vertical" && {
            marginTop: -1
        })
    }));
const $078cc07d54c9b00d$var$ButtonGroup = /*#__PURE__*/ $7fPBF.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiButtonGroup"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = "horizontal", size: size = "medium", variant: variant = "outlined" } = props, other = (0, $cFLic.default)(props, $078cc07d54c9b00d$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    });
    const classes = $078cc07d54c9b00d$var$useUtilityClasses(ownerState);
    const context = $7fPBF.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $5bbedad9f52da8be$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return "";
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($078cc07d54c9b00d$var$ButtonGroupRoot, (0, $kY3Ke.default)({
        as: component,
        role: "group",
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $40ed7573a59c2be9$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e319f5c3a4402058$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
var $078cc07d54c9b00d$export$2e2bcd8739ae039 = $078cc07d54c9b00d$var$ButtonGroup;


var $9b8a49e2878275fe$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($9b8a49e2878275fe$exports, "__esModule", {
    value: true
});
$9b8a49e2878275fe$exports.default = void 0;

var $9b8a49e2878275fe$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $9b8a49e2878275fe$var$_default = $9b8a49e2878275fe$exports.default = (0, $9b8a49e2878275fe$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"
}), "Download");



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $5e9f5ca6e3e911fc$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $5e9f5ca6e3e911fc$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($5e9f5ca6e3e911fc$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $5e9f5ca6e3e911fc$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $5e9f5ca6e3e911fc$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $b6UUh = parcelRequire("b6UUh");


var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $f29d66cab44a33c0$var$FormControlContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $f29d66cab44a33c0$export$2e2bcd8739ae039 = $f29d66cab44a33c0$var$FormControlContext;



var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $6fa629ce89e8ad57$export$149c8b8bab2289d1(slot) {
    return (0, $jzxpm.default)("MuiFormControl", slot);
}
const $6fa629ce89e8ad57$var$formControlClasses = (0, $9UILM.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $6fa629ce89e8ad57$export$2e2bcd8739ae039 = $6fa629ce89e8ad57$var$formControlClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $26a8e925f0aa9998$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $26a8e925f0aa9998$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $b6UUh.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $6fa629ce89e8ad57$export$149c8b8bab2289d1), classes);
};
const $26a8e925f0aa9998$var$FormControlRoot = (0, $kDBhE.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $kY3Ke.default)({}, styles.root, styles[`margin${(0, $b6UUh.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $26a8e925f0aa9998$var$FormControl = /*#__PURE__*/ $7fPBF.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $cFLic.default)(props, $26a8e925f0aa9998$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $26a8e925f0aa9998$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $5e9f5ca6e3e911fc$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)(child.props, true) || (0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $7fPBF.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $7fPBF.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f29d66cab44a33c0$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($26a8e925f0aa9998$var$FormControlRoot, (0, $kY3Ke.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $hngXp.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $26a8e925f0aa9998$export$2e2bcd8739ae039 = $26a8e925f0aa9998$var$FormControl;


var $fa9d0137ffbb850f$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($fa9d0137ffbb850f$exports, "__esModule", {
    value: true
});
$fa9d0137ffbb850f$exports.default = void 0;

var $fa9d0137ffbb850f$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $fa9d0137ffbb850f$var$_default = $fa9d0137ffbb850f$exports.default = (0, $fa9d0137ffbb850f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M7 14H5v5h5v-2H7zm-2-4h2V7h3V5H5zm12 7h-3v2h5v-5h-2zM14 5v2h3v3h2V5z"
}), "Fullscreen");




var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $jzxpm = parcelRequire("jzxpm");

var $fsUVx = parcelRequire("fsUVx");


var $9HPC7 = parcelRequire("9HPC7");

var $4kWyf = parcelRequire("4kWyf");

var $mqrnX = parcelRequire("mqrnX");

var $2G6xE = parcelRequire("2G6xE");

var $kY3Ke = parcelRequire("kY3Ke");
const $96bdbf4695197f4a$export$f1ce4856483bd995 = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
const $96bdbf4695197f4a$export$e04173f1577f18b7 = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === "object") {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $96bdbf4695197f4a$export$f1ce4856483bd995(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.indexOf(key) !== -1) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === "number" || typeof responsive === "string") iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};


function $7a7617bd92c75c7e$var$appendLevel(level) {
    if (!level) return "";
    return `Level${level}`;
}
function $7a7617bd92c75c7e$var$isNestedContainer(ownerState) {
    return ownerState.unstable_level > 0 && ownerState.container;
}
function $7a7617bd92c75c7e$var$createGetSelfSpacing(ownerState) {
    return function getSelfSpacing(axis) {
        return `var(--Grid-${axis}Spacing${$7a7617bd92c75c7e$var$appendLevel(ownerState.unstable_level)})`;
    };
}
function $7a7617bd92c75c7e$var$createGetParentSpacing(ownerState) {
    return function getParentSpacing(axis) {
        if (ownerState.unstable_level === 0) return `var(--Grid-${axis}Spacing)`;
        return `var(--Grid-${axis}Spacing${$7a7617bd92c75c7e$var$appendLevel(ownerState.unstable_level - 1)})`;
    };
}
function $7a7617bd92c75c7e$var$getParentColumns(ownerState) {
    if (ownerState.unstable_level === 0) return `var(--Grid-columns)`;
    return `var(--Grid-columns${$7a7617bd92c75c7e$var$appendLevel(ownerState.unstable_level - 1)})`;
}
const $7a7617bd92c75c7e$export$84053369756c53db = ({ theme: theme, ownerState: ownerState })=>{
    const getSelfSpacing = $7a7617bd92c75c7e$var$createGetSelfSpacing(ownerState);
    const styles = {};
    (0, $96bdbf4695197f4a$export$e04173f1577f18b7)(theme.breakpoints, ownerState.gridSize, (appendStyle, value)=>{
        let style = {};
        if (value === true) style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        if (value === "auto") style = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        if (typeof value === "number") style = {
            flexGrow: 0,
            flexBasis: "auto",
            width: `calc(100% * ${value} / ${$7a7617bd92c75c7e$var$getParentColumns(ownerState)}${$7a7617bd92c75c7e$var$isNestedContainer(ownerState) ? ` + ${getSelfSpacing("column")}` : ""})`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $7a7617bd92c75c7e$export$c1d4f281314969c2 = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $96bdbf4695197f4a$export$e04173f1577f18b7)(theme.breakpoints, ownerState.gridOffset, (appendStyle, value)=>{
        let style = {};
        if (value === "auto") style = {
            marginLeft: "auto"
        };
        if (typeof value === "number") style = {
            marginLeft: value === 0 ? "0px" : `calc(100% * ${value} / ${$7a7617bd92c75c7e$var$getParentColumns(ownerState)})`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $7a7617bd92c75c7e$export$ccc4d4a4923f1b06 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = $7a7617bd92c75c7e$var$isNestedContainer(ownerState) ? {
        [`--Grid-columns${$7a7617bd92c75c7e$var$appendLevel(ownerState.unstable_level)}`]: $7a7617bd92c75c7e$var$getParentColumns(ownerState)
    } : {
        "--Grid-columns": 12
    };
    (0, $96bdbf4695197f4a$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        appendStyle(styles, {
            [`--Grid-columns${$7a7617bd92c75c7e$var$appendLevel(ownerState.unstable_level)}`]: value
        });
    });
    return styles;
};
const $7a7617bd92c75c7e$export$68c4dad72dd49c74 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const getParentSpacing = $7a7617bd92c75c7e$var$createGetParentSpacing(ownerState);
    const styles = $7a7617bd92c75c7e$var$isNestedContainer(ownerState) ? {
        // Set the default spacing as its parent spacing.
        // It will be overridden if spacing props are provided
        [`--Grid-rowSpacing${$7a7617bd92c75c7e$var$appendLevel(ownerState.unstable_level)}`]: getParentSpacing("row")
    } : {};
    (0, $96bdbf4695197f4a$export$e04173f1577f18b7)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        var _theme$spacing;
        appendStyle(styles, {
            [`--Grid-rowSpacing${$7a7617bd92c75c7e$var$appendLevel(ownerState.unstable_level)}`]: typeof value === "string" ? value : (_theme$spacing = theme.spacing) == null ? void 0 : _theme$spacing.call(theme, value)
        });
    });
    return styles;
};
const $7a7617bd92c75c7e$export$a89c28919b8e3bb5 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const getParentSpacing = $7a7617bd92c75c7e$var$createGetParentSpacing(ownerState);
    const styles = $7a7617bd92c75c7e$var$isNestedContainer(ownerState) ? {
        // Set the default spacing as its parent spacing.
        // It will be overridden if spacing props are provided
        [`--Grid-columnSpacing${$7a7617bd92c75c7e$var$appendLevel(ownerState.unstable_level)}`]: getParentSpacing("column")
    } : {};
    (0, $96bdbf4695197f4a$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        var _theme$spacing2;
        appendStyle(styles, {
            [`--Grid-columnSpacing${$7a7617bd92c75c7e$var$appendLevel(ownerState.unstable_level)}`]: typeof value === "string" ? value : (_theme$spacing2 = theme.spacing) == null ? void 0 : _theme$spacing2.call(theme, value)
        });
    });
    return styles;
};
const $7a7617bd92c75c7e$export$2a0a3c01032b3f4 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $96bdbf4695197f4a$export$e04173f1577f18b7)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
const $7a7617bd92c75c7e$export$810b8c3ab5d46bf = ({ ownerState: ownerState })=>{
    const getSelfSpacing = $7a7617bd92c75c7e$var$createGetSelfSpacing(ownerState);
    const getParentSpacing = $7a7617bd92c75c7e$var$createGetParentSpacing(ownerState);
    return (0, $kY3Ke.default)({
        minWidth: 0,
        boxSizing: "border-box"
    }, ownerState.container && (0, $kY3Ke.default)({
        display: "flex",
        flexWrap: "wrap"
    }, ownerState.wrap && ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }, {
        margin: `calc(${getSelfSpacing("row")} / -2) calc(${getSelfSpacing("column")} / -2)`
    }, ownerState.disableEqualOverflow && {
        margin: `calc(${getSelfSpacing("row")} * -1) 0px 0px calc(${getSelfSpacing("column")} * -1)`
    }), (!ownerState.container || $7a7617bd92c75c7e$var$isNestedContainer(ownerState)) && (0, $kY3Ke.default)({
        padding: `calc(${getParentSpacing("row")} / 2) calc(${getParentSpacing("column")} / 2)`
    }, (ownerState.disableEqualOverflow || ownerState.parentDisableEqualOverflow) && {
        padding: `${getParentSpacing("row")} 0px 0px ${getParentSpacing("column")}`
    }));
};
const $7a7617bd92c75c7e$export$e2d1175061442d38 = (gridSize)=>{
    const classNames = [];
    Object.entries(gridSize).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
const $7a7617bd92c75c7e$export$6c7087d27c3329d3 = (spacing, smallestBreakpoint = "xs")=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === "string" && !Number.isNaN(Number(val)) || typeof val === "number" && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === "object" && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
const $7a7617bd92c75c7e$export$a7c8efbe2b138a60 = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === "object") return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};



var $bbzbN = parcelRequire("bbzbN");
const $2baa95375046eab6$var$_excluded = [
    "className",
    "children",
    "columns",
    "container",
    "component",
    "direction",
    "wrap",
    "spacing",
    "rowSpacing",
    "columnSpacing",
    "disableEqualOverflow",
    "unstable_level"
];
const $2baa95375046eab6$var$defaultTheme = (0, $2G6xE.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $2baa95375046eab6$var$defaultCreateStyledComponent = (0, $81df530a7daa801f$export$2e2bcd8739ae039)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $2baa95375046eab6$var$useThemePropsDefault(props) {
    return (0, $9HPC7.default)({
        props: props,
        name: "MuiGrid",
        defaultTheme: $2baa95375046eab6$var$defaultTheme
    });
}
function $2baa95375046eab6$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $2baa95375046eab6$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $2baa95375046eab6$var$useThemePropsDefault, componentName: componentName = "MuiGrid" } = options;
    const GridOverflowContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, gridSize: gridSize } = ownerState;
        const slots = {
            root: [
                "root",
                container && "container",
                wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
                ...(0, $7a7617bd92c75c7e$export$a7c8efbe2b138a60)(direction),
                ...(0, $7a7617bd92c75c7e$export$e2d1175061442d38)(gridSize),
                ...container ? (0, $7a7617bd92c75c7e$export$6c7087d27c3329d3)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $fsUVx.default)(slots, (slot)=>(0, $jzxpm.default)(componentName, slot), {});
    };
    const GridRoot = createStyledComponent((0, $7a7617bd92c75c7e$export$ccc4d4a4923f1b06), (0, $7a7617bd92c75c7e$export$a89c28919b8e3bb5), (0, $7a7617bd92c75c7e$export$68c4dad72dd49c74), (0, $7a7617bd92c75c7e$export$84053369756c53db), (0, $7a7617bd92c75c7e$export$2a0a3c01032b3f4), (0, $7a7617bd92c75c7e$export$810b8c3ab5d46bf), (0, $7a7617bd92c75c7e$export$c1d4f281314969c2));
    const Grid = /*#__PURE__*/ $7fPBF.forwardRef(function Grid(inProps, ref) {
        var _inProps$columns, _inProps$spacing, _ref, _inProps$rowSpacing, _ref2, _inProps$columnSpacin, _ref3, _disableEqualOverflow;
        const theme = (0, $4kWyf.default)();
        const themeProps = useThemeProps(inProps);
        const props = (0, $mqrnX.default)(themeProps); // `color` type conflicts with html color attribute.
        const overflow = $7fPBF.useContext(GridOverflowContext);
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = "div", direction: direction = "row", wrap: wrap = "wrap", spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, disableEqualOverflow: themeDisableEqualOverflow, unstable_level: level = 0 } = props, rest = (0, $cFLic.default)(props, $2baa95375046eab6$var$_excluded);
        // Because `disableEqualOverflow` can be set from the theme's defaultProps, the **nested** grid should look at the instance props instead.
        let disableEqualOverflow = themeDisableEqualOverflow;
        if (level && themeDisableEqualOverflow !== undefined) disableEqualOverflow = inProps.disableEqualOverflow;
        // collect breakpoints related props because they can be customized from the theme.
        const gridSize = {};
        const gridOffset = {};
        const other = {};
        Object.entries(rest).forEach(([key, val])=>{
            if (theme.breakpoints.values[key] !== undefined) gridSize[key] = val;
            else if (theme.breakpoints.values[key.replace("Offset", "")] !== undefined) gridOffset[key.replace("Offset", "")] = val;
            else other[key] = val;
        });
        const columns = (_inProps$columns = inProps.columns) != null ? _inProps$columns : level ? undefined : columnsProp;
        const spacing = (_inProps$spacing = inProps.spacing) != null ? _inProps$spacing : level ? undefined : spacingProp;
        const rowSpacing = (_ref = (_inProps$rowSpacing = inProps.rowSpacing) != null ? _inProps$rowSpacing : inProps.spacing) != null ? _ref : level ? undefined : rowSpacingProp;
        const columnSpacing = (_ref2 = (_inProps$columnSpacin = inProps.columnSpacing) != null ? _inProps$columnSpacin : inProps.spacing) != null ? _ref2 : level ? undefined : columnSpacingProp;
        const ownerState = (0, $kY3Ke.default)({}, props, {
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            gridSize: gridSize,
            gridOffset: gridOffset,
            disableEqualOverflow: (_ref3 = (_disableEqualOverflow = disableEqualOverflow) != null ? _disableEqualOverflow : overflow) != null ? _ref3 : false,
            // use context value if exists.
            parentDisableEqualOverflow: overflow // for nested grid
        });
        const classes = useUtilityClasses(ownerState, theme);
        let result = /*#__PURE__*/ (0, $bbzbN.jsx)(GridRoot, (0, $kY3Ke.default)({
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $hngXp.default)(classes.root, className)
        }, other, {
            children: $7fPBF.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $7fPBF.isValidElement(child) && (0, $df988254f818111e$export$2e2bcd8739ae039)(child, [
                    "Grid"
                ])) {
                    var _child$props$unstable;
                    return /*#__PURE__*/ $7fPBF.cloneElement(child, {
                        unstable_level: (_child$props$unstable = child.props.unstable_level) != null ? _child$props$unstable : level + 1
                    });
                }
                return child;
            })
        }));
        if (disableEqualOverflow !== undefined && disableEqualOverflow !== (overflow != null ? overflow : false)) // There are 2 possibilities that should wrap with the GridOverflowContext to communicate with the nested grids:
        // 1. It is the root grid with `disableEqualOverflow`.
        // 2. It is a nested grid with different `disableEqualOverflow` from the context.
        result = /*#__PURE__*/ (0, $bbzbN.jsx)(GridOverflowContext.Provider, {
            value: disableEqualOverflow,
            children: result
        });
        return result;
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = "Grid";
    return Grid;
}



var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");
"use client";
const $c444a3def854c6aa$var$Grid2 = (0, $2baa95375046eab6$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $kDBhE.default)("div", {
        name: "MuiGrid2",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    componentName: "MuiGrid2",
    useThemeProps: (inProps)=>(0, $5j2OD.default)({
            props: inProps,
            name: "MuiGrid2"
        })
});
var $c444a3def854c6aa$export$2e2bcd8739ae039 = $c444a3def854c6aa$var$Grid2;


var $0a7d45d6c9dbfb3d$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($0a7d45d6c9dbfb3d$exports, "__esModule", {
    value: true
});
$0a7d45d6c9dbfb3d$exports.default = void 0;

var $0a7d45d6c9dbfb3d$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $0a7d45d6c9dbfb3d$var$_default = $0a7d45d6c9dbfb3d$exports.default = (0, $0a7d45d6c9dbfb3d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M11 18h2v-2h-2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4"
}), "HelpOutlineOutlined");



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $fsUVx = parcelRequire("fsUVx");

var $hngXp = parcelRequire("hngXp");
function $e570c333aacea667$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $7fPBF = parcelRequire("7fPBF");

"use client";
function $1af6f86e160474f0$export$2e2bcd8739ae039() {
    return $7fPBF.useContext((0, $f29d66cab44a33c0$export$2e2bcd8739ae039));
}



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");



var $b6UUh = parcelRequire("b6UUh");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $94ffd68a66aaae7e$export$f7d501e40371cd17(slot) {
    return (0, $jzxpm.default)("MuiFormLabel", slot);
}
const $94ffd68a66aaae7e$var$formLabelClasses = (0, $9UILM.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $94ffd68a66aaae7e$export$2e2bcd8739ae039 = $94ffd68a66aaae7e$var$formLabelClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $90370d1df15229dd$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $90370d1df15229dd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $b6UUh.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $94ffd68a66aaae7e$export$f7d501e40371cd17), classes);
};
const $90370d1df15229dd$export$aa5bc7f8a4705b27 = (0, $kDBhE.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $kY3Ke.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $90370d1df15229dd$var$AsteriskComponent = (0, $kDBhE.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $90370d1df15229dd$var$FormLabel = /*#__PURE__*/ $7fPBF.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $cFLic.default)(props, $90370d1df15229dd$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $90370d1df15229dd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($90370d1df15229dd$export$aa5bc7f8a4705b27, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $bbzbN.jsxs)($90370d1df15229dd$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
var $90370d1df15229dd$export$2e2bcd8739ae039 = $90370d1df15229dd$var$FormLabel;



var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $2b0d2ae144238f59$export$c1c4b4545ad2ea5f(slot) {
    return (0, $jzxpm.default)("MuiInputLabel", slot);
}
const $2b0d2ae144238f59$var$inputLabelClasses = (0, $9UILM.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $2b0d2ae144238f59$export$2e2bcd8739ae039 = $2b0d2ae144238f59$var$inputLabelClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $fcd80672e9993aad$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $fcd80672e9993aad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, $b6UUh.default)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $fsUVx.default)(slots, (0, $2b0d2ae144238f59$export$c1c4b4545ad2ea5f), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $fcd80672e9993aad$var$InputLabelRoot = (0, $kDBhE.default)((0, $90370d1df15229dd$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $kY3Ke.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $kY3Ke.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $kY3Ke.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $fcd80672e9993aad$var$InputLabel = /*#__PURE__*/ $7fPBF.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $5j2OD.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $cFLic.default)(props, $fcd80672e9993aad$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required",
            "focused"
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $fcd80672e9993aad$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($fcd80672e9993aad$var$InputLabelRoot, (0, $kY3Ke.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $fcd80672e9993aad$export$2e2bcd8739ae039 = $fcd80672e9993aad$var$InputLabel;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");

var $7jL4F = parcelRequire("7jL4F");

var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $5j2OD = parcelRequire("5j2OD");





var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $be601d991ccbe49a$export$46f01d01378ec5a2(slot) {
    return (0, $jzxpm.default)("MuiDivider", slot);
}
const $be601d991ccbe49a$var$dividerClasses = (0, $9UILM.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $be601d991ccbe49a$export$2e2bcd8739ae039 = $be601d991ccbe49a$var$dividerClasses;





var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $81e9a11bd449f186$export$515f8c67b5305377(slot) {
    return (0, $jzxpm.default)("MuiMenuItem", slot);
}
const $81e9a11bd449f186$var$menuItemClasses = (0, $9UILM.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $81e9a11bd449f186$export$2e2bcd8739ae039 = $81e9a11bd449f186$var$menuItemClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $3bdbe9250415b022$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $3bdbe9250415b022$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $3bdbe9250415b022$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $fsUVx.default)(slots, (0, $81e9a11bd449f186$export$515f8c67b5305377), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $3bdbe9250415b022$var$MenuItemRoot = (0, $kDBhE.default)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $3bdbe9250415b022$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $be601d991ccbe49a$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $be601d991ccbe49a$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $7a8a9052410fb062$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $kY3Ke.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $7a8a9052410fb062$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $3bdbe9250415b022$var$MenuItem = /*#__PURE__*/ $7fPBF.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className } = props, other = (0, $cFLic.default)(props, $3bdbe9250415b022$var$_excluded);
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $7fPBF.useRef(null);
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $3bdbe9250415b022$var$useUtilityClasses(props);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($3bdbe9250415b022$var$MenuItemRoot, (0, $kY3Ke.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $hngXp.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $hngXp.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $3bdbe9250415b022$export$2e2bcd8739ae039 = $3bdbe9250415b022$var$MenuItem;




var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $l1GiU = parcelRequire("l1GiU");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $a4yCM = parcelRequire("a4yCM");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("j2VHG");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");



var $9502daaf177b272b$export$2e2bcd8739ae039 = (0, $cac0a17fea472264$export$2e2bcd8739ae039);



var $b6UUh = parcelRequire("b6UUh");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("j2VHG");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");




var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("j2VHG");



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $fsUVx = parcelRequire("fsUVx");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");


var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $d56e26d1d10ff784$export$c6bd6795ed6e3203(slot) {
    return (0, $jzxpm.default)("MuiList", slot);
}
const $d56e26d1d10ff784$var$listClasses = (0, $9UILM.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $d56e26d1d10ff784$export$2e2bcd8739ae039 = $d56e26d1d10ff784$var$listClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $fb70212a09473954$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $fb70212a09473954$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $d56e26d1d10ff784$export$c6bd6795ed6e3203), classes);
};
const $fb70212a09473954$var$ListRoot = (0, $kDBhE.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $fb70212a09473954$var$List = /*#__PURE__*/ $7fPBF.forwardRef(function List(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $cFLic.default)(props, $fb70212a09473954$var$_excluded);
    const context = $7fPBF.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $fb70212a09473954$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)($fb70212a09473954$var$ListRoot, (0, $kY3Ke.default)({
            as: component,
            className: (0, $hngXp.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $fb70212a09473954$export$2e2bcd8739ae039 = $fb70212a09473954$var$List;



var $15bf9ba27fbfc052$export$2e2bcd8739ae039 = (0, $d5ff8c68944ff1f6$export$2e2bcd8739ae039);





var $bbzbN = parcelRequire("bbzbN");
"use client";
const $9cb95136bc90d127$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $9cb95136bc90d127$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $9cb95136bc90d127$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $9cb95136bc90d127$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$9cb95136bc90d127$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $9cb95136bc90d127$var$MenuList = /*#__PURE__*/ $7fPBF.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $cFLic.default)(props, $9cb95136bc90d127$var$_excluded);
    const listRef = $7fPBF.useRef(null);
    const textCriteriaRef = $7fPBF.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $15bf9ba27fbfc052$export$2e2bcd8739ae039)((0, $9502daaf177b272b$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $9502daaf177b272b$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $9cb95136bc90d127$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $9cb95136bc90d127$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $7fPBF.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $7fPBF.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $9cb95136bc90d127$export$2e2bcd8739ae039 = $9cb95136bc90d127$var$MenuList;



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $fsUVx = parcelRequire("fsUVx");






var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $2ef6c47c0201f9e8$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $3aadd01758bd49c1$export$2e2bcd8739ae039 = (0, $2ef6c47c0201f9e8$export$2e2bcd8739ae039);




var $6cb2f4180c9526e0$export$2e2bcd8739ae039 = (0, $66b23e3809994643$export$2e2bcd8739ae039);




var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");








var $bbzbN = parcelRequire("bbzbN");
"use client";
const $7ec2c0aa92d4d29c$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $7ec2c0aa92d4d29c$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $7ec2c0aa92d4d29c$var$styles = {
    entering: {
        opacity: 1,
        transform: $7ec2c0aa92d4d29c$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $7ec2c0aa92d4d29c$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $7ec2c0aa92d4d29c$var$Grow = /*#__PURE__*/ $7fPBF.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $623678cbb6daf054$export$2e2bcd8739ae039) } = props, other = (0, $cFLic.default)(props, $7ec2c0aa92d4d29c$var$_excluded);
    const timer = (0, $c687181065d3a58c$export$2e2bcd8739ae039)();
    const autoTimeout = $7fPBF.useRef();
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $1ae2edacd7be6319$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $7ec2c0aa92d4d29c$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $7ec2c0aa92d4d29c$var$isWebKit154 ? duration : duration * 0.666,
                delay: $7ec2c0aa92d4d29c$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $7ec2c0aa92d4d29c$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
                style: (0, $kY3Ke.default)({
                    opacity: 0,
                    transform: $7ec2c0aa92d4d29c$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $7ec2c0aa92d4d29c$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$7ec2c0aa92d4d29c$var$Grow.muiSupportAuto = true;
var $7ec2c0aa92d4d29c$export$2e2bcd8739ae039 = $7ec2c0aa92d4d29c$var$Grow;





var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $a5a68170633995c3$export$88f455dd56c95edb(slot) {
    return (0, $jzxpm.default)("MuiPopover", slot);
}
const $a5a68170633995c3$var$popoverClasses = (0, $9UILM.default)("MuiPopover", [
    "root",
    "paper"
]);
var $a5a68170633995c3$export$2e2bcd8739ae039 = $a5a68170633995c3$var$popoverClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $77b3b30833fb8c12$var$_excluded = [
    "onEntering"
], $77b3b30833fb8c12$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $77b3b30833fb8c12$var$_excluded3 = [
    "slotProps"
];
function $77b3b30833fb8c12$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $77b3b30833fb8c12$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $77b3b30833fb8c12$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $77b3b30833fb8c12$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $77b3b30833fb8c12$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $a5a68170633995c3$export$88f455dd56c95edb), classes);
};
const $77b3b30833fb8c12$export$bcce13685275fc99 = (0, $kDBhE.default)((0, $a65b89a1133e1fe4$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $77b3b30833fb8c12$export$821346c38a2d9390 = (0, $kDBhE.default)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $77b3b30833fb8c12$var$Popover = /*#__PURE__*/ $7fPBF.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $7ec2c0aa92d4d29c$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $cFLic.default)(props.TransitionProps, $77b3b30833fb8c12$var$_excluded), other = (0, $cFLic.default)(props, $77b3b30833fb8c12$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $7fPBF.useRef();
    const handlePaperRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $77b3b30833fb8c12$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $7fPBF.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $77b3b30833fb8c12$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $9502daaf177b272b$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $77b3b30833fb8c12$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $77b3b30833fb8c12$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $7fPBF.useCallback((elemRect)=>{
        return {
            vertical: $77b3b30833fb8c12$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $77b3b30833fb8c12$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $7fPBF.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $77b3b30833fb8c12$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $77b3b30833fb8c12$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $7fPBF.useState(open);
    const setPositioningStyles = $7fPBF.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $7fPBF.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $7fPBF.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $7fPBF.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $3aadd01758bd49c1$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $9502daaf177b272b$export$2e2bcd8739ae039)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $77b3b30833fb8c12$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $77b3b30833fb8c12$export$821346c38a2d9390;
    const paperProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: (0, $kY3Ke.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $kY3Ke.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $cFLic.default)(_useSlotProps, $77b3b30833fb8c12$var$_excluded3);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(RootSlot, (0, $kY3Ke.default)({}, rootProps, !(0, $59c589404b20ab2d$export$e28348cc2430497)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)(PaperSlot, (0, $kY3Ke.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $77b3b30833fb8c12$export$2e2bcd8739ae039 = $77b3b30833fb8c12$var$Popover;



var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $5j2OD = parcelRequire("5j2OD");

var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $a942fdfc6e6c5d42$export$2cf86a63a84fe23d(slot) {
    return (0, $jzxpm.default)("MuiMenu", slot);
}
const $a942fdfc6e6c5d42$var$menuClasses = (0, $9UILM.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $a942fdfc6e6c5d42$export$2e2bcd8739ae039 = $a942fdfc6e6c5d42$var$menuClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $c415fb7f3f0f9d08$var$_excluded = [
    "onEntering"
], $c415fb7f3f0f9d08$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $c415fb7f3f0f9d08$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $c415fb7f3f0f9d08$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $c415fb7f3f0f9d08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $a942fdfc6e6c5d42$export$2cf86a63a84fe23d), classes);
};
const $c415fb7f3f0f9d08$var$MenuRoot = (0, $kDBhE.default)((0, $77b3b30833fb8c12$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $c415fb7f3f0f9d08$export$4f7c51a5920c9f33 = (0, $kDBhE.default)((0, $77b3b30833fb8c12$export$821346c38a2d9390), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $c415fb7f3f0f9d08$var$MenuMenuList = (0, $kDBhE.default)((0, $9cb95136bc90d127$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $c415fb7f3f0f9d08$var$Menu = /*#__PURE__*/ $7fPBF.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $cFLic.default)(props.TransitionProps, $c415fb7f3f0f9d08$var$_excluded), other = (0, $cFLic.default)(props, $c415fb7f3f0f9d08$var$_excluded2);
    const isRtl = (0, $ef654b446fc390d6$export$b2dd014b6c321cb)();
    const ownerState = (0, $kY3Ke.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $c415fb7f3f0f9d08$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $7fPBF.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? "rtl" : "ltr"
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $c415fb7f3f0f9d08$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($c415fb7f3f0f9d08$var$MenuRoot, (0, $kY3Ke.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $c415fb7f3f0f9d08$var$RTL_ORIGIN : $c415fb7f3f0f9d08$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $kY3Ke.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($c415fb7f3f0f9d08$var$MenuMenuList, (0, $kY3Ke.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $hngXp.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $c415fb7f3f0f9d08$export$2e2bcd8739ae039 = $c415fb7f3f0f9d08$var$Menu;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $fsUVx = parcelRequire("fsUVx");

var $b6UUh = parcelRequire("b6UUh");

var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $a5651256592f6f65$export$1ee13051fd9e2ab5(slot) {
    return (0, $jzxpm.default)("MuiNativeSelect", slot);
}
const $a5651256592f6f65$var$nativeSelectClasses = (0, $9UILM.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $a5651256592f6f65$export$2e2bcd8739ae039 = $a5651256592f6f65$var$nativeSelectClasses;



var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $7a6261f84c63d345$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $7a6261f84c63d345$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $b6UUh.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $a5651256592f6f65$export$1ee13051fd9e2ab5), classes);
};
const $7a6261f84c63d345$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $kY3Ke.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $a5651256592f6f65$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $7a6261f84c63d345$var$NativeSelectSelect = (0, $kDBhE.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $HgAeG.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $a5651256592f6f65$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($7a6261f84c63d345$export$c1eccd1617458c87);
const $7a6261f84c63d345$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $a5651256592f6f65$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $7a6261f84c63d345$var$NativeSelectIcon = (0, $kDBhE.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $b6UUh.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($7a6261f84c63d345$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $7a6261f84c63d345$var$NativeSelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $cFLic.default)(props, $7a6261f84c63d345$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $7a6261f84c63d345$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($7a6261f84c63d345$var$NativeSelectSelect, (0, $kY3Ke.default)({
                ownerState: ownerState,
                className: (0, $hngXp.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $bbzbN.jsx)($7a6261f84c63d345$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $7a6261f84c63d345$export$2e2bcd8739ae039 = $7a6261f84c63d345$var$NativeSelectInput;




var $kDBhE = parcelRequire("kDBhE");
var $yfUan = parcelRequire("yfUan");


var $7fPBF = parcelRequire("7fPBF");
"use client";
function $07aab0091e3efebc$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $7fPBF.useRef(controlled !== undefined);
    const [valueState, setValue] = $7fPBF.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $7fPBF.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


"use client";
var $3b64539a8a5729fa$export$2e2bcd8739ae039 = (0, $07aab0091e3efebc$export$2e2bcd8739ae039);



var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $5ea8b5d2968b699c$export$2c0c1ee5a3392e(slot) {
    return (0, $jzxpm.default)("MuiSelect", slot);
}
const $5ea8b5d2968b699c$var$selectClasses = (0, $9UILM.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $5ea8b5d2968b699c$export$2e2bcd8739ae039 = $5ea8b5d2968b699c$var$selectClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
var $59b8977b1194262f$var$_span;
const $59b8977b1194262f$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $59b8977b1194262f$var$SelectSelect = (0, $kDBhE.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $7a6261f84c63d345$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $59b8977b1194262f$var$SelectIcon = (0, $kDBhE.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $b6UUh.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $7a6261f84c63d345$export$e7a817afd12a40d0));
const $59b8977b1194262f$var$SelectNativeInput = (0, $kDBhE.default)("input", {
    shouldForwardProp: (prop)=>(0, $yfUan.default)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $59b8977b1194262f$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $59b8977b1194262f$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $59b8977b1194262f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $b6UUh.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $5ea8b5d2968b699c$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $59b8977b1194262f$var$SelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $cFLic.default)(props, $59b8977b1194262f$var$_excluded);
    const [value, setValueState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $7fPBF.useRef(null);
    const displayRef = $7fPBF.useRef(null);
    const [displayNode, setDisplayNode] = $7fPBF.useState(null);
    const { current: isOpenControlled } = $7fPBF.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $7fPBF.useState();
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $7fPBF.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $7fPBF.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $7fPBF.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $7fPBF.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $9502daaf177b272b$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $7fPBF.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $a4yCM.default)(2));
            selected = value.some((v)=>$59b8977b1194262f$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $59b8977b1194262f$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $7fPBF.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $59b8977b1194262f$var$useUtilityClasses(ownerState);
    const paperProps = (0, $kY3Ke.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $67dd8d1013271871$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectSelect, (0, $kY3Ke.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $hngXp.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $59b8977b1194262f$var$isEmpty(display) ? $59b8977b1194262f$var$_span || ($59b8977b1194262f$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectNativeInput, (0, $kY3Ke.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $kY3Ke.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $kY3Ke.default)({}, MenuProps.slotProps, {
                    paper: (0, $kY3Ke.default)({}, paperProps, {
                        style: (0, $kY3Ke.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $59b8977b1194262f$export$2e2bcd8739ae039 = $59b8977b1194262f$var$SelectInput;




parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $7cc16c93aade5bc5$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $fsUVx = parcelRequire("fsUVx");

var $l1GiU = parcelRequire("l1GiU");


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $a4yCM = parcelRequire("a4yCM");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $9907d957cc1b52b6$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $9907d957cc1b52b6$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $9907d957cc1b52b6$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $9907d957cc1b52b6$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $9907d957cc1b52b6$export$d1710922ecaf577a = /*#__PURE__*/ $7fPBF.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $cFLic.default)(props, $9907d957cc1b52b6$var$_excluded);
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const inputRef = $7fPBF.useRef(null);
    const handleRef = (0, $52155878109bdfb9$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const shadowRef = $7fPBF.useRef(null);
    const calculateTextareaStyles = $7fPBF.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $66b23e3809994643$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $9907d957cc1b52b6$var$getStyleValue(computedStyle.paddingBottom) + $9907d957cc1b52b6$var$getStyleValue(computedStyle.paddingTop);
        const border = $9907d957cc1b52b6$var$getStyleValue(computedStyle.borderBottomWidth) + $9907d957cc1b52b6$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = $7fPBF.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if ($9907d957cc1b52b6$var$isEmpty(textareaStyles)) return;
        const input = inputRef.current;
        input.style.height = `${textareaStyles.outerHeightStyle}px`;
        input.style.overflow = textareaStyles.overflowing ? "hidden" : "";
    }, [
        calculateTextareaStyles
    ]);
    (0, $f7f8f12b8c6feb2f$export$2e2bcd8739ae039)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $2ef6c47c0201f9e8$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $66b23e3809994643$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, $f7f8f12b8c6feb2f$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", (0, $kY3Ke.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $kY3Ke.default)({}, $9907d957cc1b52b6$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});




var $fsUVx = parcelRequire("fsUVx");




var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");





var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $2b15682cef07fc0a$export$ef57d5c8ca2278f6(slot) {
    return (0, $jzxpm.default)("MuiInputBase", slot);
}
const $2b15682cef07fc0a$var$inputBaseClasses = (0, $9UILM.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $2b15682cef07fc0a$export$2e2bcd8739ae039 = $2b15682cef07fc0a$var$inputBaseClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $ba9f7182d6802613$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $ba9f7182d6802613$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $ba9f7182d6802613$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $ba9f7182d6802613$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $b6UUh.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $b6UUh.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $2b15682cef07fc0a$export$ef57d5c8ca2278f6), classes);
};
const $ba9f7182d6802613$export$298a043133d72a38 = (0, $kDBhE.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $ba9f7182d6802613$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $2b15682cef07fc0a$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $kY3Ke.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $ba9f7182d6802613$export$a1ad29c901026019 = (0, $kDBhE.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $ba9f7182d6802613$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $kY3Ke.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $kY3Ke.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $2b15682cef07fc0a$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $2b15682cef07fc0a$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $ba9f7182d6802613$var$inputGlobalStyles = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a50e20ff7f02e09b$export$2e2bcd8739ae039), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $ba9f7182d6802613$var$InputBase = /*#__PURE__*/ $7fPBF.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $cFLic.default)(props, $ba9f7182d6802613$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const inputRef = $7fPBF.useRef();
    const handleInputRefWarning = $7fPBF.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $7fPBF.useState(false);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $7fPBF.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $7fPBF.useCallback((obj)=>{
        if ((0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $a4yCM.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $7fPBF.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $kY3Ke.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $kY3Ke.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $9907d957cc1b52b6$export$d1710922ecaf577a);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $7fPBF.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $ba9f7182d6802613$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $ba9f7182d6802613$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $ba9f7182d6802613$export$a1ad29c901026019;
    inputProps = (0, $kY3Ke.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $ba9f7182d6802613$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $bbzbN.jsxs)(Root, (0, $kY3Ke.default)({}, rootProps, !(0, $59c589404b20ab2d$export$e28348cc2430497)(Root) && {
                ownerState: (0, $kY3Ke.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $hngXp.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f29d66cab44a33c0$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)(Input, (0, $kY3Ke.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $59c589404b20ab2d$export$e28348cc2430497)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $kY3Ke.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $hngXp.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $kY3Ke.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $ba9f7182d6802613$export$2e2bcd8739ae039 = $ba9f7182d6802613$var$InputBase;



var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $5j2OD = parcelRequire("5j2OD");

var $kY3Ke = parcelRequire("kY3Ke");

var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");

function $aadd2b32ac43594b$export$cdb270390122322b(slot) {
    return (0, $jzxpm.default)("MuiInput", slot);
}
const $aadd2b32ac43594b$var$inputClasses = (0, $kY3Ke.default)({}, (0, $2b15682cef07fc0a$export$2e2bcd8739ae039), (0, $9UILM.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $aadd2b32ac43594b$export$2e2bcd8739ae039 = $aadd2b32ac43594b$var$inputClasses;




var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e0d49bb29c2f8b76$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $e0d49bb29c2f8b76$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $fsUVx.default)(slots, (0, $aadd2b32ac43594b$export$cdb270390122322b), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $e0d49bb29c2f8b76$var$InputRoot = (0, $kDBhE.default)((0, $ba9f7182d6802613$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $ba9f7182d6802613$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $kY3Ke.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).disabled}, .${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $e0d49bb29c2f8b76$var$InputInput = (0, $kDBhE.default)((0, $ba9f7182d6802613$export$a1ad29c901026019), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $ba9f7182d6802613$export$cf507b112810e72d)
})({});
const $e0d49bb29c2f8b76$var$Input = /*#__PURE__*/ $7fPBF.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $cFLic.default)(props, $e0d49bb29c2f8b76$var$_excluded);
    const classes = $e0d49bb29c2f8b76$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $l1GiU.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $e0d49bb29c2f8b76$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $e0d49bb29c2f8b76$var$InputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ba9f7182d6802613$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$e0d49bb29c2f8b76$var$Input.muiName = "Input";
var $e0d49bb29c2f8b76$export$2e2bcd8739ae039 = $e0d49bb29c2f8b76$var$Input;




var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $l1GiU = parcelRequire("l1GiU");



var $fsUVx = parcelRequire("fsUVx");


var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $5j2OD = parcelRequire("5j2OD");

var $kY3Ke = parcelRequire("kY3Ke");

var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");

function $c2b262889cde4af1$export$3331e419f1a48437(slot) {
    return (0, $jzxpm.default)("MuiFilledInput", slot);
}
const $c2b262889cde4af1$var$filledInputClasses = (0, $kY3Ke.default)({}, (0, $2b15682cef07fc0a$export$2e2bcd8739ae039), (0, $9UILM.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $c2b262889cde4af1$export$2e2bcd8739ae039 = $c2b262889cde4af1$var$filledInputClasses;




var $bbzbN = parcelRequire("bbzbN");
"use client";
const $faf35b44bb61ebfd$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $faf35b44bb61ebfd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $fsUVx.default)(slots, (0, $c2b262889cde4af1$export$3331e419f1a48437), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $faf35b44bb61ebfd$var$FilledInputRoot = (0, $kDBhE.default)((0, $ba9f7182d6802613$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $ba9f7182d6802613$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $kY3Ke.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).disabled}, .${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $kY3Ke.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $faf35b44bb61ebfd$var$FilledInputInput = (0, $kDBhE.default)((0, $ba9f7182d6802613$export$a1ad29c901026019), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $ba9f7182d6802613$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $faf35b44bb61ebfd$var$FilledInput = /*#__PURE__*/ $7fPBF.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $cFLic.default)(props, $faf35b44bb61ebfd$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $faf35b44bb61ebfd$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $l1GiU.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $faf35b44bb61ebfd$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $faf35b44bb61ebfd$var$FilledInputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ba9f7182d6802613$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$faf35b44bb61ebfd$var$FilledInput.muiName = "Input";
var $faf35b44bb61ebfd$export$2e2bcd8739ae039 = $faf35b44bb61ebfd$var$FilledInput;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");



var $fsUVx = parcelRequire("fsUVx");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");


var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $ae700d9709d2b786$var$_span;
const $ae700d9709d2b786$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $ae700d9709d2b786$var$NotchedOutlineRoot = (0, $kDBhE.default)("fieldset", {
    shouldForwardProp: (0, $HgAeG.default)
})({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $ae700d9709d2b786$var$NotchedOutlineLegend = (0, $kDBhE.default)("legend", {
    shouldForwardProp: (0, $HgAeG.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $kY3Ke.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $ae700d9709d2b786$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $cFLic.default)(props, $ae700d9709d2b786$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $kY3Ke.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($ae700d9709d2b786$var$NotchedOutlineRoot, (0, $kY3Ke.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($ae700d9709d2b786$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                children: label
            }) : $ae700d9709d2b786$var$_span || ($ae700d9709d2b786$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $kY3Ke = parcelRequire("kY3Ke");

var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");

function $fbe32ff46b8bf823$export$89922944c7227687(slot) {
    return (0, $jzxpm.default)("MuiOutlinedInput", slot);
}
const $fbe32ff46b8bf823$var$outlinedInputClasses = (0, $kY3Ke.default)({}, (0, $2b15682cef07fc0a$export$2e2bcd8739ae039), (0, $9UILM.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $fbe32ff46b8bf823$export$2e2bcd8739ae039 = $fbe32ff46b8bf823$var$outlinedInputClasses;




var $5j2OD = parcelRequire("5j2OD");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $50e7e9efec2c0b8c$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $50e7e9efec2c0b8c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $fsUVx.default)(slots, (0, $fbe32ff46b8bf823$export$89922944c7227687), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $50e7e9efec2c0b8c$var$OutlinedInputRoot = (0, $kDBhE.default)((0, $ba9f7182d6802613$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $ba9f7182d6802613$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $kY3Ke.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).focused} .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).error} .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).disabled} .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $kY3Ke.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $50e7e9efec2c0b8c$var$NotchedOutlineRoot = (0, $kDBhE.default)((0, $ae700d9709d2b786$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $50e7e9efec2c0b8c$var$OutlinedInputInput = (0, $kDBhE.default)((0, $ba9f7182d6802613$export$a1ad29c901026019), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $ba9f7182d6802613$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $50e7e9efec2c0b8c$var$OutlinedInput = /*#__PURE__*/ $7fPBF.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $cFLic.default)(props, $50e7e9efec2c0b8c$var$_excluded);
    const classes = $50e7e9efec2c0b8c$var$useUtilityClasses(props);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $50e7e9efec2c0b8c$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $50e7e9efec2c0b8c$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ba9f7182d6802613$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $bbzbN.jsx)($50e7e9efec2c0b8c$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $kY3Ke.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$50e7e9efec2c0b8c$var$OutlinedInput.muiName = "Input";
var $50e7e9efec2c0b8c$export$2e2bcd8739ae039 = $50e7e9efec2c0b8c$var$OutlinedInput;



var $5j2OD = parcelRequire("5j2OD");

parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");
var $kDBhE = parcelRequire("kDBhE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e07ff65b28ac412d$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $e07ff65b28ac412d$var$_excluded2 = [
    "root"
];
const $e07ff65b28ac412d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $e07ff65b28ac412d$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) && prop !== "variant",
    slot: "Root"
};
const $e07ff65b28ac412d$var$StyledInput = (0, $kDBhE.default)((0, $e0d49bb29c2f8b76$export$2e2bcd8739ae039), $e07ff65b28ac412d$var$styledRootConfig)("");
const $e07ff65b28ac412d$var$StyledOutlinedInput = (0, $kDBhE.default)((0, $50e7e9efec2c0b8c$export$2e2bcd8739ae039), $e07ff65b28ac412d$var$styledRootConfig)("");
const $e07ff65b28ac412d$var$StyledFilledInput = (0, $kDBhE.default)((0, $faf35b44bb61ebfd$export$2e2bcd8739ae039), $e07ff65b28ac412d$var$styledRootConfig)("");
const $e07ff65b28ac412d$var$Select = /*#__PURE__*/ $7fPBF.forwardRef(function Select(inProps, ref) {
    const props = (0, $5j2OD.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $7cc16c93aade5bc5$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $cFLic.default)(props, $e07ff65b28ac412d$var$_excluded);
    const inputComponent = native ? (0, $7a6261f84c63d345$export$2e2bcd8739ae039) : (0, $59b8977b1194262f$export$2e2bcd8739ae039);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $e07ff65b28ac412d$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $cFLic.default)(classes, $e07ff65b28ac412d$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
        children: /*#__PURE__*/ $7fPBF.cloneElement(InputComponent, (0, $kY3Ke.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $kY3Ke.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $kY3Ke.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $l1GiU.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $hngXp.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$e07ff65b28ac412d$var$Select.muiName = "Select";
var $e07ff65b28ac412d$export$2e2bcd8739ae039 = $e07ff65b28ac412d$var$Select;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");




var $fsUVx = parcelRequire("fsUVx");

var $7jL4F = parcelRequire("7jL4F");


var $kDBhE = parcelRequire("kDBhE");


var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");


var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

function $5a7577945ba4d648$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $f3e95cf60f991b3e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f3e95cf60f991b3e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f3e95cf60f991b3e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $cb70389d1b75072d$export$8960430cfd85939f = Math.max;
var $cb70389d1b75072d$export$96ec731ed4dcb222 = Math.min;
var $cb70389d1b75072d$export$2077e0241d6afd3c = Math.round;



function $c76403bd29ed319a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $b48f13af3862f004$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
}


function $e7afd89efa353b85$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b48f13af3862f004$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $e95acb4acf5ee909$export$2e2bcd8739ae039(node) {
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $6923eaccf7a43aef$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $fa62512f527d34a4$export$2e2bcd8739ae039(node) {
    if (node === (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node) || !(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(node)) return (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(node);
    else return (0, $6923eaccf7a43aef$export$2e2bcd8739ae039)(node);
}


function $b8ce8e5214ef2302$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $7d9656f011992b2b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e0a76d77d33c9d6e$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $e7afd89efa353b85$export$2e2bcd8739ae039)((0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element)).left + (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $3e40145ffd569d9c$export$2e2bcd8739ae039(element) {
    return (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $998896b7349c78b7$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $585037a155f95873$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $585037a155f95873$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent) && $585037a155f95873$var$isElementScaled(offsetParent);
    var documentElement = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $998896b7349c78b7$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $fa62512f527d34a4$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $790f3bf845b39e8e$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $9906540837c752ea$export$2e2bcd8739ae039(element) {
    if ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $1d462f2c86b4c65a$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(node) && (0, $998896b7349c78b7$export$2e2bcd8739ae039)(node)) return node;
    return $1d462f2c86b4c65a$export$2e2bcd8739ae039((0, $9906540837c752ea$export$2e2bcd8739ae039)(node));
}





function $3d1bbe7c8c599173$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $1d462f2c86b4c65a$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $998896b7349c78b7$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($3d1bbe7c8c599173$export$2e2bcd8739ae039((0, $9906540837c752ea$export$2e2bcd8739ae039)(target)));
}







function $08ccc1de57d53c59$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) >= 0;
}




function $6ebea87f6f98e49c$var$getTrueOffsetParent(element) {
    if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $6ebea87f6f98e49c$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
    if (isIE && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $9906540837c752ea$export$2e2bcd8739ae039)(element);
    if ((0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $6ebea87f6f98e49c$export$2e2bcd8739ae039(element) {
    var window = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element);
    var offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $08ccc1de57d53c59$export$2e2bcd8739ae039)(offsetParent) && (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $6ebea87f6f98e49c$var$getContainingBlock(element) || window;
}


var $7c96f63dd602b579$export$1e95b668f3b82d = "top";
var $7c96f63dd602b579$export$40e543e69a8b3fbb = "bottom";
var $7c96f63dd602b579$export$79ffe56a765070d2 = "right";
var $7c96f63dd602b579$export$eabcd2c8791e7bf4 = "left";
var $7c96f63dd602b579$export$dfb5619354ba860 = "auto";
var $7c96f63dd602b579$export$aec2ce47c367b8c3 = [
    $7c96f63dd602b579$export$1e95b668f3b82d,
    $7c96f63dd602b579$export$40e543e69a8b3fbb,
    $7c96f63dd602b579$export$79ffe56a765070d2,
    $7c96f63dd602b579$export$eabcd2c8791e7bf4
];
var $7c96f63dd602b579$export$b3571188c770cc5a = "start";
var $7c96f63dd602b579$export$bd5df0f255a350f8 = "end";
var $7c96f63dd602b579$export$390fd549c5303b4d = "clippingParents";
var $7c96f63dd602b579$export$d7b7311ec04a3e8f = "viewport";
var $7c96f63dd602b579$export$ae5ab1c730825774 = "popper";
var $7c96f63dd602b579$export$ca50aac9f3ba507f = "reference";
var $7c96f63dd602b579$export$368f9a87e87fa4e1 = /*#__PURE__*/ $7c96f63dd602b579$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []);
var $7c96f63dd602b579$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($7c96f63dd602b579$export$aec2ce47c367b8c3, [
    $7c96f63dd602b579$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $7c96f63dd602b579$export$421679a7c3d56e = "beforeRead";
var $7c96f63dd602b579$export$aafa59e2e03f2942 = "read";
var $7c96f63dd602b579$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $7c96f63dd602b579$export$c65e99957a05207c = "beforeMain";
var $7c96f63dd602b579$export$f22da7240b7add18 = "main";
var $7c96f63dd602b579$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $7c96f63dd602b579$export$8d4d2d70e7d46032 = "beforeWrite";
var $7c96f63dd602b579$export$68d8715fc104d294 = "write";
var $7c96f63dd602b579$export$70a6e5159acce2e6 = "afterWrite";
var $7c96f63dd602b579$export$d087d3878fdf71d5 = [
    $7c96f63dd602b579$export$421679a7c3d56e,
    $7c96f63dd602b579$export$aafa59e2e03f2942,
    $7c96f63dd602b579$export$6964f6c886723980,
    $7c96f63dd602b579$export$c65e99957a05207c,
    $7c96f63dd602b579$export$f22da7240b7add18,
    $7c96f63dd602b579$export$bab79516f2d662fe,
    $7c96f63dd602b579$export$8d4d2d70e7d46032,
    $7c96f63dd602b579$export$68d8715fc104d294,
    $7c96f63dd602b579$export$70a6e5159acce2e6
];


function $13c27cceb4b24b2f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $13c27cceb4b24b2f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $13c27cceb4b24b2f$var$order(modifiers); // order based on phase
    return (0, $7c96f63dd602b579$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $4c8edc0cb4d5666b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $320e6f4d2835a922$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $879850b738b0fd85$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $879850b738b0fd85$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $879850b738b0fd85$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $879850b738b0fd85$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $879850b738b0fd85$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(reference) ? (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $13c27cceb4b24b2f$export$2e2bcd8739ae039)((0, $320e6f4d2835a922$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $585037a155f95873$export$2e2bcd8739ae039)(reference, (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4c8edc0cb4d5666b$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $879850b738b0fd85$export$8f7491d57c8f97a9 = /*#__PURE__*/ $879850b738b0fd85$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $1564186ea0096528$var$passive = {
    passive: true
};
function $1564186ea0096528$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $1564186ea0096528$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $1564186ea0096528$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $1564186ea0096528$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $1564186ea0096528$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $1564186ea0096528$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $1564186ea0096528$var$effect,
    data: {}
};



function $2e8856bdb677ff8e$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $cd593f453867f36a$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $334987ecb6fc56c7$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $c2c9d9550c09d816$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $7c96f63dd602b579$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $7c96f63dd602b579$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $7c96f63dd602b579$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $7c96f63dd602b579$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $7c96f63dd602b579$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $7c96f63dd602b579$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $e0848fa64ca744df$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $c2c9d9550c09d816$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e0848fa64ca744df$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $e0848fa64ca744df$var$popperOffsets,
    data: {}
};










var $adff49e8d09ee1e5$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $adff49e8d09ee1e5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $adff49e8d09ee1e5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
    var sideY = (0, $7c96f63dd602b579$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(popper);
            if ((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $7c96f63dd602b579$export$1e95b668f3b82d) || (placement === (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) || placement === (0, $7c96f63dd602b579$export$79ffe56a765070d2)) && variation === (0, $7c96f63dd602b579$export$bd5df0f255a350f8)) {
            sideY = (0, $7c96f63dd602b579$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) || (placement === (0, $7c96f63dd602b579$export$1e95b668f3b82d) || placement === (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)) && variation === (0, $7c96f63dd602b579$export$bd5df0f255a350f8)) {
            sideX = (0, $7c96f63dd602b579$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $adff49e8d09ee1e5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $adff49e8d09ee1e5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $adff49e8d09ee1e5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $cd593f453867f36a$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $adff49e8d09ee1e5$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $adff49e8d09ee1e5$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $5bfb95a331f35baa$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || !(0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $5bfb95a331f35baa$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || !(0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $5bfb95a331f35baa$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $5bfb95a331f35baa$var$applyStyles,
    effect: $5bfb95a331f35baa$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a984b8b647b41eeb$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $7c96f63dd602b579$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a984b8b647b41eeb$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $a984b8b647b41eeb$var$offset
};


var $690483208b9a3207$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $690483208b9a3207$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $690483208b9a3207$var$hash[matched];
    });
}



var $13515282412eb271$var$hash = {
    start: "end",
    end: "start"
};
function $13515282412eb271$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $13515282412eb271$var$hash[matched];
    });
}







function $05957f974ad3b041$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element);
    var html = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b48f13af3862f004$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $f2541b971d258cf0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $fa38ef77d76834a0$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $18107b7e48021ffa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $86796f3d3717fc99$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $7c96f63dd602b579$export$d7b7311ec04a3e8f) ? (0, $18107b7e48021ffa$export$2e2bcd8739ae039)((0, $05957f974ad3b041$export$2e2bcd8739ae039)(element, strategy)) : (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clippingParent) ? $86796f3d3717fc99$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $18107b7e48021ffa$export$2e2bcd8739ae039)((0, $f2541b971d258cf0$export$2e2bcd8739ae039)((0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $86796f3d3717fc99$var$getClippingParents(element) {
    var clippingParents = (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)((0, $9906540837c752ea$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) ? (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clippingParent) && (0, $fa38ef77d76834a0$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $86796f3d3717fc99$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $86796f3d3717fc99$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $cb70389d1b75072d$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cb70389d1b75072d$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $86796f3d3717fc99$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $1e806166c2cdf48d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $ff6dcd1b0906e9b8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $1e806166c2cdf48d$export$2e2bcd8739ae039)(), paddingObject);
}


function $c8d699eb93b3090c$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $52693e6050d55014$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $7c96f63dd602b579$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $7c96f63dd602b579$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $7c96f63dd602b579$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $ff6dcd1b0906e9b8$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c8d699eb93b3090c$export$2e2bcd8739ae039)(padding, (0, $7c96f63dd602b579$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) ? (0, $7c96f63dd602b579$export$ca50aac9f3ba507f) : (0, $7c96f63dd602b579$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $86796f3d3717fc99$export$2e2bcd8739ae039)((0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $c2c9d9550c09d816$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $18107b7e48021ffa$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $7c96f63dd602b579$export$79ffe56a765070d2),
                (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $7c96f63dd602b579$export$1e95b668f3b82d),
                (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $a935996b3496591b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $7c96f63dd602b579$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $7c96f63dd602b579$export$368f9a87e87fa4e1) : (0, $7c96f63dd602b579$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $7c96f63dd602b579$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $a97241372b70cd07$var$getExpandedFallbackPlacements(placement) {
    if ((0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $690483208b9a3207$export$2e2bcd8739ae039)(placement);
    return [
        (0, $13515282412eb271$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $13515282412eb271$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $a97241372b70cd07$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $690483208b9a3207$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $a97241372b70cd07$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$dfb5619354ba860) ? (0, $a935996b3496591b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$b3571188c770cc5a);
        var isVertical = [
            (0, $7c96f63dd602b579$export$1e95b668f3b82d),
            (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $7c96f63dd602b579$export$79ffe56a765070d2) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $690483208b9a3207$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $690483208b9a3207$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a97241372b70cd07$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $a97241372b70cd07$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $8d60439f259d6a8c$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max) {
    return (0, $cb70389d1b75072d$export$8960430cfd85939f)(min, (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(value, max));
}
function $14b5cb667dce379f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $cf968237b9d7dd4a$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $8d60439f259d6a8c$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $7c96f63dd602b579$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $7c96f63dd602b579$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $1e806166c2cdf48d$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(tether ? (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $cb70389d1b75072d$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $7c96f63dd602b579$export$1e95b668f3b82d),
            (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $14b5cb667dce379f$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $14b5cb667dce379f$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cf968237b9d7dd4a$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $cf968237b9d7dd4a$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $e7f3cf13e0769248$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $ff6dcd1b0906e9b8$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c8d699eb93b3090c$export$2e2bcd8739ae039)(padding, (0, $7c96f63dd602b579$export$aec2ce47c367b8c3)));
};
function $e7f3cf13e0769248$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $e7f3cf13e0769248$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $e7f3cf13e0769248$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $fa38ef77d76834a0$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $e7f3cf13e0769248$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $e7f3cf13e0769248$var$arrow,
    effect: $e7f3cf13e0769248$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $74f12d998f890694$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $74f12d998f890694$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $7c96f63dd602b579$export$1e95b668f3b82d),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2),
        (0, $7c96f63dd602b579$export$40e543e69a8b3fbb),
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $74f12d998f890694$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $74f12d998f890694$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $74f12d998f890694$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $74f12d998f890694$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $74f12d998f890694$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $74f12d998f890694$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $74f12d998f890694$var$hide
};




var $a5ed26444bdb4d3e$export$d34966752335dd47 = [
    (0, $1564186ea0096528$export$2e2bcd8739ae039),
    (0, $e0848fa64ca744df$export$2e2bcd8739ae039),
    (0, $adff49e8d09ee1e5$export$2e2bcd8739ae039),
    (0, $5bfb95a331f35baa$export$2e2bcd8739ae039),
    (0, $a984b8b647b41eeb$export$2e2bcd8739ae039),
    (0, $a97241372b70cd07$export$2e2bcd8739ae039),
    (0, $cf968237b9d7dd4a$export$2e2bcd8739ae039),
    (0, $e7f3cf13e0769248$export$2e2bcd8739ae039),
    (0, $74f12d998f890694$export$2e2bcd8739ae039)
];
var $a5ed26444bdb4d3e$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $879850b738b0fd85$export$ed5e13716264f202)({
    defaultModifiers: $a5ed26444bdb4d3e$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $fsUVx = parcelRequire("fsUVx");


var $jzxpm = parcelRequire("jzxpm");
const $a3c689a96a013a98$var$GLOBAL_CLASS_PREFIX = "base";
function $a3c689a96a013a98$var$buildStateClass(state) {
    return `${$a3c689a96a013a98$var$GLOBAL_CLASS_PREFIX}--${state}`;
}
function $a3c689a96a013a98$var$buildSlotClass(componentName, slot) {
    return `${$a3c689a96a013a98$var$GLOBAL_CLASS_PREFIX}-${componentName}-${slot}`;
}
function $a3c689a96a013a98$export$1d132570e11858b0(componentName, slot) {
    const globalStateClass = (0, $jzxpm.globalStateClasses)[slot];
    return globalStateClass ? $a3c689a96a013a98$var$buildStateClass(globalStateClass) : $a3c689a96a013a98$var$buildSlotClass(componentName, slot);
}
function $a3c689a96a013a98$export$34c0130b1f3e8ae3(slot) {
    return (0, $jzxpm.globalStateClasses)[slot] !== undefined;
}



function $1d6f6a7ecf017320$export$de4f15803c389669(componentName, slots) {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $a3c689a96a013a98$export$1d132570e11858b0)(componentName, slot);
    });
    return result;
}


const $d3e903795686cbee$var$COMPONENT_NAME = "Popper";
function $d3e903795686cbee$export$1b69b6cd0fa638a1(slot) {
    return (0, $a3c689a96a013a98$export$1d132570e11858b0)($d3e903795686cbee$var$COMPONENT_NAME, slot);
}
const $d3e903795686cbee$export$b6aa214021e734b0 = (0, $1d6f6a7ecf017320$export$de4f15803c389669)($d3e903795686cbee$var$COMPONENT_NAME, [
    "root"
]);




var $7fPBF = parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $6169d433b17180d2$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $6169d433b17180d2$var$ClassNameConfiguratorContext = /*#__PURE__*/ $7fPBF.createContext($6169d433b17180d2$var$defaultContextValue);
function $6169d433b17180d2$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $7fPBF.useContext($6169d433b17180d2$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $6169d433b17180d2$export$2efe1f5e70172ae9(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $7fPBF.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($6169d433b17180d2$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $53db6a0252cebd95$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $53db6a0252cebd95$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $53db6a0252cebd95$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $53db6a0252cebd95$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $53db6a0252cebd95$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $53db6a0252cebd95$var$isVirtualElement(element) {
    return !$53db6a0252cebd95$var$isHTMLElement(element);
}
const $53db6a0252cebd95$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $6169d433b17180d2$export$b0f7603cd2f9ee15)((0, $d3e903795686cbee$export$1b69b6cd0fa638a1)));
};
const $53db6a0252cebd95$var$defaultPopperOptions = {};
const $53db6a0252cebd95$var$PopperTooltip = /*#__PURE__*/ $7fPBF.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $cFLic.default)(props, $53db6a0252cebd95$var$_excluded);
    const tooltipRef = $7fPBF.useRef(null);
    const ownRef = (0, $52155878109bdfb9$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $7fPBF.useRef(null);
    const handlePopperRef = (0, $52155878109bdfb9$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $7fPBF.useRef(handlePopperRef);
    (0, $f7f8f12b8c6feb2f$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $7fPBF.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $53db6a0252cebd95$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $7fPBF.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $7fPBF.useState($53db6a0252cebd95$var$resolveAnchorEl(anchorEl));
    $7fPBF.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $7fPBF.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($53db6a0252cebd95$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $f7f8f12b8c6feb2f$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $a5ed26444bdb4d3e$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $kY3Ke.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $53db6a0252cebd95$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Root, (0, $kY3Ke.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const $53db6a0252cebd95$export$badac9ada3a0bdf9 = /*#__PURE__*/ $7fPBF.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $53db6a0252cebd95$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $cFLic.default)(props, $53db6a0252cebd95$var$_excluded2);
    const [exited, setExited] = $7fPBF.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $53db6a0252cebd95$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $53db6a0252cebd95$var$isHTMLElement(resolvedAnchorEl) ? (0, $cac0a17fea472264$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $cac0a17fea472264$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $af6f301d1bc38583$export$602eac185826482c), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($53db6a0252cebd95$var$PopperTooltip, (0, $kY3Ke.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $kY3Ke.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});


var $555d6be71c82d9fe$exports = {};
"use strict";
"use client";
Object.defineProperty($555d6be71c82d9fe$exports, "__esModule", {
    value: true
});
$555d6be71c82d9fe$exports.default = void 0;

var $555d6be71c82d9fe$var$React = $555d6be71c82d9fe$var$_interopRequireWildcard((parcelRequire("7fPBF")));
parcelRequire("bpHMA");
var $hpTPt = parcelRequire("hpTPt");
function $555d6be71c82d9fe$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($555d6be71c82d9fe$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $555d6be71c82d9fe$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $555d6be71c82d9fe$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $555d6be71c82d9fe$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $555d6be71c82d9fe$var$useTheme(defaultTheme = null) {
    const contextTheme = $555d6be71c82d9fe$var$React.useContext($hpTPt.T);
    return !contextTheme || $555d6be71c82d9fe$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $555d6be71c82d9fe$var$_default = $555d6be71c82d9fe$exports.default = $555d6be71c82d9fe$var$useTheme;






var $7fPBF = parcelRequire("7fPBF");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $2ecffc9bd505b8cc$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $2ecffc9bd505b8cc$var$PopperRoot = (0, $kDBhE.default)((0, $53db6a0252cebd95$export$badac9ada3a0bdf9), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $2ecffc9bd505b8cc$var$Popper = /*#__PURE__*/ $7fPBF.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($555d6be71c82d9fe$exports)))();
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $cFLic.default)(props, $2ecffc9bd505b8cc$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $kY3Ke.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($2ecffc9bd505b8cc$var$PopperRoot, (0, $kY3Ke.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $2ecffc9bd505b8cc$export$2e2bcd8739ae039 = $2ecffc9bd505b8cc$var$Popper;





"use client";
var $8631184a92cee7e5$export$2e2bcd8739ae039 = (0, $67dd8d1013271871$export$2e2bcd8739ae039);





var $9UILM = parcelRequire("9UILM");

var $jzxpm = parcelRequire("jzxpm");
function $684603ff395d34b1$export$837848f5f6cee923(slot) {
    return (0, $jzxpm.default)("MuiTooltip", slot);
}
const $684603ff395d34b1$var$tooltipClasses = (0, $9UILM.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $684603ff395d34b1$export$2e2bcd8739ae039 = $684603ff395d34b1$var$tooltipClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $ea99f2520fe8509d$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $ea99f2520fe8509d$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $ea99f2520fe8509d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $b6UUh.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $fsUVx.default)(slots, (0, $684603ff395d34b1$export$837848f5f6cee923), classes);
};
const $ea99f2520fe8509d$var$TooltipPopper = (0, $kDBhE.default)((0, $2ecffc9bd505b8cc$export$2e2bcd8739ae039), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $kY3Ke.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: (0, $kY3Ke.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: (0, $kY3Ke.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $ea99f2520fe8509d$var$TooltipTooltip = (0, $kDBhE.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $b6UUh.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $7jL4F.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$ea99f2520fe8509d$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $kY3Ke.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $kY3Ke.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $kY3Ke.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $kY3Ke.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $kY3Ke.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $kY3Ke.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $kY3Ke.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $kY3Ke.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $ea99f2520fe8509d$var$TooltipArrow = (0, $kDBhE.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $7jL4F.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $ea99f2520fe8509d$var$hystersisOpen = false;
const $ea99f2520fe8509d$var$hystersisTimer = new (0, $c687181065d3a58c$export$786b4da70f00938b)();
let $ea99f2520fe8509d$var$cursorPosition = {
    x: 0,
    y: 0
};
function $ea99f2520fe8509d$export$b9ee5a7ace0541f8() {
    $ea99f2520fe8509d$var$hystersisOpen = false;
    $ea99f2520fe8509d$var$hystersisTimer.clear();
}
function $ea99f2520fe8509d$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $ea99f2520fe8509d$var$Tooltip = /*#__PURE__*/ $7fPBF.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $7ec2c0aa92d4d29c$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $cFLic.default)(props, $ea99f2520fe8509d$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $7fPBF.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isRtl = (0, $ef654b446fc390d6$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $7fPBF.useState();
    const [arrowRef, setArrowRef] = $7fPBF.useState(null);
    const ignoreNonTouchEvents = $7fPBF.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $c687181065d3a58c$export$2e2bcd8739ae039)();
    const enterTimer = (0, $c687181065d3a58c$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $c687181065d3a58c$export$2e2bcd8739ae039)();
    const touchTimer = (0, $c687181065d3a58c$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $8631184a92cee7e5$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $7fPBF.useRef();
    const stopTouchInteraction = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $7fPBF.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $ea99f2520fe8509d$var$hystersisTimer.clear();
        $ea99f2520fe8509d$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $ea99f2520fe8509d$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $ea99f2520fe8509d$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $ea99f2520fe8509d$var$hystersisOpen && enterNextDelay) enterTimer.start($ea99f2520fe8509d$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $77c51d9bab7ec5dd$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $7fPBF.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $7fPBF.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $ea99f2520fe8509d$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $kY3Ke.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $hngXp.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $ea99f2520fe8509d$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $ea99f2520fe8509d$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $ea99f2520fe8509d$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $ea99f2520fe8509d$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $7fPBF.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $kY3Ke.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $ea99f2520fe8509d$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $ea99f2520fe8509d$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $7ec2c0aa92d4d29c$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $ea99f2520fe8509d$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $ea99f2520fe8509d$var$TooltipArrow;
    const popperProps = (0, $465892a610f5fa03$export$b089efb01a7bdf50)(PopperComponent, (0, $kY3Ke.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $hngXp.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $465892a610f5fa03$export$b089efb01a7bdf50)(TransitionComponent, (0, $kY3Ke.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $465892a610f5fa03$export$b089efb01a7bdf50)(TooltipComponent, (0, $kY3Ke.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $hngXp.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $465892a610f5fa03$export$b089efb01a7bdf50)(ArrowComponent, (0, $kY3Ke.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $hngXp.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ $7fPBF.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $bbzbN.jsx)(PopperComponent, (0, $kY3Ke.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $2ecffc9bd505b8cc$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $ea99f2520fe8509d$var$cursorPosition.y,
                            left: $ea99f2520fe8509d$var$cursorPosition.x,
                            right: $ea99f2520fe8509d$var$cursorPosition.x,
                            bottom: $ea99f2520fe8509d$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)(TooltipComponent, (0, $kY3Ke.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $bbzbN.jsx)(ArrowComponent, (0, $kY3Ke.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $ea99f2520fe8509d$export$2e2bcd8739ae039 = $ea99f2520fe8509d$var$Tooltip;


var $a4314aa68965cc2d$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($a4314aa68965cc2d$exports, "__esModule", {
    value: true
});
$a4314aa68965cc2d$exports.default = void 0;

var $a4314aa68965cc2d$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $a4314aa68965cc2d$var$_default = $a4314aa68965cc2d$exports.default = (0, $a4314aa68965cc2d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2M4 18V6h2v12zm4 0V6h8v12zm12 0h-2V6h2z"
}), "WidthWideOutlined");


var $85cdb57fa3b7ef67$exports = {};
var $85cdb57fa3b7ef67$var$parser = function() {
    var pItems = {};
    /**
     * Converts SubRip subtitles into array of objects
     * [{
     *     id:        `Number of subtitle`
     *     startTime: `Start time of subtitle`
     *     endTime:   `End time of subtitle
     *     text: `Text of subtitle`
     * }]
     *
     * @param  {String}  data SubRip suntitles string
     * @param  {Boolean} ms   Optional: use milliseconds for startTime and endTime
     * @return {Array}  
     */ pItems.fromSrt = function(data, ms) {
        var useMs = ms ? true : false;
        data = data.replace(/\r/g, "");
        var regex = /(\d+)\n(\d{2}:\d{2}:\d{2},\d{3}) --> (\d{2}:\d{2}:\d{2},\d{3})/g;
        data = data.split(regex);
        data.shift();
        var items = [];
        for(var i = 0; i < data.length; i += 4)items.push({
            id: data[i].trim(),
            startTime: useMs ? timeMs(data[i + 1].trim()) : data[i + 1].trim(),
            endTime: useMs ? timeMs(data[i + 2].trim()) : data[i + 2].trim(),
            text: data[i + 3].trim()
        });
        return items;
    };
    /**
     * Converts Array of objects created by this module to SubRip subtitles
     * @param  {Array}  data
     * @return {String}      SubRip subtitles string
     */ pItems.toSrt = function(data) {
        if (!data instanceof Array) return "";
        var res = "";
        for(var i = 0; i < data.length; i++){
            var s = data[i];
            if (!isNaN(s.startTime) && !isNaN(s.endTime)) {
                s.startTime = msTime(parseInt(s.startTime, 10));
                s.endTime = msTime(parseInt(s.endTime, 10));
            }
            res += s.id + "\r\n";
            res += s.startTime + " --> " + s.endTime + "\r\n";
            res += s.text.replace("\n", "\r\n") + "\r\n\r\n";
        }
        return res;
    };
    var timeMs = function(val) {
        var regex = /(\d+):(\d{2}):(\d{2}),(\d{3})/;
        var parts = regex.exec(val);
        if (parts === null) return 0;
        for(var i = 1; i < 5; i++){
            parts[i] = parseInt(parts[i], 10);
            if (isNaN(parts[i])) parts[i] = 0;
        }
        // hours + minutes + seconds + ms
        return parts[1] * 3600000 + parts[2] * 60000 + parts[3] * 1000 + parts[4];
    };
    var msTime = function(val) {
        var measures = [
            3600000,
            60000,
            1000
        ];
        var time = [];
        for(var i in measures){
            var res = (val / measures[i] >> 0).toString();
            if (res.length < 2) res = "0" + res;
            val %= measures[i];
            time.push(res);
        }
        var ms = val.toString();
        if (ms.length < 3) for(i = 0; i <= 3 - ms.length; i++)ms = "0" + ms;
        return time.join(":") + "," + ms;
    };
    return pItems;
}();
$85cdb57fa3b7ef67$exports = $85cdb57fa3b7ef67$var$parser;


/* eslint-disable promise/prefer-await-to-then */ const $940804b5a2084986$var$methodMap = [
    [
        "requestFullscreen",
        "exitFullscreen",
        "fullscreenElement",
        "fullscreenEnabled",
        "fullscreenchange",
        "fullscreenerror"
    ],
    // New WebKit
    [
        "webkitRequestFullscreen",
        "webkitExitFullscreen",
        "webkitFullscreenElement",
        "webkitFullscreenEnabled",
        "webkitfullscreenchange",
        "webkitfullscreenerror"
    ],
    // Old WebKit
    [
        "webkitRequestFullScreen",
        "webkitCancelFullScreen",
        "webkitCurrentFullScreenElement",
        "webkitCancelFullScreen",
        "webkitfullscreenchange",
        "webkitfullscreenerror"
    ],
    [
        "mozRequestFullScreen",
        "mozCancelFullScreen",
        "mozFullScreenElement",
        "mozFullScreenEnabled",
        "mozfullscreenchange",
        "mozfullscreenerror"
    ],
    [
        "msRequestFullscreen",
        "msExitFullscreen",
        "msFullscreenElement",
        "msFullscreenEnabled",
        "MSFullscreenChange",
        "MSFullscreenError"
    ]
];
const $940804b5a2084986$var$nativeAPI = (()=>{
    if (typeof document === "undefined") return false;
    const unprefixedMethods = $940804b5a2084986$var$methodMap[0];
    const returnValue = {};
    for (const methodList of $940804b5a2084986$var$methodMap){
        const exitFullscreenMethod = methodList === null || methodList === void 0 ? void 0 : methodList[1];
        if (exitFullscreenMethod in document) {
            for (const [index, method] of methodList.entries())returnValue[unprefixedMethods[index]] = method;
            return returnValue;
        }
    }
    return false;
})();
const $940804b5a2084986$var$eventNameMap = {
    change: $940804b5a2084986$var$nativeAPI.fullscreenchange,
    error: $940804b5a2084986$var$nativeAPI.fullscreenerror
};
// eslint-disable-next-line import/no-mutable-exports
let $940804b5a2084986$var$screenfull = {
    // eslint-disable-next-line default-param-last
    request (element = document.documentElement, options) {
        return new Promise((resolve, reject)=>{
            const onFullScreenEntered = ()=>{
                $940804b5a2084986$var$screenfull.off("change", onFullScreenEntered);
                resolve();
            };
            $940804b5a2084986$var$screenfull.on("change", onFullScreenEntered);
            const returnPromise = element[$940804b5a2084986$var$nativeAPI.requestFullscreen](options);
            if (returnPromise instanceof Promise) returnPromise.then(onFullScreenEntered).catch(reject);
        });
    },
    exit () {
        return new Promise((resolve, reject)=>{
            if (!$940804b5a2084986$var$screenfull.isFullscreen) {
                resolve();
                return;
            }
            const onFullScreenExit = ()=>{
                $940804b5a2084986$var$screenfull.off("change", onFullScreenExit);
                resolve();
            };
            $940804b5a2084986$var$screenfull.on("change", onFullScreenExit);
            const returnPromise = document[$940804b5a2084986$var$nativeAPI.exitFullscreen]();
            if (returnPromise instanceof Promise) returnPromise.then(onFullScreenExit).catch(reject);
        });
    },
    toggle (element, options) {
        return $940804b5a2084986$var$screenfull.isFullscreen ? $940804b5a2084986$var$screenfull.exit() : $940804b5a2084986$var$screenfull.request(element, options);
    },
    onchange (callback) {
        $940804b5a2084986$var$screenfull.on("change", callback);
    },
    onerror (callback) {
        $940804b5a2084986$var$screenfull.on("error", callback);
    },
    on (event, callback) {
        const eventName = $940804b5a2084986$var$eventNameMap[event];
        if (eventName) document.addEventListener(eventName, callback, false);
    },
    off (event, callback) {
        const eventName = $940804b5a2084986$var$eventNameMap[event];
        if (eventName) document.removeEventListener(eventName, callback, false);
    },
    raw: $940804b5a2084986$var$nativeAPI
};
Object.defineProperties($940804b5a2084986$var$screenfull, {
    isFullscreen: {
        get: ()=>Boolean(document[$940804b5a2084986$var$nativeAPI.fullscreenElement])
    },
    element: {
        enumerable: true,
        get: ()=>{
            var _document_nativeAPI_fullscreenElement;
            return (_document_nativeAPI_fullscreenElement = document[$940804b5a2084986$var$nativeAPI.fullscreenElement]) !== null && _document_nativeAPI_fullscreenElement !== void 0 ? _document_nativeAPI_fullscreenElement : undefined;
        }
    },
    isEnabled: {
        enumerable: true,
        // Coerce to boolean in case of old WebKit.
        get: ()=>Boolean(document[$940804b5a2084986$var$nativeAPI.fullscreenEnabled])
    }
});
if (!$940804b5a2084986$var$nativeAPI) $940804b5a2084986$var$screenfull = {
    isEnabled: false
};
var $940804b5a2084986$export$2e2bcd8739ae039 = $940804b5a2084986$var$screenfull;





var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");





function $eb8e2e88895ad82c$export$2e2bcd8739ae039(props) {
    const getSubtitleCredits = ()=>{
        if (props.credits.length <= 0) return null;
        return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
            dividers: true,
            children: [
                "Subtitle credits:",
                props.credits.map((entity, _)=>{
                    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                        children: [
                            entity.name,
                            " (",
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $375541c69d4ec6b6$export$2e2bcd8739ae039), {
                                href: `https://twitter.com/${entity.twitter_username}`,
                                children: [
                                    "@",
                                    entity.twitter_username
                                ]
                            }),
                            ")"
                        ]
                    }, entity.name);
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $7f096abd658f7c85$export$2e2bcd8739ae039), {
        open: props.isOpen,
        onClose: props.handleClose,
        scroll: "paper",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ac75506ecdb312f1$export$2e2bcd8739ae039), {
                children: "About Versioning"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                        gutterBottom: true,
                        children: "Going to use a funny SemVer for handling subtitle versioning. Instead of Major.Minor.Patch it'll be Stage.Completion.Patch. This is here to set expectations since quick and rough translations tend to be... rough. Nobody wants to make mistakes, but they can and do happen!"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                        gutterBottom: true,
                        children: "Stage will be 1 for a single pass rough translation, 2 for a TL check and edit pass, and 3 for an in depth check and edit. Depending on available capacity, it might not go beyond 1 sometimes, but the target is at least 2."
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                        gutterBottom: true,
                        children: "Completion will be a number from 0-9 dictating how much progress has been made to reach the next Stage."
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                        gutterBottom: true,
                        children: "Patch will be quick fixes for any glaring or major errors."
                    })
                ]
            }),
            getSubtitleCredits()
        ]
    });
}


var $092b30b392812906$exports = {};
(function(global, factory) {
    $092b30b392812906$exports = factory();
})($092b30b392812906$exports, function() {
    "use strict";
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    var Container = /** @class */ function() {
        function Container() {
            this.window = null;
            this.document = null;
            this.YT = null;
            this.initService = null;
        }
        Container.prototype.setWindow = function(window1) {
            this.window = window1;
        };
        Container.prototype.getWindow = function() {
            return this.window;
        };
        Container.prototype.setDocument = function(document) {
            this.document = document;
        };
        Container.prototype.getDocument = function() {
            return this.document;
        };
        Container.prototype.setYT = function(YT) {
            this.YT = YT;
        };
        Container.prototype.getYT = function() {
            return this.YT;
        };
        Container.prototype.setInitService = function(initService) {
            this.initService = initService;
        };
        Container.prototype.getInitService = function() {
            return this.initService;
        };
        return Container;
    }();
    var DIC = new Container();
    var CSS = {
        ID: "youtube-external-subtitle-style",
        CLASS: "youtube-external-subtitle",
        FULLSCREEN: "fullscreen",
        FULLSCREEN_IGNORE: "fullscreen-ignore"
    };
    var iframeApiScriptAdded = function(document) {
        var scripts = document.getElementsByTagName("script");
        for(var i = 0; i < scripts.length; i++){
            var src = scripts[i].src;
            if (src && src.indexOf("youtube.com/iframe_api") !== -1) return true;
        }
        return false;
    };
    var addIframeApiScript = function(document) {
        var tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    };
    var grantIframeApiScript = function(document) {
        if (!iframeApiScriptAdded(document)) addIframeApiScript(document);
    };
    var iframeApiLoaded = function(window1) {
        return !!(window1.YT && window1.YT.Player);
    };
    var waitFor = function(isReady, onComplete) {
        if (isReady()) {
            onComplete();
            return;
        }
        var interval = setInterval(function() {
            if (isReady()) {
                clearInterval(interval);
                onComplete();
            }
        }, 100);
    };
    var getFullscreenElement = function(document) {
        return document.fullscreenElement || document.webkitFullscreenElement || document.webkitCurrentFullScreenElement || document.mozFullScreenElement || document.msFullscreenElement;
    };
    var getSubtitles = function(container) {
        var initService = DIC.getInitService();
        return initService.getSubtitles().filter(function(subtitle) {
            return subtitle.isInContainer(container);
        });
    };
    var getFullscreenSubtitle = function(fullscreenElement) {
        if (!fullscreenElement) return null;
        if (fullscreenElement.youtubeExternalSubtitle) return fullscreenElement.youtubeExternalSubtitle;
        var elements = getSubtitles(fullscreenElement);
        if (elements.length > 0) return elements[0];
        return null;
    };
    var fullscreenChangeHandler = function() {
        var document = DIC.getDocument();
        var fullscreenElement = getFullscreenElement(document);
        var isFullscreen = !!fullscreenElement;
        var fullscreenSubtitle = getFullscreenSubtitle(fullscreenElement);
        var subtitles = getSubtitles(document);
        for(var _i = 0, subtitles_1 = subtitles; _i < subtitles_1.length; _i++){
            var subtitle = subtitles_1[_i];
            subtitle.setIsFullscreenActive(isFullscreen ? fullscreenSubtitle === subtitle : null);
        }
    };
    var globalStylesAdded = function(document) {
        return !!document.getElementById(CSS.ID);
    };
    var addGlobalStyles = function(document) {
        var style = document.createElement("style");
        style.id = CSS.ID;
        style.type = "text/css";
        style.innerHTML = "\n    ." + CSS.CLASS + " { position: absolute; display: none; z-index: 0; pointer-events: none; color: #fff; font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif; font-weight: normal; font-size: 17px; text-align: center; }\n    ." + CSS.CLASS + " span { background: #000; background: rgba(0, 0, 0, 0.9); padding: 1px 4px; display: inline-block; margin-bottom: 2px; }\n    ." + CSS.CLASS + "." + CSS.FULLSCREEN_IGNORE + " { display: none !important; }\n    ." + CSS.CLASS + "." + CSS.FULLSCREEN + " { z-index: 3000000000; }\n  ";
        var head = document.getElementsByTagName("head")[0] || document.documentElement;
        head.insertBefore(style, head.firstChild);
        document.addEventListener("fullscreenchange", fullscreenChangeHandler);
        document.addEventListener("webkitfullscreenchange", fullscreenChangeHandler);
        document.addEventListener("mozfullscreenchange", fullscreenChangeHandler);
        document.addEventListener("MSFullscreenChange", fullscreenChangeHandler);
    };
    var InitService = /** @class */ function() {
        function InitService() {
            this.subtitles = [];
        }
        InitService.prototype.getSubtitles = function() {
            return this.subtitles;
        };
        InitService.prototype.addSubtitle = function(subtitle) {
            this.subtitles.push(subtitle);
        };
        InitService.prototype.removeSubtitle = function(subtitle) {
            var index = this.subtitles.indexOf(subtitle);
            if (index !== -1) this.subtitles.splice(index, 1);
        };
        InitService.prototype.grantIframeApi = function(cb) {
            if (DIC.getYT() !== null) {
                cb();
                return;
            }
            var window1 = DIC.getWindow();
            var document = DIC.getDocument();
            waitFor(function() {
                return iframeApiLoaded(window1);
            }, function() {
                DIC.setYT(window1.YT);
                cb();
            });
            grantIframeApiScript(document);
        };
        InitService.prototype.grantGlobalStyles = function() {
            var document = DIC.getDocument();
            if (!globalStylesAdded(document)) addGlobalStyles(document);
        };
        return InitService;
    }();
    var init = function(window1) {
        DIC.setWindow(window1);
        DIC.setDocument(window1.document);
        DIC.setInitService(new InitService());
    };
    var getCacheName = function(seconds) {
        return Math.floor(seconds / 10);
    };
    var getCacheNames = function(start, end) {
        var cacheNames = [];
        var endCacheName = getCacheName(end);
        for(var i = getCacheName(start); i <= endCacheName; i++)cacheNames.push(i);
        return cacheNames;
    };
    var buildCache = function(subtitles) {
        var cache = {};
        for(var _i = 0, subtitles_1 = subtitles; _i < subtitles_1.length; _i++){
            var subtitle = subtitles_1[_i];
            for(var _a = 0, _b = getCacheNames(subtitle.start, subtitle.end); _a < _b.length; _a++){
                var cacheName = _b[_a];
                if (!cache[cacheName]) cache[cacheName] = [];
                cache[cacheName].push(subtitle);
            }
        }
        return cache;
    };
    var getSubtitleFromCache = function(seconds, builtCache) {
        if (!builtCache) return null;
        var cache = builtCache[getCacheName(seconds)];
        if (!cache) return null;
        for(var _i = 0, cache_1 = cache; _i < cache_1.length; _i++){
            var subtitle = cache_1[_i];
            if (seconds >= subtitle.start && seconds <= subtitle.end) return subtitle;
        }
        return null;
    };
    var addQueryStringParameterToUrl = function(url, qsParameters) {
        var hashIndex = url.indexOf("#");
        var hash = "";
        if (hashIndex !== -1) {
            hash = url.substr(hashIndex);
            url = url.substr(0, hashIndex);
        }
        var qsIndex = url.indexOf("?");
        var qs = "";
        if (qsIndex !== -1) {
            qs = url.substr(qsIndex);
            url = url.substr(0, qsIndex);
        }
        for(var _i = 0, _a = Object.keys(qsParameters); _i < _a.length; _i++){
            var qsParameterName = _a[_i];
            qs += "" + (qs === "" ? "?" : "&") + qsParameterName + "=" + qsParameters[qsParameterName];
        }
        return "" + url + qs + hash;
    };
    var getIframeSrc = function(src) {
        var newSrc = src;
        if (newSrc.indexOf("enablejsapi=1") === -1) newSrc = addQueryStringParameterToUrl(newSrc, {
            enablejsapi: "1"
        });
        if (newSrc.indexOf("html5=1") === -1) newSrc = addQueryStringParameterToUrl(newSrc, {
            html5: "1"
        });
        if (newSrc.indexOf("playsinline=1") === -1) newSrc = addQueryStringParameterToUrl(newSrc, {
            playsinline: "1"
        });
        if (newSrc.indexOf("fs=") === -1) newSrc = addQueryStringParameterToUrl(newSrc, {
            fs: "0"
        });
        return newSrc;
    };
    var createSubtitleElement = function(iframe, subtitle) {
        var document = DIC.getDocument();
        var element = document.createElement("div");
        element.youtubeExternalSubtitle = subtitle;
        iframe.parentNode.insertBefore(element, iframe.nextSibling);
        return element;
    };
    var isStateChanged = function(prevState, nextState) {
        for(var _i = 0, _a = Object.keys(nextState); _i < _a.length; _i++){
            var propertyName = _a[_i];
            if (prevState[propertyName] !== nextState[propertyName]) return true;
        }
        return false;
    };
    var renderClassName = function(isFullscreenActive) {
        var classes = [
            CSS.CLASS
        ];
        if (isFullscreenActive !== null) classes.push(isFullscreenActive ? CSS.FULLSCREEN : CSS.FULLSCREEN_IGNORE);
        return classes.join(" ");
    };
    var renderText = function(text) {
        return "<span>" + (text === null ? "" : text).replace(/(?:\r\n|\r|\n)/g, "</span><br /><span>") + "</span>";
    };
    var getFrameRect = function(iframe, controlsVisible) {
        var height = iframe.offsetHeight;
        return {
            x: iframe.offsetLeft - iframe.scrollLeft + iframe.clientLeft,
            y: iframe.offsetTop - iframe.scrollTop + iframe.clientTop,
            width: iframe.offsetWidth,
            height: height,
            bottomPadding: height < 200 && !controlsVisible ? 20 : 60
        };
    };
    var renderSubtitle = function(element, player, isFullscreenActive, text, controlsVisible) {
        element.className = renderClassName(isFullscreenActive);
        element.innerHTML = renderText(text);
        element.style.display = text === null ? "" : "block";
        if (player) {
            var frame = getFrameRect(player.getIframe(), controlsVisible);
            element.style.visibility = "hidden";
            element.style.top = frame.y + "px";
            element.style.left = frame.x + "px";
            element.style.maxWidth = frame.width - 20 + "px";
            element.style.fontSize = frame.height / 260 + "em";
            element.style.top = frame.y + frame.height - frame.bottomPadding - element.offsetHeight + "px";
            element.style.left = frame.x + (frame.width - element.offsetWidth) / 2 + "px";
            element.style.visibility = "";
        }
    };
    var Subtitle = /** @class */ function() {
        function Subtitle(iframe, subtitles, renderMethod) {
            var _this = this;
            if (subtitles === void 0) subtitles = [];
            if (renderMethod === void 0) renderMethod = null;
            this.cache = null;
            this.timeChangeInterval = 0;
            this.controlsHideTimeout = 0;
            this.player = null;
            this.videoId = null;
            this.element = null;
            this.renderMethod = null;
            this.state = {
                text: null,
                isFullscreenActive: null,
                controlsVisible: true
            };
            this.onTimeChange = function() {
                var subtitle = getSubtitleFromCache(_this.player.getCurrentTime(), _this.cache);
                _this.setState({
                    text: subtitle ? subtitle.text : null
                });
            };
            this.onControlsHide = function() {
                _this.setState({
                    controlsVisible: false
                });
            };
            this.onPlayerReady = function() {
                _this.videoId = _this.getCurrentVideoId();
            };
            this.onPlayerStateChange = function(e) {
                if (_this.videoId !== _this.getCurrentVideoId()) return;
                var YT = DIC.getYT();
                if (e.data === YT.PlayerState.PLAYING) _this.start();
                else if (e.data === YT.PlayerState.PAUSED) _this.stop();
                else if (e.data === YT.PlayerState.ENDED) {
                    _this.stop();
                    _this.setState({
                        text: null
                    });
                }
            };
            if (iframe.youtubeExternalSubtitle) throw new Error("YoutubeExternalSubtitle: subtitle is already added for this element");
            iframe.youtubeExternalSubtitle = this;
            var src = getIframeSrc(iframe.src);
            if (iframe.src !== src) iframe.src = src;
            this.load(subtitles);
            this.element = createSubtitleElement(iframe, this);
            this.renderMethod = renderMethod === null ? renderSubtitle : renderMethod;
            var initService = DIC.getInitService();
            initService.grantGlobalStyles();
            initService.addSubtitle(this);
            this.render();
            initService.grantIframeApi(function() {
                var YT = DIC.getYT();
                _this.player = new YT.Player(iframe);
                _this.player.addEventListener("onReady", _this.onPlayerReady);
                _this.player.addEventListener("onStateChange", _this.onPlayerStateChange);
            });
        }
        Subtitle.prototype.load = function(subtitles) {
            this.cache = buildCache(subtitles);
        };
        Subtitle.prototype.setIsFullscreenActive = function(isFullscreenActive) {
            this.setState({
                isFullscreenActive: isFullscreenActive
            });
        };
        Subtitle.prototype.destroy = function() {
            this.stop();
            this.element.parentNode.removeChild(this.element);
            this.player.getIframe().youtubeExternalSubtitle = null;
            this.player.removeEventListener("onReady", this.onPlayerReady);
            this.player.removeEventListener("onStateChange", this.onPlayerStateChange);
            var initService = DIC.getInitService();
            initService.removeSubtitle(this);
        };
        Subtitle.prototype.render = function() {
            this.renderMethod(this.element, this.player, this.state.isFullscreenActive, this.state.text, this.state.controlsVisible);
        };
        Subtitle.prototype.isInContainer = function(container) {
            return container.contains(this.element) || container === this.element;
        };
        Subtitle.prototype.getYTPlayer = function() {
            return this.player;
        };
        Subtitle.prototype.setState = function(state) {
            var prevState = this.state;
            var nextState = __assign(__assign({}, prevState), state);
            if (!isStateChanged(prevState, nextState)) return;
            this.state = nextState;
            this.render();
        };
        Subtitle.prototype.start = function() {
            this.stop();
            var window1 = DIC.getWindow();
            this.timeChangeInterval = window1.setInterval(this.onTimeChange, 500);
            this.controlsHideTimeout = window1.setTimeout(this.onControlsHide, 3000);
            this.onTimeChange();
        };
        Subtitle.prototype.stop = function() {
            var window1 = DIC.getWindow();
            window1.clearInterval(this.timeChangeInterval);
            window1.clearTimeout(this.controlsHideTimeout);
            this.setState({
                controlsVisible: true
            });
        };
        Subtitle.prototype.getCurrentVideoId = function() {
            return this.player.getVideoData().video_id;
        };
        return Subtitle;
    }();
    init(window);
    var youtube_external_subtitle = {
        Subtitle: Subtitle
    };
    return youtube_external_subtitle;
});


const $d251d2ce7a451dc0$var$Navi = (0, $kDBhE.default)((0, $74e245c78e363f11$export$2e2bcd8739ae039))(({ theme: theme })=>({
        backgroundColor: "#1A2027",
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: "center",
        color: theme.palette.text.secondary
    }));
function $d251d2ce7a451dc0$export$2e2bcd8739ae039() {
    const params = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    let [isVersioningModalOpen, setIsVersioningModalOpen] = (0, $7fPBF.useState)(false);
    let [availableSubtitles, setAvailableSubtitles] = (0, $7fPBF.useState)([]);
    let [subtitleCredits, setSubtitleCredits] = (0, $7fPBF.useState)([]);
    let [currentSubtitleFile, setCurrentSubtitleFile] = (0, $7fPBF.useState)("");
    let [title, setTitle] = (0, $7fPBF.useState)("Loading...");
    let [isWidescreen, setIsWidescreen] = (0, $7fPBF.useState)(false);
    const containerRef = (0, $7fPBF.useRef)(null);
    const videoRef = (0, $7fPBF.useRef)(null);
    const YOUTUBE_VIDEO_PLAYER_DEFAULT_TITLE = "YouTube video player";
    function formatSRT(srtData) {
        let subtitles = (0, (/*@__PURE__*/$parcel$interopDefault($85cdb57fa3b7ef67$exports))).fromSrt(srtData, true);
        for(var ii in subtitles)subtitles[ii] = {
            start: subtitles[ii].startTime / 1000,
            end: subtitles[ii].endTime / 1000,
            text: subtitles[ii].text
        };
        return subtitles;
    }
    const handleClickAboutVersioning = ()=>{
        setIsVersioningModalOpen(true);
    };
    const handleCloseVersioningModal = ()=>{
        setIsVersioningModalOpen(false);
    };
    const handleChangeSubtitleVersion = (event)=>{
        setCurrentSubtitleFile(event.target.value);
    };
    const handleClickWidescreen = ()=>{
        setIsWidescreen(!isWidescreen);
    };
    const handleClickFullscreen = ()=>{
        (0, $940804b5a2084986$export$2e2bcd8739ae039).request(containerRef.current);
    };
    const prettifyVersionName = (subtitleFilename)=>{
        let prettyName = subtitleFilename.replaceAll(".srt", "");
        prettyName = prettyName.replaceAll("_", ".");
        return prettyName;
    };
    (0, $7fPBF.useEffect)(()=>{
        // Poll for the title until the YouTube player finishes loading
        const getTitleInterval = setInterval(()=>{
            if (videoRef.current.title != YOUTUBE_VIDEO_PLAYER_DEFAULT_TITLE) {
                setTitle(videoRef.current.title);
                clearInterval(getTitleInterval);
            }
        }, 300);
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        fetch(`${(0, $8ec0c955b9f9a345$export$c3ee1e672e1e24e7)}/api/get_available_subtitles?video_id=${params.videoId}`).then((response)=>response.json()).then((data)=>{
            setAvailableSubtitles(data.available_subtitles);
            setCurrentSubtitleFile(data.available_subtitles[0]);
        });
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        fetch(`${(0, $8ec0c955b9f9a345$export$c3ee1e672e1e24e7)}/api/get_subtitle_credits?video_id=${params.videoId}`).then((response)=>response.json()).then((data)=>{
            setSubtitleCredits(data.subtitle_credits);
        });
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        if (currentSubtitleFile == "") return;
        fetch(`${(0, $8ec0c955b9f9a345$export$c3ee1e672e1e24e7)}/static/subtitles/${params.videoId}/${currentSubtitleFile}`).then((response)=>response.text()).then((data)=>{
            var _videoRef_current;
            if ((videoRef === null || videoRef === void 0 ? void 0 : (_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.youtubeExternalSubtitle) == undefined) new (0, (/*@__PURE__*/$parcel$interopDefault($092b30b392812906$exports))).Subtitle(document.getElementById("video"), formatSRT(data));
            else videoRef.current.youtubeExternalSubtitle.load(formatSRT(data));
        });
    }, [
        currentSubtitleFile
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e7713da642e42c71$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                width: "100%",
                maxWidth: isWidescreen ? null : "960px",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        style: isWidescreen ? {
                            width: "100%",
                            height: "95vh"
                        } : {
                            width: "100%",
                            height: "560px"
                        },
                        ref: containerRef,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("iframe", {
                            ref: videoRef,
                            id: "video",
                            width: "100%",
                            height: "100%",
                            src: `https://www.youtube.com/embed/${params.videoId}`,
                            title: YOUTUBE_VIDEO_PLAYER_DEFAULT_TITLE,
                            frameBorder: "0",
                            allow: "web-share",
                            referrerPolicy: "strict-origin-when-cross-origin",
                            allowFullScreen: false
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)($d251d2ce7a451dc0$var$Navi, {
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $c444a3def854c6aa$export$2e2bcd8739ae039), {
                            container: true,
                            alignItems: "center",
                            rowSpacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c444a3def854c6aa$export$2e2bcd8739ae039), {
                                    xs: 12
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c444a3def854c6aa$export$2e2bcd8739ae039), {
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                                        variant: "h5",
                                        children: title
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c444a3def854c6aa$export$2e2bcd8739ae039), {
                                    xs: 12
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c444a3def854c6aa$export$2e2bcd8739ae039), {
                                    xs: 4,
                                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
                                        fullWidth: true,
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), {
                                                children: "Subtitle Version"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                                value: currentSubtitleFile,
                                                label: "Subtitle Version",
                                                onChange: handleChangeSubtitleVersion,
                                                children: availableSubtitles.map((availableSubtitle)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                        value: availableSubtitle,
                                                        id: availableSubtitle,
                                                        children: prettifyVersionName(availableSubtitle)
                                                    }))
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c444a3def854c6aa$export$2e2bcd8739ae039), {
                                    xs: 1,
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                        title: "About Versioning",
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                                            sx: {
                                                marginLeft: "-2.5em",
                                                width: 0,
                                                minWidth: 0
                                            },
                                            variant: "outlined secondary",
                                            onClick: handleClickAboutVersioning,
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0a7d45d6c9dbfb3d$exports))), {
                                                fontSize: "small",
                                                sx: {
                                                    height: "100%"
                                                }
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c444a3def854c6aa$export$2e2bcd8739ae039), {
                                    xs: 3
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c444a3def854c6aa$export$2e2bcd8739ae039), {
                                    xs: 4,
                                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $078cc07d54c9b00d$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                                                variant: "outlined secondary",
                                                onClick: handleClickWidescreen,
                                                children: [
                                                    "Widescreen",
                                                    " ",
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a4314aa68965cc2d$exports))), {
                                                        fontSize: "large",
                                                        sx: {
                                                            paddingLeft: "0.2em",
                                                            height: "100%"
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                                                variant: "outlined secondary",
                                                onClick: handleClickFullscreen,
                                                children: [
                                                    "Fullscreen",
                                                    " ",
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fa9d0137ffbb850f$exports))), {
                                                        fontSize: "large",
                                                        sx: {
                                                            paddingLeft: "0.2em",
                                                            height: "100%"
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c444a3def854c6aa$export$2e2bcd8739ae039), {
                                    xs: 1,
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
                                        href: `${(0, $8ec0c955b9f9a345$export$c3ee1e672e1e24e7)}/static/subtitles/${params.videoId}/${currentSubtitleFile}`,
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                                            title: "Download Subtitles",
                                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                                                variant: "outlined",
                                                children: [
                                                    "Download",
                                                    " ",
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9b8a49e2878275fe$exports))), {
                                                        fontSize: "large",
                                                        sx: {
                                                            height: "100%"
                                                        }
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eb8e2e88895ad82c$export$2e2bcd8739ae039), {
                isOpen: isVersioningModalOpen,
                handleClose: handleCloseVersioningModal,
                credits: subtitleCredits
            })
        ]
    });
}


const $5c121a02b943fe91$var$darkTheme = (0, $hmhHQ.default)({
    palette: {
        mode: "dark"
    }
});
function $5c121a02b943fe91$var$App() {
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $b8226d5132dedede$export$2e2bcd8739ae039), {
        theme: $5c121a02b943fe91$var$darkTheme,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $81465d564338b8cb$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                textAlign: "center",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d9fd026bfea79ab9$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2edbd157720007ec$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                path: "/video/:videoId",
                                element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d251d2ce7a451dc0$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                })
            })
        ]
    });
}
var $5c121a02b943fe91$export$2e2bcd8739ae039 = $5c121a02b943fe91$var$App;


const $4a5191623062d5ff$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($f11ec298ebcca059$exports))).createRoot(document.getElementById("root"));
$4a5191623062d5ff$var$root.render(/*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).StrictMode, {
    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5c121a02b943fe91$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=index.a0c30014.js.map
